import React, { Component, Fragment } from 'react';

import {
    Container,
    Row,
    Col, Input, Label, Modal, ModalBody, ModalHeader, FormGroup, Button, Table
} from 'reactstrap';
import { Link } from 'react-router-dom';

import EventComponent from './EventComponentt'

import FormBuilder from '../../../components/forms/modalFormBuilder';
import { required, checkSocialSecurityNumber, dateValidate, validateGender } from '../../../components/forms/validation';
import { connect } from 'react-redux';
import { formValueSelector, change } from 'redux-form';  // ES6
import ListBuilder from '../../../components/listBuilder';
import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../../../helpers/linkHelper';
import { API_ENDPOINT, getAgeLimit, translateAgeLimitMessage } from '../../../constants';

import TimePicker from '../../../components/forms/fields/timepicker';
import TimePickerV2 from '../../../components/forms/fields/timepicker_v2';
import TimePickerV3 from '../../../components/forms/fields/timepicker_v3';

import SocialSecurityNumber, { isSocialSecurityNumberValid } from '../../../components/forms/fields/socialSecurityNumber';

import Isvg from 'react-inlinesvg'
import Search from '../../../components/search';
import PatientFilter from '../../../components/patientFilter';
import profileUser from '../../../assets/images/user.png'
import holidayIcon from '../../../assets/svg/holiday.svg';
import noNotifications from '../../../assets/svg/no-notif.svg';
import arrowDown from '../../../assets/svg/arrow-down.svg'
import arrowUp from '../../../assets/svg/arrow-up.svg'
import handled from '../../../assets/svg/check.svg'

import moreIcon from '../../../assets/svg/more.svg';
import warrning from '../../../assets/images/warrning.png';
import xIcon from '../../../assets/svg/x.svg';
import InfoModal from '../../../components/infoModal';

import TriangleIcon from '../../../assets/svg/alert-triangle-icon.svg';

import { Calendar, Day, momentLocalizer } from 'react-big-calendar';
import DefaultDateHeader from 'react-big-calendar/lib/DateHeader';

import CustomToolbar from './CustomToolbar';
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Tooltip } from '@material-ui/core';
import { withStyles, makeStyles } from "@material-ui/core/styles";

import Checkbox from '../../../components/forms/fields/checkbox';
import DoctorListComponent from '../../../components/forms/fields/doctorListComponent'
import DatePicker from '../../../components/forms/fields/datePicker';

import SelectWithCheckbox from '../../../components/forms/fields/selectWithCheckbox'
import CustomSelectWithSearch from '../../../components/forms/fields/customSelectWithSearch';
import openChat from '../../../assets/svg/open_chat.svg';
import waitingRoomIcon from '../../../assets/svg/waiting-room.svg';
import notesIcon from '../../../assets/svg/notes-icon.svg';




import { Player, Controls } from "@lottiefiles/react-lottie-player";

import infoIcon from "../../../assets/svg/link-new-tab.svg";

import multiIcon from "../../../assets/svg/multi.svg";
import FormPreview from '../../forms/previewAnsweredForm';
import ReferralContent from '../../../components/referralContent';
const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: "rgba(58, 63, 85, 0.9)",
        color: "#fff",
        boxShadow: theme.shadows[1],
        fontSize: 14
    }
}))(Tooltip);

const LightTooltipHoliday = withStyles((theme) => ({
    tooltip: {
        backgroundColor: "#e61f00",
        color: "#fff",
        boxShadow: theme.shadows[1],
        fontSize: 14
    }
}))(Tooltip);

function isValidDate(d) {
    return d instanceof Date && !isNaN(d);
}
function validateTime(timeString) {
    const timeRegex = /^([01]?\d|2[0-3]):([0-5]?\d)$/;
    if (timeString && timeRegex.test(timeString)) {
        const [hours, minutes] = timeString.split(":").map((x) => parseInt(x, 10));
        const paddedHours = hours.toString().padStart(2, "0");
        const paddedMinutes = minutes.toString().padStart(2, "0");
        return `${paddedHours}:${paddedMinutes}`;
    }
    return null;
}
function isTimeValidString(timeString) {
    let valid = false;
    if (timeString?.length === 5) {
        const [hours, minutes] = timeString.split(":").map((x) => parseInt(x, 10));
        if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
            valid = true;
        }
    }


    return valid;
}

function getWeekNumber(dateString) {
    // Parse the date string into a Date object
    const date = new Date(dateString);

    if (isNaN(date)) {
        throw new Error("Invalid date format. Please use a valid date string in MM/DD/YYYY format.");
    }

    // Set the start of the year for calculations
    const startOfYear = new Date(date.getFullYear(), 0, 1);

    // Calculate the difference in days between the date and the start of the year
    const daysDifference = Math.floor((date - startOfYear) / (24 * 60 * 60 * 1000)) + 1;

    // Get the week number (ISO week starting on Monday)
    const weekNumber = Math.ceil(daysDifference / 7);

    return weekNumber;
}

import moment from 'moment';
import { faTintSlash } from '@fortawesome/free-solid-svg-icons';
import ModalFooter from 'reactstrap/lib/ModalFooter';
import striptags from 'striptags';
import UserIsNotVerifiedTooltip from '../../../components/UserIsNotVerifiedTooltip';
import { isStringAValidNumber } from '../../../components/TwoFactorAuthModal';
import { validateSocialSecurityNumber } from '../../patients/searchEnterprise';
import AddSecondParentModal from '../../../components/addSecondParentModal';
import PhoneField from '../../../components/forms/fields/phone';
import EventMeetingsModal from '../../../components/eventMeetingsModal';
import { showStatusHistoryButton } from '../../../helpers/referral-statuses';
import ReferralStatusHistoryModal from '../../../components/referralStatusHistoryModal';
import { CalendarLegend, getBackgroundColorForEvent, getTextColor } from '../../../helpers/colors';
import PatientNotesPreview from '../../../components/patientNotesPreview';

import ErrorModalV2 from '../../../components/errorModal_v2';
import { checkRescheduleData } from '../../egenRemiss/helper';
import RecurringDescription from '../RecurringDescription';
import PaymentMethodsField from '../../payments/components/paymentMethodsField';
import EventPreviewPaymentField from '../../payments/components/eventPreviewPaymentField';
import VisitCancellation from '../../payments/components/visitCancellation';
import { getExtendedPaymentManagement } from '../../payments/helper';
import WebDocInfo from '../../calendar/components/webDocInfo';
import { checkContinuesEarlierOrLaterEvents, isDurationHideCheckboxAvailable } from '../helper';
import AddNewAdministrativeBookingButton from '../../calendar/administrativeBookings/addNewAdministrativeBookingButton';
import UpdateAdministrativeBooking from '../../calendar/administrativeBookings/updateAdministrativeBooking';
import ErrorModal from '../../../components/errorModal';
import { checkIsJournalEnabled } from '../../../helpers/journal.helper';

function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
function truncateString(str) {
    if (str.length > 210) {
        return str.substring(0, 210) + '...';
    }
    return str;
}

function hexToRgba(hex, alpha = 1) {
    hex = hex.replace(/^#/, '');

    if (hex.length === 3) {
        hex = hex.split('').map(char => char + char).join('');
    }

    const bigint = parseInt(hex, 16);
    const red = (bigint >> 16) & 255;
    const green = (bigint >> 8) & 255;
    const blue = bigint & 255;

    return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
}


const localizer = momentLocalizer(moment)

function pad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

/**
* @typedef {{
    *  id: string;
    *  title?: string;
    *  status?: string;
    *  fullName: string;
    *  dob: string;
    *  gender: string;
    *  email?: string;
    *  phones?: { phoneType: string; phoneNumber: string; }[];
    *  address?: { address?: string; city?: string; postcode?: string; };
    *  numbers?: { id: string; name: string; value: string; }[];
    *  relatedAccounts?: {
    *  relationshipId: string;
    *  relationshipType: ('FAMILY' | 'EMERGENCY_CONTACT' | 'NEXT_OF_KIN' | 'INSURER' | 'PRACTITIONER' | 'PAYER' | 'REFERRING_CLINICIAN' | 'OTHER' | 'GP' | 'PARENT_GUARDIAN' | 'SOCIAL_WORKER' | 'SPOUSE_PARTNER' | 'PHARMACY' | 'ANAESTHETIST');
    *  relationshipLabel: string;
    *  deleted: boolean;
    *  contactDetails: {
    *   relatedAccountId?: string | null;
    *   source?: string | null;
    *   sourceId?: string | null;
    *   firstName?: string | null;
    *   lastName?: string | null;
    *   phones?: { phoneType: string; phoneNumber: string; }[];
    *   email?: string | null;
    *   address?: string | null;
    *   city?: string | null;
    *   postcode?: string | null;
    *   country?: string | null;
    *   name?: string | null;
    *   contactInfo?: string | null;
    *  };
    * }[];
    * }} SemblePatient
    */



const tcDoctorTitles = ['practitioner', 'performer'];

const USE_FILTER_V2 = true;

const loadDataWithQuery = [
    (fetchFunction, lang, match, query) => {

        let queryFields = {};
        for (var key in query) {
            if (key && key.indexOf('query-') === 0) {
                queryFields[key.replace('query-', '')] = query[key];
            }
        }

        return fetchFunction(API_ENDPOINT + '/working-hours/web-booking-forms', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                group: query.group,
                doctor: query.doctor,
                clinic: query.clinic
            })
        }).then(parseJSON).then(({ result, status }) => {
            if (status >= 200 && status < 300)
                return {
                    webBookingForms: result
                }
        })

    },
    (fetchFunction, lang, match, query) => {

        return fetchFunction(API_ENDPOINT + '/working-hours/events', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                doctor: query.doctor,
                clinic: query.clinic,
                group: query.group,
                day: query.day,
                view: query.view

            })
        }).then(parseJSON).then(({ result, status }) => {
            if (status >= 200 && status < 300) {
                let events = result?.events ?? [];
                if (query.view == 'month' && events && events.length) {
                    let dateStart = new Date(query.day)
                    let dateEnd = new Date(query.day)
                    dateEnd = new Date(dateEnd.getFullYear(), dateEnd.getMonth() + 1, 0);
                    dateStart.setHours(0, 0, 0, 0)
                    dateEnd.setHours(23, 59, 59, 0)
                    let dateStartTs = Math.floor(new Date(dateStart).getTime() / 1000) - 24 * 60 * 60 * 7;
                    let dateEndTs = Math.floor(new Date(dateEnd).getTime() / 1000) + 24 * 60 * 60 * 7;

                    let obj = {
                        title: 'Temporary event',
                        doctor: query.doctor,
                        type: "temporaryEvent",
                        clinic: query.clinic,
                        group: query.group,
                    }
                    for (let i = dateStartTs; i < dateEndTs; i += 24 * 60 * 60) {
                        let start = i;
                        let end = i + 24 * 60 * 60 - 1;
                        if (events.filter(el => el.startTime >= start && el.startTime <= end && el.group == query.group && !el.reserved).length == 0) {
                            let date = new Date(i * 1000)
                            date.setHours(4, 0, 0, 0)
                            obj.startTime = Math.floor(new Date(date).getTime() / 1000)
                            obj.endTime = Math.floor(new Date(date).getTime() / 1000) + 60 * 15;
                            events.push({ ...obj })
                            events.push({ ...obj })
                        }
                    }
                }
                return {
                    items: events,
                    daysWithDuplicate: result?.daysWithDuplicate ?? []
                }
            }


        })

    },

    (fetchFunction, lang, match, query) => {


        return fetchFunction(API_ENDPOINT + '/languages', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                sortType: 1,
                sortField: 'key',
                query: {}
            })
        }).then(parseJSON).then(({ result, status }) => {
            if (status >= 200 && status < 300)
                return {
                    languages: result
                }
        })

    },
]

class DoctorWorkingHoursComponent extends Component {
    constructor(props) {
        super(props);
        this.player = React.createRef();
        this.player2 = React.createRef();
        this.state = {
            ...props.initialData,
            form: false,
            useState: false,
            params: {
                entries: 10,
                page: 0
            },
            items: [],
            total: 0,
            loading: true,
            activeRevisitForm: 1,
            step: 15,
            referrals: [],
            view: typeof window != 'undefined' && window.innerWidth < 768 ? 'day' : 'month',
            searchItemNumber: 0,
            day: new Date(),
            doctorsList: [],
            errorAdditionalDoctors: null,
            visitReasons: [],
            revisitForms: [],
            revisitFormsSelected: [],
            revisitFormsSelect: [],
            daysWithDuplicate: [],
            journalNoteFormSelected: null,
            webBookingForms: [],
            selectOpen: false,
            creatingEvent: false,
            searchByNameAndEmail: false,
            // currentDateForDay: new Date()
            referralToOpen: props?.[0]?.location?.state?.referralToOpen || null,
            selectOptions: {
                instances: [],
                gap: []
            },

            filterV2: '',
            isFilterV2InFocus: false,
            changedMinOrMax: true,
            holidayEvents: [],
            meetingParticipantsList: [],
            socialSecurityNumberExist: false,
            showWebBookingForms: true,
            lastSerach: null,
            doctors: [],
        };
        this.state.min = new Date();
        this.state.min.setHours(7, 0, 0)
        this.state.max = new Date();
        this.state.max.setHours(18, 0, 0)

        this.state.minTransferDoctor = new Date();
        this.state.minTransferDoctor.setHours(7, 0, 0)
        this.state.maxTransferDoctor = new Date();
        this.state.maxTransferDoctor.setHours(18, 0, 0)
    }
    checkMeeting = () => {
        const eventId = this.state.updateEvent?.id ?? this.state.updateEvent?._id;
        if (eventId) {
            fetch(API_ENDPOINT + '/meetings/calendar/event/' + eventId, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(res => res.json()).then((result) => {
                if (result?.meeting?._id) {
                    let updateEvent = this.state.updateEvent;
                    let prevUpdateEvent = this.state.prevUpdateEvent;
                    updateEvent.meeting = result.meeting;
                    if (prevUpdateEvent) {
                        prevUpdateEvent.meeting = { ...result.meeting };
                    }
                    if (result.meeting?.guests) {
                        updateEvent.guests = result.meeting.guests;
                        if (prevUpdateEvent) {
                            prevUpdateEvent.guests = [...result.meeting.guests];
                        }
                    }
                    if (result.meeting?.colleagues && this.state.updateEvent?.type === 'event') {
                        updateEvent.colleagues = result.meeting.colleagues;
                        if (prevUpdateEvent) {
                            prevUpdateEvent.colleagues = [...result.meeting.colleagues];
                        }
                    }
                    this.setState({ updateEvent, prevUpdateEvent });
                }
            })
        }
    }
    showPlayer = () => {
        this.setState({
            showPlayer: true,
        });
    };

    hidePlayer = () => {
        this.setState({
            showPlayer: false,
        });
    };
    stopAnimation = () => {
        this.player.current.play();
    };

    setWorkingTimeConfig = () => {
        let obj = {

        };
        obj.min = new Date();
        obj.min.setHours(7, 0, 0)
        obj.max = new Date();
        obj.max.setHours(18, 0, 0)

        obj.min = new Date(this.props.getStringDateTs(Math.floor(new Date(obj.min).getTime() / 1000), 'MM/DD/YYYY HH:mm'))
        obj.max = new Date(this.props.getStringDateTs(Math.floor(new Date(obj.max).getTime() / 1000), 'MM/DD/YYYY HH:mm'))



        if (this.props.uData && this.props.uData.workingTimeConfig && this.props.uData.workingTimeConfig[this.props.selectedGroup] && this.props.uData.workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic]) {

            obj = this.props.uData.workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic];

            let minTime = obj.min;
            obj.min = new Date();
            obj.min.setHours(new Date(minTime).getHours(), new Date(minTime).getMinutes(), 0)
            let maxTime = obj.max;
            obj.max = new Date();
            obj.max.setHours(new Date(maxTime).getHours(), new Date(maxTime).getMinutes(), 0)
            obj.freeMin = new Date(obj.min)
            obj.freeMax = new Date(obj.max)
        } else if (this.props.uData && this.props.selectedGroup && this.props.selectedClinic) {
            let selectedGroupIdx = -1;
            if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
                for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                    if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                        selectedGroupIdx = i;
                        break;
                    }
                }
            }
            if (selectedGroupIdx !== -1) {
                if (this.props.uData.clinicGroups && this.props.uData.clinicGroups[selectedGroupIdx] && this.props.uData.clinicGroups[selectedGroupIdx].bookingSettings) {
                    const bookingSettings = this.props.uData.clinicGroups[selectedGroupIdx].bookingSettings;

                    if (bookingSettings?.workingHours && bookingSettings.workingHours[this.props.selectedClinic] && bookingSettings?.workingHours[this.props.selectedClinic].min && bookingSettings?.workingHours[this.props.selectedClinic].max) {

                        obj.min = new Date(this.props.getStringDateTs(Math.floor(new Date(bookingSettings?.workingHours[this.props.selectedClinic].min).getTime() / 1000), 'MM/DD/YYYY HH:mm'))
                        obj.max = new Date(this.props.getStringDateTs(Math.floor(new Date(bookingSettings?.workingHours[this.props.selectedClinic].max).getTime() / 1000), 'MM/DD/YYYY HH:mm'))

                    }

                }
            }

        }

        this.setState({
            ...obj
        })

    }

    getTsWithZeroSec = (ts) => {

        let formatedTs = moment.unix(ts).format('MM/DD/YYYY HH:mm');
        if (formatedTs) {
            ts = Math.floor(new Date(formatedTs).getTime() / 1000)
        }

        return ts;
    }

    get = () => {
        this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));

        for (let i = 0; i < this.props.loadData.length; i++) {
            this.props.loadData[i](window.fetch, this.props.lang, this.props[0].match, this.state.useState ? this.state.params : getSearchParams(this.props[0].location.search, { entries: 10, page: 0, group: this.props.selectedGroup, clinic: this.props.selectedClinic, doctor: this.props.uData._id, filter: this.state.searchVisitReason ? this.state.searchVisitReason : this.state.selectRevisitForm ? this.state.searchRevisitForm : '', day: this.state.day ? new Date(this.props.getStringDateInverseTsV1(Math.floor(new Date(this.state.day).getTime() / 1000 + 60 * 60), 'MM/DD/YYYY HH:mm')) : new Date(this.props.getStringDateInverseTsV1(Math.floor(new Date().getTime() / 1000), 'MM/DD/YYYY HH:mm')), view: this.state.view })).then((data) => {
                this.setState({
                    ...data,
                    loading: null
                }, () => {
                    this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
                })
            })
        }
        for (let i = 0; i < loadDataWithQuery.length; i++) {
            loadDataWithQuery[i](window.fetch, this.props.lang, this.props[0].match, this.state.useState ? this.state.params : getSearchParams(this.props[0].location.search, { entries: 10, page: 0, group: this.props.selectedGroup, clinic: this.props.selectedClinic, doctor: this.state.doctor ? this.state.doctor : this.props.uData._id, filter: this.state.searchVisitReason ? this.state.searchVisitReason : this.state.selectRevisitForm ? this.state.searchRevisitForm : '', day: this.state.day ? new Date(this.props.getStringDateInverseTsV1(Math.floor(new Date(this.state.day).getTime() / 1000 + 60 * 60), 'MM/DD/YYYY HH:mm')) : new Date(this.props.getStringDateInverseTsV1(Math.floor(new Date().getTime() / 1000), 'MM/DD/YYYY HH:mm')), view: this.state.view }), this.props.getStringDateTs).then((data) => { // + 60 * 60 zbog promjene vremenske zone kod zimskog racunanja vremena
                this.setState({
                    ...data,
                    loading: null,
                    loadingDoctor: false
                }, () => {
                    try {
                        if (this.state.referralToOpen && this.state.events?.length > 0) {
                            let event = this.state.events.find(el => el.referral === this.state.referralToOpen);
                            if (event) {
                                const transformedEvent = this.transformEvent(event);
                                if (transformedEvent) {
                                    this.selectedEvent(transformedEvent);
                                    this.setState({ referralToOpen: null });
                                }
                            }
                        }
                    } catch (err) { }

                    this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
                    checkContinuesEarlierOrLaterEvents(Math.floor(new Date(this.state.min).getTime() / 1000));
                })
            })
        }
        this.setWorkingTimeConfig();

    }

    fetchFromWebDoc = () => {
        fetch(API_ENDPOINT + '/working-hours/webdoc/bookings/fetch', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({ doctor: this.state.doctor ? this.state.doctor : this.props.uData._id, group: this.props.selectedGroup, clinic: this.props.selectedClinic })
        }).then(res => res.json()).then((result) => {
            if (result.error) {
                this.setState({
                    error: result.error.translate(this.props.lang)
                })
            } else {
                this.get()

            }
        })
    }

    googleHolidayEvents = () => {
        this.setState({ holidayEvents: [] }, () => {
            fetch(API_ENDPOINT + '/google/holidays/events/' + this.props.selectedGroup, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.setState({
                        error: result.error.translate(this.props.lang)
                    })
                } else {

                    if (result.items && result.items.length) {
                        let holidayEvents = [...result.items]
                        for (let i = 0; i < holidayEvents.length; i++) {
                            if (holidayEvents[i].date) {
                                let _start = `${holidayEvents[i].date} 08:00`;
                                let _end = `${holidayEvents[i].date} 17:00`;
                                holidayEvents[i].startTime = Math.floor(new Date(_start).getTime() / 1000);
                                holidayEvents[i].endTime = Math.floor(new Date(_end).getTime() / 1000);
                            }
                        }
                        this.setState({ holidayEvents })
                    }

                }
            })
        })

    }
    getDoctors = () => {
        let query = { entries: 10, page: 0, group: this.props.selectedGroup, clinic: this.props.selectedClinic, doctor: this.state.doctor ? this.state.doctor : this.props.uData._id, filter: this.state.searchVisitReason ? this.state.searchVisitReason : this.state.selectRevisitForm ? this.state.searchRevisitForm : '', day: this.state.day ? this.state.day : new Date(), view: this.state.view };
        let queryFields = {};
        for (var key in query) {
            if (key && key.indexOf('query-') === 0) {
                queryFields[key.replace('query-', '')] = query[key];
            }
        }

        fetch(API_ENDPOINT + '/users/subaccounts/doctors', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                page: null,
                entries: null,
                filter: query.filter,
                sortType: query.sortType,
                sortField: query.sortField,
                groupId: query.group,
                clinic: query.clinic,
                query: queryFields
            })
        }).then(res => res.json()).then((result) => {
            if (result) {
                this.setState({ doctors: result })
            }
        })


    }
    getPriceList = () => {
        let query = { entries: 10, page: 0, group: this.props.selectedGroup, clinic: this.props.selectedClinic, doctor: this.state.doctor ? this.state.doctor : this.props.uData._id, filter: this.state.searchVisitReason ? this.state.searchVisitReason : this.state.selectRevisitForm ? this.state.searchRevisitForm : '', day: this.state.day ? this.state.day : new Date(), view: this.state.view };
        let queryFields = {};
        for (var key in query) {
            if (key && key.indexOf('query-') === 0) {
                queryFields[key.replace('query-', '')] = query[key];
            }
        }

        fetch(API_ENDPOINT + '/users/price-list/all', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({

                group: query.group,
                clinic: query.clinic,
                query: queryFields,
                filter: query.filter
            })
        }).then(res => res.json()).then((result) => {
            if (result) {
                this.setState({ visitReasons: result })
            }
        })

    }
    getRevisitQuestionary = () => {
        let query = { entries: 10, page: 0, group: this.props.selectedGroup, clinic: this.props.selectedClinic, doctor: this.state.doctor ? this.state.doctor : this.props.uData._id, filter: this.state.searchVisitReason ? this.state.searchVisitReason : this.state.selectRevisitForm ? this.state.searchRevisitForm : '', day: this.state.day ? this.state.day : new Date(), view: this.state.view };
        let queryFields = {};
        for (var key in query) {
            if (key && key.indexOf('query-') === 0) {
                queryFields[key.replace('query-', '')] = query[key];
            }
        }


        fetch(API_ENDPOINT + '/data/revisit-questionary/all', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({

                group: query.group,
                clinic: query.clinic,
                query: queryFields,
                filter: query.filter
            })
        }).then(res => res.json()).then((result) => {
            if (result) {
                this.setState({ revisitForms: result })
            }
        })

    }
    getAllReferrals = () => {
        let query = { entries: 10, page: 0, group: this.props.selectedGroup, clinic: this.props.selectedClinic, doctor: this.state.doctor ? this.state.doctor : this.props.uData._id, filter: this.state.searchVisitReason ? this.state.searchVisitReason : this.state.selectRevisitForm ? this.state.searchRevisitForm : '', day: this.state.day ? this.state.day : new Date(), view: this.state.view };
        let queryFields = {};
        for (var key in query) {
            if (key && key.indexOf('query-') === 0) {
                queryFields[key.replace('query-', '')] = query[key];
            }
        }


        fetch(API_ENDPOINT + '/referrals/all', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                doctor: query.doctor,
                group: query.group,
                clinic: query.clinic,
                sortType: query.sortType,
                sortField: query.sortField,
                lang: lang
            })
        }).then(res => res.json()).then((result) => {
            if (result) {
                this.setState({ referrals: result, referralsFetched: true })
            }
        })


    }


    initialGet = (reset = false) => {

        this.getDoctors()
        this.getPriceList()
        this.getRevisitQuestionary()
        if (reset) {
            this.setState({ referrals: [], referralsFetched: false })
        }
        // this.getAllReferrals()


    }
    checkToday = () => {
        if (typeof window !== 'undefined') {
            let check = document.getElementsByClassName('rbc-now');
            if (check && check.length) {
                for (let i = 0; i < check.length; i++) {
                    if (check && check[i] && check[i].children && check[i].children[0] && check[i].children[0].innerHTML) {
                        let calendarToday = Number(check[i].children[0].innerHTML);
                        let today = this.props.getStringDateTs(Math.floor(new Date().getTime() / 1000), 'DD')
                        if (today) {
                            today = Number(today);
                        }
                        if (calendarToday !== today) {
                            document.getElementsByClassName('rbc-now')[i].className = document.getElementsByClassName('rbc-now')[i].className.replace(/rbc-now/, '');
                        }
                    }
                }
            }


            let checkToday = document.getElementsByClassName('rbc-today');
            if (checkToday && checkToday.length) {
                for (let i = 0; i < checkToday.length; i++) {
                    if (checkToday && checkToday[i] && checkToday[i].className && checkToday[i].className.indexOf('rbc-today') !== -1) {
                        let checkString = `date_${this.props.getStringDateTs(Math.floor(new Date().getTime() / 1000), 'YYYY-MM-DD')}_date`;
                        if (checkToday[i].className.indexOf(checkString) === -1) {
                            document.getElementsByClassName('rbc-today')[i].className = document.getElementsByClassName('rbc-today')[i].className.replace(/rbc-today/, '');
                        }

                    }
                }
            }


        }

    }






    handleResize = () => {
        if (this.checkTodayTimeout) {
            clearTimeout(this.checkTodayTimeout)
        }
        this.checkTodayTimeout = setTimeout(() => {
            this.checkToday()
        }, 400);

        if (typeof window != 'undefined' && window.innerWidth < 768 && !['day', 'agenda'].includes(this.state.view)) {
            this.setState({
                view: 'day'
            }, () => {
                this.get()
                this.checkLinkParams();

            })
        }

    }
    fetchAvailabilityTemplates = () => {
        this.setState({ availabilityTemplates: [] }, () => {
            fetch(API_ENDPOINT + '/data/availability-templates/data/fetch', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    userId: this.state.doctor ? this.state.doctor : this.props.uData?._id,
                    groupId: this.props.selectedGroup,
                    clinicId: this.props.selectedClinic
                })
            }).then(parseJSON).then(({ result, status }) => {
                if (result?.items?.length) {
                    this.setState({ availabilityTemplates: result.items })
                }
            })
        })

    }
    checkLinkParams = () => {
        let params = {};
        if (this.state.useState) {
            params = this.state.params;
        } else {
            params = getSearchParams(this.props[0].location.search, { entries: 10, page: 0 })
        }
        if (params?.ts) {
            let ts = params.ts;
            let time = this.props.getStringDateTs(ts, 'MM/DD/YYYY HH:mm');
            if (time) {
                this.setState({
                    day: new Date(time),
                    view: 'day',
                    scroll: true
                }, () => {
                    console.log('day', this.state.day, 'view', this.state.view, 'scroll', this.state.scroll);

                    this.get()
                })
            }

        }
    }
    componentDidMount() {
        if (typeof window !== 'undefined') { window.scrollTo(0, 0); }
        // document.addEventListener('keydown', this.handleEnterPress);

        this.getClinicGroupSettings();
        this.getPossibleMeetingParticipantsList();
        window.addEventListener('resize', this.handleResize)
        // this.googleHolidayEvents()
        this.get();
        this.initialGet()

        // this.getTakeCareAppointments?.();

        // this.fetchFromWebDoc()
        // this.fetchWebDocInterval = setInterval(() => {
        //     this.fetchFromWebDoc()
        // }, 1000 * 30);



        // if(this.state.items){
        //     this.setState({ events: this.state.items })
        // }
        if (this.props[0].location && this.props[0].location.state && this.props[0].location.state.date && this.state.day && this.state.view) {
            this.setState({
                day: new Date(this.props[0].location.state.date),
                view: 'day',
                scroll: true
            }, () => this.get())

        }
        document.addEventListener('mousedown', this.handleClick);

        if (this.props.uData && this.props.socket && !this.state._registerEvents) {
            this.setState({
                _registerEvents: true
            }, () => {
                this.registerEvents();


            })
        } else {
            this.socketInterval = setInterval(() => {
                if (this.props.uData && this.props.socket && !this.state._registerEvents) {
                    if (this.socketInterval) {
                        clearInterval(this.socketInterval)
                    }

                    this.setState({
                        _registerEvents: true
                    }, () => {
                        this.registerEvents();


                    })
                }

            }, 150);
        }
        this.fetchAvailabilityTemplates();
        this.setInitialSelectOptions();

        if (this.props.uData && this.props.uData.calendarStep) {
            this.setState({ step: this.props.uData.calendarStep });
        }

        if (this.props.uData && this.props.uData._id) {
            this.setState({ doctor: this.props.uData._id })
        }

        // if (this.props?.uData?.usersGeneralSettings?.[this.props.selectedGroup]?.[this.props.selectedClinic]?.myCalendar?.view) {
        //     let view = this.props?.uData?.usersGeneralSettings?.[this.props.selectedGroup]?.[this.props.selectedClinic]?.myCalendar?.view;
        //     this.setState({
        //         view
        //     }, () => this.get())
        // }
        if (this.props?.uData?.usersGeneralSettings?.myCalendar?.view) {
            let view = this.props?.uData?.usersGeneralSettings?.myCalendar?.view;
            if (typeof window != 'undefined' && window.innerWidth < 768) {
                if (!['day', 'agenda'].includes(view)) {
                    view = 'day';
                }
            }
            this.setState({
                view
            }, () => {
                this.get()
                this.checkLinkParams();

            })
        } else {
            this.checkLinkParams();

        }


    }
    setInitialSelectOptions = () => {
        let selectOptions = this.state.selectOptions;
        for (let i = 1; i <= 20; i++) {
            selectOptions.instances.push(i)
        }
        for (let i = 0; i <= 90; i += 5) {
            selectOptions.gap.push(i)
        }
        this.setState({ selectOptions })
    }

    onActiveVideoCalls = (data) => {
        let foundVideoCall = false;
        if (data.myVideoCallsDisconnected && Object.keys(data.myVideoCallsDisconnected).length > 0) {
            this.setState({
                offerData: { ...data.myVideoCallsDisconnected }
            })
        }


        foundVideoCall = true;

        if (!foundVideoCall) {
            this.setState({
                offerData: null
            })
        }

    }

    tryOpenApp = (data) => {
        const uid = this.props.uData?._id;
        let bundleId;
        const conversationId = data?.conversation;
        const initiator = data?.initiator;
        if (conversationId) {
            fetch(API_ENDPOINT + '/clinic-groups/check/bundleId', {
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ cid: conversationId })
            }).then(res => res.json()).then((result) => {
                if (result.bundleId) {
                    bundleId = result.bundleId;
                    if (bundleId && conversationId && initiator && uid) {
                        if (bundleId) {
                            try {
                                window.location.replace(`${bundleId}://?conversation=${conversationId}&initiator=${initiator}&uid=${uid}`);
                            } catch (err) { console.log(err) }
                        }
                    }
                }
            });
        }
    }

    answerCall = async (data) => {
        // if (this.state.callInProgress) return;
        this.tryOpenApp(data)

        if (!data?.initiator || !data?.conversation) return;

        if (typeof window === 'undefined') return;

        const initiator = data.initiator;
        const conversationId = data.conversation;


        var strWindowFeatures = `height=${window.innerHeight - 1},width=${window.innerWidth - 1},resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes`;
        let link = `/video-call/${conversationId}?initiator=${initiator}`;
        this.videoCallWindow = window.open(link, "_blank", strWindowFeatures);


        if (this.videoCallWindow) {
            this.videoCallWindow?.addEventListener?.('message',
                (e) => {
                    if (e?.data == 'end-video-call') {
                        this.videoCallWindow?.close?.();
                    }

                }
                , false)
        }
    }

    registerEvents = async () => {

        this.props.socket.on('newEventCreated', (data) => {
            if (data?.error && this.scheduleControlApiCalled) {
                this.setState({ error: data.error.translate(this.props.lang) })
            }
            this.get()
            this.getAllReferrals()
        })

        this.props.socket?.on('isPatientInWaitingRoom', (data) => {
            if (data?.patientId) {
                let waitingRoom = {
                    patientId: data.patientId,
                    patientInWaitingRoom: data.patientInWaitingRoom,
                    patientHasActiveVideoCall: data.activeCall,
                    showInfoWaitingRoom: !data.activeCall && data.patientInWaitingRoom
                }
                this.setState({ waitingRoom })
            } else {
                if (this.state.waitingRoom) {
                    this.setState({ waitingRoom: null })
                }
            }

        })

        this.props.socket.on('endCall', async (data) => {
            this.setState({
                offerData: null
            })

        });

        this.props.socket.on('activeVideoCalls', (data) => this.onActiveVideoCalls(data));

    }
    handleClick = (event) => {
        if (this.state.view == 'month' && event && event.target && event.target.className && event.target.className.indexOf) {
            if (event.target.className.indexOf('rbc-date-cell') != -1) {
                if (event.target.children && event.target.children[0] && event.target.children[0].innerHTML) {
                    let day = new Date(this.state.day);
                    day.setDate(1);
                    let val = event.target.children[0].innerHTML;
                    if (event.target.children[0]?.className === 'week-number-calendar' && event.target.children[0].title) {
                        let title = event.target.children[0].title;
                        let label;
                        if (title?.indexOf('Week-day ') !== -1) {
                            label = title.split('Week-day ')[1];
                        }
                        if (label && parseInt(label) > 0) {
                            val = label;
                        }
                    }
                    if (event.srcElement && event.srcElement.className, event.srcElement && event.srcElement.className.indexOf('rbc-off-range') != -1) {
                        if (Number(val) && Number(val) > 20) {
                            day.setMonth(day.getMonth() - 1)
                        } else {
                            day.setMonth(day.getMonth() + 1)
                        }
                    }
                    day.setDate(Number(val))
                    this.setState({ view: 'day', day: day })
                }

            } else if (event.target.className.indexOf('rbc-day-bg') != -1) {
                let split = event.target.className.split('date_')
                if (split[1]) {
                    let split2 = split[1].split('_date')
                    if (split2[0]) {
                        let day = new Date(split2[0])
                        if (split2[0] && split2[0].split('-') && split2[0].split('-').length > 2) {
                            let dayString = split2[0].split('-')[split2[0].split('-').length - 1]
                            let monthString = split2[0].split('-')[split2[0].split('-').length - 2]
                            if (dayString && Number(dayString))
                                day.setDate(Number(dayString))
                            if (monthString && Number(monthString))
                                day.setMonth(Number(monthString) - 1)
                        }
                        this.setState({ view: 'day', day: day })

                    }

                }
            }
        }

    }

    checkValidateParent2 = () => {
        let parent2Required = false;
        let socialSecurityNumberParent2 = this.props.socialSecurityNumberParent2;
        if (socialSecurityNumberParent2 === '000000000000') {
            socialSecurityNumberParent2 = null;
        }
        if (socialSecurityNumberParent2 || this.props.email2 || this.props.phone2 || this.props.nameParent2) {
            parent2Required = true;
        }
        if (this.state.parent2Required !== parent2Required) {
            this.setState({ parent2Required })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if ((!prevProps?.selectedGroup && this.props.selectedGroup) || (prevProps?.selectedGroup !== this.props.selectedGroup)) {
            this.getClinicGroupSettings();
        }
        if (
            (!prevProps?.selectedGroup && this.props.selectedGroup) || (prevProps?.selectedGroup !== this.props.selectedGroup) ||
            (!prevProps?.selectedClinic && this.props.selectedClinic) || (prevProps?.selectedClinic !== this.props.selectedClinic)
        ) {
            this.getPossibleMeetingParticipantsList();
        }
        this.checkToday()

        if (prevProps[0].location.search != this.props[0].location.search) {
            this.setState({
                loading: true
            }, () => {
                this.get();

            })
        }
        if (prevProps[0].location.pathname != this.props[0].location.pathname) {
            // if (this.fetchWebDocInterval) {
            //     clearInterval(this.fetchWebDocInterval)
            // }
            // this.fetchFromWebDoc()
            // this.fetchWebDocInterval = setInterval(() => {
            //     this.fetchFromWebDoc()
            // }, 1000 * 30);
        }

        if (prevProps.selectedGroup != this.props.selectedGroup || prevProps.selectedClinic != this.props.selectedClinic) {
            this.setWorkingTimeConfig();
            this.get();
            this.initialGet(true)
            this.googleHolidayEvents();
            this.fetchAvailabilityTemplates();
        }

        // if ((!prevProps?.selectedGroup && this.props?.selectedGroup) || (prevProps?.selectedGroup !== this.props?.selectedGroup) || (!prevProps?.selectedClinic && this.props?.selectedClinic) || (prevProps?.selectedClinic !== this.props?.selectedClinic) || (!prevProps?.uData && this.props?.uData) || (String(prevProps?.uData?._id) !== String(this.props?.uData?._id)) || (!prevProps?.hasTakeCare && this.props?.hasTakeCare)) {
        //     this.setState({ takeCareAppointments: null }, () => {
        //         this.getTakeCareAppointments?.();
        //     })
        // }

        if (this.props[0].location && this.props[0].location.state && this.props[0].location.state.day) {
            this.setState({
                day: this.props[0].location.state.day,
                view: 'day',
                scroll: true,
            }, () => {
                this.props[0].history.push({
                    search: '?fromAllCases=true',
                    state: {
                        doctor: null,
                        day: null,
                        step: null,


                    }
                })
                this.get()
            })
        }

        const countrySSN = this.state.countryStateDict?.['socialSecurityNumber'] ?? this.props.country;
        const countrySSNParent1 = this.state.countryStateDict?.['socialSecurityNumberParent'] ?? this.props.country;
        const countrySSNParent2 = this.state.countryStateDict?.['socialSecurityNumberParent2'] ?? this.props.country;
        if (prevProps.socialSecurityNumberParent != this.props.socialSecurityNumberParent && this.props.socialSecurityNumberParent && (this.props.socialSecurityNumberParent.length == 12 || (countrySSNParent1 === 'denmark' && this.props.socialSecurityNumberParent.length == 10))) {
            this.checkUser();
        }

        if (prevProps.socialSecurityNumber !== this.props.socialSecurityNumber) {
            if ((countrySSN === 'denmark' && this.props.socialSecurityNumber?.length === 10) || this.props.socialSecurityNumber?.length === 12) {
                let dateOfBirth = this.props.getDateOfBirthFromSSN(this.props.socialSecurityNumber, countrySSN);
                if (dateOfBirth && this.props.changeDateOfBirth) {
                    this.props.changeDateOfBirth(dateOfBirth)
                    if (!this.state.disabledDateOfBirth) { this.setState({ disabledDateOfBirth: true }) }
                } else {
                    if (this.state.disabledDateOfBirth) { this.setState({ disabledDateOfBirth: false }) }
                }
            } else {
                if (this.state.disabledDateOfBirth) { this.setState({ disabledDateOfBirth: false }) }
            }
        }
        if (prevProps.socialSecurityNumberParent !== this.props.socialSecurityNumberParent) {

            if ((countrySSNParent1 === 'denmark' && this.props.socialSecurityNumberParent?.length === 10) || this.props.socialSecurityNumberParent?.length === 12) {
                let dateOfBirth = this.props.getDateOfBirthFromSSN(this.props.socialSecurityNumberParent, countrySSNParent1);
                if (dateOfBirth && this.props.changeDateOfBirthParent) {
                    this.props.changeDateOfBirthParent(dateOfBirth)
                    if (!this.state.disabledDateOfBirthParent) { this.setState({ disabledDateOfBirthParent: true }) }
                } else {
                    if (this.state.disabledDateOfBirthParent) { this.setState({ disabledDateOfBirthParent: false }) }
                }
            } else {
                if (this.state.disabledDateOfBirthParent) { this.setState({ disabledDateOfBirthParent: false }) }
            }
        }

        if (prevProps.socialSecurityNumberParent2 != this.props.socialSecurityNumberParent2 && this.props.socialSecurityNumberParent2 && ((countrySSNParent2 === 'denmark' && this.props.socialSecurityNumberParent2.length == 10) || this.props.socialSecurityNumberParent2.length == 12)) {
            this.checkUser2();
        }
        if (prevProps.socialSecurityNumberParent2 !== this.props.socialSecurityNumberParent2) {

            if ((countrySSNParent2 === 'denmark' && this.props.socialSecurityNumberParent2?.length === 10) || this.props.socialSecurityNumberParent2?.length === 12) {
                let dateOfBirth = this.props.getDateOfBirthFromSSN(this.props.socialSecurityNumberParent2, countrySSNParent2);
                if (dateOfBirth && this.props.changeDateOfBirthParent) {
                    this.props.changeDateOfBirthParent2(dateOfBirth)
                    if (!this.state.disabledDateOfBirthParent2) { this.setState({ disabledDateOfBirthParent2: true }) }
                } else {
                    if (this.state.disabledDateOfBirthParent2) { this.setState({ disabledDateOfBirthParent2: false }) }
                }
            } else {
                if (this.state.disabledDateOfBirthParent2) { this.setState({ disabledDateOfBirthParent2: false }) }
            }
        }

        if ((prevProps.socialSecurityNumberParent2 !== this.props.socialSecurityNumberParent2) || (prevProps.email2 !== this.props.email2) || (prevProps.phone2 !== this.props.phone2) || (prevProps.nameParent2 !== this.props.nameParent2)) {
            this.checkValidateParent2()
        }

        if (prevState.updateEvent !== this.state.updateEvent) {
            if (this.waitingRoomInterval) clearInterval(this.waitingRoomInterval)
            this.checkWaitingRoom()
            this.waitingRoomInterval = setInterval(() => {
                this.checkWaitingRoom()
            }, 5000);


        }

        if (prevState.updateEvent?.id !== this.state.updateEvent?.id && this.state.updateEvent) {
            this.checkMeeting();
        }

        if ((prevState.min !== this.state.min) || (prevState.max !== this.state.max)) {
            this.setState({
                changedMinOrMax: false
            }, () => {
                this.setState({
                    changedMinOrMax: true
                })
            })
            checkContinuesEarlierOrLaterEvents(Math.floor(new Date(this.state.min).getTime() / 1000));
        }

        const { referralNote, controlNote, scheduleReferral, scheduleControl, updateEvent, referralId } = this.state;

        if (
            prevState.referralNote !== referralNote
            || prevState.controlNote !== controlNote
            || JSON.stringify(prevState.scheduleReferral) !== JSON.stringify(scheduleReferral)
            || prevState.referralId !== referralId
            || JSON.stringify(prevState.scheduleControl) !== JSON.stringify(scheduleControl)
            || JSON.stringify(prevState.updateEvent) !== JSON.stringify(updateEvent)
        ) {
            this.checkPatientNotes();
        }


        if (this.props.setUsersGeneralSettings && this.state.view !== prevState.view) {
            this.props.setUsersGeneralSettings({
                myCalendar: { view: this.state.view }
            })
        }
        if (prevState.scheduleModal && !this.state.scheduleModal && this.state.scheduleNewVisitDropdown) {
            this.setState({ scheduleNewVisitDropdown: false })
        }
    }
    checkWaitingRoom = () => {

        if (this.state.updateEvent?.patientId) {

            let patientId = this.state.updateEvent?.patientId
            let data = {
                patientId: patientId,
                groupId: this.props.selectedGroup
            }
            this.props.socket.emit('isPatientInWaitingRoom', data);

        } else {
            if (this.waitingRoomInterval) clearInterval(this.waitingRoomInterval)
            if (this.state.waitingRoom) {
                this.setState({ waitingRoom: null })
            }
        }


    }

    checkUser2 = () => {
        fetch(API_ENDPOINT + '/users/subaccounts/get', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({ socialSecurityNumber: this.props.socialSecurityNumberParent2, group: this.props.selectedGroup, clinic: this.props.selectedClinic })
        }).then(parseJSON).then(({ result, status }) => {
            if (status == 200 && result && result.userData) {

                // console.log(result)
                // if (result.groupPermissions && result.groupPermissions[this.props.selectedGroup] && result.groupPermissions[this.props.selectedGroup][this.props.selectedClinic] && result.groupPermissions[this.props.selectedGroup][this.props.selectedClinic].indexOf(this.state.doctorIdPermissions) != -1) {
                //     this.setState({ doctorPermissions: true })
                // }

                // this.setState({
                //     form: result
                // }, () => {
                //     if (!result.email) {
                //         this.setState({ changeEmail: true })
                //     }
                this.props.changeNameParent2(result.name);
                this.props.changeEmail2(result.email);
                if (result.userData.sex)
                    this.props.changeSexParent2(result.userData.sex);
                this.props.changeLanguage2(result.language);
                this.props.changePhone2(result.phone);
                // this.setState({ lockFields: true })
                //     })

                // }
                // if (status == 405) {
                //     this.setState({
                //         error: 'The user is forbidden!'.translate(this.props.lang)
                //     })
                //     this.props.changeSocialSecurityNumber('')
            } else {
                this.props.changeNameParent2('');
                this.props.changeEmail2('');
                this.props.changeSexParent2('');
                this.props.changeLanguage2('');
                this.props.changePhone2('');
            }
        })

    }
    checkUser = () => {
        fetch(API_ENDPOINT + '/users/subaccounts/get', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({ socialSecurityNumber: this.props.socialSecurityNumberParent, group: this.props.selectedGroup, clinic: this.props.selectedClinic })
        }).then(parseJSON).then(({ result, status }) => {
            if (status == 200 && result && result.userData) {

                this.props.changeNameParent(result.name);
                this.props.changeEmail(result.email);
                if (result.userData.sex)
                    this.props.changeSexParent(result.userData.sex);
                this.props.changeLanguage(result.language);
                this.props.changePhone(result.phone);
            } else {
                this.props.changeNameParent('');
                this.props.changeEmail('');
                this.props.changeSexParent('');
                this.props.changeLanguage('');
                this.props.changePhone('');
            }
        })

    }
    componentWillUnmount = () => {
        // document.removeEventListener('keydown', this.handleEnterPress);
        if (this.waitingRoomInterval) clearInterval(this.waitingRoomInterval)

        if (this.props.socket) {
            this.props.socket.removeListener('newEventCreated');
            this.props.socket.removeListener('isPatientInWaitingRoom');
            this.props.socket.removeListener('activeVideoCalls', this.onActiveVideoCalls);
            this.props.socket.removeListener('endCall');
        }
        if (this.fetchWebDocInterval) {
            clearInterval(this.fetchWebDocInterval)
        }

        document.removeEventListener('mousedown', this.handleClick);

        document.removeEventListener('resize', this.handleResize);
        if (this.checkTodayTimeout) {
            clearTimeout(this.checkTodayTimeout)
        }
    }


    updateSort = (field, type) => {
        if (this.state.useState) {
            let state = this.state.params;
            state.sortField = field;
            state.sortType = type;
            this.setState({
                params: state
            })
        } else {
            this.props[0].history.push(generateSearchLinkMultiple(this.props[0].location.search, { entries: 10, page: 0 }, [{ name: 'sortField', value: field }, { name: 'sortType', value: type }], false));

        }
    }

    updateParams = (name, value, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };
                obj[name] = value;
                this.setState({ params: obj });
            } else {
                let obj = this.state.params;
                obj[name] = value;
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(generateSearchLink(this.props[0].location.search, { entries: 10, page: 0 }, name, value, restart));
        }
    }
    updateMultipleParams = (fields, restart = false) => {

        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj });

            } else {
                let obj = this.state.params;
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(generateSearchLinkMultiple(this.props[0].location.search, { entries: 10, page: 0 }, fields, restart));
        }
    }
    checkRecurring = (data) => {
        let obj = { ...data }
        let recurringObj = {};
        if (obj.frequencyType) {
            recurringObj.frequencyType = obj.frequencyType;
            delete obj.frequencyType;
        }
        if (obj.frequencyDayText) {
            if (recurringObj.frequencyType == 'day')
                recurringObj.frequencyDayText = obj.frequencyDayText;
            delete obj.frequencyDayText;
        }
        if (obj.frequencyMonthScheduled) {
            if (recurringObj.frequencyType == 'month')
                recurringObj.frequencyMonthScheduled = obj.frequencyMonthScheduled;
            delete obj.frequencyMonthScheduled;
        }
        if (obj.frequencyDayScheduledDateFrom) {
            if (recurringObj.frequencyType == 'day')
                recurringObj.frequencyDayScheduledDateFrom = obj.frequencyDayScheduledDateFrom;
            delete obj.frequencyDayScheduledDateFrom;
        }
        if (obj.frequencyDayScheduledDateTo) {
            if (recurringObj.frequencyType == 'day')
                recurringObj.frequencyDayScheduledDateTo = obj.frequencyDayScheduledDateTo;
            delete obj.frequencyDayScheduledDateTo;
        }
        if (obj.frequencyMonthScheduledDateFrom) {
            if (recurringObj.frequencyType == 'month')
                recurringObj.frequencyMonthScheduledDateFrom = obj.frequencyMonthScheduledDateFrom;
            delete obj.frequencyMonthScheduledDateFrom;
        }
        if (obj.frequencyMonthScheduledDateTo) {
            if (recurringObj.frequencyType == 'month')
                recurringObj.frequencyMonthScheduledDateTo = obj.frequencyMonthScheduledDateTo;
            delete obj.frequencyMonthScheduledDateTo;
        }
        if (obj.frequencyWeekScheduledDateFrom) {
            if (recurringObj.frequencyType == 'week')
                recurringObj.frequencyWeekScheduledDateFrom = obj.frequencyWeekScheduledDateFrom;
            delete obj.frequencyWeekScheduledDateFrom;
        }
        if (obj.frequencyWeekScheduledDateTo) {
            if (recurringObj.frequencyType == 'week')
                recurringObj.frequencyWeekScheduledDateTo = obj.frequencyWeekScheduledDateTo;
            delete obj.frequencyWeekScheduledDateTo;
        }
        if (obj.checkedMonday) { if (recurringObj.frequencyType == 'week') recurringObj.checkedMonday = obj.checkedMonday; delete obj.checkedMonday; }
        if (obj.checkedTuesday) { if (recurringObj.frequencyType == 'week') recurringObj.checkedTuesday = obj.checkedTuesday; delete obj.checkedTuesday; }
        if (obj.checkedWednesday) { if (recurringObj.frequencyType == 'week') recurringObj.checkedWednesday = obj.checkedWednesday; delete obj.checkedWednesday; }
        if (obj.checkedThursday) { if (recurringObj.frequencyType == 'week') recurringObj.checkedThursday = obj.checkedThursday; delete obj.checkedThursday; }
        if (obj.checkedFriday) { if (recurringObj.frequencyType == 'week') recurringObj.checkedFriday = obj.checkedFriday; delete obj.checkedFriday; }
        if (obj.checkedSaturday) { if (recurringObj.frequencyType == 'week') recurringObj.checkedSaturday = obj.checkedSaturday; delete obj.checkedSaturday; }
        if (obj.checkedSunday) { if (recurringObj.frequencyType == 'week') recurringObj.checkedSunday = obj.checkedSunday; delete obj.checkedSunday; }

        obj.recurringObj = recurringObj;
        return obj;
    }
    scheduleTemplate = (data) => {
        let date = data.date;
        if (data.recurring) {
            if (data.frequencyType == 'day') {
                date = data.frequencyDayScheduledDateFrom;
            } else if (data.frequencyType == 'week') {
                date = data.frequencyWeekScheduledDateFrom;
            } else if (data.frequencyType == 'month') {
                date = data.frequencyMonthScheduledDateFrom;
            }
        }
        let checkDate = new Date(date.replace(/-/g, "/") + ' ' + data.startTime);
        let today = new Date();
        if (data && data.recurring) {
            data = this.checkRecurring(data);
        }
        if (checkDate >= today) {
            this.setState({
                loadingScheduleEvent: true
            }, () => {
                let title = data?.title?.trim();
                if (!title || title === '') {
                    title = null;
                }
                let obj = {
                    startEventReservedDateOriginal: date + ' ' + data.startTime,
                    // endEventReservedDateOriginal: date + ' ' + data.endTime,
                    startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                    // endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                    doctor: this.state.doctor ? this.state.doctor : this.props.uData._id,
                    group: this.props.selectedGroup,
                    clinic: this.props.selectedClinic,
                    recurring: data.recurring,
                    recurringObj: data.recurringObj,
                    title: title,
                    // colleagues: data.colleagues,
                    selectedAvailabilityTemplate: data.selectedAvailabilityTemplate,
                    scheduleKey: data.scheduleKey
                }

                fetch(API_ENDPOINT + '/working-hours/schedule/template', {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(obj)
                }).then(res => res.json()).then((result) => {
                    if (result.error) {
                        this.setState({
                            error: result.error.translate(this.props.lang),
                            loadingScheduleEvent: false
                        })
                    } else {
                        // this.get()
                        if (result?.notInserted?.length > 0) {
                            this.setState({
                                error: 'One or more instances could not be created due to conflicts with existing events'.translate(this.props.lang),
                            })
                        }
                        this.setState({
                            scheduleModal: null,
                            scheduleEvent: null,
                            schedulePatientTime: null,
                            recurringModal: null,
                            loadingScheduleEvent: false,
                            updateEventTemplateModal: null
                        }, () => {
                            this.get()
                        })
                    }

                    this.setState({
                        creatingEvent: false
                    })

                })
            })
        } else {
            this.setState({
                wrongDate: true,
                creatingEvent: false
            })
        }
    }

    /**
    * Schedule doctor events on calendar
    * @author   Stefan Pantic
    * @Objectparam    {String} date           date when event start
    * @Objectparam    {Number} startTime      start time for event
    * @Objectparam    {Number} endTime        start time for event
    * @Objectparam    {String} doctor         doctor id
    * @Objectparam    {String} group          group id
    * @Objectparam    {String} clinic         clinic id
    * @Objectparam    {String} title          title for event
    */
    scheduleEvent = (data, forceInsert = false) => {
        let _data = JSON.parse(JSON.stringify(data));
        let date = data.date;
        if (data.recurring) {
            if (data.frequencyType == 'day') {
                date = data.frequencyDayScheduledDateFrom;
            } else if (data.frequencyType == 'week') {
                date = data.frequencyWeekScheduledDateFrom;
            } else if (data.frequencyType == 'month') {
                date = data.frequencyMonthScheduledDateFrom;
            }
        }
        let checkDate = new Date(date.replace(/-/g, "/") + ' ' + data.startTime);
        let today = new Date();
        if (data && data.recurring) {
            data = this.checkRecurring(data);
        }
        if (checkDate < today && (!this.state.wrongDateModal || this.state.wrongDateModal.function !== 'scheduleEvent')) {
            this.setState({
                wrongDateModal: {
                    data: data,
                    forceInsert: forceInsert,
                    function: 'scheduleEvent'
                }
            }, () => {
                return;
            })
        } else {
            this.setState({
                wrongDateModal: null
            })
            // if (checkDate >= today) {
            this.setState({
                loadingScheduleEvent: true,
                errorOverlap: false
            }, () => {

                fetch(API_ENDPOINT + '/working-hours/new', {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        startEventReservedDateOriginal: data.date + ' ' + data.startTime,
                        endEventReservedDateOriginal: data.date + ' ' + data.endTime,
                        startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                        endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                        doctor: this.state.doctor ? this.state.doctor : this.props.uData._id,
                        title: data.title,
                        group: this.props.selectedGroup,
                        clinic: this.props.selectedClinic,
                        recurring: data.recurring,
                        recurringObj: data.recurringObj,
                        title: data.title ? data.title : 'Event',
                        colleagues: data.colleagues,
                        forceInsert: forceInsert,
                        wrongDate: checkDate >= today,
                    })
                }).then(res => res.json()).then((result) => {
                    if (result.errorOverlap) {
                        this.setState({
                            errorOverlap: {
                                _data: _data
                            },
                            loadingScheduleEvent: false
                        })
                    } else if (result.error) {
                        this.setState({
                            error: result.error.translate(this.props.lang),
                            loadingScheduleEvent: false
                        })
                    } else {
                        // this.get()
                        this.setState({
                            scheduleModal: null,
                            scheduleEvent: null,
                            schedulePatientTime: null,
                            recurringModal: null,
                            // view: 'week',
                            // day: new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime),
                            // scroll: true,
                            loadingScheduleEvent: false
                        }, () => {
                            this.get()
                        })
                    }

                    this.setState({
                        creatingEvent: false
                    })

                })
            })
        }
        // } else {
        //     this.setState({
        //         wrongDate: true,
        //         creatingEvent: false
        //     })
        // }

    }
    markAsAvailable = (data) => {
        let date = data.date;
        if (data.recurring) {
            if (data.frequencyType == 'day') {
                date = data.frequencyDayScheduledDateFrom;
            } else if (data.frequencyType == 'week') {
                date = data.frequencyWeekScheduledDateFrom;
            } else if (data.frequencyType == 'month') {
                date = data.frequencyMonthScheduledDateFrom;
            }
        }
        let checkDate = new Date(date.replace(/-/g, "/") + ' ' + data.startTime);
        let today = new Date();

        if (data && data.recurring) {
            data = this.checkRecurring(data);
        }

        if (checkDate >= today) {
            this.setState({
                loading: true
            }, () => {

                fetch(API_ENDPOINT + '/working-hours/patient-time-available/new', {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        startEventReservedDateOriginal: data.date + ' ' + data.startTime,
                        endEventReservedDateOriginal: data.date + ' ' + data.endTime,
                        startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                        endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                        doctor: this.state.doctor ? this.state.doctor : this.props.uData._id,
                        group: this.props.selectedGroup,
                        clinic: this.props.selectedClinic,
                        recurring: data.recurring,
                        recurringObj: data.recurringObj,
                        title: data.title ? data.title : 'Available for booking',
                        allActiveForms: data.allActiveForms ? data.allActiveForms : false,
                        eventForms: data.eventForms ? data.eventForms : [],
                        selectedEventDepartments: data.selectedEventDepartments ? data.selectedEventDepartments : [],
                    })
                }).then(res => res.json()).then((result) => {
                    if (result.error) {
                        this.setState({
                            error: result.error.translate(this.props.lang),
                            loading: false,
                        })
                    } else {
                        // this.get()
                        this.setState({
                            scheduleModal: null,
                            markAsAvailable: null,
                            recurringModal: null,
                            schedulePatientTime: null,
                            // view: 'week',
                            // day: new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime),
                            // scroll: true,
                            loading: false

                        }, () => {
                            this.get()
                        })
                    }

                    this.setState({
                        creatingEvent: false
                    })

                })
            })
        } else {
            this.setState({
                wrongDate: true,
                creatingEvent: false
            })
        }
    }

    /**
    * Schedule control events for patients on calendar
    * @author   Stefan Pantic
    * @Objectparam    {String} date                 date when event start
    * @Objectparam    {Number} startTime            start time for event
    * @Objectparam    {Number} endTime              start time for event
    * @Objectparam    {String} doctor               doctor id
    * @Objectparam    {String} group                group id
    * @Objectparam    {String} clinic               clinic id
    * @Objectparam    {String} title                title for event
    * @Objectparam    {String} socialSecurityNumber patient socialSecurityNumber
    * @Objectparam    {String} patientControlNote   event note
    */
    scheduleControl = (data, checkPreScheduleInfo = false) => {
        if (Number(data.visitReasonPrice) > 0 && Number(data._visitReasonPrice) === 0 && this.state.isPaymentMethodErrorShow) {
            this.setState({ showPaymentMethodError: true, creatingEvent: false });
            return;
        }
        const _data = JSON.parse(JSON.stringify(data));
        let checkDate = new Date(data?.date?.replace(/-/g, "/") + ' ' + data?.startTime);
        let today = new Date();


        if (checkDate < today && (!this.state.wrongDateModal || this.state.wrongDateModal.function !== 'scheduleControl')) {
            this.setState({
                wrongDateModal: {
                    data: data,
                    checkPreScheduleInfo: checkPreScheduleInfo,
                    function: 'scheduleControl'
                }
            }, () => {
                return;
            })
        } else {
            this.setState({
                wrongDateModal: null
            })


            let templateData;
            if (data.templateData) {
                templateData = {};
                templateData._id = data.templateData?.id;
                templateData.scheduleKey = data.templateData?.scheduleKey;
                if (data.templateData?.startTime !== data.startTime || data.templateData?.endTime !== data.endTime) {
                    templateData.startTime = data.templateData?.startTime;
                    templateData.endTime = data.templateData?.endTime;
                    templateData.changedTime = true;
                }

            }

            data.journalNoteFormSelected = this.state.journalNoteFormSelected;
            if (data.controlSchedule) {
                data.patientControlNote = data.patientNote;
                data.title = data.controlSchedule.event && data.controlSchedule.event.title;
                data.socialSecurityNumber = data.controlSchedule.patient ? data.controlSchedule.patient.socialSecurityNumber : '';
                data.visitReasonOnline = data.controlSchedule.event && data.controlSchedule.event.visitReasonOnline;
                data.videoCall = data.controlSchedule.event && data.controlSchedule.event.videoCall;
                data.titleDoctor = '';
                data.revisitForms = data.controlSchedule.event && data.controlSchedule.event.revisitForms;
                data.visitReasonName = data.controlSchedule.event && data.controlSchedule.event.visitReasonName;
                data.visitReasonPrice = data.controlSchedule.event && data.controlSchedule.event.questionaryPrice ? data.controlSchedule.event.questionaryPrice : 0;
                data.visiReason = data.controlSchedule.event && data.controlSchedule.event.visiReason;
                data.hideTimeFromThePatient = data.controlSchedule.event && data.controlSchedule.event.hideTimeFromThePatient;
                // data.hideDurationForPatient = data.controlSchedule.event && data.controlSchedule.event.hideDurationForPatient;
                data.closeCaseManually = data.controlSchedule.event && data.controlSchedule.event.closeCaseManually;
                data.referralExists = data.controlSchedule ? data.controlSchedule._id : '';
                data.appointmentPaid = data.controlSchedule?.event?.appointmentPaid ? data.controlSchedule.event.appointmentPaid : false;
                data.revisitFormsArray = data.controlSchedule?.event?.revisitFormsArray ? data.controlSchedule.event.revisitFormsArray : [];
                data.journalNoteFormSelected = data.controlSchedule?.event?.journalNoteFormSelected ? data.controlSchedule.event.journalNoteFormSelected : null;
                data.visitReasonOnline = data.controlSchedule?.event?.onlineVisit ? data.controlSchedule.event.onlineVisit : false;
                data.selectedParents = data.controlSchedule?.event?.selectedParents ?? null;
                data.rescheduleRevisit = data.rescheduleRevisit ? true : false;
            }
            let noteToPatient;
            if (data?.noteToPatient?.trim()) {
                noteToPatient = {
                    note: data.noteToPatient,
                    sendNoteAsPatientNotification: data.sendNoteAsPatientNotification ? true : false
                }

                if (data.sendNoteAsPatientNotification && !checkPreScheduleInfo) {
                    this.setState({ noteToPatientPreScheduleInfo: { data: _data } })
                    return;
                }
            }



            // if (checkDate >= today) {
            this.setState({
                loading: true
            }, () => {
                this.scheduleControlApiCalled = true;
                fetch(API_ENDPOINT + '/working-hours/control', {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        startEventReservedDateOriginal: data.date + ' ' + data.startTime,
                        endEventReservedDateOriginal: data.date + ' ' + data.endTime,
                        startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                        endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                        title: data.title,
                        socialSecurityNumber: data.socialSecurityNumber,
                        doctor: this.state.doctor ? this.state.doctor : this.props.uData._id,
                        group: this.props.selectedGroup,
                        clinic: this.props.selectedClinic,
                        patientControlNote: data.patientControlNote,
                        onlineVisit: data.visitReasonOnline,
                        videoCall: data.videoCall,
                        additionalDoctors: data.additionalDoctors,
                        titleDoctor: data.titleDoctor,
                        revisitForms: data.revisitForms ? data.revisitForms : this.state.revisitFormsSelected,
                        visitReasonName: data.visitReasonName,
                        visitReasonPrice: data.visitReasonPrice,
                        visiReason: data.visiReason,
                        freePayment: data.freePayment,
                        hideTimeFromThePatient: data.hideTimeFromThePatient,
                        hideDurationForPatient: data.hideDurationForPatient,
                        closeCaseManually: data.closeCaseManually,
                        referralExists: data.referralExists ? data.referralExists : null,
                        appointmentPaid: data.appointmentPaid ? data.appointmentPaid : false,
                        revisitFormsArray: data.revisitFormsArray ? data.revisitFormsArray : [],
                        journalNoteFormSelected: data.journalNoteFormSelected,
                        rescheduleRevisit: data.rescheduleRevisit,
                        selectedParents: data.selectedParents,
                        guests: data.guests,
                        templateData: templateData,
                        noteToPatient: noteToPatient,
                        wrongDate: checkDate >= today,
                        paymentMethods: data.paymentMethods,
                        attachedInvoice: data.attachedInvoice,
                        _visitReasonPrice: data?._visitReasonPrice
                        // patientControlNote: data.patientControlNote,

                    })
                }).then(res => res.json()).then((result) => {
                    if (result.error) {
                        this.setState({
                            error: result.error.translate(this.props.lang),
                            loading: false
                        })
                    } else {
                        if (data.controlSchedule) {
                            // this.get();
                            this.setState({
                                scheduleReferral: null,
                                // view: 'week',
                                // day: new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime),
                                // scroll: true,
                                doctorsList: [],
                                updateEventTemplate: null,
                                referralId: null
                            }, () => this.get())
                        } else {
                            // this.get()
                            this.setState({
                                scheduleModal: null,
                                referralId: null,
                                scheduleControl: null,
                                patient: null,
                                age: null,
                                revisitFormsSelected: [],
                                revisitFormsSelect: [],
                                journalNoteFormSelected: null,
                                updateEventTemplate: null,
                                // view: 'week',
                                // day: new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime),
                                // scroll: true,
                                doctorsList: []

                            }, () => {
                                this.get()
                            })
                        }

                        if (result.invoiceMessage) {
                            this.setState({
                                invoiceMessage: result.invoiceMessage
                            })
                        }

                    }
                    this.setState({
                        creatingEvent: false
                    })

                })
            })
        }
        // } else {
        //     this.setState({
        //         wrongDate: true,
        //         creatingEvent: false
        //     })
        // }

    }

    /**
    * Select time range on calendar
    * @author   Stefan Pantic, Aleksandar Dabic
    * @Objectparam    {Object} event        data from calendar range
    */
    handleSelect = (event) => {
        if (!event || !event.start || !event.end) {
            const now = new Date();
            const startDate = new Date(now.getTime() + 60 * 60 * 1000);
            startDate.setSeconds(0, 0);

            // Round to nearest 5 minutes
            const minutes = Math.round(startDate.getMinutes() / 5) * 5;
            startDate.setMinutes(minutes);

            const endDate = new Date(startDate.getTime() + 5 * 60 * 1000);

            event = {
                start: startDate,
                end: endDate,
            }
        }

        var startDate = moment.unix(Math.floor(event.start.getTime() / 1000)).format('YYYY-MM-DD');
        let endDate = moment.unix(Math.floor(event.end.getTime() / 1000)).format('YYYY-MM-DD');
        let start = moment.unix(Math.floor(event.start.getTime() / 1000)).format('HH:mm')
        var end = moment.unix(Math.floor(event.end.getTime() / 1000)).format("HH:mm");

        // var startDate = this.props.getStringDateTs(Math.floor(event.start.getTime() / 1000), 'YYYY-MM-DD');
        // let endDate = this.props.getStringDateTs(Math.floor(event.end.getTime() / 1000), 'YYYY-MM-DD');
        // let start = this.props.getStringDateTs(Math.floor(event.start.getTime() / 1000), 'HH:mm');
        // var end = this.props.getStringDateTs(Math.floor(event.end.getTime() / 1000), 'HH:mm');


        // let minTime = moment.unix(Math.floor(this.state.min.getTime() / 1000)).format('HH:mm');
        // let maxTime = moment.unix(Math.floor(this.state.max.getTime() / 1000)).format('HH:mm');
        let minTime = this.props.getStringDateTs(Math.floor(this.state.min.getTime() / 1000), 'HH:mm');
        let maxTime = this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm');

        if (Number(start.split(":")[0]) < Number(minTime.split(":")[0]) || (Number(start.split(":")[0]) == Number(minTime.split(":")[0]) && Number(start.split(":")[1]) < Number(minTime.split(":")[1]))) {
            start = minTime;
            let newEnd = Math.floor(this.state.min.getTime() / 1000) + 5 * 60;
            if (Number(end.split(":")[0]) < Number(moment.unix(newEnd).format('HH:mm').split(":")[0]) || (Number(end.split(":")[0]) == Number(moment.unix(newEnd).format('HH:mm').split(":")[0]) && Number(end.split(":")[1]) < Number(moment.unix(newEnd).format('HH:mm').split(":")[1])))
                end = moment.unix(newEnd).format('HH:mm');
        } else if (Number(end.split(":")[0]) > Number(maxTime.split(":")[0]) || (Number(end.split(":")[0]) == Number(maxTime.split(":")[0]) && Number(end.split(":")[1]) > Number(maxTime.split(":")[1]))) {
            let newStart = Math.floor(this.state.max.getTime() / 1000) - 5 * 60;
            if (Number(start.split(":")[0]) > Number(moment.unix(newStart).format('HH:mm').split(":")[0]) || (Number(start.split(":")[0]) == Number(moment.unix(newStart).format('HH:mm').split(":")[0]) && Number(start.split(":")[1]) > Number(moment.unix(newStart).format('HH:mm').split(":")[1])))
                start = moment.unix(newStart).format('HH:mm');
            end = maxTime;
        }

        let obj = {
            date: startDate,
            endDate: endDate,
            startTime: start,
            endTime: end,
            title: ''

        }

        this.setState({
            scheduleModal: obj,
            doctorsList: []
        })


    }
    /**
    * Select time range for free events on calendar
    * free events are used when patitent schedule his referral
    * @author   Stefan Pantic
    */
    handleSelectFree = () => {
        var startDate = this.props.getStringDateTs(Math.floor(new Date().getTime() / 1000), 'YYYY-MM-DD')// moment.unix(Math.floor(new Date().getTime() / 1000)).format('YYYY-MM-DD');
        let endDate = this.props.getStringDateTs(Math.floor(new Date().getTime() / 1000), 'YYYY-MM-DD')// moment.unix(Math.floor(new Date().getTime() / 1000)).format('YYYY-MM-DD');
        let start = this.props.getStringDateTs(Math.floor(this.state.min.getTime() / 1000), 'HH:mm')// moment.unix(Math.floor(this.state.min.getTime() / 1000)).format('HH:mm')
        var end = this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm') // moment.unix(Math.floor(this.state.max.getTime() / 1000)).format("HH:mm");

        let obj = {
            date: startDate,
            endDate: endDate,
            startTime: start,
            endTime: end,
            title: ''
            // recurring: true
            // title: '',
            // monday: true,
            // tuesday: true,
            // wednesday: true,
            // thursday: true,
            // friday: true,
            // saturday: false,
            // sunday: false

        }
        this.setState({
            schedulePatientTime: obj,

        })
    }

    /**
    * Update time range when doctor is working
    * @author   Stefan Pantic
    */
    update = () => {

        let selectedGroup = this.props.selectedGroup;
        let selectedClinic = this.props.selectedClinic;

        const doctor = this.state.doctors.filter(item => item._id === this.state.doctor)[0];

        let workingTimeConfig = this.state.doctor && doctor && doctor.workingTimeConfig ? doctor.workingTimeConfig : {};

        if (!doctor)
            workingTimeConfig = this.props.uData.workingTimeConfig ? this.props.uData.workingTimeConfig : {};

        if (!workingTimeConfig[this.props.selectedGroup]) {
            workingTimeConfig[this.props.selectedGroup] = {};
        }


        if (!workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic]) {
            workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic] = {};
        }

        workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic].min = this.state.min;
        workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic].max = this.state.max;

        this.setState({ showPlayer: true }, () => {
            this.player.current.play();
            fetch(API_ENDPOINT + '/users/account/update/working-time-config', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ workingTimeConfig: workingTimeConfig })
            }).then(parseJSON).then(({ result, status }) => {
                if (result.error) {
                    this.setState({ error: result.error.translate(this.props.lang) })
                } else {
                    this.setState({
                        message: result.message
                    })
                    this.props.verifyUser(() => {
                        this.setWorkingTimeConfig();

                    }, () => {
                        this.props.changeGroup(selectedGroup);
                        this.props.changeClinic(selectedClinic);

                    });
                    this.setState({
                        showPlayer: false,
                        showPlayer2: true,
                    }, () => {
                        setTimeout(() => {
                            this.setState({ showPlayer2: false });
                        }, 1000);
                    })
                }
            })
        })
    }
    updateUserCalendarStep = () => {
        this.setState({ showPlayer: true }, () => {
            this.player.current.play();
            fetch(API_ENDPOINT + '/users/account/update/calendar-step', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ calendarStep: this.state.step })
            }).then(parseJSON).then(({ result, status }) => {
                if (result.error) {
                    this.setState({ error: result.error.translate(this.props.lang) })
                } else {
                    this.setState({
                        message: result.message
                    })
                    this.props.verifyUser(() => {

                    }, () => {

                    });
                    this.setState({
                        showPlayer: false,
                        showPlayer2: true,
                    }, () => {
                        setTimeout(() => {
                            this.setState({ showPlayer2: false });
                        }, 1000);
                    })
                }
            })
        })
    }
    getWorkingTime = () => {
        let obj = {

        };
        obj.min = new Date();
        obj.min.setHours(7, 0, 0)
        obj.max = new Date();
        obj.max.setHours(18, 0, 0)

        obj.min = new Date(this.props.getStringDateTs(Math.floor(new Date(obj.min).getTime() / 1000), 'MM/DD/YYYY HH:mm'))
        obj.max = new Date(this.props.getStringDateTs(Math.floor(new Date(obj.max).getTime() / 1000), 'MM/DD/YYYY HH:mm'))

        obj.minSelectedDoctor = obj.min
        obj.maxSelectedDoctor = obj.max

        obj.minTransferDoctor = obj.min
        obj.maxTransferDoctor = obj.max

        if (this.state.doctor) {

            if (this.state.doctors && this.state.doctors.length && this.state.doctors.filter(item => item._id.toString() == this.state.doctor).length) {
                let doctors = this.state.doctors.filter(item => item._id.toString() == this.state.doctor);

                for (let i = 0; i < doctors.length; i++) {
                    if (doctors[i].workingTimeConfig) {

                        if (doctors[i].workingTimeConfig[this.props.selectedGroup] && doctors[i].workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic]) {
                            let minTime = doctors[i].workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic].min
                            let maxTime = doctors[i].workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic].max
                            obj.min = new Date();
                            obj.min.setHours(new Date(minTime).getHours(), new Date(minTime).getMinutes(), 0)
                            obj.max = new Date();
                            obj.max.setHours(new Date(maxTime).getHours(), new Date(maxTime).getMinutes(), 0)

                        }
                    } else if (this.props.uData && this.props.selectedGroup && this.props.selectedClinic) {
                        let selectedGroupIdx = -1;
                        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
                            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                                    selectedGroupIdx = i;
                                    break;
                                }
                            }
                        }
                        if (selectedGroupIdx !== -1) {
                            if (this.props.uData.clinicGroups && this.props.uData.clinicGroups[selectedGroupIdx] && this.props.uData.clinicGroups[selectedGroupIdx].bookingSettings) {
                                const bookingSettings = this.props.uData.clinicGroups[selectedGroupIdx].bookingSettings;

                                if (bookingSettings?.workingHours && bookingSettings?.workingHours.min && bookingSettings?.workingHours.max) {

                                    obj.min = new Date(this.props.getStringDateTs(Math.floor(new Date(bookingSettings?.workingHours.min).getTime() / 1000), 'MM/DD/YYYY HH:mm'))
                                    obj.max = new Date(this.props.getStringDateTs(Math.floor(new Date(bookingSettings?.workingHours.max).getTime() / 1000), 'MM/DD/YYYY HH:mm'))

                                }

                            }
                        }

                    }
                }
            }
        }

        if (this.state.transferModal && this.state.transferModal.doctor) {
            if (this.state.doctors && this.state.doctors.length && this.state.doctors.filter(item => item._id.toString() == this.state.transferModal.doctor).length) {
                let doctors = this.state.doctors.filter(item => item._id.toString() == this.state.transferModal.doctor);

                for (let i = 0; i < doctors.length; i++) {
                    if (doctors[i].workingTimeConfig) {

                        if (doctors[i].workingTimeConfig[this.props.selectedGroup] && doctors[i].workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic]) {
                            let minTime = doctors[i].workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic].min
                            let maxTime = doctors[i].workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic].max
                            obj.minTransferDoctor = new Date();
                            obj.minTransferDoctor.setHours(new Date(minTime).getHours(), new Date(minTime).getMinutes(), 0)
                            obj.maxTransferDoctor = new Date();
                            obj.maxTransferDoctor.setHours(new Date(maxTime).getHours(), new Date(maxTime).getMinutes(), 0)

                        }
                    } else if (this.props.uData && this.props.selectedGroup && this.props.selectedClinic) {
                        let selectedGroupIdx = -1;
                        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
                            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                                    selectedGroupIdx = i;
                                    break;
                                }
                            }
                        }
                        if (selectedGroupIdx !== -1) {
                            if (this.props.uData.clinicGroups && this.props.uData.clinicGroups[selectedGroupIdx] && this.props.uData.clinicGroups[selectedGroupIdx].bookingSettings) {
                                const bookingSettings = this.props.uData.clinicGroups[selectedGroupIdx].bookingSettings;

                                if (bookingSettings?.workingHours && bookingSettings?.workingHours.min && bookingSettings?.workingHours.max) {

                                    obj.minTransferDoctor = new Date(this.props.getStringDateTs(Math.floor(new Date(bookingSettings?.workingHours.min).getTime() / 1000), 'MM/DD/YYYY HH:mm'))
                                    obj.maxTransferDoctor = new Date(this.props.getStringDateTs(Math.floor(new Date(bookingSettings?.workingHours.max).getTime() / 1000), 'MM/DD/YYYY HH:mm'))

                                }

                            }
                        }

                    }
                }
            }

        }

        if (this.state.listDoctor) {
            if (this.state.doctors && this.state.doctors.length && this.state.doctors.filter(item => item._id.toString() == this.state.listDoctor).length) {
                let doctors = this.state.doctors.filter(item => item._id.toString() == this.state.listDoctor);
                for (let i = 0; i < doctors.length; i++) {
                    if (doctors[i].workingTimeConfig) {
                        if (doctors[i].workingTimeConfig[this.props.selectedGroup] && doctors[i].workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic]) {
                            obj.minSelectedDoctor = new Date(doctors[i].workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic].min)
                            obj.maxSelectedDoctor = new Date(doctors[i].workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic].max)
                        }
                    }
                }
            }
            let scheduleListReferral = this.state.scheduleListReferral;

            let min = this.props.getStringDateTs(Math.floor(obj?.minSelectedDoctor?.getTime() / 1000), 'HH:mm');
            let max = this.props.getStringDateTs(Math.floor(obj?.maxSelectedDoctor?.getTime() / 1000), 'HH:mm');
            if (scheduleListReferral?.startTime && scheduleListReferral?.endTime && min) {
                let minSeconds = Number(min?.split(':')?.[0]) * 60 + Number(min?.split(':')?.[1])
                let maxSeconds = Number(max?.split(':')?.[0]) * 60 + Number(max?.split(':')?.[1])
                let startTimeSeconds = Number(scheduleListReferral.startTime?.split(':')?.[0]) * 60 + Number(scheduleListReferral.startTime?.split(':')?.[1])
                let endTimeSeconds = Number(scheduleListReferral.endTime?.split(':')?.[0]) * 60 + Number(scheduleListReferral.endTime?.split(':')?.[1])
                if (minSeconds > startTimeSeconds) {
                    scheduleListReferral.startTime = min;
                    obj.scheduleListReferral = scheduleListReferral;
                }
                if (minSeconds > endTimeSeconds) {
                    scheduleListReferral.endTime = this.props.getStringDateTs(Math.floor((obj?.minSelectedDoctor?.getTime() / 1000) + 60 * 5), 'HH:mm');
                    obj.scheduleListReferral = scheduleListReferral;
                }
                if (maxSeconds < startTimeSeconds) {
                    scheduleListReferral.startTime = this.props.getStringDateTs(Math.floor((obj?.maxSelectedDoctor?.getTime() / 1000) - 60 * 5), 'HH:mm');;
                    obj.scheduleListReferral = scheduleListReferral;
                }
                if (maxSeconds < endTimeSeconds) {
                    scheduleListReferral.endTime = max;
                    obj.scheduleListReferral = scheduleListReferral;
                }
            }


        }

        this.setState(obj, () => {
            if (this.state.transferModal)
                this.disableTransferIfTimeIsOutOfWorkingHours()
        })

    }

    /**
    * Select event on calendar
    * @author   Stefan Pantic
    * @Objectparam    {Object} event        data from calendar event
    */
    selectedEvent = (event) => {
        if (event?.type === 'administrativeBooking' && event?.id) {
            this.setState({ updateAdministrativeBookingModal: event?.id })
            return;
        }
        if (this.props.selectedClinic !== event?.clinic && (!event?.selectedEventDepartments || (event?.selectedEventDepartments && event?.selectedEventDepartments?.indexOf(this.props.selectedClinic) === -1))) return;

        if (this.props.selectedClinic === event?.clinic && event?.selectedEventDepartments && event?.selectedEventDepartments?.length && event?.selectedEventDepartments?.indexOf(this.props.selectedClinic) === -1) return;

        if (event?.type && event.type === 'take-care') return this.setState({
            takeCareEvent: {
                ...event,
                date: moment.unix(Math.floor(event.start.getTime() / 1000)).format('YYYY-MM-DD'),
                startTime: moment.unix(Math.floor(event.start.getTime() / 1000)).format('HH:mm'),
                endTime: moment.unix(Math.floor(event.end.getTime() / 1000)).format("HH:mm")
            }
        })

        if (event?.type && event.type === 'semble') {
            return this.getSembleEvent((event._id ?? event.id), event);

            //  return this.setState({
            //     sembleEvent: {
            //         ...event,
            //         date: moment.unix(Math.floor(event.start.getTime() / 1000)).format('YYYY-MM-DD'),
            //         startTime: moment.unix(Math.floor(event.start.getTime() / 1000)).format('HH:mm'),
            //         endTime: moment.unix(Math.floor(event.end.getTime() / 1000)).format("HH:mm")
            //     }
            // });
        }

        this.setState({ previewReferral: null }, async () => {
            if (event.id && (event.type === 'revisit' || event.type === 'referral')) {
                const response = await fetch(API_ENDPOINT + '/data/referral-from-event/' + event.id,
                    {
                        method: 'GET',
                        headers: {
                            'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                            'content-type': 'application/json'
                        }
                    });
                if (response && response.ok) {
                    const result = await response.json();
                    if (result && typeof result === 'object') {
                        if (result && result._2fa) event._2fa = true;
                        this.setState({
                            previewReferral: { ...result, event: event }
                        });
                    }
                }


                // fetch(API_ENDPOINT + '/data/referral-from-event/' + event.id, {
                //     method: 'GET',
                //     headers: {
                //         'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                //         'content-type': 'application/json'
                //     }
                // }).then(res => res.json()).then((result) => {
                //     if (result.error) {
                //         this.setState({
                //             error: result.error.translate(this.props.lang)
                //         })
                //     } else {
                //         this.setState({
                //             previewReferral: { ...result, event: event }
                //         });
                //     }
                // })
            }

            if (event.type == 'temporaryEvent') {
                let date = new Date(event.start)
                date.setHours(0, 0, 0, 0)
                this.setState({ view: 'day', day: date })


            } else {
                var startDate = moment.unix(Math.floor(event.start.getTime() / 1000)).format('YYYY-MM-DD');
                let start = moment.unix(Math.floor(event.start.getTime() / 1000)).format('HH:mm')
                var end = moment.unix(Math.floor(event.end.getTime() / 1000)).format("HH:mm");
                let obj = {
                    title: event.title,
                    titleDoctor: event.titleDoctor,
                    baseTitle: event.baseTitle,
                    visitReasonName: event.visitReasonName,
                    id: event.id,
                    date: startDate,
                    startTime: start,
                    endTime: end,
                    patientNote: event.patientNote,
                    patientId: event.patientId,
                    patientControlNote: event.patientControlNote,
                    type: event.type,
                    appointmentPaid: event.appointmentPaid,
                    additionalDoctor: event.additionalDoctor,
                    patientProfile: event.patientProfile,
                    onlineVisit: event.onlineVisit ? true : false,
                    additionalDoctors: event.additionalDoctors,
                    closeCaseManually: event.closeCaseManually,
                    allActiveForms: event.allActiveForms,
                    eventForms: event.eventForms,
                    isColleagueEvent: event.isColleagueEvent,
                    _2fa: event?._2fa ? true : false,
                    scheduleKey: event.scheduleKey,
                    recurringKey: event.recurringKey,
                    noteToPatient: event?.noteToPatient,
                    _doctorName: event._doctorName,
                    _additionalDoctors: event._additionalDoctors,
                    hideTimeFromThePatient: event.hideTimeFromThePatient,
                    hideDurationForPatient: event.hideDurationForPatient,
                    isMarkedAsDone: event?.isMarkedAsDone,
                    recurringObj: event?.recurringObj ?? null,
                    tsCreated: event?.tsCreated ?? null,
                    tsModified: event?.tsModified ?? null,
                    selectedEventDepartments: event?.selectedEventDepartments ?? null,
                    createOnWebDoc: event?.createOnWebDoc ?? false,
                    isMarkedForCheckIn: event?.isMarkedForCheckIn
                }

                if (event && event.additionalDoctors) {
                    this.setState({ doctorsList: event.additionalDoctors })
                }
                if (event.type === 'free') {
                    if (event.type === 'free') {

                        obj.allActiveForms = event.allActiveForms ? event.allActiveForms : false
                        obj.eventForms = event.eventForms ? event.eventForms : []
                        obj.id = event.id
                    }
                    this.setState({
                        schedulePatientTime: obj
                    }, () => {
                        this.getWebBookingForms();
                    })
                } else if (event.type === 'template') {
                    // obj.selectedAvailabilityTemplate = {
                    //     id: event?.templateData?._id,
                    //     gap: event?.templateData?.gap,
                    //     instances: event?.templateData?.instances,
                    // }
                    obj.selectedAvailabilityTemplate = {
                        ...event?.templateData,
                        id: event?.templateData?._id,
                    }
                    obj.id = event.id

                    if (event?.recurringObj) {
                        obj.recurring = true;
                        obj = { ...obj, ...event.recurringObj }
                    }
                    obj._date = obj.date;
                    obj._startTime = obj.startTime;

                    this.setState({
                        updateEventTemplatePreModal: obj
                    })
                } else {
                    this.setState({
                        updateEvent: obj,
                        meetingParticipants: null,
                        prevUpdateEvent: { ...obj },
                        startedVideoCallConversation: null
                    }, () => {
                        this.checkWaitingRoom()

                        if (this.state.updateEvent && this.state.updateEvent.additionalDoctors && this.state.updateEvent.additionalDoctors.filter(item => item == this.props.uData._id).length) {

                            if (this.state.updateEvent.id || (this.state.updateEvent?.type === 'semble' && this.state.updateEvent._id)) {
                                let id = this.state.updateEvent.id ? this.state.updateEvent.id : this.state.updateEvent._id;
                                fetch(API_ENDPOINT + '/working-hours/get-referral/' + id, {
                                    method: 'GET',
                                    headers: {
                                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                                        'content-type': 'application/json'
                                    }
                                }).then(res => res.json()).then((result) => {

                                    if (result.error) {
                                        this.setState({
                                            error: result.error.translate(this.props.lang)
                                        })
                                    } else {
                                        if (result.conversations && result.conversations.length) {

                                            this.setState({
                                                startedVideoCallConversation: result.conversations[0]._id
                                            }, () => {

                                                this.props.socket.emit('activeVideoCalls', {})
                                            })

                                        }

                                    }

                                })

                            }


                        }
                    })
                }

            }
        })




    }

    /**
    * Update start and end time for event or title on calendar
    * @author   Stefan Pantic
    * @Objectparam    {String} date                 date when event start
    * @Objectparam    {Number} startTime            start time for event
    * @Objectparam    {Number} endTime              start time for event
    * @Objectparam    {String} doctor               doctor id
    * @Objectparam    {String} title                title for event
    * @Objectparam    {String} patientControlNote   event note
    * @Objectparam    {String} patientNote          note for events with referral
    */
    updateEvent = (data, cb) => {
        if (data.type === 'event') {

            if (data?.recurringKey) {
                this.setState({ updateEventModal: { ...data } })
            } else {
                this.updateEventTypeEvent(data, false)
            }

            cb?.();

            return;
        }
        let templateData = {}
        if (data.type === 'template') {
            templateData = {
                selectedAvailabilityTemplate: data.selectedAvailabilityTemplate,
                scheduleKey: data.scheduleKey,
                group: this.props.selectedGroup,
                clinic: this.props.selectedClinic,
            }
        }

        if (data && data.additionalDoctors && data.additionalDoctors.length) {
            this.checkDoctorsAvailable(data, 4, () => {
                if (!this.state.errorAdditionalDoctors) {
                    let checkDate = new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime);
                    let today = new Date();

                    if (checkDate < today && (!this.state.wrongDateModal || this.state.wrongDateModal.function !== 'updateEvent')) {
                        this.setState({
                            wrongDateModal: {
                                data: data,
                                cb: cb,
                                function: 'updateEvent'
                            }
                        }, () => {
                            return;
                        })
                    } else {
                        this.setState({
                            wrongDateModal: null
                        })

                        // if (checkDate >= today) {
                        this.setState({
                            loading: true
                        }, () => {

                            fetch(API_ENDPOINT + '/working-hours/update/' + data.id, {
                                method: 'POST',
                                headers: {
                                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                                    'content-type': 'application/json'
                                },
                                body: JSON.stringify({
                                    allActiveForms: data.allActiveForms ? data.allActiveForms : false,
                                    eventForms: data.eventForms ? data.eventForms : [],
                                    startEventReservedDateOriginal: data.date + ' ' + data.startTime,
                                    endEventReservedDateOriginal: data.date + ' ' + data.endTime,
                                    startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                                    endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                                    title: data.title,
                                    titleDoctor: data.titleDoctor,
                                    doctor: this.state.doctor ? this.state.doctor : this.props.uData._id,
                                    patientNote: data.patientNote,
                                    patientControlNote: data.patientControlNote,
                                    additionalDoctors: data.additionalDoctors,
                                    closeCaseManually: data.closeCaseManually,
                                    guests: data.guests,
                                    colleagues: data.colleagues,
                                    wrongDate: checkDate >= today,
                                    selectedEventDepartments: data.selectedEventDepartments ? data.selectedEventDepartments : null,
                                    ...templateData
                                })
                            }).then(res => res.json()).then((result) => {
                                if (result.error) {
                                    this.setState({
                                        error: result.error.translate(this.props.lang),
                                        loading: false
                                    })
                                } else {

                                    this.setState({
                                        updateEvent: null,
                                        meetingParticipants: null,
                                        offerData: null,
                                        prevUpdateEvent: null,
                                        schedulePatientTime: null,
                                        // view: 'week',
                                        // day: new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime),
                                        // scroll: true,
                                        loading: false,
                                        doctorsList: []
                                    }, () => {
                                        cb ? cb() : this.get();
                                        // this.get()
                                    })
                                }

                                this.setState({
                                    creatingEvent: false
                                })

                            })
                        })
                    }
                    // } else {
                    //     this.setState({
                    //         wrongDate: true,
                    //         creatingEvent: false
                    //     })


                    // }
                } else {
                    this.setState({
                        creatingEvent: false
                    })

                    cb?.();
                }

            })
        } else {
            let checkDate = new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime);
            let today = new Date();

            if (checkDate < today && (!this.state.wrongDateModal || this.state.wrongDateModal.function !== 'updateEvent')) {
                this.setState({
                    wrongDateModal: {
                        data: data,
                        cb: cb,
                        function: 'updateEvent'
                    }
                }, () => {
                    return;
                })
            } else {
                this.setState({
                    wrongDateModal: null
                })

                // if (checkDate >= today) {
                this.setState({
                    loading: true
                }, () => {

                    fetch(API_ENDPOINT + '/working-hours/update/' + data.id, {
                        method: 'POST',
                        headers: {
                            'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                            'content-type': 'application/json'
                        },
                        body: JSON.stringify({
                            allActiveForms: data.allActiveForms && data.type !== 'event' ? data.allActiveForms : false,
                            eventForms: data.eventForms ? data.eventForms : [],
                            type: data.type,
                            startEventReservedDateOriginal: data.date + ' ' + data.startTime,
                            endEventReservedDateOriginal: data.date + ' ' + data.endTime,
                            startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                            endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                            title: data.title,
                            titleDoctor: data.titleDoctor,
                            doctor: this.state.doctor ? this.state.doctor : this.props.uData._id,
                            patientNote: data.patientNote,
                            patientControlNote: data.patientControlNote,
                            additionalDoctors: data.additionalDoctors,
                            closeCaseManually: data.closeCaseManually,
                            guests: data.guests,
                            colleagues: data.colleagues,
                            wrongDate: checkDate >= today,
                            selectedEventDepartments: data.selectedEventDepartments ? data.selectedEventDepartments : null,
                            ...templateData
                        })
                    }).then(res => res.json()).then((result) => {
                        if (result.error) {
                            this.setState({
                                error: result.error.translate(this.props.lang),
                                loading: false
                            })
                        } else {

                            this.setState({
                                updateEvent: null,
                                meetingParticipants: null,
                                offerData: null,
                                prevUpdateEvent: null,
                                schedulePatientTime: null,
                                // view: 'week',
                                // day: new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime),
                                // scroll: true,
                                loading: false,
                                doctorsList: []
                            }, () => {
                                cb ? cb() : this.get();
                                // this.get()
                            })
                        }

                        this.setState({
                            creatingEvent: false
                        })

                    })
                })
            }
            // } else {
            //     this.setState({
            //         wrongDate: true,
            //         creatingEvent: false
            //     })


            // }
        }


    }

    /**
    * Delete event from calendar
    * @author   Stefan Pantic
    * @Objectparam    {String} date                 date when event start
    * @Objectparam    {Number} startTime            start time for event
    * @Objectparam    {Number} endTime              start time for event
    * @Objectparam    {String} doctor               doctor id
    * @Objectparam    {String} title                title for event
    */
    deleteEvent = (data) => {
        this.setState({
            loading: true
        }, () => {

            fetch(API_ENDPOINT + '/working-hours/delete/' + data.id, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ startEventReservedDateOriginal: data.date + ' ' + data.startTime, endEventReservedDateOriginal: data.date + ' ' + data.endTime, startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`), endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`), title: data.title, doctor: this.state.doctor ? this.state.doctor : this.props.uData._id })
            }).then(res => res.json()).then((result) => {
                if (result?.error) {
                    this.setState({
                        error: result.error?.translate(this.props.lang),
                        loading: false
                    })
                } else {
                    this.get()
                    this.getAllReferrals()
                    this.setState({
                        updateEvent: null,
                        meetingParticipants: null,
                        offerData: null,
                        prevUpdateEvent: null,
                        warningModal: null,
                        loading: false
                    })
                }

            })
        })
    }

    /**
    * Schedule referral event on calendar
    * @author   Stefan Pantic
    * @Objectparam    {String} date                 date when event start
    * @Objectparam    {Number} startTime            start time for event
    * @Objectparam    {Number} endTime              start time for event
    * @Objectparam    {String} doctor               doctor id
    * @Objectparam    {String} patientNote          note for events with referral
    */
    scheduleReferral = (data) => {

        if (this.state.referralId) {
            for (let i = 0; i < this.state.referrals.length; i++) {
                if (this.state.referralId == this.state.referrals[i]._id) {
                    this.setState({
                        referral: this.state.referrals[i]
                    })
                }
            }
        }

        let checkDate = new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime);
        let today = new Date();

        if (checkDate < today && (!this.state.wrongDateModal || this.state.wrongDateModal.function !== 'scheduleReferral')) {
            this.setState({
                wrongDateModal: {
                    data: data,
                    function: 'scheduleReferral'
                }
            }, () => {
                return;
            })
        } else {
            this.setState({
                wrongDateModal: null
            })


            // if (checkDate >= today) {
            this.setState({
                loading: true
            }, () => {
                fetch(API_ENDPOINT + '/referrals/schedule/' + this.state.referral._id, {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        startEventReservedDateOriginal: data.date + ' ' + data.startTime,
                        endEventReservedDateOriginal: data.date + ' ' + data.endTime,
                        startPatientReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                        endPatientReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                        doctor: this.state.doctor ? this.state.doctor : this.props.uData._id,
                        patientNote: data.patientNote,
                        additionalDoctors: data.additionalDoctors,
                        rescheduleReferral: data.rescheduleReferral ? true : false,
                        guests: data.guests,
                        wrongDate: checkDate >= today,
                        hideDurationForPatient: this.state.scheduleReferral.hideDurationForPatient ? true : false,
                    })
                }).then(res => res.json()).then((result) => {
                    if (result.error) {
                        this.setState({ error: result.error.translate(this.props.lang), loading: false })
                        this.get();
                        this.getAllReferrals()
                    } else {
                        this.get();
                        this.getAllReferrals()
                        this.setState({
                            scheduleReferral: null,
                            doctorsList: [],
                            referralId: null
                        }, () => this.get())
                    }

                    this.setState({
                        creatingEvent: false
                    })

                })
            })
        }
        // } else {
        //     this.setState({
        //         wrongDate: true,
        //         creatingEvent: false
        //     })


        // }
    }

    /**
    * Schedule free event on calendar
    * @author   Stefan Pantic
    * @Objectparam    {String} date                 date when event start
    * @Objectparam    {String} endDate              date when event end
    * @Objectparam    {Number} startTime            start time for event
    * @Objectparam    {Number} endTime              start time for event
    * @Objectparam    {String} doctor               doctor id
    * @Objectparam    {String} title                event title
    * @Objectparam    {String} group                group id
    * @Objectparam    {String} clinic               clinic id
    * @Objectparam    {String} referral             referral id
    */
    schedulePatientTime = (data) => {
        let checkDate = new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime);
        let today = new Date();

        if (checkDate >= today) {
            this.setState({
                loading: true
            }, () => {

                fetch(API_ENDPOINT + '/working-hours/patient-time/new', {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({ startEventReservedDateOriginal: data.date + ' ' + data.startTime, endEventReservedDateOriginal: data.date + ' ' + data.endTime, startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`), endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`), lastDaydate: data.endDate + ' ' + data.startTime, doctor: this.state.doctor ? this.state.doctor : this.props.uData._id, title: data.title, group: this.props.selectedGroup, clinic: this.props.selectedClinic, referral: this.state.referralId, monday: data.monday, tuesday: data.tuesday, wednesday: data.wednesday, thursday: data.thursday, friday: data.friday, saturday: data.saturday, sunday: data.sunday })
                }).then(res => res.json()).then((result) => {
                    if (result.error) {
                        this.setState({
                            error: result.error.translate(this.props.lang),
                            loading: false
                        })
                    } else {
                        // this.get()
                        this.setState({
                            scheduleModal: null,
                            schedulePatientTime: null,
                            // view: 'week',
                            day: checkDate,
                            scroll: true,
                            loading: false

                        }, () => {
                            this.get()
                        })
                    }

                })
            })
        } else {
            this.setState({
                wrongDate: true
            })
        }
    }
    generateSections = (itemsArr) => {
        let sections = {};
        let items = [{ type: 0 }, ...itemsArr];
        let lastSectionId = -1;
        for (let i = 0; i < items.length; i++) {
            if (items[i].type == 0) {
                lastSectionId++;
                sections[lastSectionId] = {
                    name: items[i].name,
                    displayOnReferral: false,
                    questions: [],
                    conditions: items[i].conditions ? items[i].conditions : [],
                    displayOnReferral: items[i].displayOnReferral,
                    fontStyle: items[i].fontStyle,
                    fontSize: items[i].fontSize,
                    fontWeight: items[i].fontWeight,

                }
            }
            if (lastSectionId != -1 && items[i].type != 0) {


                let wikiLinks = [];

                items[i].wikiLinks = wikiLinks;


                if (items[i].type == 1) {
                    let displayOnReferral = false;
                    if (items[i].answers) {
                        for (let j = 0; j < items[i].answers.length; j++) {
                            if (items[i].answers[j].text) {
                                displayOnReferral = true;
                            }
                        }
                    }

                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        answers: items[i].answers,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        displayOnReferral: displayOnReferral,
                        wikiLinks: items[i].wikiLinks,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                    });

                } else if (items[i].type == 2) {
                    let displayOnReferral = false;
                    if (items[i].answers) {
                        for (let j = 0; j < items[i].answers.length; j++) {

                            if (items[i].answers[j].text) {
                                displayOnReferral = true;
                            }
                        }
                    }
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        answers: items[i].answers,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        answerPrefix: items[i].answerPrefix,
                        userInput: items[i].userInput,
                        displayOnReferral: displayOnReferral || items[i].answerPrefix ? true : false,
                        wikiLinks: items[i].wikiLinks,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,

                    })
                } else if (items[i].type == 3) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        answerPrefix: items[i].answerPrefix,
                        wikiLinks: items[i].wikiLinks,
                        displayOnReferral: true,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                    })

                } else if (items[i].type == 4) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        text: items[i].text,
                        userInput: items[i].userInput,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                    })
                } else if (items[i].type == 15) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        text: items[i].text,
                        userInput: items[i].userInput,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                    })

                } else if (items[i].type == 5) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        displayOnReferral: true,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                        score: items[i].score
                    })

                } else if (items[i].type == 6) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        displayOnReferral: true,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                        score: items[i].score
                    })

                } else if (items[i].type == 7) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        displayOnReferral: true,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                    })

                } else if (items[i].type == 8) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        displayOnReferral: true,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                    })

                } else if (items[i].type == 9) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        displayOnReferral: true,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                    })

                } else if (items[i].type == 10) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        userInput: items[i].userInput,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        displayOnReferral: true,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                    })
                } else if (items[i].type == 12) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        displayOnReferral: true,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                        score: items[i].score
                    })
                } else if (items[i].type == 14) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        displayOnReferral: true,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                        score: items[i].score
                    })

                } else if (items[i].type == 13) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        displayOnReferral: true,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                        score: items[i].score
                    })

                } else if (items[i].type == 16) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        displayOnReferral: true,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                        blocks: items[i].blocks,
                    })

                } else if (items[i].type == 17) {
                    sections[lastSectionId].questions.push({
                        id: items[i].id,
                        type: items[i].type,
                        name: items[i].name,
                        conditions: items[i].conditions ? items[i].conditions : [],
                        wikiLinks: items[i].wikiLinks,
                        displayOnReferral: true,
                        fontStyle: items[i].fontStyle,
                        fontSize: items[i].fontSize,
                        fontWeight: items[i].fontWeight,
                        blocks: items[i].blocks,

                    })

                }
            }
        }

        return Object.values(sections);
    }

    /**
    * Delete free event on calendar
    * @author   Stefan Pantic
    * @Objectparam    {String} date                 date when event start
    * @Objectparam    {String} endDate              date when event end
    * @Objectparam    {Number} startTime            start time for event
    * @Objectparam    {Number} endTime              start time for event
    * @Objectparam    {String} doctor               doctor id
    * @Objectparam    {String} title                event title
    * @Objectparam    {String} group                group id
    * @Objectparam    {String} clinic               clinic id
    * @Objectparam    {String} referral             referral id
    */
    deletePatientTime = (data) => {
        let date = data.date;
        if (data.recurring) {
            if (data.frequencyType == 'day') {
                date = data.frequencyDayScheduledDateFrom;
            } else if (data.frequencyType == 'week') {
                date = data.frequencyWeekScheduledDateFrom;
            } else if (data.frequencyType == 'month') {
                date = data.frequencyMonthScheduledDateFrom;
            }
        }
        let checkDate = new Date(date.replace(/-/g, "/") + ' ' + data.startTime);
        let today = new Date();

        if (data && data.recurring) {
            data = this.checkRecurring(data);
        }

        this.setState({
            loadingDelete: true
        }, () => {

            fetch(API_ENDPOINT + '/working-hours/patient-time/delete/v2', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    startEventReservedDateOriginal: data.date + ' ' + data.startTime,
                    endEventReservedDateOriginal: data.date + ' ' + data.endTime,
                    startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                    endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                    doctor: this.state.doctor ? this.state.doctor : this.props.uData._id,
                    group: this.props.selectedGroup,
                    clinic: this.props.selectedClinic,
                    recurring: data.recurring,
                    recurringObj: data.recurringObj,
                })
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.setState({
                        error: result.error.translate(this.props.lang),
                        loadingDelete: false
                    })
                } else {
                    // this.get()
                    this.setState({
                        scheduleModal: null,
                        schedulePatientTime: null,
                        loadingDelete: false
                        // view: 'week',
                        // day: new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime)

                    }, () => {
                        this.get()
                    })
                }

            })
        })



        // this.setState({
        //     loadingDelete: true
        // }, () => {

        //     fetch(API_ENDPOINT + '/working-hours/patient-time/delete', {
        //         method: 'POST',
        //         headers: {
        //             'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
        //             'content-type': 'application/json'
        //         },
        //         body: JSON.stringify({ startEventReservedDateOriginal: data.date + ' ' + data.startTime, endEventReservedDateOriginal: data.date + ' ' + data.endTime,startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`), endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`), lastDaydate: data.endDate + ' ' + data.startTime, doctor: this.props.uData._id, title: data.title, group: this.props.selectedGroup, clinic: this.props.selectedClinic, referral: this.state.referralId, monday: data.monday, tuesday: data.tuesday, wednesday: data.wednesday, thursday: data.thursday, friday: data.friday, saturday: data.saturday, sunday: data.sunday })
        //     }).then(res => res.json()).then((result) => {
        //         if (result.error) {
        //             this.setState({
        //                 error: result.error.translate(this.props.lang),
        //                 loadingDelete: false
        //             })
        //         } else {
        //             this.get()
        //             this.setState({
        //                 scheduleModal: null,
        //                 schedulePatientTime: null,
        //                 loadingDelete: false
        //                 // view: 'week',
        //                 // day: new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime)

        //             })
        //         }

        //     })
        // })


    }

    /**
    * Schedule free event just for selected time range on calendar
    * @author   Stefan Pantic
    * @Objectparam    {String} date                 date when event start
    * @Objectparam    {String} endDate              date when event end
    * @Objectparam    {Number} startTime            start time for event
    * @Objectparam    {Number} endTime              start time for event
    * @Objectparam    {String} doctor               doctor id
    * @Objectparam    {String} title                event title
    * @Objectparam    {String} group                group id
    * @Objectparam    {String} clinic               clinic id
    * @Objectparam    {String} referral             referral id
    */
    // schedulePatientTimeOneDay = (data) => {
    //     let checkDate = new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime);
    //     let today = new Date();

    //     if (checkDate >= today) {
    //         this.setState({
    //             loading: true
    //         }, () => {

    //             fetch(API_ENDPOINT + '/working-hours/patient-time/new', {
    //                 method: 'POST',
    //                 headers: {
    //                     'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
    //                     'content-type': 'application/json'
    //                 },
    //                 body: JSON.stringify({ startEventReservedDateOriginal: data.date + ' ' + data.startTime, endEventReservedDateOriginal: data.date + ' ' + data.endTime,startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`), endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`), lastDaydate: data.endDate + ' ' + data.startTime, doctor: this.props.uData._id, title: data.title, group: this.props.selectedGroup, clinic: this.props.selectedClinic, referral: this.state.referralId })
    //             }).then(res => res.json()).then((result) => {
    //                 if (result.error) {
    //                     this.setState({
    //                         error: result.error.translate(this.props.lang),
    //                         loading: false,
    //                     })
    //                 } else {
    //                     this.get()
    //                     this.setState({
    //                         scheduleModal: null,
    //                         // schedulePatientTime: null
    //                         // view: 'week',
    //                         day: new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime),
    //                         scroll: true,
    //                         loading: false

    //                     })
    //                 }

    //             })
    //         })
    //     } else {
    //         this.setState({
    //             wrongDate: true
    //         })
    //     }
    // }

    patientTime = () => {
        this.setState({
            loading: true
        }, () => {
            fetch(API_ENDPOINT + '/working-hours/patient-time', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ startTime: this.state.freeMin, endTime: this.state.freeMax, doctor: this.state.doctor ? this.state.doctor : this.props.uData._id })
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.setState({ error: result.error.translate(this.props.lang) })
                } else {
                    this.get();
                    this.setState({
                        patientTimeModal: false
                    })
                }

            })
        })
    }

    /**
    * Submit note for event with referral
    * @author   Aleksandar Dabic
    * @Objectparam    {String} note                 note for event
    */
    submitNote = () => {

        if (this.state.patientNote) {
            fetch(API_ENDPOINT + '/referrals/update/patient-note/' + this.state.referralNote, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    note: this.state.patientNote
                })
            }).then(res => res.json()).then((result) => {
                this.setState({
                    referralNote: null
                })
                this.get()
            })
        }

    }
    /**
    * Submit note for event
    * @author   Aleksandar Dabic
    * @Objectparam    {String} note                 note for event
    */
    submitControlNote = () => {

        if (this.state.patientNote) {
            fetch(API_ENDPOINT + '/working-hours/events/update/patient-note/' + this.state.controlNote, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    note: this.state.patientNote
                })
            }).then(res => res.json()).then((result) => {
                this.setState({
                    controlNote: null
                })
                this.get()
            })
        }

    }

    countItems = (data, view) => {
        let item = this.state.items?.filter(item => item.patientProfile).sort((a, b) => b.startTime - a.startTime)
        let count = 0;
        if (!view) {
            view = 'month'
        }

        let startTime
        let endTime
        if (view === 'day') {
            startTime = new Date(this.state.day.getFullYear(), this.state.day.getMonth(), this.state.day.getDate(), 0, 0, 0).getTime() / 1000;
            endTime = new Date(this.state.day.getFullYear(), this.state.day.getMonth(), this.state.day.getDate(), 23, 59, 59).getTime() / 1000;
        } else if (view === 'week') {
            startTime = new Date(this.state.day.getFullYear(), this.state.day.getMonth(), this.state.day.getDate() - this.state.day.getDay(), 0, 0, 0).getTime() / 1000;
            endTime = new Date(this.state.day.getFullYear(), this.state.day.getMonth(), this.state.day.getDate() + (6 - this.state.day.getDay()), 23, 59, 59).getTime() / 1000;
        } else if (view === 'month') {
            startTime = new Date(this.state.day.getFullYear(), this.state.day.getMonth(), 1, 0, 0, 0).getTime() / 1000;
            endTime = new Date(this.state.day.getFullYear(), this.state.day.getMonth() + 1, 0, 23, 59, 59).getTime() / 1000;
        } else if (view === 'work_week') {
            startTime = new Date(this.state.day.getFullYear(), this.state.day.getMonth(), this.state.day.getDate() - this.state.day.getDay() + 1, 0, 0, 0).getTime() / 1000;
            endTime = new Date(this.state.day.getFullYear(), this.state.day.getMonth(), this.state.day.getDate() + (5 - this.state.day.getDay()), 23, 59, 59).getTime() / 1000;
        } else if (view === 'agenda') {
            startTime = new Date(this.state.day.getFullYear(), this.state.day.getMonth(), this.state.day.getDate() - 15, 0, 0, 0).getTime() / 1000;
            endTime = new Date(this.state.day.getFullYear(), this.state.day.getMonth(), this.state.day.getDate() + 15, 23, 59, 59).getTime() / 1000;
        }
        for (let i = 0; i < item.length; i++) {
            if (item && item.length && item[i] && item[i].patientProfile && item[i].patientProfile.name && item[i].patientProfile.socialSecurityNumber) {

                if ((item[i].patientProfile.name.toLowerCase().trim().indexOf(data.toLowerCase().trim()) != -1 || item[i].patientProfile.socialSecurityNumber.indexOf(data) != -1) && item[i].clinic === this.props.selectedClinic) {

                    if (startTime && endTime && (item[i].startTime >= startTime && item[i].startTime <= endTime)) {
                        count++
                    }
                }
            }
        }

        this.setState({
            countItemsState: count,
            searchView: view,
        })

        return count
    }

    /**
    * Search in calendar
    * @author   Stefan Pantic
    * @Objectparam    {Array} data                 events
    */
    searchEvents = (data, doCount = true) => {

        let count = doCount ? this.countItems(data, this.state.view) : this.state.countItemsState;
        if (count == 0) {
            this.setState({ noSearchResults: 'No matching results found in'.translate(this.props.lang), searchItemNumber: 0, showFromTo: false, day: new Date() })
            return;
        }

        let newIndex = this.state.searchItemNumber >= count ? 0 : this.state.searchItemNumber
        this.setState({
            searchItemNumber: newIndex,
        })
        let item = this.state.items?.filter(item => item.patientProfile).sort((a, b) => a.startTime - b.startTime)

        if (item.length <= 1) {
            this.setState({
                disabledNext: true,
                disabledBack: true
            })
        }

        if (newIndex <= 0) {
            this.setState({
                disabledBack: true,
            })
        } else {
            this.setState({
                disabledBack: false

            })
        }

        let found = false;
        let c1 = 0
        let view = this.state.searchView;
        if (!view) {
            view = 'month'
        }

        let startTime
        let endTime
        if (view === 'day') {
            startTime = new Date(this.state.day.getFullYear(), this.state.day.getMonth(), this.state.day.getDate(), 0, 0, 0).getTime() / 1000;
            endTime = new Date(this.state.day.getFullYear(), this.state.day.getMonth(), this.state.day.getDate(), 23, 59, 59).getTime() / 1000;
        } else if (view === 'week') {
            startTime = new Date(this.state.day.getFullYear(), this.state.day.getMonth(), this.state.day.getDate() - this.state.day.getDay(), 0, 0, 0).getTime() / 1000;
            endTime = new Date(this.state.day.getFullYear(), this.state.day.getMonth(), this.state.day.getDate() + (6 - this.state.day.getDay()), 23, 59, 59).getTime() / 1000;
        } else if (view === 'month') {
            startTime = new Date(this.state.day.getFullYear(), this.state.day.getMonth(), 1, 0, 0, 0).getTime() / 1000;
            endTime = new Date(this.state.day.getFullYear(), this.state.day.getMonth() + 1, 0, 23, 59, 59).getTime() / 1000;
        } else if (view === 'work_week') {
            startTime = new Date(this.state.day.getFullYear(), this.state.day.getMonth(), this.state.day.getDate() - this.state.day.getDay() + 1, 0, 0, 0).getTime() / 1000;
            endTime = new Date(this.state.day.getFullYear(), this.state.day.getMonth(), this.state.day.getDate() + (5 - this.state.day.getDay()), 23, 59, 59).getTime() / 1000;
        } else if (view === 'agenda') {
            startTime = new Date(this.state.day.getFullYear(), this.state.day.getMonth(), this.state.day.getDate() - 15, 0, 0, 0).getTime() / 1000;
            endTime = new Date(this.state.day.getFullYear(), this.state.day.getMonth(), this.state.day.getDate() + 15, 23, 59, 59).getTime() / 1000;
        }

        for (let i = 0; i < item.length; i++) {
            if (item && item.length && item[i] && item[i].patientProfile && item[i].patientProfile.name && item[i].patientProfile.socialSecurityNumber) {
                if ((item[i].patientProfile.name.toLowerCase().trim().indexOf(data.toLowerCase().trim()) != -1 || item[i].patientProfile.socialSecurityNumber.indexOf(data) != -1) && item[i].clinic === this.props.selectedClinic && startTime && endTime && (item[i].startTime >= startTime && item[i].startTime <= endTime)) {
                    if (c1 == newIndex) {
                        this.setState({
                            view: 'day',
                            day: new Date(item[i].startEventReservedDate.replace(/-/g, "/")),
                            showFromTo: true
                        })
                        found = true
                        break;

                    }
                    c1++
                    found = true;
                    // break;
                }

            }
        }

        if (!found) {
            this.setState({

                showFromTo: false
            })

        }

    }
    conversation = (id, data, startCall = false) => {
        this.setState({
            loadingConversation: true
        }, () => {
            fetch(API_ENDPOINT + '/referrals/conversation/recpient/' + id, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                if (startCall) {
                    this.props.startVideoCall(result.conversation)
                } else {
                    this.props[0].history.push(`/chat?conversation=${result.conversation}`)

                }

            })

        })
    }
    controlConversation = (id, data) => {
        this.setState({
            loading: true
        }, () => {
            fetch(API_ENDPOINT + '/controls/conversation/recpient/' + id, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                this.props[0].history.push(`/chat?conversation=${result.conversation}`)
            })

        })
    }
    openConveration = (item) => {
        if (item.id || (item?.type === 'semble' && item._id)) {
            let id = item.id ? item.id : item._id;
            fetch(API_ENDPOINT + '/working-hours/get-referral/' + id + '?openConversation=true', {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.setState({
                        error: result.error.translate(this.props.lang)
                    })
                } else {
                    if (result.conversations && result.conversations.length) {
                        this.props[0].history.push(`/chat?conversation=${result.conversations[0]._id}`)
                    } else {
                        this.setState({
                            conversationForm: { name: result.patient.referralNumber + '-' + pad(result.conversations.length + 1, 2) }
                        }, () => {
                            this.conversation(result._id, { ...this.state.conversationForm, patient: true });

                        })
                    }

                }

            })

        }
        // else if (item.type == 'revisit' && item.id) {
        //     this.setState({ updateEvent: !this.state.updateEvent, doctorsList: [], conversationControlModal: item, conversationForm: { name: item && item.patientProfile ? (item.patientProfile.name) : '', socialSecurityNumber: item && item.patientProfile ? item.patientProfile.socialSecurityNumber : '' } })
        // }
    }
    startVideoCall = (item) => {
        if (item.id || (item?.type === 'semble' && item._id)) {
            let id = item.id ? item.id : item._id;
            fetch(API_ENDPOINT + '/working-hours/get-referral/' + id + '?openConversation=true', {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.setState({
                        error: result.error.translate(this.props.lang)
                    })
                } else {
                    if (result.conversations && result.conversations.length) {
                        // this.props[0].history.push(`/chat?conversation=${result.conversations[0]._id}`)
                        this.props.startVideoCall(result.conversations[0]._id)
                    } else {
                        this.setState({
                            conversationForm: { name: result.patient.referralNumber + '-' + pad(result.conversations.length + 1, 2) }
                        }, () => {
                            this.conversation(result._id, { ...this.state.conversationForm, patient: true }, true);

                        })
                    }
                    // this.setState({ eventReferral: result }, () => {
                    //     let item = this.state.eventReferral;
                    //     this.setState({ updateEvent: !this.state.updateEvent, doctorsList: [], conversationModal: item, conversationForm: { name: item.patient.referralNumber + '-' + pad(item.conversations.length + 1, 2) } })
                    // })

                }

            })

        }
    }

    checkDoctorsAvailable = (doctorsList, modal, callback) => {
        let event;

        if (modal == 1) {
            event = this.state.updateEvent;
        } else if (modal == 2) {
            event = this.state.scheduleReferral;
        } else if (modal == 3) {
            event = this.state.scheduleControl;
        } else if (modal == 4) {
            event = doctorsList;
            doctorsList = doctorsList.additionalDoctors;
        }

        if (doctorsList) {
            let data = {
                doctorsList: doctorsList,
                startEventReservedDateOriginal: event.date + ' ' + event.startTime,
                endEventReservedDateOriginal: event.date + ' ' + event.endTime,
                startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(event.date + ' ' + event.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(event.date + ' ' + event.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                eventId: event.id
            }
            fetch(API_ENDPOINT + '/working-hours/check/doctors', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.setState({
                        errorAdditionalDoctors: result.doctorsList
                    })
                } else {
                    this.setState({ doctorsModal: false, successfullyAdditionalDoctors: modal != 4 ? true : false }, () => {
                        if (modal == 1) {
                            let updateEvent = this.state.updateEvent;
                            updateEvent.additionalDoctors = this.state.doctorsList;
                            this.setState({ updateEvent })
                        } else if (modal == 2) {
                            let scheduleReferral = this.state.scheduleReferral;
                            scheduleReferral.additionalDoctors = this.state.doctorsList;
                            this.setState({ scheduleReferral })
                        } else if (modal == 3) {
                            let scheduleControl = this.state.scheduleControl;
                            scheduleControl.additionalDoctors = this.state.doctorsList;
                            this.setState({ scheduleControl })
                        }


                    })
                }
                if (callback) {
                    callback();
                }


            })
        }


    }

    patientAge = (data, callback) => {

        let country = this.state.countryStateDict?.['search-ssn'] ?? this.props.country;

        fetch(API_ENDPOINT + '/users/users/get-age/' + data, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({ socialSecurityNumber: this.state.patientSocialSecurityNumber, country })
        }).then(res => res.json()).then((result) => {
            this.setState({
                age: result.age
            }, () => {
                if (callback) {
                    callback();
                }
            })
        })
    }
    leaveCase = (data) => {
        this.setState({ leaveCaseModal: null })
        let additionalDoctors = [];
        if (data.additionalDoctors && data.additionalDoctors.length) {
            for (let i = 0; i < data.additionalDoctors.length; i++) {
                if (data.additionalDoctors[i] != (this.state.doctor ? this.state.doctor : this.props.uData._id))
                    additionalDoctors.push(data.additionalDoctors[i])
            }
        }

        fetch(API_ENDPOINT + '/working-hours/update/' + data.id, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({ additionalDoctors: additionalDoctors, updateOnlyAD: true })
        }).then(res => res.json()).then((result) => {
            if (result.error) {
                this.setState({
                    error: result.error.translate(this.props.lang),
                    loading: false
                })
            } else {
                this.setState({
                    updateEvent: null,
                    meetingParticipants: null,
                    offerData: null,
                    prevUpdateEvent: null,
                    loading: false,
                    doctorsList: []
                }, () => {
                    this.get()
                })
            }

        })
    }

    findPatient = (callback = false) => {
        if (this.state.patientSocialSecurityNumber) {
            this.checkSSN(this.state.patientSocialSecurityNumber)
        }

        this.setState({ patient: null, age: null }, () => {
            fetch(API_ENDPOINT + '/users/find/patient', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ group: this.props.selectedGroup, clinic: this.props.selectedClinic, socialSecurityNumber: this.state.patientSocialSecurityNumber })
            }).then(res => res.json()).then((result) => {
                //result = result?.error ? result?.error : result?.length ? result[0] : null;
                if (result.error) {
                    this.setState({
                        error: result.error.translate(this.props.lang),
                        loading: false
                    })
                } else {
                    this.get()
                    if (result && result.name && result.socialSecurityNumber) {
                        this.setState({
                            patient: result
                        }, () => {
                            this.patientAge(this.state.patient._id)

                            // this is just for search history in calendar
                            if (callback) {
                                callback();
                            }
                        })
                    } else {
                        let selectedGroupIdx = -1;
                        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
                            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                                    selectedGroupIdx = i;
                                    break;
                                }
                            }
                        }
                        let enterprise = this.props.uData && this.props.uData.clinicGroups && this.props.uData.clinicGroups[selectedGroupIdx] && this.props.uData.clinicGroups[selectedGroupIdx].enterprise;
                        let canSearchPatients = this.props.uData && this.props.uData.clinicGroups && this.props.uData.clinicGroups[selectedGroupIdx] && this.props.uData.clinicGroups[selectedGroupIdx].sarchPatients;

                        if (enterprise || canSearchPatients) {
                            this.setState({
                                errorPatientNotFound: 'Check digits or register a new patient'.translate(this.props.lang)
                            }, () => {
                                this.patientAge(this.state.patientSocialSecurityNumber)
                            })
                        } else {
                            this.setState({
                                error: 'The patient you are searching can not be found in your clinic'.translate(this.props.lang)
                            })
                        }

                    }

                }

            })
        })
    }

    checkSSN = (ssn) => {
        fetch(API_ENDPOINT + '/users/patient/check/ssn', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                group: this.props.selectedGroup,
                clinic: this.props.selectedClinic,
                socialSecurityNumber: ssn
            })
        }).then(res => res.json()).then((result) => {
            if (result) {
                this.setState({ socialSecurityNumberExist: result.exist, ssnExistInThisGroup: result.ssnExistInThisGroup, needsParent: result.needsParent, hasParent: result.hasParent }, () => {
                    const _ageLimitFix = this.state.socialSecurityNumberExist && !this.state.ssnExistInThisGroup && this.state.needsParent && !this.state.hasParent ? true : false;
                    if (this.state.socialSecurityNumberExist && !this.state.ssnExistInThisGroup) {
                        fetch(API_ENDPOINT + '/users/subaccounts/get', {
                            method: 'POST',
                            headers: {
                                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                                'content-type': 'application/json'
                            },
                            body: JSON.stringify({ socialSecurityNumber: ssn, group: this.props.selectedGroup, clinic: this.props.selectedClinic })
                        }).then(parseJSON).then(({ result, status }) => {
                            if (status == 200 && result && result.userData) {

                                this.props.changeName(result.userData.name);
                                this.props.changeSex(result.userData.sex);
                                if (!_ageLimitFix) this.props.changeEmail(result.email)
                                if (!_ageLimitFix) this.props.changePhone(result.phone)

                                if (result.parentObj) {
                                    this.props.changeSocialSecurityNumberParent(result.parentObj.socialSecurityNumber)
                                    this.props.changeNameParent(result.parentObj.name);
                                    this.props.changeEmail(result.parentObj.email);
                                    if (result.parentObj.userData.sex)
                                        this.props.changeSexParent(result.parentObj.userData.sex);
                                    this.props.changeLanguage(result.parentObj.language);
                                    this.props.changePhone(result.parentObj.phone);
                                }

                            }
                        })
                    }
                })
            }

        })
    }

    checkPatientValidations = (data) => {

        if (!data || (!this.state.clinicGroupSettings?.twoFactorAuthentication && data.twoFactorAuthenticationEnabled)) return this.setState({ error: 'Something went wrong! Please refresh your browser and try again!'.translate(this.props.lang) });
        const AGE_LIMIT = getAgeLimit(this.props.country, this.props.selectedGroup, this.props.clinicsAgeLimitExceptions);
        if (typeof this.state.age === 'number' && this.state.age >= AGE_LIMIT && data) {
            if (data.socialSecurityNumberParent) delete data.socialSecurityNumberParent;
            if (data.socialSecurityNumberParent2) delete data.socialSecurityNumberParent2;
            if (data.dateOfBirthParent) delete data.dateOfBirthParent;
            if (data.dateOfBirthParent2) delete data.dateOfBirthParent2;
            if (data.nameParent) delete data.nameParent;
            if (data.nameParent2) delete data.nameParent2;
            if (data.sexParent) delete data.sexParent;
            if (data.sexParent2) delete data.sexParent2;
            if (data.email2) delete data.email2;
            if (data.phone2) delete data.phone2;
        }

        // if (this.state.clinicGroupSettings?.twoFactorAuthentication && data.twoFactorAuthenticationEnabled && (!data.email?.trim?.() || !data.phone?.trim?.())) return this.setState({ error: 'When two factor authentication is enabled, both email and phone number are required!'.translate(this.props.lang) });

        if (!(data.email || data.phone) && (!this.state.socialSecurityNumberExist || (this.state.clinicGroupSettings?.twoFactorAuthentication && data.twoFactorAuthenticationEnabled))) {
            this.setState({ error: 'Mandatory to enter either email or phone.'.translate(this.props.lang) })
        } else {
            if (data.socialSecurityNumberParent) {
                let check = validateSocialSecurityNumber(data.socialSecurityNumberParent, true, this.state.countryStateDict?.['socialSecurityNumberParent'] ?? this.props.country);

                if (check.error) {
                    this.setState({ error: check.error.translate(this.props.lang) })
                } else {
                    this.setState({
                        saveModal: data
                    })
                }

            } else if (data.socialSecurityNumber && !data.socialSecurityNumberParent) {
                let check = validateSocialSecurityNumber(data.socialSecurityNumber, false, this.state.countryStateDict?.['socialSecurityNumber'] ?? this.props.country);

                if (check.error) {
                    this.setState({ error: check.error.translate(this.props.lang) })
                } else {
                    if (data.socialSecurityNumberParent2 && this.state.parent2Required) {
                        let check = validateSocialSecurityNumber(data.socialSecurityNumberParent2, true, this.state.countryStateDict?.['socialSecurityNumberParent2'] ?? this.props.country)

                        if (check.error) {
                            this.setState({ error: check.error.translate(this.props.lang) })
                        } else {

                            this.setState({
                                saveModal: data
                            })
                        }
                    } else {
                        this.setState({
                            saveModal: data
                        })
                    }
                }
            }
        }

    }

    addPatient = (data) => {
        if (this.state.addPatientLoader) return;
        if (this.props.country === 'uk' && !this.state.parent2Required && data) {
            if (data.socialSecurityNumberParent2) delete data.socialSecurityNumberParent2;
            if (data.dateOfBirthParent2) delete data.dateOfBirthParent2;
            if (data.nameParent2) delete data.nameParent2;
            if (data.sexParent2) delete data.sexParent2;
            if (data.email2) delete data.email2;
            if (data.phone2) delete data.phone2;
        }
        const _ageLimitFix = this.state.socialSecurityNumberExist && this.state.needsParent && !this.state.hasParent ? true : false;
        this.setState({ addPatientLoader: true }, () => {
            fetch(API_ENDPOINT + '/users/patient/add/new', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    group: this.props.selectedGroup,
                    clinic: this.props.selectedClinic,
                    _ageLimitFix,
                    ...data
                })
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.setState({ error: result.error })
                } else {
                    this.setState({ patientSocialSecurityNumber: result.responseSSN ?? this.state.patientSocialSecurityNumber, succesMessage: 'You have successfully added a patient'.translate(this.props.lang), form: null, registerNewPatientModal: null, registerNewPatientModal: null, ssnExistInThisGroup: null, socialSecurityNumberExist: null, needsParent: null, hasParent: null }, () => {
                        this.findPatient()
                    })
                }
                this.setState({ saveModal: null, addPatientLoader: false })

            })
        });
    }

    getTakeCareAppointments = async () => {
        return;
        if (!this.props.hasTakeCare || !this.props?.selectedGroup || !this.props?.selectedClinic || !this.props?.uData) return;

        const response = await fetch(API_ENDPOINT + '/take-care/get-bookings-for-doctor', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
            },
            body: JSON.stringify({
                groupId: this.props?.selectedGroup,
                clinicId: this.props?.selectedClinic,
                doctorId: this.props?.uData?._id
            })
        });

        if (response && response.ok) {
            const result = await response.json();
            if (result?.error && this.props?.hasTakeCare) this.setState({ error: result.error?.translate?.(this.props?.lang) });
            if (result?.appointments && Array.isArray(result.appointments) && result.appointments?.length) {
                this.setState({ takeCareAppointments: result?.appointments, daysWithDuplicate: [] }, () => {
                    if (this.state.view == 'month' && this.state.items && this.state.items.length) {
                        let ITEMS = [...(this.state.items || [])];
                        if (this.props.hasTakeCare && this.state.takeCareAppointments && Array.isArray(this.state.takeCareAppointments) && this.state.takeCareAppointments?.length) ITEMS = [...ITEMS, ...this.state.takeCareAppointments];
                        let items = ITEMS?.filter(item => item.group.toString() == this.props.selectedGroup.toString() && (item.type != 'temporaryEvent' || (item.type == 'temporaryEvent' && this.state.view == 'month')));
                        let daysWithDuplicate = []
                        for (let i = 0; i < items.length; i++) {
                            if (items[i] && items[i].startTime && !items[i].reserved) {
                                let date = moment.unix(items[i].startTime).format('MM-DD-YYYY')
                                if (daysWithDuplicate.filter(el => el == date).length == 0) {
                                    if (items.filter(el => el._id != items[i]._id &&
                                        (
                                            (this.getTsWithZeroSec(items[i].startTime) <= this.getTsWithZeroSec(el.startTime) && this.getTsWithZeroSec(items[i].endTime) >= this.getTsWithZeroSec(el.endTime))
                                            || (this.getTsWithZeroSec(items[i].startTime) <= this.getTsWithZeroSec(el.startTime) && this.getTsWithZeroSec(items[i].endTime) > this.getTsWithZeroSec(el.startTime) && this.getTsWithZeroSec(items[i].endTime) <= this.getTsWithZeroSec(el.endTime))
                                            || (this.getTsWithZeroSec(items[i].startTime) >= this.getTsWithZeroSec(el.startTime) && this.getTsWithZeroSec(items[i].startTime) < this.getTsWithZeroSec(el.endTime) && this.getTsWithZeroSec(items[i].endTime) >= this.getTsWithZeroSec(el.endTime))
                                        )
                                    ).length) {
                                        daysWithDuplicate.push(date)
                                    }
                                }

                            }
                        }
                        if (daysWithDuplicate && daysWithDuplicate.length) {
                            this.setState({ daysWithDuplicate })
                        }

                    }
                });
            }
        }
    }

    getClinicGroupSettings = () => {
        this.setState({ clinicGroupSettings: null }, async () => {
            if (!this.props?.selectedGroup) return;
            const response = await fetch(API_ENDPOINT + '/data/clinic-group-settings/' + this.props.selectedGroup);
            if (!response || !response.ok) return;
            const result = await response.json();
            if (!result || result.error || !result.clinicGroupSettings) return;
            this.setState({ clinicGroupSettings: result.clinicGroupSettings }, () => {
                // if (this.state.clinicGroupSettings && this.state.clinicGroupSettings.holidayEvents && this.state.clinicGroupSettings.showNationalHolidaysClinic) {
                //     let holidayEvents = [...this.state.holidayEvents];
                //     this.setState({ holidayEvents: [...holidayEvents, ...this.state.clinicGroupSettings?.holidayEvents] }, () => {
                //     })
                // }
                // if (this.state.clinicGroupSettings && this.state.clinicGroupSettings.holidayEvents && this.state.clinicGroupSettings.showNationalHolidaysAPI) {
                this.googleHolidayEvents()
                // }
            });
        })
    }

    searchPatientWithRedirect = (SSN) => {
        if (!this.state.clinicGroupSettings) return this.setState({ error: 'User not found in this clinic group' });

        const { enterprise, canSearchPatients } = this.state.clinicGroupSettings;
        if (!enterprise && !canSearchPatients) return this.setState({ error: 'User not found in this clinic group' });

        let obj = {
            socialSecurityNumber: SSN,
            group: this.props.selectedGroup,
            clinic: this.props.selectedClinic,
            openOnWebDoc: false,
        }
        enterprise && (obj.openOnWebDoc = true);

        fetch(API_ENDPOINT + '/users/find/patient', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(obj)
        }).then(res => res.json()).then((result) => {
            //result = result?.error ? result?.error : result?.length ? result[0] : null;

            if (result && result?._id) {
                const path = enterprise ? '/patients/search-enterprise' : '/patients/search';
                this.props.registerClinicGroupLogs({
                    type: 'patientProfile',
                    patient: SSN,
                });

                let state = {
                    TYPE: 'redirect',
                    redirectPatient: result,
                    redirectTabIndex: 1
                }
                enterprise && (state.redirectTabActive = 1);

                this.props?.[0]?.history?.push?.(path, state);

            } else {
                this.setState({ error: 'User not found in this clinic group' })
            }
        })
    }

    closeReferral = (data, action = false) => {
        const closeCaseActionModal = {
            data: data ? JSON.parse(JSON.stringify(data)) : null,
            function: 'closeReferral'
        }
        if (!data) data = {};
        data.selectedGroup = this.props.selectedGroup;
        data.closeConversation = true;
        data.action = action;

        this.setState({
            loading: true
        }, () => {
            fetch(API_ENDPOINT + '/referrals/close/' + this.state.previewReferral._id, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                if (result?.eventExits && result?.neededAction) {
                    this.setState({
                        closeCaseActionModal: closeCaseActionModal,
                        loading: false
                    })
                    return;
                }
                this.get();
                if (result?.error) {
                    this.setState({
                        error: result.error?.translate(this.props.lang),
                        loading: false
                    })
                } else {
                    this.setState({
                        previewReferral: null,
                        openPreviewReferral: false,
                        updateEvent: null,
                        meetingParticipants: null,
                        offerData: null,
                        prevUpdateEvent: null,
                    })
                }

            })
        })
    }
    deleteReferral = () => {
        if (!this.state.previewReferral?._id) {
            return;
        }
        this.setState({
            loading: true
        }, () => {
            fetch(API_ENDPOINT + '/referrals/delete/' + this.state.previewReferral._id, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({})
            }).then(res => res.json()).then((result) => {
                this.get();
                if (result?.error) {
                    this.setState({
                        error: result.error?.translate(this.props.lang),
                        loading: false
                    })
                } else {
                    this.setState({
                        previewReferral: null,
                        openPreviewReferral: false,
                        updateEvent: null,
                        meetingParticipants: null,
                        offerData: null,
                        prevUpdateEvent: null,
                    })
                }

            })
        })
    }

    checkForChanges = (redirectSSN = null) => {
        if (this.state.updateEvent && this.state.prevUpdateEvent) {
            if (JSON.stringify(this.state.updateEvent) != JSON.stringify(this.state.prevUpdateEvent)) {
                this.setState({
                    changesNotSaved: (redirectSSN ?? true)
                })
            } else {
                if (redirectSSN) {
                    this.searchPatientWithRedirect(redirectSSN);
                    return;
                }
                this.setState({
                    updateEvent: null,
                    meetingParticipants: null,
                    offerData: null,
                    prevUpdateEvent: null,
                    doctorsList: []
                })
            }
        } else {
            if (redirectSSN) {
                this.searchPatientWithRedirect(redirectSSN);
                return;
            }
            this.setState({
                updateEvent: null,
                meetingParticipants: null,
                offerData: null,
                prevUpdateEvent: null,
                doctorsList: []
            })
        }
    }

    showWeekAndMonthReccuringOptions = () => {
        // Function to check on whether today is greater than or equeal to 31st of March 2024
        // If it is, then show the recurring options for week and month
        // If it is not, then hide the recurring options for week and month
        let today = new Date();
        let march2024 = new Date('2024-03-31');
        if (today >= march2024) return true;
        return false;
    }

    calculateMaxDateHotfix = (minDateString) => {
        try {
            if (minDateString && minDateString !== 'Invalid date' && minDateString !== 'NaN-NaN-NaN' && minDateString !== 'Invalid Date') {
                let minDate = new Date(minDateString);
                minDate.setHours(12, 0, 0, 0);
                if (minDate.getFullYear() === 2024 && minDate.getMonth() === 2) {
                    // March 2024
                    if (minDate.getDate() < 31) {
                        const maxDate = new Date('2024-03-30T12:00:00.000Z');
                        // const maxDateString = this.props.getStringDateTs(Math.floor(maxDate.getTime() / 1000));
                        return maxDate;
                    }
                }
            }
        } catch (err) {
            console.log('calculateMaxDateHotfix error: ', err);
        }
        return undefined;
    }

    getSembleEvent = (id, _event) => {
        if (!id) return;
        this.setState({ loading: true }, async () => {
            const response = await fetch(`${API_ENDPOINT}/working-hours/semble/data/${id}`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
            });
            if (!response || !response.ok) return this.setState({ error: 'Something went wrong! Please try again!', loading: false });

            const result = await response.json();
            if (!result.event) return this.setState({ error: 'Something went wrong! Please try again!', loading: false });

            const event = result.event;
            this.setState({
                sembleEvent: {
                    ...event,
                    startTimeNum: event.startTime,
                    endTimeNum: event.endTime,
                    date: moment.unix(Math.floor(_event.start.getTime() / 1000)).format('YYYY-MM-DD'),
                    startTime: moment.unix(Math.floor(_event.start.getTime() / 1000)).format('HH:mm'),
                    endTime: moment.unix(Math.floor(_event.end.getTime() / 1000)).format("HH:mm")
                },
                loading: false
            });
        });
    }

    cancelSembleEvent = () => {
        if (!this.state.sembleEventCancel || !this.state.sembleEventCancel._id) return;
        this.setState({ loading: true }, async () => {
            const response = await fetch(`${API_ENDPOINT}/working-hours/semble/cancel/${this.state.sembleEventCancel._id}`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    groupId: this.props.selectedGroup,
                    departmentId: this.props.selectedClinic,
                })
            });
            if (!response || !response.ok) return this.setState({ error: 'Something went wrong! Please try again!', loading: false, sembleEventCancel: null });

            const result = await response.json();
            if (result?.error) return this.setState({ error: result.error, loading: false, sembleEventCancel: null });

            this.setState({ sembleEventCancel: null, loading: false, sembleEvent: null }, () => {
                this.get();
            });
        });
    }

    prepareSembleUpdate = () => {
        if (!this.state.sembleEvent?._id || !this.state.sembleEvent.type || this.state.sembleEvent.type !== 'semble') return;
        if (this.state._sembleUpdateData) {
            const sembleEvent = this.state.sembleEvent;
            const values = {
                doctor: sembleEvent.doctor._id,
                location: sembleEvent.clinic,
                date: sembleEvent.date,
                startTime: sembleEvent.startTime,
                endTime: sembleEvent.endTime,
                startTimeNum: sembleEvent.startTimeNum,
                endTimeNum: sembleEvent.endTimeNum,
            };
            const availableDoctors = this.state._sembleUpdateData.doctors;
            if (!availableDoctors?.find?.(obj => obj._id === values.doctor)) availableDoctors.push({
                _id: values.doctor,
                name: sembleEvent.doctor.name,
            });

            const availableLocations = this.state._sembleUpdateData.departments;
            if (!availableLocations?.find?.(obj => obj._id === values.location)) availableLocations.push({
                _id: values.location,
                name: sembleEvent.sembleData?.location?.name || '',
            });
            return this.setState({
                sembleEventUpdate: {
                    eventId: sembleEvent._id,
                    values,
                    oldValues: values,
                    availableDoctors,
                    availableLocations,
                    fullEdit: (sembleEvent?.referral && sembleEvent?.patient?.ssn) ? false : true
                }
            });
        }

        this.setState({ loading: true }, async () => {
            const response = await fetch(`${API_ENDPOINT}/working-hours/semble/prepare-update/${this.state.sembleEvent._id}`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    groupId: this.props.selectedGroup,
                    departmentId: this.props.selectedClinic,
                })
            });

            if (!response || !response.ok) return this.setState({ error: 'Something went wrong! Please try again!', loading: false });

            const result = await response.json();
            if (!result?.sembleUpdateData) return this.setState({ error: 'Something went wrong! Please try again!', loading: false });

            this.setState({ loading: false, _sembleUpdateData: result.sembleUpdateData }, () => {
                const sembleEvent = this.state.sembleEvent;
                const values = {
                    doctor: sembleEvent.doctor._id,
                    location: sembleEvent.clinic,
                    date: sembleEvent.date,
                    startTime: sembleEvent.startTime,
                    endTime: sembleEvent.endTime,
                    startTimeNum: sembleEvent.startTimeNum,
                    endTimeNum: sembleEvent.endTimeNum,
                };
                const availableDoctors = result.sembleUpdateData.doctors;
                if (!availableDoctors?.find?.(obj => obj._id === values.doctor)) availableDoctors.push({
                    _id: values.doctor,
                    name: sembleEvent.doctor.name,
                });

                const availableLocations = result.sembleUpdateData.departments;
                if (!availableLocations?.find?.(obj => obj._id === values.location)) availableLocations.push({
                    _id: values.location,
                    name: sembleEvent.sembleData?.location?.name || '',
                });

                this.setState({
                    sembleEventUpdate: {
                        eventId: sembleEvent._id,
                        values,
                        oldValues: values,
                        availableDoctors,
                        availableLocations,
                        fullEdit: (sembleEvent?.referral && sembleEvent?.patient?.ssn) ? false : true
                    }
                });
            });
        });
    }

    updateSembleEvent = () => {
        if (!this.state.sembleEventUpdate?.eventId || !this.state.sembleEventUpdate?.values || typeof this.state.sembleEventUpdate?.values !== 'object') return;
        const values = this.state.sembleEventUpdate.values;

        this.setState({ loading: true }, async () => {
            const response = await fetch(`${API_ENDPOINT}/working-hours/semble/update/${this.state.sembleEventUpdate.eventId}`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    groupId: this.props.selectedGroup,
                    departmentId: this.props.selectedClinic,
                    values,
                })
            });

            if (!response || !('json' in response)) return this.setState({ error: 'Something went wrong! Please try again!', loading: false });

            const result = await response.json();
            if (!result || result.error) return this.setState({ error: result.error || 'Something went wrong! Please try again!', loading: false });

            this.setState({ loading: false, sembleEventUpdate: null, sembleEvent: null }, () => {
                this.get();
            });
        });
    }

    /**
     * 
     * @param {any} dt 
     * @param {Intl.DateTimeFormatOptions} options 
     * @returns 
     */
    getGBDate = (dt, options) => {
        try {
            if (!dt) return '';
            if (!options) options = {
                dateStyle: 'short',
            }
            const ts = new Date(dt).getTime();
            if (ts && !isNaN(ts)) {
                const date = new Intl.DateTimeFormat('en-GB', options).format(ts);

                if (date) return date;
            }
        } catch (err) {
        }
        return dt;
    }

    transformEvent = (item) => {
        if (!item) return;
        if (!item.group || !this.props.selectedGroup || item.group !== this.props.selectedGroup) return;

        let start = new Date(this.props.getStringDateTs(item.startTime, 'MM/DD/YYYY HH:mm'));
        let end = new Date(this.props.getStringDateTs(item.endTime, 'MM/DD/YYYY HH:mm'));

        // if ((new Date(item.endTime * 1000).getHours() > new Date(this.state.min).getHours() || (new Date(item.endTime * 1000).getHours() == new Date(this.state.min).getHours() && new Date(item.endTime * 1000).getMinutes() > new Date(this.state.min).getMinutes())) || this.state.view == 'agenda') // old condition

        let _minDateTs = Math.floor(new Date(this.state.min).getTime() / 1000);
        let _minDateHours = this.props.getStringDateTs(_minDateTs, 'HH');
        let _minDateMinutes = this.props.getStringDateTs(_minDateTs, 'HH');

        let minDateHours = _minDateHours && Number(_minDateHours) !== 'NaN' ? Number(_minDateHours) : new Date(this.state.min).getHours();
        let minDateMinutes = _minDateMinutes && Number(_minDateMinutes) !== 'NaN' ? Number(_minDateMinutes) : new Date(this.state.min).getMinutes();

        minDateHours = 0;
        minDateMinutes = 0;

        let title;
        if (item?.clinic !== this.props.selectedClinic && !item.allDay) {
            let type = item.type === 'free' ? 'Availability' : item.type === 'event' ? 'Event' : 'Booking';

            if (item.group !== this.props.selectedGroup) {
                // Other group
                let isInSameMainClinicGroup = false;
                if (this.state.clinicGroupSettings?.mainClinicGroup?.clinics?.length) {
                    if (this.state.clinicGroupSettings.mainClinicGroup.clinics.find(obj => obj && obj._id && obj._id === item.group) && this.state.clinicGroupSettings.mainClinicGroup.clinics.find(obj => obj && obj._id && obj._id === this.props.selectedGroup)) isInSameMainClinicGroup = true;
                }

                if (isInSameMainClinicGroup) {
                    const name = this.state.clinicGroupSettings.mainClinicGroup.clinics.find(obj => obj && obj._id && obj._id === item.group)?.name;

                    title = `${type} in {clinicName}`.translate(this.props.lang).replace('{clinicName}', name || '');
                } else {
                    title = `${type} in another clinic`.translate(this.props.lang);
                }
            } else {
                // Other department
                const name = this.state.clinicGroupSettings?.departments?.find?.(obj => obj && obj._id === item.clinic)?.name;
                title = `${type} in {clinicName}`.translate(this.props.lang).replace('{clinicName}', name || '');
            }
        } else {
            if (item._title && !item.allDay) title = item._title;
        }

        let isTeam = false;
        if (this.props.selectedClinic === item.clinic && this.props.selectedGroup === item.group && ['referral', 'revisit'].includes(item.type) && item?.additionalDoctors && Array.isArray(item.additionalDoctors) && item.additionalDoctors.length > 0) isTeam = true;

        let visitType;
        if (this.props.selectedClinic === item.clinic && this.props.selectedGroup === item.group && ['referral', 'revisit'].includes(item.type)) {
            if (item.type === 'revisit') visitType = 'Revisit/New visit';
            else {
                if (item.scheduledBy === 'patient') visitType = 'Web booking';
                else visitType = 'Booking by clinic';
            }
        }

        if (item.allDay && (this.state.view === 'month' || this.state.view === 'agenda')) {
            return null
        }


        if ((end?.getHours() > minDateHours || (end?.getHours() == minDateHours && end?.getMinutes() > minDateMinutes)) || this.state.view == 'agenda') { // new condition
            if (!item.reserved) {
                return {
                    id: item._id,
                    title: title ? title : (item?.type === 'take-care' && item.participants) ? (
                        item?.participants?.filter?.(obj => obj?.role === 'patient')?.length > 1 ? `Take Care - ${item?.participants?.filter?.(obj => obj?.role === 'patient')?.length} ${'Patients'.translate(this.props.lang)}${item?.healthcare_services?.length ? (' - ' + item?.healthcare_services?.[0]?.name || '') : ''}` : item.title
                    ) : item?.titleDoctor ? (
                        item.title?.translate(this.props.lang) + ',' + item.titleDoctor
                    ) : item.title.translate(this.props.lang),
                    titleDoctor: item.titleDoctor,
                    visitReasonPrice: item?.visitReasonPrice,
                    visitReasonName: item.visitReasonName,
                    baseTitle: item.title.translate(this.props.lang),
                    start: new Date(this.props.getStringDateTs(item.startTime, 'MM/DD/YYYY HH:mm')),
                    end: new Date(this.props.getStringDateTs(item.endTime, 'MM/DD/YYYY HH:mm')),
                    referral: item.referral,
                    patientId: item.patient,
                    clinic: item.clinic,
                    type: item.type,
                    allActiveForms: item.allActiveForms ? item.allActiveForms : false,
                    eventForms: item.eventForms ? item.eventForms : [],
                    scheduledBy: item.scheduledBy,
                    appointmentPaid: item.appointmentPaid,
                    questionaryPrice: item?.questionaryPrice,
                    onlineVisit: item.onlineVisit,
                    createOnWebDoc: item.createOnWebDoc,
                    patientNote: item.patientNote,
                    additionalDoctor: item.additionalDoctor,
                    patientProfile: item.patientProfile,
                    additionalDoctors: item.additionalDoctors,
                    additionalDoctor: item.additionalDoctor,
                    patientControlNote: item.patientControlNote,
                    closeCaseManually: item.closeCaseManually,
                    _2fa: item?._2fa ? true : false,
                    isColleagueEvent: item.isColleagueEvent,
                    templateData: item.templateData,
                    scheduleKey: item.scheduleKey,
                    recurringObj: item.type === 'template' && item.recurringObj ? item.recurringObj : null,
                    recurringKey: item.recurringKey ?? null,
                    noteToPatient: item?.noteToPatient,
                    takeCareData: item?.type === 'take-care' ? {
                        healthcare_services: item.healthcare_services || null,
                        participants: item.participants || null,
                        title: item?.healthcare_services?.[0]?.name || 'Take Care Event'.translate?.(this.props.lang),
                        status: item.status || null,
                        description: item.description || null,
                        comment: item.comment || null,
                        arbitraryTime: item.arbitraryTime
                    } : null,
                    sembleData: item?.type === 'semble' ? item.sembleData : null,
                    tooltip: item?._hoverTitle
                        ? ((isTeam ? `(${'Team visit'.translate(this.props.lang)}) ` : '') + item._hoverTitle + ((item.patientNote || item.patientControlNote) ? (` | ${'Note'.translate(this.props.lang)}: ${item.patientNote || item.patientControlNote}`) : '') + (visitType ? ` (${visitType.translate(this.props.lang)})` : ''))
                        : item.title && item.patientNote
                            ? ((isTeam ? `(${'Team visit'.translate(this.props.lang)}) ` : '') + item.title + ' | ' + 'Note'.translate(this.props.lang) + ': ' + item.patientNote + (visitType ? ` (${visitType.translate(this.props.lang)})` : ''))
                            : item.title && item.patientControlNote
                                ? ((isTeam ? `(${'Team visit'.translate(this.props.lang)}) ` : '') + item.title + ' | ' + 'Note'.translate(this.props.lang) + ': ' + item.patientControlNote + (visitType ? ` (${visitType.translate(this.props.lang)})` : ''))
                                : item.title
                                    ? ((isTeam ? `(${'Team visit'.translate(this.props.lang)}) ` : '') + item.title.translate(this.props.lang) + (visitType ? ` (${visitType.translate(this.props.lang)})` : ''))
                                    : "",
                    allDay: item.allDay ? item.allDay : false,
                    titleEn: item.titleEn ? item.titleEn : null,
                    _doctorName: item._doctorName ?? '',
                    _additionalDoctors: item._additionalDoctors ?? [],
                    hideTimeFromThePatient: item.hideTimeFromThePatient,
                    hideDurationForPatient: item.hideDurationForPatient,
                    isMarkedAsDone: item.type === 'event' ? item?.isMarkedAsDone?.[this.state.doctor ? this.state.doctor : this.props.uData?._id] : item?.isMarkedAsDone,
                    tsCreated: item?.tsCreated ?? null,
                    tsModified: item?.tsModified ?? null,
                    colleagues: item?.colleagues,
                }
            }
        }
    }

    deleteEventTemplate = (item, deleteFutureEvents = false, callback) => {
        const eventId = item.id;
        if (eventId && eventId?.length === 24) {

            this.setState({ loadingDelete: true }, () => {
                fetch(API_ENDPOINT + '/working-hours/event-template/delete', {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        eventId: eventId,
                        deleteFutureEvents: deleteFutureEvents
                    })
                }).then(res => res.json()).then((result) => {
                    this.get();
                    let setObj = { loadingDelete: false, deleteEventTemplateModal: null };
                    if (result?.error) {
                        setObj.error = result.error?.translate(this.props.lang);
                    } else {
                        setObj.deleteEventTemplateModal = null;
                        setObj.updateEventTemplate = null;
                        // setObj.updateEventTemplateModal = null;

                        if (callback) callback();
                    }
                    this.setState(setObj)

                })
            })

        } else {
            this.setState({ deleteEventTemplateModal: null })
        }
    }

    getLastOpenedChats = () => {
        fetch(API_ENDPOINT + '/users/patients/last/search', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                group: this.props.selectedGroup
            })
        }).then(res => res.json()).then((result) => {
            if (result && result.searchItems) {
                this.setState({ lastSerach: result.searchItems })
            }
        })
    }

    updateEventTemplate = (item, updateFutureEvents = false) => {
        const eventId = item.id;


        if (eventId && eventId?.length === 24) {

            let data = {
                title: item.title,
                eventId: eventId,
                date: item.date,
                startTime: item.startTime,
                selectedAvailabilityTemplate: item.selectedAvailabilityTemplate,
                updateFutureEvents: updateFutureEvents,
                startEventReservedDateOriginal: item.date + ' ' + item.startTime,
                startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(item.date + ' ' + item.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
            }
            let checkDate = new Date(data?.date?.replace(/-/g, "/") + ' ' + data.startTime);
            let today = new Date();

            if (checkDate >= today) {
                this.setState({ loading: true }, () => {
                    fetch(API_ENDPOINT + '/working-hours/event-template/update', {
                        method: 'POST',
                        headers: {
                            'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                            'content-type': 'application/json'
                        },
                        body: JSON.stringify(data)
                    }).then(res => res.json()).then((result) => {
                        this.get();
                        let setObj = { loading: false, updateEventTemplateModal: null };
                        if (result?.error) {
                            setObj.error = result.error?.translate(this.props.lang);
                        } else {
                            setObj.updateEventTemplateModal = null;
                            setObj.updateEventTemplate = null;
                        }
                        this.setState(setObj)

                    })
                })
            } else {
                this.setState({ wrongDate: true })
            }



        } else {
            this.setState({ updateEventTemplateModal: null })
        }
    }
    setVisitReasonFromTemplate = () => {
        let scheduleControl = this.state.scheduleControl;
        if (scheduleControl?.templateData) {
            const data = scheduleControl.templateData;

            if (data?.selectedAvailabilityTemplate?.visitType) {
                let visitReasons = this.state.visitReasons?.items ?? [];
                let visitReason = visitReasons.find(obj => obj._id === data.selectedAvailabilityTemplate.visitType);
                if (visitReason) {
                    let selectedGroupIdx = -1;
                    if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
                        for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                            if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                                selectedGroupIdx = i;
                                break;
                            }
                        }
                    }
                    let groupData = this.props?.uData?.clinicGroups?.[selectedGroupIdx];
                    const enterprise = groupData?.enterprise;


                    scheduleControl.visitReasonName = visitReason.name;
                    if (this.state.age && visitReason.under18 && this.state.age < 18) {
                        scheduleControl.visitReasonPrice = 0;
                        scheduleControl.freePayment = 4
                    } else if (this.state.age && visitReason.under20 && this.state.age < 20) {
                        scheduleControl.visitReasonPrice = 0;
                        scheduleControl.freePayment = 3
                    } else if (this.state.age && visitReason.under23 && this.state.age < 23) {
                        scheduleControl.visitReasonPrice = 0;
                        scheduleControl.freePayment = 2
                    } else if (this.state.age && visitReason.under18child && this.state.age < 18) {
                        scheduleControl.visitReasonPrice = 0;
                        scheduleControl.freePayment = 6
                    } else if (this.state.age && visitReason.older85 && this.state.age > 85) {
                        scheduleControl.visitReasonPrice = 0;
                        scheduleControl.freePayment = 5
                    } else {
                        scheduleControl.visitReasonPrice = visitReason.price;
                        // scheduleControl.paymentMethod = visitReason.onlinePayment ? 3 : visitReason.invoice ? 2 : visitReason.paymentOnSite ? 1 : 0
                    }

                    scheduleControl.visiReason = visitReason._id;
                    scheduleControl.visitReasonOnline = visitReason.onlineVisit;
                    scheduleControl.videoCall = visitReason.videoCall;

                    let setObj = { selectVisitReason: false, scheduleControl };
                    let revisitFormsSelected = [];
                    let journalNoteFormSelected = null;

                    if (enterprise && visitReason && visitReason.defaultForm && this.state.revisitForms && this.state.revisitForms.items?.filter(el => el._id === visitReason.defaultForm).length) {
                        revisitFormsSelected.push(visitReason.defaultForm);
                        journalNoteFormSelected = visitReason.defaultForm;

                    }
                    setObj.journalNoteFormSelected = journalNoteFormSelected;
                    setObj.revisitFormsSelected = revisitFormsSelected;
                    this.setState(setObj)

                }
            }
        }
    }

    leaveMeeting = (eventId, colleagueId, leaveAllRecurringEvents = false) => {
        if (!eventId || !colleagueId) return;

        let data = {
            eventId,
            colleagueId,
            leaveAllRecurringEvents: leaveAllRecurringEvents ?? false
        }

        this.setState({ loadingLeaveMeeting: true }, () => {
            fetch(API_ENDPOINT + '/working-hours/event/leave-meeting', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                this.get();
                let setObj = { loadingLeaveMeeting: false, deleteColleagueEventModal: null };
                if (result?.error) {
                    setObj.error = result.error?.translate(this.props.lang);
                } else {
                    setObj.updateEvent = null;
                }
                this.setState(setObj)

            })
        })

    }
    deleteEventTypeEvent = (eventId, deleteAllRecurringEvents = false) => {
        if (!eventId) return;

        let data = {
            eventId,
            deleteAllRecurringEvents: deleteAllRecurringEvents ?? false
        }

        this.setState({ loadingDelete: true }, () => {
            fetch(API_ENDPOINT + '/working-hours/event/delete', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                this.get();
                let setObj = { loadingDelete: false, deleteEventModal: null };
                if (result?.error) {
                    setObj.error = result.error?.translate(this.props.lang);
                } else {
                    setObj.updateEvent = null;
                }
                this.setState(setObj)

            })
        })

    }
    updateEventTypeEvent = (data, updateAllRecurringEvents = false, forceUpdate = false) => {
        if (!data?.id) return;

        let checkDate = new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime);
        let today = new Date();
        if (checkDate < today && (!this.state.wrongDateModal || this.state.wrongDateModal.function !== 'updateEventTypeEvent')) {
            this.setState({
                wrongDateModal: {
                    data: data,
                    updateAllRecurringEvents: updateAllRecurringEvents,
                    forceUpdate: forceUpdate,
                    function: 'updateEventTypeEvent'
                }
            }, () => {
                return;
            })
        } else {
            this.setState({
                wrongDateModal: null
            })
            // if (checkDate >= today) {
            let obj = {
                updateAllRecurringEvents: updateAllRecurringEvents ?? false,
                eventId: data.id,
                allActiveForms: data.allActiveForms && data.type !== 'event' ? data.allActiveForms : false,
                eventForms: data.eventForms ? data.eventForms : [],
                type: 'event',
                startEventReservedDateOriginal: data.date + ' ' + data.startTime,
                endEventReservedDateOriginal: data.date + ' ' + data.endTime,
                startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                title: data.title,
                titleDoctor: data.titleDoctor,
                doctor: this.state.doctor ? this.state.doctor : this.props.uData._id,
                colleagues: data.colleagues,
                forceUpdate: forceUpdate,
                wrongDate: checkDate >= today,
            };
            this.setState({
                loading: true,
                errorOverlap: null
            }, () => {

                fetch(API_ENDPOINT + '/working-hours/event/update', {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(obj)
                }).then(res => res.json()).then((result) => {
                    if (result?.errorOverlap) {
                        this.setState({
                            errorOverlap: {
                                data: data,
                                updateAllRecurringEvents: updateAllRecurringEvents
                            },
                            loading: false
                        })
                    } else if (result.error) {
                        this.setState({
                            error: result.error.translate(this.props.lang),
                            loading: false
                        })
                    } else {
                        this.setState({
                            updateEventModal: null,
                            updateEvent: null,
                            meetingParticipants: null,
                            offerData: null,
                            prevUpdateEvent: null,
                            schedulePatientTime: null,
                            loading: false,
                            doctorsList: []
                        }, () => {
                            this.get()
                        })
                    }

                    this.setState({
                        creatingEvent: false
                    })

                })
            })
        }
        // } else {
        //     this.setState({
        //         wrongDate: true,
        //         creatingEvent: false
        //     })
        // }

    }

    getPossibleMeetingParticipantsList = (callback) => {
        try {
            const clinicId = this.props.selectedClinic;

            this.setState({ meetingParticipantsList: [] }, () => {
                fetch(API_ENDPOINT + `/meetings/calendar/colleagues/${clinicId}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()).then((result) => {
                    if (result?.users) {
                        this.setState({ meetingParticipantsList: result.users }, () => {
                            callback?.(this.state.meetingParticipantsList);
                        });
                    }
                })
            })
        } catch (err) { }
    }
    checkPatientNotes = () => {
        const { referralNote, controlNote, scheduleReferral, scheduleControl, updateEvent } = this.state;
        let patientId, patientSSN, eventId, referralId;
        if (referralNote) {
            let referral = this.state.items.find(item => item.referral === referralNote);
            if (referral?.patient) patientId = referral.patient;
            if (referral?.patientProfile?.socialSecurityNumber) patientSSN = referral.patientProfile.socialSecurityNumber;
            referralId = referralNote;
        } else if (controlNote) {
            let event = this.state.items.find(item => item._id === controlNote);
            if (event?.patient) patientId = event.patient;
            if (event?.patientProfile?.socialSecurityNumber) patientSSN = event.patientProfile.socialSecurityNumber;
            eventId = event?._id;
        } else if (scheduleReferral && this.state.referralId) {
            let referral = this.state.referrals.find(item => item._id === this.state.referralId);
            if (referral?.patient?.socialSecurityNumber) patientSSN = referral.patient.socialSecurityNumber;
            if (referral?._id) referralId = referral._id;
        } else if (scheduleControl && (scheduleControl?.patient || scheduleControl?.socialSecurityNumber)) {
            if (scheduleControl?.patient) patientId = scheduleControl.patient;
            if (scheduleControl?.socialSecurityNumber) patientSSN = scheduleControl.socialSecurityNumber;
        } else if (updateEvent) {
            if (updateEvent?.patientId) patientId = updateEvent.patientId;
            if (updateEvent?.patientProfile?.socialSecurityNumber) patientSSN = updateEvent.patientProfile.socialSecurityNumber;
            if (updateEvent?._id || updateEvent?.id) eventId = updateEvent._id || updateEvent.id;
        }
        if (!patientId && !patientSSN && !eventId && !referralId) {
            this.setState({ patientNotes: [] })

            return;
        }
        let data = {
            patientId,
            patientSSN,
            eventId,
            referralId,
            clinicId: this.props.selectedClinic,
            groupId: this.props.selectedGroup,
            lang: this.props.lang
        };

        this.setState({ patientNotes: [] }, () => {
            fetch(API_ENDPOINT + `/user/patients-notes/fetch`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                if (result?.items?.length) {
                    this.setState({ patientNotes: result.items });
                }
            })
        })

    }

    updateEventIsDone = (isDone, id, doctor) => {
        fetch(API_ENDPOINT + `/working-hours/event/update-is-done/` + id, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({ isDone: isDone, doctor: doctor })
        }).then(res => res.json()).then((result) => {
            if (result.error) {
                this.setState({
                    error: result.error.translate(this.props.lang),
                    loading: false
                })
            } else {
                this.setState({
                    updateEventModal: null,
                    updateEvent: null,
                    meetingParticipants: null,
                    offerData: null,
                    prevUpdateEvent: null,
                    schedulePatientTime: null,
                    loading: false,
                    doctorsList: []
                }, () => {
                    this.get()
                })
            }
        })
    }

    disableTransferIfTimeIsOutOfWorkingHours = () => {
        let transferModal = this.state.transferModal;
        let startTimeSplit = transferModal.startTime.split(":");
        let endTimeSplit = transferModal.endTime.split(":");

        let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
        let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);
        let maxTransferDoctorHourMinute = Number(new Date(this.state.maxTransferDoctor).getHours() * 60 + new Date(this.state.maxTransferDoctor).getMinutes())
        let minTransferDoctorHourMinute = Number(new Date(this.state.minTransferDoctor).getHours() * 60 + new Date(this.state.minTransferDoctor).getMinutes())

        if (startTimeHourMinute > maxTransferDoctorHourMinute || endTimeHourMinute > maxTransferDoctorHourMinute) {
            if (startTimeHourMinute > maxTransferDoctorHourMinute) {
                transferModal.startTime = Math.trunc((Number(new Date(this.state.maxTransferDoctor).getHours()) * 60 + Number(new Date(this.state.maxTransferDoctor).getMinutes()) - 10) / 60) + ":" + (Number(new Date(this.state.maxTransferDoctor).getHours()) * 60 + Number(new Date(this.state.maxTransferDoctor).getMinutes()) - 10) % 60
                transferModal.endTime = Math.trunc((Number(new Date(this.state.maxTransferDoctor).getHours()) * 60 + Number(new Date(this.state.maxTransferDoctor).getMinutes())) / 60) + ":" + (Number(new Date(this.state.maxTransferDoctor).getHours()) * 60 + Number(new Date(this.state.maxTransferDoctor).getMinutes())) % 60

                this.setState({
                    transferModal
                })
            } else {
                let doctor = this.state.doctors.filter(item => item._id.toString() == this.state.transferModal?.doctor)[0];
                if (doctor)
                    this.setState({
                        timeErrorMessage: `${this.props.formatName(doctor?.userData?.title, doctor?.userData?.name)}` + ' ' + 'is not available at this time.' + ' ' + 'Working hours:' + ' ' + this.props.getStringDateTs(Math.floor(new Date(this.state.minTransferDoctor).getTime() / 1000), 'HH:mm') + ' - ' + this.props.getStringDateTs(Math.floor(new Date(this.state.maxTransferDoctor).getTime() / 1000), 'HH:mm')
                    })

            }
            return true

        }
        if (startTimeHourMinute < minTransferDoctorHourMinute || endTimeHourMinute < minTransferDoctorHourMinute) {
            if (startTimeHourMinute < minTransferDoctorHourMinute) {
                transferModal.startTime = Math.trunc((Number(new Date(this.state.minTransferDoctor).getHours()) * 60 + Number(new Date(this.state.minTransferDoctor).getMinutes())) / 60) + ":" + (Number(new Date(this.state.minTransferDoctor).getHours()) * 60 + Number(new Date(this.state.minTransferDoctor).getMinutes())) % 60
                transferModal.endTime = Math.trunc((Number(new Date(this.state.minTransferDoctor).getHours()) * 60 + Number(new Date(this.state.minTransferDoctor).getMinutes()) + 10) / 60) + ":" + (Number(new Date(this.state.minTransferDoctor).getHours()) * 60 + Number(new Date(this.state.minTransferDoctor).getMinutes()) + 10) % 60
                this.setState({
                    transferModal
                })
            } else {
                let doctor = this.state.doctors.filter(item => item._id.toString() == this.state.transferModal?.doctor)[0];
                if (doctor)
                    this.setState({
                        timeErrorMessage: `${this.props.formatName(doctor?.userData?.title, doctor?.userData?.name)}` + ' ' + 'is not available at this time.' + ' ' + 'Working hours:' + ' ' + this.props.getStringDateTs(Math.floor(new Date(this.state.minTransferDoctor).getTime() / 1000), 'HH:mm') + ' - ' + this.props.getStringDateTs(Math.floor(new Date(this.state.maxTransferDoctor).getTime() / 1000), 'HH:mm')
                    })
            }
            return true
        }

        this.setState({
            timeErrorMessage: null
        })
        return false
    }

    transferEvent = (data) => {
        let checkDate = new Date(data.date.replace(/-/g, "/") + ' ' + data.startTime);
        let today = new Date();

        if (checkDate >= today) {
            this.setState({
                loading: true
            }, () => {

                fetch(API_ENDPOINT + '/referrals/transfer/' + data.id, {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        startEventReservedDateOriginal: data.date + ' ' + data.startTime,
                        endEventReservedDateOriginal: data.date + ' ' + data.endTime,
                        startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                        endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                        title: data.title,
                        titleDoctor: data.titleDoctor,
                        doctor: data.doctor,
                        group: this.props.selectedGroup,
                        clinic: this.props.selectedClinic,
                        allActiveForms: data.allActiveForms,
                        eventForms: data.eventForms
                    })
                }).then(res => res.json()).then((result) => {
                    if (result.error) {
                        this.setState({
                            error: result.error.translate(this.props.lang),
                            loading: false
                        })
                    } else {
                        this.get()
                        this.setState({
                            transferModal: null,
                            timeErrorMessage: null
                        })
                    }

                })
            })
        } else {
            this.setState({
                wrongDate: true
            })


        }
    }

    calculateWorkingHours = (clinic, group, doctor) => {
        let workingHours = '';

        let obj = {}
        obj.min = new Date()
        obj.min.setHours(7, 0, 0)
        obj.max = new Date()
        obj.max.setHours(18, 0, 0)
        if (doctor.workingTimeConfig) {

            if (doctor.workingTimeConfig[group] && doctor.workingTimeConfig[group][clinic]) {
                let minTime = doctor.workingTimeConfig[group][clinic].min
                let maxTime = doctor.workingTimeConfig[group][clinic].max
                obj.min = new Date();
                obj.min.setHours(new Date(minTime).getHours(), new Date(minTime).getMinutes(), 0)
                obj.max = new Date();
                obj.max.setHours(new Date(maxTime).getHours(), new Date(maxTime).getMinutes(), 0)
            }

            workingHours = `(${this.props.getStringDateTs(Math.floor(obj?.min?.getTime() / 1000), 'HH:mm')} - ${this.props.getStringDateTs(Math.floor(obj?.max?.getTime() / 1000), 'HH:mm')})`
        } else if (this.props.uData && group && clinic) {
            let selectedGroupIdx = -1;
            if (this.props.uData && group && this.props.uData?.clinicGroups?.length) {
                for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                    if (this.props.uData.clinicGroups[i]._id == group) {
                        selectedGroupIdx = i;
                        break;
                    }
                }
            }

            if (selectedGroupIdx !== -1) {
                if (this.props.uData.clinicGroups && this.props.uData.clinicGroups[selectedGroupIdx] && this.props.uData.clinicGroups[selectedGroupIdx].bookingSettings) {
                    const bookingSettings = this.props.uData.clinicGroups[selectedGroupIdx].bookingSettings;

                    if (bookingSettings?.workingHours && bookingSettings?.workingHours.min && bookingSettings?.workingHours.max) {

                        obj.min = new Date(this.props.getStringDateTs(Math.floor(new Date(bookingSettings?.workingHours.min).getTime() / 1000), 'MM/DD/YYYY HH:mm'))
                        obj.max = new Date(this.props.getStringDateTs(Math.floor(new Date(bookingSettings?.workingHours.max).getTime() / 1000), 'MM/DD/YYYY HH:mm'))

                    }

                }
            }

            workingHours = `(${this.props.getStringDateTs(Math.floor(obj?.min?.getTime() / 1000), 'HH:mm')} - ${this.props.getStringDateTs(Math.floor(obj?.max?.getTime() / 1000), 'HH:mm')})`

        }

        return workingHours

    }

    getClinicDepartments = () => {

        let departments = [];
        if (this.state.clinicGroupSettings?.mainClinicGroup?.clinics?.map(clinic => clinic._id)?.includes(this.props.selectedGroup)) {
            if (this.props.uData?.clinicGroups && this.props.uData.clinicGroups.length) {
                for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                    if (this.state.clinicGroupSettings?.mainClinicGroup?.clinics?.map(clinic => clinic._id)?.includes(this.props.uData.clinicGroups[i]._id))
                        if (this.props.uData.clinicGroups[i].clinics && this.props.uData.clinicGroups[i].clinics.length) {
                            for (let j = 0; j < this.props.uData.clinicGroups[i].clinics.length; j++) {

                                if (this.props.uData?.groupPermissionsUser?.[this.props.uData.clinicGroups[i]._id]?.[this.props.uData.clinicGroups[i].clinics[j]._id]?.indexOf(this.props.uData?.permissions?.doctor) !== -1) {
                                    departments.push({ ...this.props.uData.clinicGroups[i].clinics[j], groupId: this.props.uData.clinicGroups[i]._id, workingHours: this.calculateWorkingHours(this.props.uData.clinicGroups[i].clinics[j]._id, this.props.uData.clinicGroups[i]._id, this.props.uData) });
                                }
                            }
                        }
                }
            }
        } else {
            if (this.props.uData?.clinicGroups && this.props.uData.clinicGroups.length) {
                for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                    if (this.props.selectedGroup === this.props.uData.clinicGroups[i]._id)
                        if (this.props.uData.clinicGroups[i].clinics && this.props.uData.clinicGroups[i].clinics.length) {
                            for (let j = 0; j < this.props.uData.clinicGroups[i].clinics.length; j++) {

                                if (this.props.uData?.groupPermissionsUser?.[this.props.uData.clinicGroups[i]._id]?.[this.props.uData.clinicGroups[i].clinics[j]._id]?.indexOf(this.props.uData?.permissions?.doctor) !== -1) {
                                    departments.push({ ...this.props.uData.clinicGroups[i].clinics[j], groupId: this.props.uData.clinicGroups[i]._id, workingHours: this.calculateWorkingHours(this.props.uData.clinicGroups[i].clinics[j]._id, this.props.uData.clinicGroups[i]._id, this.props.uData) });
                                }
                            }
                        }
                }
            }
        }


        return departments;
    }

    getWebBookingForms = () => {
        if (!this.state.schedulePatientTime?.selectedEventDepartments?.length) return;
        fetch(API_ENDPOINT + '/working-hours/web-booking-forms', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                // group: query.group,
                doctor: this.state.doctor ? this.state.doctor : this.props.uData._id,
                clinic: this.state.schedulePatientTime?.selectedEventDepartments
            })
        }).then(res => res.json()).then((result) => {
            if (result?.length)
                this.setState({
                    webBookingForms: result,
                    showWebBookingForms: false
                }, () => {
                    if (this.state.schedulePatientTime?.eventForms?.length) {
                        let forms = this.state.webBookingForms.filter(form => this.state.schedulePatientTime?.eventForms?.includes(form._id));
                        let schedulePatientTime = this.state.schedulePatientTime;
                        if (forms.length) {
                            schedulePatientTime.eventForms = forms.map(form => form._id);
                            this.setState({
                                schedulePatientTime
                            })
                        } else {
                            schedulePatientTime.eventForms = [];
                            this.setState({
                                schedulePatientTime
                            })
                        }
                    }
                    this.setState({
                        showWebBookingForms: true
                    })
                });

        })
    }

    doctorCheckedEventFroPatient = (checkIn) => {
        let checkDate = new Date(this.state.updateEvent?.date.replace(/-/g, "/") + ' ' + this.state.updateEvent?.startTime);
        let today = new Date();

        if (checkDate >= today || this.state.wrongDateCheckInModal) {
            const eventId = this.state.updateEvent?.id ?? this.state.updateEvent?._id;
            fetch(API_ENDPOINT + '/working-hours/doctor-check-in', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ eventId: eventId, checkIn: checkIn })
            }).then(res => res.json()).then((result) => {
                this.setState({
                    updateEvent: null,
                    wrongDateCheckInModal: null
                })
                this.get();

            })
        } else {
            this.setState({
                wrongDateCheckInModal: checkIn ? 'yes' : 'no'
            })
        }

    }

    render() {

        const WeekNumber = ({ week, weekYear, weekDay, className, date }) => (
            <span
                className={className ? className : 'week-number-calendar'}
                title={`Week-day ${weekDay ?? 'test'}`}
                onClick={(e) => {
                    e.stopPropagation();
                    if (date && this.state.view === 'month') {
                        this.setState({
                            view: 'week',
                            day: new Date(this.props.getStringDateTs(Math.floor(new Date(date).getTime() / 1000) + 60 * 60, 'MM/DD/YYYY HH:mm'))
                        })

                    }
                }}
            >
                {'v.'.translate(this.props.lang)}{week}
            </span>
        );

        const MonthWeekHederNumber = (props) => {
            const m = moment(props.date);
            return (
                <>
                    {
                        // Display week number on leftmost day in calendar view
                        m.weekday() === 1 && <WeekNumber week={m.week()} weekYear={m.weekYear()} weekDay={props.label} date={props.date} />
                    }
                    <DefaultDateHeader {...props} />
                </>
            );
        };
        const DayWeekHeaderWeekNumber = () => {
            if (this.state.day && this.state.day !== NaN) {
                let date = new Date(this.state.day);
                date.setHours(12, 0, 0, 0);
                date.setDate(date.getDate() - 1);
                const m = moment(date);

                return (
                    <WeekNumber week={m.week()} weekYear={m.weekYear()} className="week-number-calendar-day-view" />
                );
            } else {
                return null;
            }
        };

        const placeholder = 'Type text...'.translate(this.props.lang);
        const showRecurringOptions = this.showWeekAndMonthReccuringOptions();

        /**
         * @type {undefined | {
         *  _id: string;
         *  type: 'semble';
         *  semble: true;
         *  sembleId: string;
         *  title: string;
         *  doctor: string;
         *  clinic: string;
         *  group: string;
         *  sembleData: {
         *      id: string;
         *      deleted: boolean;
         *      doctor: {id: string; email: string; fullName: string;};
         *      location: {id: string; name: string;};
         *      appointment: {title: string; id: string; duration: number; price: number;};
         *      start: string;
         *      end: string;
         *      patient: SemblePatient;
         *      comments: string;
         *  };
         *  patientData: string | SemblePatient;
         *  patient?: undefined | {
         *      _id: string;
         *      name: string;
         *      ssn: string;
         *      dob?: string;
         *      email: string;
         *      phone: string;
         *      gender: string;
         *      address: {
         *          street?: string;
         *          city?: string;
         *          zip?: string;
         *      }
         *  };
         *  date: string;
         *  startTime: string;
         *  endTime: string;
         *  startTimeNum: number;
         *  endTimeNum: number;
         *  canEdit?: boolean;
         *  referral?: string;
         * }}
         */
        let _sembleEvent = undefined;
        let _semblePatient = undefined;
        if (this.state.sembleEvent) {
            _sembleEvent = this.state.sembleEvent;
            if (_sembleEvent?.patient) _semblePatient = _sembleEvent.patient;
            else if (_sembleEvent?.patientData && typeof _sembleEvent.patientData === 'object') {
                _semblePatient = {
                    _id: _sembleEvent.patientData.id,
                    name: _sembleEvent.patientData.fullName,
                    dob: _sembleEvent.patientData.dob,
                    ssn: null,
                    email: _sembleEvent.patientData.email,
                    phone: null,
                    gender: _sembleEvent.patientData.gender,
                    address: {
                        city: _sembleEvent.patientData.address?.city || '',
                        zip: _sembleEvent.patientData.address?.postcode || '',
                        street: _sembleEvent.patientData.address?.address || '',
                    }
                };
                if (_sembleEvent.patientData.phones?.length) {
                    const mobile = _sembleEvent.patientData.phones.find(p => p.phoneType === 'Mobile');
                    if (mobile && mobile.phoneNumber) _semblePatient.phone = mobile.phoneNumber;
                    else _semblePatient.phone = _sembleEvent.patientData.phones[0]?.phoneNumber;
                }
            }
            // Check if start datetime of event is in the future - if is allow editing
            _sembleEvent.canEdit = _sembleEvent.startTimeNum > Math.floor(new Date().getTime() / 1000);
        }

        let hasSembleUpdate = false;
        if (this.state.sembleEventUpdate) {
            if (this.state.sembleEventUpdate.values && this.state.sembleEventUpdate.oldValues) {
                if (this.state.sembleEventUpdate.values.doctor !== this.state.sembleEventUpdate.oldValues.doctor) hasSembleUpdate = true;
                if (this.state.sembleEventUpdate.values.location !== this.state.sembleEventUpdate.oldValues.location) hasSembleUpdate = true;
                if (this.state.sembleEventUpdate.values.date !== this.state.sembleEventUpdate.oldValues.date) hasSembleUpdate = true;
                if (this.state.sembleEventUpdate.values.startTime !== this.state.sembleEventUpdate.oldValues.startTime) hasSembleUpdate = true;
                if (this.state.sembleEventUpdate.values.endTime !== this.state.sembleEventUpdate.oldValues.endTime) hasSembleUpdate = true;
            }
        }

        let params = {};
        if (this.state.useState) {
            params = this.state.params;
        } else {
            params = getSearchParams(this.props[0].location.search, { entries: 10, page: 0 })
        }
        // console.log()
        // let calendarConf = { min: this.state.min, max: this.state.max };

        let _minDateTs = Math.floor(new Date(this.state.min).getTime() / 1000);
        let _maxDateTs = Math.floor(new Date(this.state.max).getTime() / 1000);

        let _minDateString = this.props.getStringDateTs(_minDateTs, 'MM/DD/YYYY HH:mm');
        let _maxDateString = this.props.getStringDateTs(_maxDateTs, 'MM/DD/YYYY HH:mm');


        let calendarConf = {
            min: new Date(_minDateString),
            max: new Date(_maxDateString)
        };

        if (this.state.day) {
            // min: 8
            // hocu: 10
            // razlika: 2
            // scrollToTimeSat:  2

            let newDay = new Date(this.state.day.getTime() - this.state.min.getHours() * 60 * 60 * 1000 - this.state.min.getMinutes() * 60 * 1000 - 10 * 60 * 1000)
            calendarConf.scrollToTime = newDay;
        }

        if (this.state.searchIsOn || this.state.scroll) {
            // delete calendarConf.min
            // delete calendarConf.max
        } else {
            delete calendarConf.scrollToTime

        }

        const humanReadable = {
            'waiting-for-approval': 'Waiting for approval',
            'disallowed': 'Disallowed',
            'allowed': 'Allowed',
            'return-for-update': 'Return for update',
            'patient-requested-another-time': 'Patient requested anoother time',
            'patient-rejected': 'Cancelled by patient', // 'Rejected by patient',
            'patient-accepted': 'Patient accepted',
            'clinic-accepted-requested-time': 'Clinic accepted requested time',
            'clinic-rejected-requested-time': 'Clinic rejected requested time',
            'approved-by-region-manager': 'Approved by region manager',
            'rejected-by-region-manager': 'Rejected by region manager',
            'scheduled': 'Scheduled',
            'canceled-by-clinic': 'Cancelled by clinician', // 'Canceled by clinic'
            'not-booked': 'Cancelled by clinician', //'Not booked',
            'closed': 'Closed',
            'requested-new-appointment': 'Requested new appointment'.translate(this.props.lang),
            'visit-rescheduled': 'Visit rescheduled'.translate(this.props.lang),
            'external': 'External transfer'.translate(this.props.lang),
            'not-scheduled': 'Not scheduled',

        }
        let searchCount = 0;

        // if (this.state.searchParam) searchCount = this.countItems(this.state.searchParam);

        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }

        let enterprise = this.props.uData && this.props.uData.clinicGroups && this.props.uData.clinicGroups[selectedGroupIdx] && this.props.uData.clinicGroups[selectedGroupIdx].enterprise;
        let canSearchPatients = this.props.uData && this.props.uData.clinicGroups && this.props.uData.clinicGroups[selectedGroupIdx] && this.props.uData.clinicGroups[selectedGroupIdx].sarchPatients;

        let canOpenProfile = false;
        if (this.state.clinicGroupSettings?.enterprise || this.state.clinicGroupSettings?.canSearchPatients) canOpenProfile = true;

        const AGE_LIMIT = getAgeLimit(this.props.country, this.props.selectedGroup, this.props.clinicsAgeLimitExceptions);
        const isChild = typeof this.state.age === 'number' && this.state.age < AGE_LIMIT ? true : false;
        const availabilityInformationToClinicians = this.props?.uData?.clinicGroups?.[selectedGroupIdx]?.bookingSettings?.availabilityInformationToClinicians ?? null;

        const eventMeetings = this.props?.uData?.clinicGroups?.[selectedGroupIdx]?.eventMeetings ?? false;

        const groupData = this.props?.uData?.clinicGroups?.[selectedGroupIdx];
        const EXTENDED_PAYMENT_MANAGEMENT = getExtendedPaymentManagement(groupData);
        const administrativeBookingsEnabled = true; // groupData?.administrativeBookings ? true : false;

        const msg = translateAgeLimitMessage(
            "Child is under {AGE_LIMIT} years of age - Account must be connected to a parent- or legal guardian account.",
            this.props.lang,
            AGE_LIMIT
        );
        const msg2 = translateAgeLimitMessage(
            "Child is under {AGE_LIMIT} years of age - Appointments are handled by parent or legal guardian.",
            this.props.lang,
            AGE_LIMIT
        );

        let _showStatusHistoryButton = null;
        if (this.state.previewReferral) {
            const showButton = showStatusHistoryButton(this.state.previewReferral);
            if (showButton) _showStatusHistoryButton = this.state.previewReferral;
        }


        const visitTemplates = this.props?.uData?.clinicGroups?.[selectedGroupIdx]?.visitTemplates ?? null;

        const patientInfoSettings = this.props?.uData?.clinicGroups?.[selectedGroupIdx]?.patientInfoSettings ?? null;

        const availabilityTemplatesEnabled = this.state.availabilityTemplates?.length && visitTemplates ? true : false;

        const updateEventTemplateWithReccuring = false;

        let _additionalDoctors;
        try {
            if (this.state.updateEvent?.additionalDoctors && Array.isArray(this.state.updateEvent.additionalDoctors) && this.state.updateEvent.additionalDoctors.length && this.state.doctors && Array.isArray(this.state.doctors) && this.state.doctors.length) {
                _additionalDoctors = this.state.updateEvent.additionalDoctors.map(id => {
                    const doc = this.state.doctors.find(o => o?._id === id);
                    return doc?.name ?? null;
                }).filter(i => i !== null);
            }
        } catch (err) { }

        const adminPermissionId = this.props.uData?.permissions?.admin;
        const schedulerPermissionId = this.props.uData?.permissions?.scheduler;
        const groupId = this.props.selectedGroup ?? groupData?._id ?? null;
        const clinicId = this.props.selectedClinic;
        const groupPermissionsUser = this.props.uData?.groupPermissionsUser;
        const isAdmin = groupPermissionsUser?.[groupId]?.[clinicId]?.indexOf(adminPermissionId) !== -1 || groupPermissionsUser?.[groupId]?.[clinicId]?.indexOf(schedulerPermissionId) !== -1 ? true : false;

        const journalCuroflowEnable = checkIsJournalEnabled(this.props);

        // console.log("MIN", this.props.getStringDateTs(Math.floor(new Date(this.state.min).getTime() / 1000), 'HH:mm'), "MAX", this.props.getStringDateTs(Math.floor(new Date(this.state.max).getTime() / 1000), 'HH:mm'))
        return (
            // <div className={this.props.autoHideSidebar ? "dashboard dashboard-auto-hide" : "dashboard"}>
            <div>
                <Container fluid>
                    <Row>
                        <Col lg='12'>
                            <div className='panel'>
                                <h5 className="component-header">
                                    {
                                        !this.props.hideHeaderText ?
                                            this.props.linksMeta && this.props.linksMeta[this.props[0].location.pathname] ? this.props.linksMeta[this.props[0].location.pathname][this.props.lang] : ''
                                            :
                                            null
                                    }
                                </h5>
                                <div className={`schedule-working-hours schedule-mini-content calendar-mobile-height calendar-my-calendar ${this.state.view === 'month' ? 'calendar-my-calendar-month' : ''}`} style={{ height: this.state.view == 'month' ? 'auto' : 700 }}>
                                    <div className="schedule-content ">
                                        <div className="schedule-container" style={this.props.preselectPatient && isAdmin ? { flexDirection: 'column' } : {}}>
                                            <div style={this.props.preselectPatient && isAdmin ? { display: 'flex' } : {}}>
                                                {
                                                    this.props.preselectPatient && this.props.preselectPatient !== '' && isAdmin ?
                                                        <div className="schedule-input-fullwidth-mobile">
                                                            <Label>{'Doctor:'.translate(this.props.lang)}</Label>
                                                            <Input type='select' name="schedule" className="schedule-container-input" value={this.state.doctor ? this.state.doctor : 'None'.translate(this.props.lang)}
                                                                onChange={e => this.setState({ doctor: e.target.value == -1 ? null : e.target.value, loadingDoctor: true, scroll: false }, () => {
                                                                    if (!this.state.doctor) {
                                                                        this.setState({ searchParam: '' })
                                                                    }
                                                                    this.get();
                                                                    this.getWorkingTime();
                                                                })}>
                                                                <option value={-1}>{'None'.translate(this.props.lang)}</option>

                                                                {this.state.doctors.sort((a, b) => {
                                                                    const nameA = a.name;
                                                                    const nameB = b.name;
                                                                    if (nameA < nameB) {
                                                                        return -1
                                                                    }
                                                                    if (nameA > nameB) {
                                                                        return 1
                                                                    }
                                                                }).map(item => {
                                                                    return <option value={item._id}>
                                                                        {item?.userData?.title && item?.userData?.name ? `${this.props.formatName(item?.userData?.title, item?.userData?.name)}` : item.name} - {item.username}
                                                                    </option>
                                                                })}

                                                            </Input>
                                                        </div>
                                                        :
                                                        null
                                                }

                                                <div className="schedule-step">
                                                    <Label>{'Step:'.translate(this.props.lang)}</Label>
                                                    <Input type='select'
                                                        value={this.state.step}
                                                        className="schedule-container-input"
                                                        onChange={(e) => this.setState({ step: e.target.value }, () => {
                                                            this.updateUserCalendarStep();
                                                        })}>

                                                        {/* <option value={5}>{'None'.translate(this.props.lang)}</option> */}
                                                        <option value={1}>{'1 minute'.translate(this.props.lang)}</option>
                                                        <option value={5}>{'5 minutes'.translate(this.props.lang)}</option>
                                                        <option value={10}>{'10 minutes'.translate(this.props.lang)}</option>
                                                        <option value={15}>{'15 minutes'.translate(this.props.lang)}</option>

                                                    </Input>
                                                </div>
                                            </div>

                                            <div className="timepicker-container remove-mt schedule-timepicker-new" style={{ display: 'flex', alignItems: 'center' }}>
                                                <div>
                                                    <div class="timepicker-container-text">
                                                        {'Working from:'.translate(this.props.lang)}
                                                    </div>

                                                    {/* &nbsp; */}
                                                    {
                                                        this.state.changedMinOrMax ?
                                                            <TimePickerV2
                                                                getStringDateTs={this.props.getStringDateTs}
                                                                format={'HH:mm'}
                                                                widthInput={typeof window !== 'undefined' && window.innerWidth > 768 && window.innerWidth < 991 ? 125 : 146}
                                                                value={this.props.getStringDateTs(Math.floor(new Date(this.state.min).getTime() / 1000), 'HH:mm')}
                                                                flag={2}
                                                                onChange={(time1, timeString) => {
                                                                    // console.log('timeString', timeString)
                                                                    let oldDate = this.state.min;
                                                                    let currentDateStr = this.props.getStringDateTs(Math.floor(new Date().getTime() / 1000), 'MM/DD/YYYY');
                                                                    let newDate = new Date(`${currentDateStr} ${timeString}`);

                                                                    let maxDateStr = this.props.getStringDateTs(Math.floor(new Date(this.state.max).getTime() / 1000), 'MM/DD/YYYY HH:mm');
                                                                    let max = new Date(maxDateStr);

                                                                    let _newDateHours = timeString?.split?.(':')?.[0] ?? '0';
                                                                    let _newDateMinutes = timeString?.split?.(':')?.[1] ?? '0';
                                                                    let maxDateStrHours = this.props.getStringDateTs(Math.floor(new Date(this.state.max).getTime() / 1000), 'HH');
                                                                    let maxDateStrMinutes = this.props.getStringDateTs(Math.floor(new Date(this.state.max).getTime() / 1000), 'mm');

                                                                    let newDateHours = _newDateHours && Number(_newDateHours) !== 'NaN' ? Number(_newDateHours) : new Date(newDate).getHours();
                                                                    let newDateMinutes = _newDateMinutes && Number(_newDateMinutes) !== 'NaN' ? Number(_newDateMinutes) : new Date(newDate).getMinutes();
                                                                    let maxDateHours = maxDateStrHours && Number(maxDateStrHours) !== 'NaN' ? Number(maxDateStrHours) : new Date(max).getHours();
                                                                    let maxDateMinutes = maxDateStrMinutes && Number(maxDateStrMinutes) !== 'NaN' ? Number(maxDateStrMinutes) : new Date(max).getMinutes();

                                                                    let newDateSum = newDateHours * 60 + newDateMinutes;
                                                                    let maxDateSum = maxDateHours * 60 + maxDateMinutes;



                                                                    if (newDateSum < maxDateSum && isValidDate(newDate)) {
                                                                        this.setState({ min: new Date(this.props.getStringDateInverseTsV1(Math.floor(new Date(newDate).getTime() / 1000), 'MM/DD/YYYY HH:mm')) });
                                                                    } else {
                                                                        this.setState({ min: oldDate });
                                                                    }
                                                                    // if (newDate.getTime() < max.getTime() && isValidDate(newDate)) {
                                                                    //     this.setState({ min: newDate });
                                                                    // } else {
                                                                    //     this.setState({ min: oldDate });
                                                                    // }
                                                                }}
                                                            />
                                                            :
                                                            null
                                                    }
                                                </div>


                                                <div>
                                                    <span className='calendar-title-to-text'>{"to:".translate(this.props.lang)}</span>

                                                    {
                                                        this.state.changedMinOrMax ?
                                                            <TimePickerV2
                                                                getStringDateTs={this.props.getStringDateTs}
                                                                format={'HH:mm'}
                                                                widthInput={typeof window !== 'undefined' && window.innerWidth > 768 && window.innerWidth < 991 ? 125 : 146}
                                                                value={this.props.getStringDateTs(Math.floor(new Date(this.state.max).getTime() / 1000), 'HH:mm')}
                                                                flag={2}
                                                                onChange={(time1, timeString) => {
                                                                    let oldDate = this.state.max;
                                                                    let newDate = new Date(this.props.getStringDateTs(Math.floor(new Date().getTime() / 1000), 'MM/DD/YYYY HH:mm'))
                                                                    let time = timeString.split(':')
                                                                    newDate.setHours(time[0], time[1], 0)
                                                                    let min = new Date(`${this.props.getStringDateTs(Math.floor(new Date().getTime() / 1000), 'MM/DD/YYYY')} ${this.props.getStringDateTs(Math.floor(new Date(this.state.min).getTime() / 1000), 'HH:mm')}`)

                                                                    let _newDateHours = timeString?.split?.(':')?.[0] ?? '0';
                                                                    let _newDateMinutes = timeString?.split?.(':')?.[1] ?? '0';
                                                                    let minDateStrHours = this.props.getStringDateTs(Math.floor(new Date(this.state.min).getTime() / 1000), 'HH');
                                                                    let minDateStrMinutes = this.props.getStringDateTs(Math.floor(new Date(this.state.min).getTime() / 1000), 'mm');

                                                                    let newDateHours = _newDateHours && Number(_newDateHours) !== 'NaN' ? Number(_newDateHours) : new Date(newDate).getHours();
                                                                    let newDateMinutes = _newDateMinutes && Number(_newDateMinutes) !== 'NaN' ? Number(_newDateMinutes) : new Date(newDate).getMinutes();
                                                                    let minDateHours = minDateStrHours && Number(minDateStrHours) !== 'NaN' ? Number(minDateStrHours) : new Date(max).getHours();
                                                                    let minDateMinutes = minDateStrMinutes && Number(minDateStrMinutes) !== 'NaN' ? Number(minDateStrMinutes) : new Date(max).getMinutes();

                                                                    let newDateSum = newDateHours * 60 + newDateMinutes;
                                                                    let minDateSum = minDateHours * 60 + minDateMinutes;

                                                                    if (newDateSum > minDateSum && isValidDate(newDate))
                                                                        this.setState({ max: new Date(this.props.getStringDateInverseTsV1(Math.floor(new Date(newDate).getTime() / 1000), 'MM/DD/YYYY HH:mm')) })

                                                                    // if (newDate.getTime() > min.getTime() && isValidDate(newDate))
                                                                    //     this.setState({ max: new Date(this.props.getStringDateInverseTsV1(Math.floor(new Date(newDate).getTime() / 1000), 'MM/DD/YYYY HH:mm')) })
                                                                    // // else {
                                                                    // //     this.setState({ max: newDate }, () => { this.setState({ max: oldDate }) })
                                                                    // // }
                                                                }}
                                                            />
                                                            :
                                                            null
                                                    }
                                                </div>

                                                {/* <TimePicker
                                                    getStringDateTs={this.props.getStringDateTs}
                                                    format={'HH:mm'}
                                                    value={moment(this.state.min)}
                                                    flag={2}
                                                    onChange={(time1, timeString) => {
                                                        let oldDate = this.state.min;
                                                        let newDate = new Date()
                                                        let time = timeString.split(':')
                                                        newDate.setHours(time[0], time[1], 0)

                                                        if (newDate.getTime() < this.state.max.getTime() && isValidDate(newDate))
                                                            this.setState({ min: newDate })
                                                        // else {
                                                        //     this.setState({ min: newDate }, () => { this.setState({ min: oldDate }) })
                                                        // }
                                                    }}
                                                    allowClear={false}

                                                />
                                                <span>{"to:".translate(this.props.lang)}</span>

                                                <TimePicker
                                                    getStringDateTs={this.props.getStringDateTs}
                                                    format={'HH:mm'}
                                                    value={moment(this.state.max)}
                                                    flag={2}
                                                    onChange={(time1, timeString) => {
                                                        let oldDate = this.state.max;
                                                        let newDate = new Date()
                                                        let time = timeString.split(':')
                                                        newDate.setHours(time[0], time[1], 0)
                                                        if (newDate.getTime() > this.state.min.getTime() && isValidDate(newDate))
                                                            this.setState({ max: newDate })
                                                        // else {
                                                        //     this.setState({ max: newDate }, () => { this.setState({ max: oldDate }) })
                                                        // }
                                                    }}
                                                    allowClear={false}
                                                /> */}


                                                <Button color='primary' className="custom-button" style={{ paddingTop: 12, paddingBottom: 12, paddingLeft: 21, paddingRight: 21, marginLeft: 0 }} onClick={() => this.update()}>
                                                    {/* {'Save'.translate(this.props.lang).translate(this.props.lang)} */}
                                                    {
                                                        this.state.showPlayer ? (
                                                            <Player
                                                                onEvent={(event) => {
                                                                    if (event === "load" && this.player && this.player.current) this.stopAnimation();
                                                                }}
                                                                onStateChange={this.toggleVisibility}
                                                                ref={this.player} // set the ref to your class instance
                                                                autoplay={true}
                                                                loop={true}
                                                                controls={true}
                                                                src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                                                style={{ height: "auto", width: "30px" }}
                                                            ></Player>

                                                        ) : this.state.showPlayer2 ? (
                                                            <div style={{ display: 'flex', alignItems: 'center' }}><Player
                                                                onStateChange={this.toggleVisibility}
                                                                ref={this.player2} // set the ref to your class instance
                                                                autoplay={true}
                                                                loop={true}
                                                                controls={true}
                                                                src="https://assets10.lottiefiles.com/packages/lf20_CxyxLk.json"
                                                                style={{ height: "auto", width: "30px" }}
                                                            ></Player>
                                                                {'Saved'.translate(this.props.lang)}
                                                            </div>
                                                        ) : (
                                                            "Save".translate(this.props.lang)
                                                        )
                                                    }
                                                </Button>
                                            </div>
                                            {/* Vrati
                                            <div style={{ padding: 12 }}>
                                                <Button color='primary' style={{ paddingTop: 12, paddingBottom: 12, paddingLeft: 21, paddingRight: 21 }} onClick={() => this.update()}>{'Save'.translate(this.props.lang).translate(this.props.lang)}</Button>
                                            </div>
                                            */}


                                        </div>
                                        <div style={{ padding: 12, paddingRight: 0 }}>
                                            <Button className="schedule-button" color='primary' style={{ paddingTop: 12, paddingBottom: 12, paddingLeft: 21, paddingRight: 21 }} onClick={() => {
                                                // this.handleSelectFree()
                                                this.handleSelect();
                                            }}>{'Schedule event/appointment'.translate(this.props.lang).translate(this.props.lang)}</Button>
                                        </div>
                                    </div>
                                    {/* <div style={{ display: 'flex', alignItems: 'center', width: '100%', position: 'relative', justifyContent: 'space-between' }} className="mob-flex-col">
                                        <div style={{ alignItems: 'center', display: 'flex' }} className={`flex search-mob-calendar ${USE_FILTER_V2 ? 'search-mob-calendar-v2' : ''}`}>
                                            {USE_FILTER_V2 ? <>
                                                <Input
                                                    type='search'
                                                    style={{ marginRight: 10 }}
                                                    placeholder={placeholder}
                                                    value={this.state.filterV2}
                                                    onFocus={() => this.setState({ isFilterV2InFocus: true })}
                                                    onBlur={() => this.setState({ isFilterV2InFocus: false })}
                                                    onChange={(e) => {
                                                        let value = e.target.value;
                                                        this.setState({ filterV2: value }, () => {
                                                            if (this.state.filterV2.trim() === '') {
                                                                this.setState({
                                                                    showFromTo: false,
                                                                    searchItemNumber: 0,
                                                                    day: new Date(),
                                                                    searchIsOn: false,
                                                                    searchParam: '',
                                                                })
                                                            }
                                                        });
                                                    }}
                                                />
                                                <Button
                                                    color='primary'
                                                    className='search-mob-calendar-button'
                                                    size='lg'
                                                    onClick={() => {
                                                        if (this.state.filterV2.trim() === '') return;
                                                        this.setState({
                                                            searchParam: this.state.filterV2,
                                                            searchIsOn: true,
                                                        }, () => this.searchEvents(this.state.searchParam))
                                                    }}
                                                    disabled={this.state.filterV2.trim() === ''}
                                                >
                                                    {'Search'.translate(this.props.lang)}
                                                </Button>
                                            </> : <>
                                                <Label>{'Search:'.translate(this.props.lang)}</Label>
                                                <Input style={{ margin: 10 }} type='text' onChange={e => {
                                                    if (e.target.value == '') {
                                                        this.setState({
                                                            showFromTo: false,
                                                            searchItemNumber: 0,
                                                            day: new Date(),
                                                            searchIsOn: false,
                                                            searchParam: '',
                                                        })
                                                    } else {
                                                        this.setState({
                                                            searchParam: e.target.value,
                                                            searchIsOn: true,
                                                        }, () => this.searchEvents(this.state.searchParam))
                                                    }


                                                }} />
                                            </>}
                                        </div>
                                        {this.state.showFromTo ?
                                            <div style={{ display: 'flex' }}>
                                                <Button onClick={() => {

                                                    this.setState({
                                                        searchItemNumber: this.state.searchItemNumber - 1
                                                    }, () => this.searchEvents(this.state.searchParam))


                                                }} color='primary' style={{ margin: 10 }} disabled={this.state.disabledBack}>{'Back'.translate(this.props.lang)}</Button>
                                                <p style={{ alignItems: 'center', display: 'flex', paddingTop: 15 }}>{this.state.searchItemNumber + 1} / {this.countItems(this.state.searchParam)}</p>

                                                <Button onClick={() => {

                                                    this.setState({
                                                        searchItemNumber: this.state.searchItemNumber + 1
                                                    }, () => this.searchEvents(this.state.searchParam))


                                                }} color='primary' style={{ margin: 10 }} disabled={searchCount - 1 == this.state.searchItemNumber}>{'Next'.translate(this.props.lang)}</Button>
                                            </div>
                                            : null}
                                    </div> */}



                                    <Calendar
                                        culture={this.props.culture}
                                        localizer={localizer}
                                        tooltipAccessor={null}
                                        views={typeof window != 'undefined' && window.innerWidth < 768 ? ['day', 'agenda'] : ['month', 'week', 'work_week', 'day', 'agenda']}
                                        messages={{
                                            noEventsInRange: 'There are no events in this range'.translate(this.props.lang),
                                            date: 'Date'.translate(this.props.lang),
                                            time: 'Time'.translate(this.props.lang),
                                            event: 'Event'.translate(this.props.lang),
                                            agenda: 'Agenda'.translate(this.props.lang),
                                            allDay: 'All day'.translate(this.props.lang),
                                            month: 'Month'.translate(this.props.lang),
                                            day: 'Day'.translate(this.props.lang),
                                            today: 'Today'.translate(this.props.lang),
                                            previous: 'Previous'.translate(this.props.lang),
                                            next: 'Next'.translate(this.props.lang),
                                            tomorrow: 'Tomorrow'.translate(this.props.lang),
                                            week: 'Week'.translate(this.props.lang),
                                            work_week: 'Work week'.translate(this.props.lang),
                                            yesterday: 'Yesterday'.translate(this.props.lang),
                                            showMore: (total) => `+${total} ${'more'.translate(this.props.lang)}`

                                        }}
                                        events={[...this.state.holidayEvents, ...this.state.items?.filter(item => /*item.group.toString() == this.props.selectedGroup.toString() &&*/(item.type != 'temporaryEvent' || (item.type == 'temporaryEvent' && this.state.view == 'month')))].map(item => {

                                            if (!item) return null;
                                            let start = new Date(this.props.getStringDateTs(item.startTime, 'MM/DD/YYYY HH:mm'));
                                            let end = new Date(this.props.getStringDateTs(item.endTime, 'MM/DD/YYYY HH:mm'));
                                            // if ((new Date(item.endTime * 1000).getHours() > new Date(this.state.min).getHours() || (new Date(item.endTime * 1000).getHours() == new Date(this.state.min).getHours() && new Date(item.endTime * 1000).getMinutes() > new Date(this.state.min).getMinutes())) || this.state.view == 'agenda') // old condition
                                            // console.log('item: ', item)
                                            let _minDateTs = Math.floor(new Date(this.state.min).getTime() / 1000);
                                            let _minDateHours = this.props.getStringDateTs(_minDateTs, 'HH');
                                            let _minDateMinutes = this.props.getStringDateTs(_minDateTs, 'HH');

                                            let minDateHours = _minDateHours && Number(_minDateHours) !== 'NaN' ? Number(_minDateHours) : new Date(this.state.min).getHours();
                                            let minDateMinutes = _minDateMinutes && Number(_minDateMinutes) !== 'NaN' ? Number(_minDateMinutes) : new Date(this.state.min).getMinutes();
                                            minDateHours = 0;
                                            minDateMinutes = 0;

                                            let title;
                                            if ((item?.clinic !== this.props.selectedClinic && !item.allDay && item.type !== 'free') || (item.type === 'free' && item?.clinic !== this.props.selectedClinic && item?.selectedEventDepartments?.indexOf(this.props.selectedClinic) === -1)) {

                                                let type = item.type === 'free' ? 'Availability' : item.type === 'event' ? 'Event' : item?.type === 'template' ? 'Booking Template' : 'Booking';

                                                if (item.group !== this.props.selectedGroup) {
                                                    // Other group
                                                    let isInSameMainClinicGroup = false;
                                                    if (this.state.clinicGroupSettings?.mainClinicGroup?.clinics?.length) {
                                                        if (this.state.clinicGroupSettings.mainClinicGroup.clinics.find(obj => obj && obj._id && obj._id === item.group) && this.state.clinicGroupSettings.mainClinicGroup.clinics.find(obj => obj && obj._id && obj._id === this.props.selectedGroup)) isInSameMainClinicGroup = true;
                                                    }

                                                    if (isInSameMainClinicGroup) {
                                                        const name = this.state.clinicGroupSettings.mainClinicGroup.clinics.find(obj => obj && obj._id && obj._id === item.group)?.name;

                                                        title = `${type} in {clinicName}`.translate(this.props.lang).replace('{clinicName}', name || '');
                                                    } else {
                                                        title = `${type} in another clinic`.translate(this.props.lang);
                                                    }
                                                } else {
                                                    // Other department
                                                    const name = this.state.clinicGroupSettings?.departments?.find?.(obj => obj && obj._id === item.clinic)?.name;
                                                    title = `${type} in {clinicName}`.translate(this.props.lang).replace('{clinicName}', name || '');
                                                }
                                            } else {
                                                if (item._title && !item.allDay) title = item._title;
                                            }

                                            let isTeam = false;
                                            if (this.props.selectedClinic === item.clinic && this.props.selectedGroup === item.group && ['referral', 'revisit'].includes(item.type) && item?.additionalDoctors && Array.isArray(item.additionalDoctors) && item.additionalDoctors.length > 0) isTeam = true;

                                            let visitType;
                                            if (this.props.selectedClinic === item.clinic && this.props.selectedGroup === item.group && ['referral', 'revisit'].includes(item.type)) {
                                                if (item.type === 'revisit') visitType = 'Revisit/New visit';
                                                else {
                                                    if (item.scheduledBy === 'patient') visitType = 'Web booking';
                                                    else visitType = 'Booking by clinic';
                                                }
                                            }

                                            if (item.allDay && (this.state.view === 'month' || this.state.view === 'agenda')) {
                                                return null
                                            }

                                            if ((end?.getHours() > minDateHours || (end?.getHours() == minDateHours && end?.getMinutes() > minDateMinutes)) || (this.state.view == 'agenda' && !item.allDay) || (item.allDay && (this.state.view !== 'month' || this.state.view !== 'agenda'))) // new condition
                                                if (!item.reserved)
                                                    return {
                                                        id: item._id,
                                                        title: title ? title : (item?.type === 'take-care' && item.participants) ? (
                                                            item?.participants?.filter?.(obj => obj?.role === 'patient')?.length > 1 ? `Take Care - ${item?.participants?.filter?.(obj => obj?.role === 'patient')?.length} ${'Patients'.translate(this.props.lang)}${item?.healthcare_services?.length ? (' - ' + item?.healthcare_services?.[0]?.name || '') : ''}` : item.title
                                                        ) : item?.titleDoctor ? (
                                                            item.title?.translate(this.props.lang) + ',' + item.titleDoctor
                                                        ) : item.title.translate(this.props.lang),
                                                        titleDoctor: item.titleDoctor,
                                                        visitReasonName: item.visitReasonName,
                                                        visitReasonPrice: item?.visitReasonPrice,
                                                        questionaryPrice: item?.questionaryPrice,
                                                        baseTitle: item.title.translate(this.props.lang),
                                                        // start: new Date(item.startTime * 1000),
                                                        // end: new Date(item.endTime * 1000),
                                                        start: new Date(this.props.getStringDateTs(item.startTime, 'MM/DD/YYYY HH:mm')),
                                                        end: new Date(this.props.getStringDateTs(item.endTime, 'MM/DD/YYYY HH:mm')),
                                                        referral: item.referral,
                                                        additionalDoctors: item.additionalDoctors,
                                                        patientId: item.patient,
                                                        clinic: item.clinic,
                                                        group: item.group,
                                                        scheduledBy: item.scheduledBy,
                                                        type: item.type,
                                                        allActiveForms: item.allActiveForms ? item.allActiveForms : false,
                                                        eventForms: item.eventForms ? item.eventForms : [],
                                                        appointmentPaid: item.appointmentPaid,
                                                        createOnWebDoc: item.createOnWebDoc,
                                                        patientNote: item.patientNote,
                                                        onlineVisit: item.onlineVisit,
                                                        patientProfile: item.patientProfile,
                                                        additionalDoctor: item.additionalDoctor,
                                                        closeCaseManually: item.closeCaseManually,
                                                        patientControlNote: item.patientControlNote,
                                                        _2fa: item?._2fa ? true : false,
                                                        isColleagueEvent: item.isColleagueEvent,
                                                        templateData: item.templateData,
                                                        scheduleKey: item.scheduleKey,
                                                        recurringObj: (item.type === 'template' || item.type === 'event') && item.recurringObj ? item.recurringObj : null,
                                                        recurringKey: item.recurringKey ?? null,
                                                        noteToPatient: item?.noteToPatient,
                                                        takeCareData: item?.type === 'take-care' ? {
                                                            healthcare_services: item.healthcare_services || null,
                                                            participants: item.participants || null,
                                                            title: item?.healthcare_services?.[0]?.name || 'Take Care Event'.translate?.(this.props.lang),
                                                            status: item.status || null,
                                                            description: item.description || null,
                                                            comment: item.comment || null,
                                                            arbitraryTime: item.arbitraryTime
                                                        } : null,
                                                        sembleData: item?.type === 'semble' ? item.sembleData : null,
                                                        tooltip: item?._hoverTitle
                                                            ? ((isTeam ? `(${'Team visit'.translate(this.props.lang)}) ` : '') + item._hoverTitle + ((item.patientNote || item.patientControlNote) ? (` | ${'Note'.translate(this.props.lang)}: ${item.patientNote || item.patientControlNote}`) : '') + (visitType ? ` (${visitType.translate(this.props.lang)})` : ''))
                                                            : item.title && item.patientNote
                                                                ? ((isTeam ? `(${'Team visit'.translate(this.props.lang)}) ` : '') + item.title + ' | ' + 'Note'.translate(this.props.lang) + ': ' + item.patientNote + (visitType ? ` (${visitType.translate(this.props.lang)})` : ''))
                                                                : item.title && item.patientControlNote
                                                                    ? ((isTeam ? `(${'Team visit'.translate(this.props.lang)}) ` : '') + item.title + ' | ' + 'Note'.translate(this.props.lang) + ': ' + item.patientControlNote + (visitType ? ` (${visitType.translate(this.props.lang)})` : ''))
                                                                    : item.title
                                                                        ? ((isTeam ? `(${'Team visit'.translate(this.props.lang)}) ` : '') + item.title.translate(this.props.lang) + (visitType ? ` (${visitType.translate(this.props.lang)})` : ''))
                                                                        : "",
                                                        allDay: item.allDay ? item.allDay : false,
                                                        titleEn: item.titleEn ? item.titleEn : null,
                                                        _doctorName: item._doctorName ?? '',
                                                        _additionalDoctors: item._additionalDoctors ?? [],
                                                        hideTimeFromThePatient: item.hideTimeFromThePatient,
                                                        hideDurationForPatient: item.hideDurationForPatient,
                                                        isMarkedAsDone: item.type === 'event' ? item?.isMarkedAsDone?.[this.state.doctor ? this.state.doctor : this.props.uData?._id] : item?.isMarkedAsDone,
                                                        tsCreated: item?.tsCreated ?? null,
                                                        tsModified: item?.tsModified ?? null,
                                                        colleagues: item?.colleagues,
                                                        selectedEventDepartments: item?.selectedEventDepartments || [],
                                                        isMarkedForCheckIn: item?.isMarkedForCheckIn,
                                                    }
                                        })}
                                        selectable={this.state.view == 'month' ? false : true}
                                        onNavigate={day => {

                                            // let setObj = {
                                            //     day: new Date(this.props.getStringDateTs(Math.floor(new Date(day).getTime() / 1000) + 60 * 60, 'MM/DD/YYYY HH:mm')),
                                            //     scroll: false
                                            // }
                                            // this.setState(setObj, () => this.get())
                                            this.setState({
                                                day,
                                                scroll: false
                                            }, () => this.get())

                                            if (this.state.showFromTo) {
                                                this.setState({
                                                    showFromTo: false,
                                                    searchText: '',
                                                    searchItemNumber: 0,
                                                    searchIsOn: false,
                                                    searchParam: '',
                                                })
                                            }

                                        }}
                                        // date={new Date(this.props.getStringDateTs(Math.floor(new Date(this.state.day).getTime() / 1000), 'MM/DD/YYYY'))}
                                        // defaultDate={new Date(this.props.getStringDateTs(Math.floor(new Date(this.state.day).getTime() / 1000), 'MM/DD/YYYY'))}
                                        date={this.state.day}
                                        defaultDate={this.state.day}
                                        onView={(view) => {

                                            let setObj = {
                                                // day: new Date(this.props.getStringDateTs(Math.floor(new Date().getTime() / 1000), 'MM/DD/YYYY')),
                                                view
                                            }

                                            if (Math.floor(new Date().getTime() / 1000) < Math.floor(this.state.day.getTime() / 1000)) {
                                                if (this.state.view === 'month' && (view === 'week' || view === 'work_week' || view === 'day')) {
                                                    setObj.day = new Date(this.props.getStringDateTs(Math.floor(new Date(this.state.day.getFullYear(), this.state.day.getMonth(), 2).getTime() / 1000), 'MM/DD/YYYY HH:mm'))

                                                }

                                                if ((this.state.view === 'week' || this.state.view === 'work_week') && view === 'day') {
                                                    const dayOfWeek = (this.state.day.getDay() + 6) % 7;
                                                    const diff = this.state.day.getDate() - dayOfWeek;
                                                    setObj.day = new Date(this.props.getStringDateTs(Math.floor(new Date(this.state.day.getFullYear(), this.state.day.getMonth(), diff + 1).getTime() / 1000), 'MM/DD/YYYY HH:mm'))
                                                }

                                                if ((this.state.view === 'week' || this.state.view === 'work_week') && view === 'month') {
                                                    setObj.day = new Date(this.props.getStringDateTs(Math.floor(new Date(this.state.day.getFullYear(), this.state.day.getMonth(), 2).getTime() / 1000), 'MM/DD/YYYY HH:mm'))

                                                }

                                                if (this.state.view === 'day' && (view === 'week' || view === 'work_week' || view === 'month')) {
                                                    setObj.day = new Date(this.props.getStringDateTs(Math.floor(new Date(this.state.day.getFullYear(), this.state.day.getMonth(), this.state.day.getDate()).getTime() / 1000), 'MM/DD/YYYY HH:mm'))
                                                }
                                            } else {
                                                setObj.day = new Date(this.props.getStringDateTs(Math.floor(new Date().getTime() / 1000), 'MM/DD/YYYY'))
                                            }

                                            this.setState(setObj, () => this.get())


                                            if (this.state.showFromTo) {
                                                this.setState({
                                                    showFromTo: false,
                                                    searchText: '',
                                                    searchItemNumber: 0,
                                                    searchIsOn: false,
                                                    searchParam: '',
                                                })
                                            }

                                        }}
                                        view={this.state.view}
                                        step={this.state.step}
                                        timeslots={4}
                                        onSelectSlot={(event) => this.handleSelect(event)}
                                        onSelectEvent={(event) => this.selectedEvent(event)}
                                        {...calendarConf}


                                        components={{
                                            // dateHeader: MonthWeekHederNumber,
                                            day: {
                                                timeGutterHeader: DayWeekHeaderWeekNumber,
                                            },
                                            week: {
                                                timeGutterHeader: DayWeekHeaderWeekNumber,
                                            },
                                            work_week: {
                                                timeGutterHeader: DayWeekHeaderWeekNumber,
                                            },
                                            month: {
                                                dateHeader: ({ date, label }) => {
                                                    let _date = new Date(date);
                                                    _date.setHours(12, 0, 0, 0);
                                                    return (

                                                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }} onClick={() => {
                                                            this.setState({
                                                                view: 'day',
                                                                day: new Date(this.props.getStringDateTs(Math.floor(new Date(_date).getTime() / 1000), 'MM/DD/YYYY HH:mm'))
                                                            })
                                                        }}>
                                                            <div>
                                                                {
                                                                    date && moment(date).weekday() === 1 && <WeekNumber week={moment(date).week()} weekYear={moment(date).weekYear()} weekDay={label} date={date} />
                                                                }
                                                            </div>
                                                            <div style={{ color: '#333', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }} >
                                                                {
                                                                    this.state.holidayEvents && this.state.holidayEvents.filter(el => new Date(el.date).getDate() === new Date(date).getDate() && new Date(el.date).getMonth() === new Date(date).getMonth() && new Date(el.date).getFullYear() === new Date(date).getFullYear()).length > 0 ?
                                                                        <LightTooltipHoliday title={this.state.holidayEvents.filter(el => new Date(el.date).getDate() === new Date(date).getDate() && new Date(el.date).getMonth() === new Date(date).getMonth() && new Date(el.date).getFullYear() === new Date(date).getFullYear()).map((el, index) => {
                                                                            return <>
                                                                                <div key={index} style={{ marginBottom: '2px' }}>{this.props.lang === 'en' && el.titleEn ? el.titleEn.trim() : el.title.trim()}</div>
                                                                            </>
                                                                        })} placement="top-start" >
                                                                            <div className='holiday-events-month-view-wrap'  >
                                                                                <div className='holiday-events-month-view-icon-wrap'>
                                                                                    <div className='svg-wrap'>
                                                                                        <Isvg src={holidayIcon} />
                                                                                    </div>

                                                                                </div>


                                                                            </div>
                                                                        </LightTooltipHoliday>
                                                                        :
                                                                        null

                                                                }
                                                                <div style={new Date(date).getFullYear() === new Date().getFullYear() && new Date(date).getMonth() === new Date().getMonth() && new Date(date).getDate() === new Date().getDate() ? { fontWeight: 'bold' } : {}} >
                                                                    {label} {/* Usually the day number */}
                                                                </div>

                                                            </div>
                                                        </div>
                                                    )
                                                },
                                            },
                                            agenda: {
                                                date: ({ day, label }) => {
                                                    return (
                                                        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                                                            <div style={{ width: '100%', maxWidth: 120, position: 'relative' }}>
                                                                {
                                                                    this.state.holidayEvents && this.state.holidayEvents.filter(el => new Date(el.date).getDate() === new Date(day).getDate() && new Date(el.date).getMonth() === new Date(day).getMonth() && new Date(el.date).getFullYear() === new Date(day).getFullYear()).length > 0 ?
                                                                        this.state.holidayEvents.filter(el => new Date(el.date).getDate() === new Date(day).getDate() && new Date(el.date).getMonth() === new Date(day).getMonth() && new Date(el.date).getFullYear() === new Date(day).getFullYear()).map((el, index) => {
                                                                            return <LightTooltipHoliday title={this.props.lang === 'en' && el.titleEn ? el.titleEn.trim() : el.title.trim()} placement="top-start" >
                                                                                <div key={index} className="rbc-event-label " style={{ display: 'flex', width: '100%', backgroundColor: '#e7e7e7', borderTopRightRadius: '5px', borderTopRightRadius: '5px', borderBottomRightRadius: '5px', color: '#000', }}>
                                                                                    <div style={{ backgroundColor: '#e61f00', height: 20, minWidth: 10 }}></div>
                                                                                    <div style={{ paddingLeft: 5, paddingRight: 5, maxWidth: 200, fontSize: '14px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{this.props.lang === 'en' && el.titleEn ? el.titleEn.trim() : el.title.trim()}</div>
                                                                                </div>
                                                                            </LightTooltipHoliday>
                                                                        })
                                                                        :
                                                                        null
                                                                }
                                                            </div>
                                                            <div style={{ position: 'sticky', top: 5 }}>{label}</div>
                                                            <div>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            },
                                            toolbar: props => (<CustomToolbar
                                                {...props}
                                                day={this.state.day}
                                                lang={this.props.lang}
                                                isSearching={this.state.isSearching}
                                                searchText={this.state.searchText}
                                                filterV2={this.state.filterV2}
                                                onSearchBlur={() => {
                                                    this.setState({ isSearching: false })
                                                }}
                                                onSearchChange={(val) => {
                                                    this.setState({ isSearching: true })
                                                    this.setState({ filterV2: val }, () => {
                                                        if (this.state.filterV2?.trim?.() === '') {
                                                            this.setState({
                                                                showFromTo: false,
                                                                searchItemNumber: 0,
                                                                day: new Date(),
                                                                searchIsOn: false,
                                                                searchParam: '',
                                                            })
                                                        }
                                                    })
                                                }}
                                                onSearch={(label) => {
                                                    let val = this.state.filterV2;
                                                    if (!val || val?.trim?.() === '') {
                                                        this.setState({
                                                            showFromTo: false,
                                                            searchText: '',
                                                            searchItemNumber: 0,
                                                            day: new Date(),
                                                            searchIsOn: false,
                                                            searchParam: '',
                                                        })
                                                    } else {
                                                        this.setState({
                                                            searchParam: val,
                                                            searchText: label,
                                                            searchItemNumber: 0,
                                                            searchIsOn: true,
                                                        }, () => this.searchEvents(this.state.searchParam))
                                                    }
                                                }}
                                                showFromTo={this.state.showFromTo}
                                                searchItemNumber={this.state.searchItemNumber}
                                                // searchItemNumberTotal={this.state.showFromTo ? this.countItems(this.state.searchParam) : 0}
                                                searchItemNumberTotal={this.state.showFromTo && this.state.countItemsState ? this.state.countItemsState : 0}
                                                disabledBack={this.state.showFromTo ? this.state.disabledBack : false}
                                                disabledForward={this.state.showFromTo ? searchCount - 1 === this.state.searchItemNumber : false}
                                                onSearchPrev={() => {
                                                    this.setState({
                                                        searchItemNumber: this.state.searchItemNumber - 1
                                                    }, () => this.searchEvents(this.state.searchParam, false))
                                                }}
                                                onSearchNext={() => {
                                                    this.setState({
                                                        searchItemNumber: this.state.searchItemNumber + 1
                                                    }, () => this.searchEvents(this.state.searchParam, false))
                                                }}
                                                onMiniCalendarChange={(date) => {
                                                    const currentView = this.state.view;
                                                    this.setState({
                                                        day: date,
                                                        view: currentView === 'agenda' ? 'agenda' : 'day',
                                                    }, () => {
                                                        this.get();
                                                    });
                                                }}
                                            />),
                                            event: props => (<EventComponent {...props}
                                                getStringDateTs={this.props.getStringDateTs}
                                                searchParam={this.state.searchParam}
                                                markAsDone={(isDone, id) => {
                                                    this.updateEventIsDone(isDone, id, this.state.doctor ? this.state.doctor : this.props.uData?._id);
                                                }}
                                                isClinicInJournal={journalCuroflowEnable}
                                                daysWithDuplicate={this.state.daysWithDuplicate}
                                                holidayEvents={this.state.holidayEvents}
                                                setPatientProfile={(patient) => this.setState({ patientProfile: patient })}
                                                selectedEvent={(event) => this.selectedEvent(event)}
                                                setReferral={(ref, note, title) => this.setState({ referralNote: ref, patientNote: note, noteTitle: title })}
                                                setControl={(ref, note, title) => this.setState({ controlNote: ref, patientNote: note, noteTitle: title })}
                                                view={this.state.view} lang={this.props.lang} setView={(view, date) => {
                                                    this.setState({
                                                        view,
                                                        day: date
                                                    }, () => this.get())
                                                }}
                                                selectedGroup={this.props.selectedGroup}
                                                selectedClinic={this.props.selectedClinic}
                                            />)

                                        }}

                                        eventPropGetter={event => {
                                            let templateColor = null;
                                            if (event?.type === 'template' && event.templateData?.calendarColor) templateColor = hexToRgba(event.templateData.calendarColor, 0.7);
                                            let backgroundColor = getBackgroundColorForEvent(event, this.props.selectedGroup, this.props.selectedClinic, templateColor);

                                            // backgroundColor = !event.allActiveForms && event.type === 'free' && event.eventForms && event.eventForms.length < 1 && this.props.selectedClinic === event.clinic ? 'rgba(86, 200, 138, 0.5)' : this.props.selectedGroup !== event.group ? 'rgba(86, 138, 200, 0.3)' : this.props.selectedClinic != event.clinic ? 'rgba(86, 138, 200, 0.6)' : event.scheduledBy == 'patient' ? '#B256C8' : event.additionalDoctor ? '#FDAB94' : event.createOnWebDoc ? '#f06565' : event.type == 'event' ? '#DBD233' : event.type == 'referral' ? event.onlineVisit ? '#3A3F56' : '#568AC8' : event.type == 'free' ? 'green' : event.onlineVisit ? '#3A3F56' : '#60BEBB';
                                            // // TAKECARE
                                            // if (event?.type && event.type === 'take-care' || event.type === 'semble') {
                                            //     backgroundColor = '#E30B5C';
                                            //     if (event?.onlineVisit === true) backgroundColor = '#B20A4F';
                                            //     if (this.props.selectedClinic != event.clinic) backgroundColor = 'rgba(227, 11, 92, 0.5)';
                                            // }

                                            // if (event?.type === 'template' && event?.templateData?.calendarColor) {
                                            //     backgroundColor = hexToRgba(event.templateData.calendarColor, 0.7);
                                            // }

                                            let color = getTextColor(backgroundColor);
                                            let eventStyle = { backgroundColor, fontSize: 14, opacity: event.type == 'temporaryEvent' ? 0 : 1, color };
                                            if (this.props.selectedClinic !== event?.clinic && (!event?.selectedEventDepartments || (event?.selectedEventDepartments && event?.selectedEventDepartments?.indexOf(this.props.selectedClinic) === -1))) {
                                                eventStyle.cursor = 'default';
                                            }
                                            if (this.props.selectedClinic === event?.clinic && event?.selectedEventDepartments && event?.selectedEventDepartments?.length && event?.selectedEventDepartments?.indexOf(this.props.selectedClinic) === -1) {
                                                eventStyle.cursor = 'default';
                                            }
                                            if (event?.type === 'template') {
                                                eventStyle.border = `2px dotted #fff`;
                                            }

                                            if (event?.allDay) {
                                                eventStyle.backgroundColor = 'transparent';
                                            }

                                            eventStyle.gap = '10px'

                                            if (event?.isMarkedAsDone && this.state.view !== 'agenda') {
                                                eventStyle.textDecorationLine = 'line-through';
                                                eventStyle.textDecorationThickness = '3px';
                                                eventStyle.gap = '0px';
                                            }
                                            const startTs = event?.start ? Math.floor(new Date(event.start).getTime() / 1000) : null;
                                            return { style: eventStyle, className: startTs ? `rbc-event-ts-${startTs}` : '' }
                                        }}
                                        dayPropGetter={(date) => {
                                            let dateString = moment.unix(new Date(date).getTime() / 1000).format('YYYY-MM-DD')

                                            let isToday = false;
                                            if (this.props.getStringDateTs(Math.floor(new Date().getTime() / 1000), 'YYYY-MM-DD') === dateString) {
                                                isToday = true;
                                            }

                                            date = moment.unix(new Date(date).getTime() / 1000).format('YYYY-MM-DD')
                                            return { className: `date_${dateString}_date ${isToday ? 'rbc-today' : ''}` }

                                        }}
                                        dayLayoutAlgorithm={'no-overlap'}

                                    />
                                </div>
                                <CalendarLegend
                                    lang={this.props.lang}
                                    hasTakeCare={this.props.hasTakeCare}
                                    hasSemble={this.props.hasSemble}
                                    hasWebDoc={this.props.hasWebDoc}
                                />
                                {
                                    this.state.loadingDoctor ?
                                        // <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
                                        <div className="loader-wrap" >
                                            <Player
                                                autoplay={true}
                                                loop={true}
                                                src="/lf30_editor_l5cxzdyf.json"
                                                style={{ height: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px", width: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px", position: 'absolute', top: "60%", left: '50%', transform: 'translate(-50%, -50%)' }}
                                            ></Player>
                                        </div>
                                        :
                                        null
                                }
                            </div>

                        </Col>
                    </Row>

                </Container>

                {
                    this.state.referralNote && this.state.view == 'agenda' ?
                        <Modal isOpen={this.state.referralNote} centered>
                            <ModalHeader toggle={() => this.setState({ referralNote: null })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ referralNote: null })}>&times;</button>}>{'Add note'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody>
                                <FormGroup>
                                    <Label>{this.state.noteTitle}</Label>
                                </FormGroup>
                                <FormGroup>
                                    <Label className='note-label-wrap'>{'Note'.translate(this.props.lang)}
                                        <div className={this.state.patientNotes?.length ? 'notes-icon-wrap notes-icon-active' : 'notes-icon-wrap'} onClick={() => { this.setState({ showPatientNotes: true }) }}>
                                            <Isvg src={notesIcon} />
                                            <div className='tooltip-text'>{'Notes available'.translate(this.props.lang)}</div>
                                        </div>
                                    </Label>
                                    <Input type='textarea'
                                        name="note"
                                        style={{ height: '150px' }}
                                        onChange={(e) => {

                                            this.setState({
                                                patientNote: striptags(e.target.value)
                                            })
                                        }}
                                        value={this.state.patientNote}
                                    />
                                    <div style={{ display: 'flex', 'margin-top': '10px', 'margin-left': '-5px' }}>
                                        <Button color='primary' style={{ margin: 5 }} onClick={this.submitNote}>{'Save'.translate(this.props.lang)}</Button>
                                    </div>
                                </FormGroup>

                            </ModalBody>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.controlNote && this.state.view == 'agenda' ?
                        <Modal isOpen={this.state.controlNote} centered>
                            <ModalHeader toggle={() => this.setState({ controlNote: null })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ controlNote: null })}>&times;</button>}>{'Add note'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody>
                                <FormGroup>
                                    <Label>{this.state.noteTitle}</Label>
                                </FormGroup>
                                <FormGroup>
                                    <Label className='note-label-wrap'>{'Note'.translate(this.props.lang)}
                                        <div className={this.state.patientNotes?.length ? 'notes-icon-wrap notes-icon-active' : 'notes-icon-wrap'} onClick={() => { this.setState({ showPatientNotes: true }) }}>
                                            <Isvg src={notesIcon} />
                                            <div className='tooltip-text'>{'Notes available'.translate(this.props.lang)}</div>
                                        </div>
                                    </Label>
                                    <Input type='textarea'
                                        name="note"
                                        style={{ height: '150px' }}
                                        onChange={(e) => {

                                            this.setState({
                                                patientNote: striptags(e.target.value)
                                            })
                                        }}
                                        value={this.state.patientNote}
                                    />
                                    <div style={{ display: 'flex', 'margin-top': '10px', 'margin-left': '-5px' }}>
                                        <Button color='primary' style={{ margin: 5 }} onClick={this.submitControlNote}>{'Save'.translate(this.props.lang)}</Button>
                                    </div>
                                </FormGroup>

                            </ModalBody>
                        </Modal>
                        :
                        null
                }

                {this.state.patientProfile ?
                    <Modal isOpen={this.state.patientProfile} centered>
                        <ModalHeader toggle={() => this.setState({ patientProfile: null })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ patientProfile: null })}>&times;</button>}>
                            <h4>{'Patient profile'.translate(this.props.lang)}</h4>
                        </ModalHeader>
                        <ModalBody>
                            <FormGroup>
                                <Label>{'Social security number'.translate(this.props.lang)}</Label>
                                <Input type='text' disabled
                                    value={this.state.patientProfile.socialSecurityNumber} />
                            </FormGroup>
                            <FormGroup>
                                <Label>{'Name'.translate(this.props.lang)}</Label>
                                <Input type='text' disabled
                                    value={this.state.patientProfile.name} />
                            </FormGroup>
                            <FormGroup>
                                <Label>{'Email'.translate(this.props.lang)}</Label>
                                <Input type='text' disabled
                                    value={this.state.patientProfile.email} />
                            </FormGroup>
                            <FormGroup>
                                <Label>{'Phone'.translate(this.props.lang)}</Label>
                                <Input type='text' disabled
                                    value={this.state.patientProfile.phone} />
                            </FormGroup>
                            <FormGroup>
                                <Label>{'Address'.translate(this.props.lang)}</Label>
                                <Input type='text' disabled
                                    value={this.state.patientProfile.address} />
                            </FormGroup>

                            <Button color="primary" onClick={() => this.setState({ patientProfile: !this.state.patientProfile })}>{'Close'.translate(this.props.lang)}</Button>

                        </ModalBody>
                    </Modal>

                    : null}
                {this.state.patientTimeModal ?
                    <Modal isOpen={this.state.patientTimeModal} centered>
                        <ModalHeader toggle={() => this.setState({ patientTimeModal: !this.state.patientTimeModal })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ patientTimeModal: !this.state.patientTimeModal })}>&times;</button>}>{'Pick time when you can take patients.'.translate(this.props.lang)}</ModalHeader>
                        <ModalBody>
                            <FormGroup className="timepicker-container timepicker-wide">
                                <Label>{'Start time'.translate(this.props.lang)}</Label>
                                &nbsp;
                                <TimePicker
                                    getStringDateTs={this.props.getStringDateTs}
                                    format={'HH:mm'}
                                    value={moment(this.state.freeMin)}
                                    flag={2}
                                    onChange={(time1, timeString) => {
                                        let oldDate = this.state.freeMin;
                                        let newDate = new Date()
                                        let time = timeString.split(':')
                                        newDate.setHours(time[0], time[1], 0)
                                        if (newDate.getTime() < this.state.freeMax.getTime())
                                            this.setState({ freeMin: newDate })
                                        else {
                                            this.setState({ freeMin: newDate }, () => { this.setState({ freeMin: oldDate }) })
                                        }
                                    }}
                                    allowClear={false}

                                />
                            </FormGroup>
                            <FormGroup className="timepicker-container timepicker-wide">
                                <Label>{'End time'.translate(this.props.lang)}</Label>
                                &nbsp;
                                <TimePicker
                                    getStringDateTs={this.props.getStringDateTs}
                                    format={'HH:mm'}
                                    value={moment(this.state.freeMax)}
                                    flag={2}
                                    onChange={(time1, timeString) => {
                                        let oldDate = this.state.freeMax;
                                        let newDate = new Date()
                                        let time = timeString.split(':')
                                        newDate.setHours(time[0], time[1], 0)
                                        if (newDate.getTime() > this.state.freeMin.getTime())
                                            this.setState({ freeMax: newDate })
                                        else {
                                            this.setState({ freeMax: newDate }, () => { this.setState({ freeMax: oldDate }) })
                                        }
                                    }}
                                    allowClear={false}
                                />
                            </FormGroup>

                            <Button onClick={() => this.patientTime()}>{'Schedule'.translate(this.props.lang)}</Button>
                            <Button onClick={() => this.setState({ patientTimeModal: !this.state.patientTimeModal })}>{'Cancel'.translate(this.props.lang)}</Button>
                        </ModalBody>
                    </Modal>
                    : null}

                {
                    this.state.updateEventTemplatePreModal ?
                        <Modal isOpen={this.state.updateEventTemplatePreModal} centered>
                            <ModalHeader toggle={() => this.setState({ updateEventTemplatePreModal: !this.state.updateEventTemplatePreModal, doctorsList: [] })}
                                close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ updateEventTemplatePreModal: !this.state.updateEventTemplatePreModal, doctorsList: [] })}>&times;</button>}>
                                {'Select option'.translate(this.props.lang)}
                            </ModalHeader>

                            <ModalBody>
                                <div className='schedule-modal-body-wrap'>
                                    <Button color='primary'
                                        onClick={() => {
                                            let data = { ...this.state.updateEventTemplatePreModal };
                                            let scheduleControl = {
                                                date: data.date,
                                                endTime: data.date,
                                                startTime: data.startTime,
                                                endTime: data.endTime,
                                                templateData: { ...data }
                                            }

                                            this.setState({
                                                patientModal: scheduleControl,
                                                updateEventTemplatePreModal: !this.state.updateEventTemplatePreModal
                                            }, () => {
                                                // this.setVisitReasonFromTemplate();
                                                this.getLastOpenedChats()

                                            })
                                        }}
                                    >
                                        {'Schedule Appointment'.translate(this.props.lang)}
                                    </Button>
                                    <Button color='primary'
                                        onClick={() => {
                                            let updateEventTemplate = { ...this.state.updateEventTemplatePreModal }
                                            this.setState({ updateEventTemplate, updateEventTemplatePreModal: !this.state.updateEventTemplatePreModal })
                                        }}
                                    >
                                        {'Edit'.translate(this.props.lang)}
                                    </Button>

                                </div>

                            </ModalBody>
                        </Modal>
                        :
                        null
                }

                {this.state.scheduleModal ?
                    <Modal isOpen={this.state.scheduleModal} centered>
                        <ModalHeader toggle={() => this.setState({ scheduleModal: !this.state.scheduleModal, doctorsList: [] })}
                            close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ scheduleModal: !this.state.scheduleModal, doctorsList: [] })}>&times;</button>}>
                            {'Select the way to schedule'.translate(this.props.lang)}
                        </ModalHeader>

                        <ModalBody>
                            <div className='schedule-modal-body-wrap'>
                                <Button color='primary'
                                    onClick={() => {
                                        this.setState({ /*scheduleEvent: this.state.scheduleModal,*/schedulePatientTime: { ...this.state.scheduleModal, type: 'event' }, scheduleModal: !this.state.scheduleModal })
                                    }}
                                >
                                    {'Schedule event'.translate(this.props.lang)}
                                </Button>
                                <Button color='primary'
                                    onClick={() => {
                                        this.setState({ /*markAsAvailable: this.state.scheduleModal,*/schedulePatientTime: { ...this.state.scheduleModal, type: 'free', selectedEventDepartments: [this.props.selectedClinic] }, scheduleModal: !this.state.scheduleModal })
                                    }}
                                >
                                    {'Mark as available'.translate(this.props.lang)}
                                </Button>
                                {
                                    availabilityTemplatesEnabled ?
                                        <Button color='primary'
                                            onClick={() => {
                                                this.setState({ schedulePatientTime: { ...this.state.scheduleModal, type: 'template' }, scheduleModal: !this.state.scheduleModal })
                                            }}
                                        >
                                            {'Add availability template'.translate(this.props.lang)}
                                        </Button>
                                        :
                                        null
                                }
                                <Button
                                    color='primary'
                                    onClick={() => {
                                        this.setState({
                                            scheduleNewVisitDropdown: !this.state.scheduleNewVisitDropdown
                                        })
                                    }}
                                    className='schedule-new-visit-dropdown-btn'
                                    style={this.state.scheduleNewVisitDropdown ? { marginBottom: 3 } : {}}
                                >
                                    {'Schedule new visit'.translate(this.props.lang)}
                                    <Isvg
                                        src={this.state.scheduleNewVisitDropdown ? arrowUp : arrowDown}
                                        style={{ marginTop: this.state.scheduleNewVisitDropdown ? 5 : -5 }}
                                    />
                                </Button>
                                {
                                    this.state.scheduleNewVisitDropdown ?
                                        <div className='schedule-new-visit-dropdown-wrap'>
                                            <Button color='primary'
                                                onClick={() => {
                                                    if (!this.state.referralsFetched) {
                                                        this.getAllReferrals()
                                                    }
                                                    this.setState({ scheduleControl: this.state.scheduleModal, scheduleModal: !this.state.scheduleModal }, () => {
                                                        if (this.props.preselectPatient) {
                                                            this.setState({
                                                                patientSocialSecurityNumber: this.props.preselectPatient.socialSecurityNumber || '',
                                                            }, () => {
                                                                this.findPatient(() => {
                                                                    // if (!this.state.patientModal) return;
                                                                    if (!this.state.patient) return;

                                                                    if (this.state.patient?.twoFactorAuthentication?.[this.props.selectedGroup]?.createAccount && !this.state.patient?.twoFactorAuthentication?.[this.props.selectedGroup]?.infoIsVerified) return;

                                                                    let patientModal = { ...this.state.scheduleControl }
                                                                    if (isChild) {
                                                                        patientModal.title = this.state.patient.userData.name.trim()
                                                                    } else {
                                                                        patientModal.title = this.state.patient.userData.name.trim();

                                                                    }
                                                                    patientModal.socialSecurityNumber = this.state.patient.socialSecurityNumber;
                                                                    patientModal.patient = this.state.patient._id;

                                                                    let selectedParents = null;
                                                                    if (this.state.patient?.parentObj?._id) {
                                                                        selectedParents = [this.state.patient.parentObj._id]
                                                                    }
                                                                    this.setState({ scheduleControl: { ...patientModal, selectedParents }, patientSocialSecurityNumber: '', updateEventTemplate: null }, () => {
                                                                        if (this.state.scheduleControl?.patient) {
                                                                            this.patientAge(this.state.scheduleControl?.patient, () => this.setVisitReasonFromTemplate())
                                                                        } else {
                                                                            this.setVisitReasonFromTemplate();
                                                                        }
                                                                    })
                                                                })
                                                            })
                                                        }
                                                    })
                                                }}
                                            >
                                                {/* {'Schedule a new visit / revisit'.translate(this.props.lang)} */}
                                                {'New visit / revisit'.translate(this.props.lang)}
                                            </Button>

                                            <Button color='primary'
                                                onClick={() => {
                                                    if (!this.state.referralsFetched) {
                                                        this.getAllReferrals()
                                                    }
                                                    this.setState({ scheduleReferral: this.state.scheduleModal, scheduleModal: !this.state.scheduleModal })
                                                }}
                                            >
                                                {/* {'Schedule approved case'.translate(this.props.lang)} */}
                                                {'Approved / canceled visit'.translate(this.props.lang)}
                                            </Button>

                                            {
                                                administrativeBookingsEnabled ?
                                                    <AddNewAdministrativeBookingButton
                                                        {...this.props}
                                                        initialData={this.state.scheduleModal}
                                                        doctorId={this.state.doctor ? this.state.doctor : this.props?.uData?._id}
                                                        preselectPatient={this.props.preselectPatient}
                                                        toggle={() => {
                                                            this.setState({ scheduleModal: !this.state.scheduleModal, doctorsList: [] })
                                                            this.get();
                                                        }}
                                                    />
                                                    :
                                                    null
                                            }
                                        </div>
                                        :
                                        null
                                }


                            </div>

                        </ModalBody>
                    </Modal>

                    : null}

                {
                    this.state.markAsAvailable ?
                        <Modal isOpen={this.state.markAsAvailable} centered>
                            <ModalHeader toggle={() => this.setState({ markAsAvailable: !this.state.markAsAvailable, doctorsList: [] })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ markAsAvailable: !this.state.markAsAvailable, doctorsList: [] })}>&times;</button>}>{'Mark as available'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody>


                                <DatePicker
                                    label={'Date'.translate(this.props.lang)}
                                    value={this.state.markAsAvailable.date}
                                    holidayEvents={this.state.holidayEvents}
                                    lang={this.props.lang}
                                    onChange={(e) => {
                                        let markAsAvailable = this.state.markAsAvailable;
                                        markAsAvailable.date = e;
                                        this.setState({
                                            markAsAvailable
                                        })
                                        if (Math.floor(new Date(this.state.markAsAvailable.date + ' ' + this.state.markAsAvailable.startTime) / 1000) > Math.floor(new Date(this.state.markAsAvailable.endDate + ' ' + this.state.markAsAvailable.endTime) / 1000)) {
                                            markAsAvailable.endDate = this.state.markAsAvailable.date
                                            this.setState({
                                                markAsAvailable
                                            })
                                        }
                                    }}
                                />
                                <FormGroup className="timepicker-container timepicker-wide">
                                    <Label>{'Start time'.translate(this.props.lang)}</Label>
                                    &nbsp;
                                    <TimePickerV2
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={this.state.markAsAvailable.startTime}
                                        minValue={this.props.getStringDateTs(Math.floor(this.state.min.getTime() / 1000), 'HH:mm')}
                                        maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000 - 300), 'HH:mm')}
                                        flag={0}
                                        onChange={(time1, timeString) => {

                                            let markAsAvailable = this.state.markAsAvailable;
                                            markAsAvailable.startTime = timeString

                                            let startTimeSplit = markAsAvailable.startTime.split(":");
                                            let endTimeSplit = markAsAvailable.endTime.split(":");


                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                            // this.setState({ markAsAvailable })
                                            if (startTimeHourMinute < endTimeHourMinute) {
                                                this.setState({ markAsAvailable })
                                            } else {
                                                markAsAvailable.endTime = Math.trunc((Number(this.state.markAsAvailable.startTime.split(':')[0]) * 60 + Number(this.state.markAsAvailable.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.markAsAvailable.startTime.split(':')[0]) * 60 + Number(this.state.markAsAvailable.startTime.split(':')[1]) + 5) % 60
                                                // markAsAvailable.endTime = validateTime(markAsAvailable.endTime);
                                                const padded = markAsAvailable?.endTime?.split?.(':');
                                                if (padded && Array.isArray(padded) && padded.length && isStringAValidNumber(padded[0]) && isStringAValidNumber(padded[1])) {
                                                    const h = padded[0]?.padStart?.(2, '0');
                                                    const m = padded[1]?.padStart?.(2, '0');
                                                    if (h && m) markAsAvailable.endTime = `${h}:${m}`;
                                                }
                                                this.setState({
                                                    markAsAvailable
                                                })
                                            }


                                        }}
                                    />
                                    {/* <TimePicker
                                        log={true}
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={moment(new Date(this.state.markAsAvailable.date.replace(/-/g, "/") + " " + this.state.markAsAvailable.startTime))}
                                        // maxValue={this.state.markAsAvailable.endTime}
                                        minValue={this.props.getStringDateTs(Math.floor(this.state.min.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.min.getTime() / 1000).format("HH:mm")
                                        maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                        flag={0}
                                        onChange={(time1, timeString) => {

                                            let markAsAvailable = this.state.markAsAvailable;
                                            markAsAvailable.startTime = timeString

                                            let startTimeSplit = markAsAvailable.startTime.split(":");
                                            let endTimeSplit = markAsAvailable.endTime.split(":");


                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                            this.setState({ markAsAvailable })


                                        }}
                                        allowClear={false}
                                    /> */}
                                </FormGroup>
                                <FormGroup className="timepicker-container timepicker-wide">
                                    <Label>{'End time'.translate(this.props.lang)}</Label>
                                    &nbsp;
                                    <TimePickerV2
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={this.state.markAsAvailable.endTime}
                                        minValue={Math.trunc((Number(this.state.markAsAvailable.startTime.split(':')[0]) * 60 + Number(this.state.markAsAvailable.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.markAsAvailable.startTime.split(':')[0]) * 60 + Number(this.state.markAsAvailable.startTime.split(':')[1]) + 5) % 60}
                                        maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')}
                                        flag={0}
                                        onChange={(time1, timeString) => {

                                            let markAsAvailable = this.state.markAsAvailable;
                                            markAsAvailable.endTime = timeString

                                            let startTimeSplit = markAsAvailable.startTime.split(":");
                                            let endTimeSplit = markAsAvailable.endTime.split(":");

                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                            if (startTimeHourMinute < endTimeHourMinute) {
                                                this.setState({ markAsAvailable })

                                            } else {
                                            }

                                        }}
                                    />
                                    {/* <TimePicker
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={moment(new Date(this.state.markAsAvailable.date.replace(/-/g, "/") + " " + this.state.markAsAvailable.endTime))}
                                        minValue={Math.trunc((Number(this.state.markAsAvailable.startTime.split(':')[0]) * 60 + Number(this.state.markAsAvailable.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.markAsAvailable.startTime.split(':')[0]) * 60 + Number(this.state.markAsAvailable.startTime.split(':')[1]) + 5) % 60}
                                        maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                        flag={0}
                                        // maxValue={this.state.markAsAvailable.startTime}
                                        // flag={1}
                                        onChange={(time1, timeString) => {

                                            let markAsAvailable = this.state.markAsAvailable;
                                            markAsAvailable.endTime = timeString

                                            let startTimeSplit = markAsAvailable.startTime.split(":");
                                            let endTimeSplit = markAsAvailable.endTime.split(":");

                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                            if (startTimeHourMinute < endTimeHourMinute) {
                                                this.setState({ markAsAvailable })

                                            } else {
                                            }

                                        }}
                                        allowClear={false}
                                    /> */}
                                </FormGroup>
                                <FormGroup>
                                    <Checkbox
                                        onChange={(e) => {
                                            let markAsAvailable = this.state.markAsAvailable;
                                            markAsAvailable.recurring = e.target.checked;
                                            this.setState({
                                                markAsAvailable
                                            })
                                        }}
                                        checked={this.state.markAsAvailable.recurring}
                                        label={'Recurring event'.translate(this.props.lang)}
                                    />
                                </FormGroup>
                                <div style={{ display: 'flex' }}>
                                    <Button color='primary' onClick={() => {
                                        if (this.state.markAsAvailable.recurring) {
                                            this.setState({ recurringModal: { ...this.state.markAsAvailable, typeOfEvent: 2 }, markAsAvailable: null })
                                        } else {
                                            this.markAsAvailable(this.state.markAsAvailable)
                                        }

                                    }}>{'Mark as available'.translate(this.props.lang)}</Button>


                                </div>

                            </ModalBody>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.scheduleEvent ?
                        <Modal isOpen={this.state.scheduleEvent} centered>
                            <ModalHeader toggle={() => this.setState({ scheduleEvent: !this.state.scheduleEvent, doctorsList: [] })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ scheduleEvent: !this.state.scheduleEvent, doctorsList: [] })}>&times;</button>}>{'Schedule event'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody>
                                <FormGroup>
                                    <Label>{'Title'.translate(this.props.lang)}</Label>
                                    <Input type='text' onChange={(e) => {
                                        let scheduleEvent = this.state.scheduleEvent;
                                        scheduleEvent.title = striptags(e.target.value);
                                        this.setState({
                                            scheduleEvent
                                        })
                                    }}
                                        value={this.state.scheduleEvent.title} />
                                </FormGroup>

                                <DatePicker
                                    label={'Date'.translate(this.props.lang)}
                                    value={this.state.scheduleEvent.date}
                                    holidayEvents={this.state.holidayEvents}
                                    lang={this.props.lang}
                                    onChange={(e) => {
                                        let scheduleEvent = this.state.scheduleEvent;
                                        scheduleEvent.date = e;
                                        this.setState({
                                            scheduleEvent
                                        })
                                        if (Math.floor(new Date(this.state.scheduleEvent.date + ' ' + this.state.scheduleEvent.startTime) / 1000) > Math.floor(new Date(this.state.scheduleEvent.endDate + ' ' + this.state.scheduleEvent.endTime) / 1000)) {
                                            scheduleEvent.endDate = this.state.scheduleEvent.date
                                            this.setState({
                                                scheduleEvent
                                            })
                                        }
                                    }}
                                />
                                <FormGroup className="timepicker-container timepicker-wide">
                                    <Label>{'Start time'.translate(this.props.lang)}</Label>
                                    &nbsp;
                                    <TimePickerV2
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={this.state.scheduleEvent.startTime}
                                        minValue={this.props.getStringDateTs(Math.floor(this.state.min.getTime() / 1000), 'HH:mm')}
                                        maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000 - 300), 'HH:mm')}
                                        flag={0}
                                        onChange={(time1, timeString) => {

                                            let scheduleEvent = this.state.scheduleEvent;
                                            scheduleEvent.startTime = timeString

                                            let startTimeSplit = scheduleEvent.startTime.split(":");
                                            let endTimeSplit = scheduleEvent.endTime.split(":");


                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                            // this.setState({ scheduleEvent })
                                            if (startTimeHourMinute < endTimeHourMinute) {
                                                this.setState({ scheduleEvent })
                                            } else {
                                                scheduleEvent.endTime = Math.trunc((Number(this.state.scheduleEvent.startTime.split(':')[0]) * 60 + Number(this.state.scheduleEvent.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.scheduleEvent.startTime.split(':')[0]) * 60 + Number(this.state.scheduleEvent.startTime.split(':')[1]) + 5) % 60
                                                // scheduleEvent.endTime = validateTime(scheduleEvent.endTime);
                                                const padded = scheduleEvent?.endTime?.split?.(':');
                                                if (padded && Array.isArray(padded) && padded.length && isStringAValidNumber(padded[0]) && isStringAValidNumber(padded[1])) {
                                                    const h = padded[0]?.padStart?.(2, '0');
                                                    const m = padded[1]?.padStart?.(2, '0');
                                                    if (h && m) scheduleEvent.endTime = `${h}:${m}`;
                                                }
                                                this.setState({
                                                    scheduleEvent
                                                })
                                            }


                                        }}
                                    />
                                    {/* <TimePicker
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={moment(new Date(this.state.scheduleEvent.date.replace(/-/g, "/") + " " + this.state.scheduleEvent.startTime))}
                                        // maxValue={this.state.scheduleEvent.endTime}
                                        minValue={this.props.getStringDateTs(Math.floor(this.state.min.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.min.getTime() / 1000).format("HH:mm")
                                        maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                        flag={0}
                                        onChange={(time1, timeString) => {

                                            let scheduleEvent = this.state.scheduleEvent;
                                            scheduleEvent.startTime = timeString

                                            let startTimeSplit = scheduleEvent.startTime.split(":");
                                            let endTimeSplit = scheduleEvent.endTime.split(":");


                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                            this.setState({ scheduleEvent })


                                        }}
                                        allowClear={false}
                                    /> */}
                                </FormGroup>
                                <FormGroup className="timepicker-container timepicker-wide">
                                    <Label>{'End time'.translate(this.props.lang)}</Label>
                                    &nbsp;
                                    <TimePickerV2
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={this.state.scheduleEvent.endTime}
                                        minValue={Math.trunc((Number(this.state.scheduleEvent.startTime.split(':')[0]) * 60 + Number(this.state.scheduleEvent.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.scheduleEvent.startTime.split(':')[0]) * 60 + Number(this.state.scheduleEvent.startTime.split(':')[1]) + 5) % 60}
                                        maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')}
                                        flag={0}
                                        onChange={(time1, timeString) => {

                                            let scheduleEvent = this.state.scheduleEvent;
                                            scheduleEvent.endTime = timeString

                                            let startTimeSplit = scheduleEvent.startTime.split(":");
                                            let endTimeSplit = scheduleEvent.endTime.split(":");

                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                            if (startTimeHourMinute < endTimeHourMinute) {
                                                this.setState({ scheduleEvent })

                                            } else {
                                            }

                                        }}
                                    />
                                    {/* <TimePicker
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={moment(new Date(this.state.scheduleEvent.date.replace(/-/g, "/") + " " + this.state.scheduleEvent.endTime))}
                                        minValue={Math.trunc((Number(this.state.scheduleEvent.startTime.split(':')[0]) * 60 + Number(this.state.scheduleEvent.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.scheduleEvent.startTime.split(':')[0]) * 60 + Number(this.state.scheduleEvent.startTime.split(':')[1]) + 5) % 60}
                                        maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                        flag={0}
                                        // maxValue={this.state.scheduleEvent.startTime}
                                        // flag={1}
                                        onChange={(time1, timeString) => {

                                            let scheduleEvent = this.state.scheduleEvent;
                                            scheduleEvent.endTime = timeString

                                            let startTimeSplit = scheduleEvent.startTime.split(":");
                                            let endTimeSplit = scheduleEvent.endTime.split(":");

                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                            if (startTimeHourMinute < endTimeHourMinute) {
                                                this.setState({ scheduleEvent })

                                            } else {
                                            }

                                        }}
                                        allowClear={false}
                                    /> */}
                                </FormGroup>
                                <FormGroup>
                                    <Checkbox
                                        onChange={(e) => {
                                            let scheduleEvent = this.state.scheduleEvent;
                                            scheduleEvent.recurring = e.target.checked;
                                            this.setState({
                                                scheduleEvent
                                            })
                                        }}
                                        checked={this.state.scheduleEvent.recurring}
                                        label={'Recurring event'.translate(this.props.lang)}
                                    />
                                </FormGroup>
                                <div style={{ display: 'flex' }}>
                                    <Button color='primary' disabled={this.state.scheduleEvent.title ? false : true} onClick={() => {
                                        if (this.state.scheduleEvent.recurring) {
                                            this.setState({ recurringModal: { ...this.state.scheduleEvent, typeOfEvent: 1 }, scheduleEvent: null })
                                        } else {
                                            this.scheduleEvent(this.state.scheduleEvent)
                                        }

                                    }}>{'Schedule event'.translate(this.props.lang)}</Button>


                                </div>

                            </ModalBody>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.recurringModal ?
                        <Modal isOpen={this.state.recurringModal} centered>
                            <ModalHeader style={{ marginLeft: 0 }} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ recurringModal: null, insertFormFormular: null })}><Isvg src={xIcon} /></button>}>
                                {'Recurring event'.translate(this.props.lang)}
                            </ModalHeader>
                            <ModalBody className="form-feedback-wrap-display-block" style={{ paddingTop: 0 }}>

                                <div style={{ marginTop: 10 }}>
                                    <Row>
                                        <Col lg="12">
                                            <Label >{'Frequency'.translate(this.props.lang) + '*'}</Label>
                                            <Input type='select' onChange={(e) => {
                                                let val = null;
                                                if (e.target.value != -1) {
                                                    val = e.target.value;
                                                }
                                                if (!showRecurringOptions && ['week', 'month'].includes(val)) return;
                                                let recurringModal = this.state.recurringModal;
                                                recurringModal.frequencyType = e.target.value;
                                                let date = moment(new Date()).format(this.props.dateFormat);
                                                if (recurringModal.date) {
                                                    date = moment(new Date(recurringModal.date)).format(this.props.dateFormat);
                                                }
                                                if (val == 'day') {
                                                    recurringModal.frequencyDayScheduledDateFrom = date;
                                                    recurringModal.frequencyDayScheduledDateTo = date
                                                } else if (val == 'week') {
                                                    recurringModal.frequencyWeekScheduledDateFrom = date;
                                                    recurringModal.frequencyWeekScheduledDateTo = moment.unix(Math.floor(new Date(date).getTime() / 1000) + 7 * 24 * 60 * 60).format(this.props.dateFormat);
                                                } else if (val == 'month') {
                                                    recurringModal.frequencyMonthScheduledDateFrom = date;
                                                    recurringModal.frequencyMonthScheduledDateTo = moment.unix(Math.floor(new Date(date).getTime() / 1000) + 30 * 24 * 60 * 60).format(this.props.dateFormat);
                                                }
                                                this.setState({
                                                    recurringModal,
                                                    errorEvent: null
                                                })
                                            }}>
                                                <option value={-1}>
                                                    {'Choose frequency'.translate(this.props.lang)}
                                                </option>
                                                <option value={'day'}>
                                                    {'Day'.translate(this.props.lang)}
                                                </option>
                                                {showRecurringOptions ? <>
                                                    <option value={'week'}>
                                                        {'Week'.translate(this.props.lang)}
                                                    </option>
                                                    <option value={'month'}>
                                                        {'Month'.translate(this.props.lang)}
                                                    </option>
                                                </> : null}
                                            </Input>
                                        </Col>
                                    </Row>
                                    {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                </div>

                                {this.state.recurringModal.frequencyType == 'day' ?
                                    <div>
                                        <Row>
                                            <Col lg="12">
                                                <div style={{ display: 'flex', textAlign: 'center', alignItems: 'center', marginBottom: 5, marginTop: 10 }}>
                                                    <Label style={{ marginRight: 5 }}>{'Every'.translate(this.props.lang)}</Label>
                                                    <Input style={{ width: '25%' }} type='text' value={this.state.recurringModal.frequencyDayText} onChange={(e) => {
                                                        let value = e.target.value
                                                        value = value.replace(/[^0-9]/g, '')

                                                        let recurringModal = this.state.recurringModal;
                                                        recurringModal.frequencyDayText = value;
                                                        this.setState({
                                                            recurringModal
                                                        })
                                                    }} />
                                                    <Label style={{ marginLeft: 5 }}>{'day(s)'.translate(this.props.lang) + '*'}</Label>
                                                </div>
                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                                <DatePicker
                                                    label={'Start date'.translate(this.props.lang) + '*'}
                                                    minDate={new Date()}
                                                    dateFormat={this.props.dateFormat}
                                                    lang={this.props.lang}
                                                    holidayEvents={this.state.holidayEvents}
                                                    value={this.state.recurringModal.frequencyDayScheduledDateFrom ? this.state.recurringModal.frequencyDayScheduledDateFrom : moment(new Date()).format(this.props.dateFormat)}
                                                    onChange={(e) => {
                                                        let recurringModal = this.state.recurringModal;
                                                        recurringModal.frequencyDayScheduledDateFrom = e;
                                                        this.setState({
                                                            recurringModal
                                                        })

                                                        if (this.state.recurringModal.frequencyDayScheduledDateTo && this.state.recurringModal.frequencyDayScheduledDateFrom) {
                                                            let dateTo = new Date(this.state.recurringModal.frequencyDayScheduledDateTo)
                                                            let dateFrom = new Date(this.state.recurringModal.frequencyDayScheduledDateFrom)
                                                            if (dateFrom.getTime() > dateTo.getTime() || this.calculateMaxDateHotfix(this.state.recurringModal.frequencyDayScheduledDateFrom)) {
                                                                let recurringModal = this.state.recurringModal;
                                                                recurringModal.frequencyDayScheduledDateTo = this.state.recurringModal.frequencyDayScheduledDateFrom;
                                                                this.setState({
                                                                    recurringModal
                                                                })

                                                            }
                                                        } else if (!this.state.recurringModal.frequencyDayScheduledDateTo && this.state.recurringModal.frequencyDayScheduledDateFrom) {
                                                            let recurringModal = this.state.recurringModal;
                                                            recurringModal.frequencyDayScheduledDateTo = this.state.recurringModal.frequencyDayScheduledDateFrom;
                                                            this.setState({
                                                                recurringModal
                                                            })
                                                        }

                                                    }}
                                                />
                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                            </Col>
                                            <Col lg="12">
                                                <div style={{ marginTop: 5 }}>
                                                    <DatePicker
                                                        label={'End date'.translate(this.props.lang) + '*'}
                                                        dateFormat={this.props.dateFormat}
                                                        lang={this.props.lang}
                                                        holidayEvents={this.state.holidayEvents}
                                                        minDate={new Date(this.state.recurringModal.frequencyDayScheduledDateFrom) != 'Invalid Date' ? new Date(this.state.recurringModal.frequencyDayScheduledDateFrom) : new Date()}
                                                        maxDate={this.calculateMaxDateHotfix(this.state.recurringModal.frequencyDayScheduledDateFrom)}
                                                        value={this.state.recurringModal.frequencyDayScheduledDateTo ? this.state.recurringModal.frequencyDayScheduledDateTo : moment(new Date()).format(this.props.dateFormat)}
                                                        onChange={(e) => {
                                                            let recurringModal = this.state.recurringModal;
                                                            recurringModal.frequencyDayScheduledDateTo = e;
                                                            this.setState({
                                                                recurringModal
                                                            })

                                                        }}
                                                    />
                                                </div>
                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                            </Col>
                                        </Row>

                                    </div>
                                    : null}


                                {this.state.recurringModal.frequencyType == 'week' ?
                                    <div style={{ marginTop: 10, marginBottom: 15 }}>
                                        <Row>
                                            <Col lg="12">
                                                <Checkbox
                                                    onChange={(e) => {
                                                        let recurringModal = this.state.recurringModal;
                                                        recurringModal.checkedMonday = e.target.checked
                                                        this.setState({
                                                            recurringModal
                                                        })
                                                    }}
                                                    checked={this.state.recurringModal.checkedMonday}
                                                    label={'Monday'.translate(this.props.lang)}
                                                />
                                                <Checkbox
                                                    onChange={(e) => {
                                                        let recurringModal = this.state.recurringModal;
                                                        recurringModal.checkedTuesday = e.target.checked
                                                        this.setState({
                                                            recurringModal
                                                        })
                                                    }}
                                                    checked={this.state.recurringModal.checkedTuesday}
                                                    label={'Tuesday'.translate(this.props.lang)}
                                                />
                                                <Checkbox
                                                    onChange={(e) => {
                                                        let recurringModal = this.state.recurringModal;
                                                        recurringModal.checkedWednesday = e.target.checked
                                                        this.setState({
                                                            recurringModal
                                                        })
                                                    }}
                                                    checked={this.state.recurringModal.checkedWednesday}
                                                    label={'Wednesday'.translate(this.props.lang)}
                                                />
                                                <Checkbox
                                                    onChange={(e) => {
                                                        let recurringModal = this.state.recurringModal;
                                                        recurringModal.checkedThursday = e.target.checked
                                                        this.setState({
                                                            recurringModal
                                                        })
                                                    }}
                                                    checked={this.state.recurringModal.checkedThursday}
                                                    label={'Thursday'.translate(this.props.lang)}
                                                />
                                                <Checkbox
                                                    onChange={(e) => {
                                                        let recurringModal = this.state.recurringModal;
                                                        recurringModal.checkedFriday = e.target.checked
                                                        this.setState({
                                                            recurringModal
                                                        })
                                                    }}
                                                    checked={this.state.recurringModal.checkedFriday}
                                                    label={'Friday'.translate(this.props.lang)}
                                                />
                                                <Checkbox
                                                    onChange={(e) => {
                                                        let recurringModal = this.state.recurringModal;
                                                        recurringModal.checkedSaturday = e.target.checked
                                                        this.setState({
                                                            recurringModal
                                                        })
                                                    }}
                                                    checked={this.state.recurringModal.checkedSaturday}
                                                    label={'Saturday'.translate(this.props.lang)}
                                                />
                                                <Checkbox
                                                    onChange={(e) => {
                                                        let recurringModal = this.state.recurringModal;
                                                        recurringModal.checkedSunday = e.target.checked
                                                        this.setState({
                                                            recurringModal
                                                        })
                                                    }}
                                                    checked={this.state.recurringModal.checkedSunday}
                                                    label={'Sunday'.translate(this.props.lang)}
                                                />
                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                                <DatePicker
                                                    label={'Start date'.translate(this.props.lang) + '*'}
                                                    minDate={new Date()}
                                                    dateFormat={this.props.dateFormat}
                                                    lang={this.props.lang}
                                                    holidayEvents={this.state.holidayEvents}
                                                    // completeStaeInput={this.state.recurringModal}
                                                    value={this.state.recurringModal.frequencyWeekScheduledDateFrom ? this.state.recurringModal.frequencyWeekScheduledDateFrom : moment(new Date()).format(this.props.dateFormat)}
                                                    onChange={(e) => {
                                                        let recurringModal = this.state.recurringModal;
                                                        recurringModal.frequencyWeekScheduledDateFrom = e;
                                                        this.setState({
                                                            recurringModal
                                                        })

                                                        if (this.state.recurringModal.frequencyWeekScheduledDateTo && this.state.recurringModal.frequencyWeekScheduledDateFrom) {
                                                            let dateTo = new Date(this.state.recurringModal.frequencyWeekScheduledDateTo)
                                                            let dateFrom = new Date(this.state.recurringModal.frequencyWeekScheduledDateFrom)
                                                            if (dateFrom.getTime() + 1000 * 60 * 60 * 24 * 7 > dateTo.getTime()) {
                                                                let recurringModal = this.state.recurringModal;
                                                                let date = new Date(this.state.recurringModal.frequencyWeekScheduledDateFrom)
                                                                date.setDate(date.getDate() + 7)
                                                                recurringModal.frequencyWeekScheduledDateTo = moment(new Date(date)).format(this.props.dateFormat ? this.props.dateFormat : 'YYYY-MM-DD');
                                                                this.setState({
                                                                    recurringModal
                                                                })

                                                            }
                                                        } else if (!this.state.recurringModal.frequencyWeekScheduledDateTo && this.state.recurringModal.frequencyWeekScheduledDateFrom) {
                                                            let recurringModal = this.state.recurringModal;
                                                            let date = new Date(this.state.recurringModal.frequencyWeekScheduledDateFrom)
                                                            date.setDate(date.getDate() + 7)
                                                            recurringModal.frequencyWeekScheduledDateTo = moment(new Date(date)).format(this.props.dateFormat ? this.props.dateFormat : 'YYYY-MM-DD');
                                                            this.setState({
                                                                recurringModal
                                                            })
                                                        }

                                                    }}
                                                />
                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                            </Col>
                                            <Col lg="12">
                                                <DatePicker
                                                    label={'End date'.translate(this.props.lang) + '*'}
                                                    dateFormat={this.props.dateFormat}
                                                    lang={this.props.lang}
                                                    holidayEvents={this.state.holidayEvents}
                                                    minDate={new Date(this.state.recurringModal.frequencyWeekScheduledDateFrom) != 'Invalid Date' ? new Date(this.state.recurringModal.frequencyWeekScheduledDateFrom) : new Date(this.state.weekDate)}
                                                    // completeStaeInput={this.state.recurringModal}
                                                    value={this.state.recurringModal.frequencyWeekScheduledDateTo ? this.state.recurringModal.frequencyWeekScheduledDateTo : moment(this.state.weekDate).format(this.props.dateFormat)}
                                                    onChange={(e) => {
                                                        let recurringModal = this.state.recurringModal;
                                                        recurringModal.frequencyWeekScheduledDateTo = e;
                                                        this.setState({
                                                            recurringModal
                                                        })

                                                    }}
                                                />
                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                            </Col>
                                        </Row>
                                    </div>
                                    : null}
                                {this.state.recurringModal.frequencyType == 'month' ?
                                    <div style={{ marginBottom: 5 }}>
                                        <Row>
                                            <Col lg="12">
                                                <div style={{ display: 'flex', textAlign: 'center', alignItems: 'center', marginBottom: 5, marginTop: 10 }}>
                                                    <Label style={{ marginRight: 5 }}>{'Every'.translate(this.props.lang)}</Label>
                                                    <Input style={{ width: '30%' }} type='select' onChange={(e) => {
                                                        let val = null;
                                                        if (e.target.value != '-1') {
                                                            val = e.target.value;
                                                        }
                                                        let recurringModal = this.state.recurringModal;
                                                        recurringModal.frequencyMonthScheduled = val;
                                                        this.setState({
                                                            recurringModal
                                                        })
                                                    }}>
                                                        <option value={'-1'}>

                                                        </option>
                                                        <option value={'1'}>
                                                            {'1st'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'2'}>
                                                            {'2nd'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'3'}>
                                                            {'3rd'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'4'}>
                                                            {'4th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'5'}>
                                                            {'5th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'6'}>
                                                            {'6th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'7'}>
                                                            {'7th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'8'}>
                                                            {'8th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'9'}>
                                                            {'9th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'10'}>
                                                            {'10th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'11'}>
                                                            {'11th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'12'}>
                                                            {'12th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'13'}>
                                                            {'13th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'14'}>
                                                            {'14th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'15'}>
                                                            {'15th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'16'}>
                                                            {'16th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'17'}>
                                                            {'17th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'18'}>
                                                            {'18th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'19'}>
                                                            {'19th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'20'}>
                                                            {'20th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'21'}>
                                                            {'21st'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'22'}>
                                                            {'22nd'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'23'}>
                                                            {'23rd'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'24'}>
                                                            {'24th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'25'}>
                                                            {'25th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'26'}>
                                                            {'26th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'27'}>
                                                            {'27th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'28'}>
                                                            {'28th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'29'}>
                                                            {'29th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'30'}>
                                                            {'30th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'31'}>
                                                            {'31st'.translate(this.props.lang)}
                                                        </option>

                                                    </Input>
                                                    <Label style={{ marginLeft: 5 }}>{'day of the month'.translate(this.props.lang) + '*'}</Label>
                                                </div>
                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                                <DatePicker
                                                    label={'Start date'.translate(this.props.lang) + '*'}
                                                    minDate={new Date()}
                                                    dateFormat={this.props.dateFormat}
                                                    lang={this.props.lang}
                                                    holidayEvents={this.state.holidayEvents}
                                                    value={this.state.recurringModal.frequencyMonthScheduledDateFrom ? this.state.recurringModal.frequencyMonthScheduledDateFrom : moment(new Date()).format(this.props.dateFormat)}
                                                    onChange={(e) => {
                                                        let recurringModal = this.state.recurringModal;
                                                        recurringModal.frequencyMonthScheduledDateFrom = e;
                                                        this.setState({
                                                            recurringModal
                                                        })

                                                        if (this.state.recurringModal.frequencyMonthScheduledDateTo && this.state.recurringModal.frequencyMonthScheduledDateFrom) {
                                                            let dateTo = new Date(this.state.recurringModal.frequencyMonthScheduledDateTo)
                                                            let dateFrom = new Date(this.state.recurringModal.frequencyMonthScheduledDateFrom)
                                                            if (dateFrom.getTime() + 1000 * 60 * 60 * 24 * 31 > dateTo.getTime()) {
                                                                let recurringModal = this.state.recurringModal;
                                                                let date = new Date(this.state.recurringModal.frequencyMonthScheduledDateFrom)
                                                                date.setDate(date.getDate() + 31)
                                                                recurringModal.frequencyMonthScheduledDateTo = moment(new Date(date)).format(this.props.dateFormat ? this.props.dateFormat : 'YYYY-MM-DD');
                                                                this.setState({
                                                                    recurringModal
                                                                })

                                                            }
                                                        } else if (!this.state.recurringModal.frequencyMonthScheduledDateTo && this.state.recurringModal.frequencyMonthScheduledDateFrom) {
                                                            let recurringModal = this.state.recurringModal;
                                                            let date = new Date(this.state.recurringModal.frequencyMonthScheduledDateFrom)
                                                            date.setDate(date.getDate() + 31)
                                                            recurringModal.frequencyMonthScheduledDateTo = moment(new Date(date)).format(this.props.dateFormat ? this.props.dateFormat : 'YYYY-MM-DD');
                                                            this.setState({
                                                                recurringModal
                                                            })
                                                        }
                                                    }}
                                                />
                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                            </Col>
                                            <Col lg="12">
                                                <DatePicker
                                                    label={'End date'.translate(this.props.lang) + '*'}
                                                    dateFormat={this.props.dateFormat}
                                                    holidayEvents={this.state.holidayEvents}
                                                    lang={this.props.lang}
                                                    minDate={new Date(this.state.recurringModal.frequencyMonthScheduledDateFrom) != 'Invalid Date' ? new Date(this.state.recurringModal.frequencyMonthScheduledDateFrom) : new Date(this.state.monthDate)}
                                                    value={this.state.recurringModal.frequencyMonthScheduledDateTo ? this.state.recurringModal.frequencyMonthScheduledDateTo : moment(this.state.monthDate).format(this.props.dateFormat)}
                                                    onChange={(e) => {
                                                        let recurringModal = this.state.recurringModal;
                                                        recurringModal.frequencyMonthScheduledDateTo = e;
                                                        this.setState({
                                                            recurringModal
                                                        })

                                                    }}
                                                />
                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                            </Col>
                                        </Row>
                                    </div>
                                    : null}

                            </ModalBody>
                            <ModalFooter style={{ justifyContent: 'left', marginBottom: 20 }}>
                                <Button

                                    color='primary'
                                    disabled={!this.state.loadingScheduleEvent && this.state.recurringModal && this.state.recurringModal.frequencyType && (
                                        (this.state.recurringModal.frequencyType == 'day' && this.state.recurringModal.frequencyDayText && this.state.recurringModal.frequencyDayScheduledDateFrom && this.state.recurringModal.frequencyDayScheduledDateTo)
                                        || (this.state.recurringModal.frequencyType == 'month' && this.state.recurringModal.frequencyMonthScheduled && this.state.recurringModal.frequencyMonthScheduledDateFrom && this.state.recurringModal.frequencyMonthScheduledDateTo)
                                        || (this.state.recurringModal.frequencyType == 'week' && (this.state.recurringModal.checkedMonday || this.state.recurringModal.checkedTuesday || this.state.recurringModal.checkedThursday || this.state.recurringModal.checkedWednesday || this.state.recurringModal.checkedFriday || this.state.recurringModal.checkedSaturday || this.state.recurringModal.checkedSunday) && this.state.recurringModal.frequencyWeekScheduledDateFrom && this.state.recurringModal.frequencyWeekScheduledDateTo)
                                    )
                                        ? false : true}
                                    onClick={() => {
                                        if (this.state.recurringModal.typeOfEvent === 1) {
                                            this.scheduleEvent(this.state.recurringModal)
                                        } else if (this.state.recurringModal.typeOfEvent === 2) {
                                            this.markAsAvailable(this.state.recurringModal)
                                        }


                                    }}
                                >
                                    {this.state.loadingScheduleEvent ? /*'Processing...'.translate(this.props.lang)*/

                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Player
                                                onEvent={() => {
                                                    if (!this.state.loadingScheduleEvent) this.stopAnimation();
                                                }}
                                                onStateChange={this.toggleVisibility}
                                                ref={this.player} // set the ref to your class instance
                                                autoplay={true}
                                                loop={true}
                                                controls={true}
                                                src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                                style={{ height: "20px", width: "30px" }}
                                            ></Player>
                                            {'Processing...'.translate(this.props.lang)}
                                        </div>

                                        : 'Confirm'.translate(this.props.lang)}
                                    {/* {'Confirm'.translate(this.props.lang)} */}
                                </Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }

                {this.state.scheduleReferral ?
                    <Modal isOpen={this.state.scheduleReferral} centered>
                        <ModalHeader toggle={() => this.setState({ scheduleReferral: !this.state.scheduleReferral, doctorsList: [] })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ scheduleReferral: !this.state.scheduleReferral, doctorsList: [] })}>&times;</button>}>{'Schedule referral'.translate(this.props.lang)}</ModalHeader>

                        <ModalBody>
                            <FormGroup>
                                <Label>{'Patient'.translate(this.props.lang)}</Label>
                                {/* <Input type='select' onChange={e => this.setState({ referralId: e.target.value != -1 ? e.target.value : null }, () => {
                                    let index = this.state.referrals.findIndex(ref => ref._id.toString() == this.state.referralId.toString())
                                    if (this.state.referrals[index] && this.state.referrals[index].status == 'canceled-by-clinic') {
                                        let scheduleReferral = this.state.scheduleReferral;
                                        scheduleReferral.controlSchedule = this.state.referrals[index];
                                        this.setState({
                                            scheduleReferral
                                        })
                                    }
                                })}>
                                    <option value={-1}>{'None'.translate(this.props.lang)}</option>
                                    {this.state.referrals.filter(item => (item.status == 'allowed' || item.status == 'not-booked' || item.status == 'canceled-by-clinic'  || item.status === 'requested-new-appointment') && item.recipientClinic == this.props.selectedClinic).map(item => {

                                        return <option value={item._id}>

                                            {item.patient && item.patient.referralNumber} - {item.patient.name}{" " + humanReadable[item.status].translate(this.props.lang)}{item.onlineVisit ? (' - ' + 'Online'.translate(this.props.lang)) : ''}

                                        </option>
                                    })}

                                </Input> */}

                                <div className={this.state.selectOpen ? 'custom-select-with-search-open' : 'custom-select-with-search-closed'} onClick={() => {
                                    this.setState({
                                        selectOpen: !this.state.selectOpen
                                    })
                                }}>
                                    {this.state.referrals.filter(item => (item.status == 'allowed' || item.status == 'not-booked' || item.status == 'canceled-by-clinic' || item.status === 'requested-new-appointment') && item.recipientClinic == this.props.selectedClinic).map(item => {
                                        if (item._id === this.state.referralId && this.state.referralId)
                                            return <div>

                                                {item.patient && item.patient.referralNumber} - {item.patient.name}{" " + humanReadable[item.status].translate(this.props.lang)}{item.onlineVisit ? (' - ' + 'Online'.translate(this.props.lang)) : ''}

                                            </div>
                                    })}

                                </div>

                                {
                                    this.state.selectOpen ?
                                        <div className='custom-select-with-search-items'>
                                            <CustomSelectWithSearch
                                                lang={this.props.lang}
                                                items={this.state.referrals.filter(item => (item.status == 'allowed' || item.status == 'not-booked' || item.status == 'canceled-by-clinic' || item.status === 'requested-new-appointment') && item.recipientClinic == this.props.selectedClinic && this.state.doctor != item.patientId).map((item, idx) => {
                                                    return {
                                                        name: item.patient && item.patient.referralNumber + ' - ' + item.patient.name + " " + humanReadable[item.status].translate(this.props.lang) + (item.onlineVisit ? (' - ' + 'Online'.translate(this.props.lang)) : ''),
                                                        value: item._id
                                                    }
                                                })}
                                                value={this.state.referralId}
                                                maxHeight={'250px'}
                                                onChange={async (e) => this.setState({ referralId: e.value != -1 ? e.value : null }, async () => {
                                                    let index = this.state.referrals.findIndex(ref => ref._id.toString() == this.state.referralId.toString())
                                                    let setObj = {
                                                        selectOpen: false
                                                    };
                                                    if (this.state.referrals[index] && /*this.state.referrals[index].status == 'canceled-by-clinic'*/ this.state.referrals[index].remissType === 'Revisit') {
                                                        let scheduleReferral = this.state.scheduleReferral;
                                                        scheduleReferral.controlSchedule = this.state.referrals[index];
                                                        scheduleReferral.patientNote = this.state.referrals[index]?.event?.patientControlNote ? this.state.referrals[index].event?.patientControlNote : '';

                                                        scheduleReferral.referralId = this.state.referrals[index]._id;
                                                        scheduleReferral = await checkRescheduleData(scheduleReferral, this.props, true, true);
                                                        if (scheduleReferral?.rescheduledData?.startTime) {
                                                            this.registerChangeTimePickerStartTime();
                                                            this.registerChangeTimePickerEndTime();
                                                        }

                                                        setObj.scheduleReferral = scheduleReferral;
                                                    } else if (this.state.referrals[index] && this.state.referrals[index].status === 'requested-new-appointment') {

                                                        let scheduleReferral = this.state.scheduleReferral;
                                                        scheduleReferral.patientNote = this.state.referrals[index]?.event?.patientNote ? this.state.referrals[index].event?.patientNote : '';
                                                        scheduleReferral.referralId = this.state.referrals[index]._id;
                                                        scheduleReferral = await checkRescheduleData(scheduleReferral, this.props, true, true);
                                                        if (scheduleReferral?.rescheduledData?.startTime) {
                                                            this.registerChangeTimePickerStartTime();
                                                            this.registerChangeTimePickerEndTime();
                                                        }

                                                        setObj.scheduleReferral = scheduleReferral;
                                                    }



                                                    this.setState(setObj)
                                                    // this.setState({
                                                    //     selectOpen: false
                                                    // })
                                                })}
                                            />
                                        </div>
                                        :
                                        null
                                }


                            </FormGroup>

                            <DatePicker
                                label={'Date'.translate(this.props.lang)}
                                value={this.state.scheduleReferral.date}
                                holidayEvents={this.state.holidayEvents}
                                lang={this.props.lang}
                                onChange={(e) => {
                                    let scheduleReferral = this.state.scheduleReferral;
                                    scheduleReferral.date = e;
                                    this.setState({
                                        scheduleReferral
                                    })
                                    if (Math.floor(new Date(this.state.scheduleReferral.date + ' ' + this.state.scheduleReferral.startTime) / 1000) > Math.floor(new Date(this.state.scheduleReferral.endDate + ' ' + this.state.scheduleReferral.endTime) / 1000)) {
                                        scheduleReferral.endDate = this.state.scheduleReferral.date
                                        this.setState({
                                            scheduleReferral
                                        })
                                    }
                                }}
                            />
                            <FormGroup className="timepicker-container timepicker-wide">
                                <Label>{'Start time'.translate(this.props.lang)}</Label>
                                &nbsp;
                                <TimePickerV2
                                    getStringDateTs={this.props.getStringDateTs}
                                    format={'HH:mm'}
                                    value={this.state.scheduleReferral.startTime}
                                    minValue={this.props.getStringDateTs(Math.floor(this.state.min.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.min.getTime() / 1000).format("HH:mm")
                                    maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000 - 300), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                    flag={0}
                                    onChange={(time1, timeString) => {

                                        let scheduleReferral = this.state.scheduleReferral;
                                        scheduleReferral.startTime = timeString

                                        let startTimeSplit = scheduleReferral.startTime.split(":");
                                        let endTimeSplit = scheduleReferral.endTime.split(":");

                                        let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                        let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                        // this.setState({ scheduleReferral })
                                        if (startTimeHourMinute < endTimeHourMinute) {
                                            this.setState({ scheduleReferral })
                                        } else {
                                            scheduleReferral.endTime = Math.trunc((Number(this.state.scheduleReferral.startTime.split(':')[0]) * 60 + Number(this.state.scheduleReferral.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.scheduleReferral.startTime.split(':')[0]) * 60 + Number(this.state.scheduleReferral.startTime.split(':')[1]) + 5) % 60
                                            // scheduleReferral.endTime = validateTime(scheduleReferral.endTime);
                                            const padded = scheduleReferral?.endTime?.split?.(':');
                                            if (padded && Array.isArray(padded) && padded.length && isStringAValidNumber(padded[0]) && isStringAValidNumber(padded[1])) {
                                                const h = padded[0]?.padStart?.(2, '0');
                                                const m = padded[1]?.padStart?.(2, '0');
                                                if (h && m) scheduleReferral.endTime = `${h}:${m}`;
                                            }
                                            this.setState({
                                                scheduleReferral
                                            })
                                        }
                                    }}
                                    registerHandleBlur={(value) => this.registerChangeTimePickerStartTime = value}
                                />
                                {/* <TimePicker
                                    getStringDateTs={this.props.getStringDateTs}
                                    format={'HH:mm'}
                                    value={moment(new Date(this.state.scheduleReferral.date.replace(/-/g, "/") + " " + this.state.scheduleReferral.startTime))}
                                    minValue={this.props.getStringDateTs(Math.floor(this.state.min.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.min.getTime() / 1000).format("HH:mm")
                                    maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                    flag={0}
                                    onChange={(time1, timeString) => {

                                        let scheduleReferral = this.state.scheduleReferral;
                                        scheduleReferral.startTime = timeString

                                        let startTimeSplit = scheduleReferral.startTime.split(":");
                                        let endTimeSplit = scheduleReferral.endTime.split(":");

                                        let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                        let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                        this.setState({ scheduleReferral })
                                    }}
                                    allowClear={false}
                                /> */}
                            </FormGroup>
                            <FormGroup className="timepicker-container timepicker-wide">
                                <Label>{'End time'.translate(this.props.lang)}</Label>
                                &nbsp;
                                <TimePickerV2
                                    getStringDateTs={this.props.getStringDateTs}
                                    format={'HH:mm'}
                                    value={this.state.scheduleReferral.endTime}
                                    minValue={Math.trunc((Number(this.state.scheduleReferral.startTime.split(':')[0]) * 60 + Number(this.state.scheduleReferral.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.scheduleReferral.startTime.split(':')[0]) * 60 + Number(this.state.scheduleReferral.startTime.split(':')[1]) + 5) % 60}
                                    maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                    flag={0}
                                    onChange={(time1, timeString) => {

                                        let scheduleReferral = this.state.scheduleReferral;
                                        scheduleReferral.endTime = timeString


                                        let startTimeSplit = scheduleReferral.startTime.split(":");
                                        let endTimeSplit = scheduleReferral.endTime.split(":");

                                        let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                        let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                        if (startTimeHourMinute < endTimeHourMinute) {
                                            this.setState({ scheduleReferral })
                                        }
                                    }}
                                    registerHandleBlur={(value) => this.registerChangeTimePickerEndTime = value}
                                />
                                {/* <TimePicker
                                    getStringDateTs={this.props.getStringDateTs}
                                    format={'HH:mm'}
                                    value={moment(new Date(this.state.scheduleReferral.date.replace(/-/g, "/") + " " + this.state.scheduleReferral.endTime))}
                                    minValue={Math.trunc((Number(this.state.scheduleReferral.startTime.split(':')[0]) * 60 + Number(this.state.scheduleReferral.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.scheduleReferral.startTime.split(':')[0]) * 60 + Number(this.state.scheduleReferral.startTime.split(':')[1]) + 5) % 60}
                                    maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                    flag={0}
                                    onChange={(time1, timeString) => {

                                        let scheduleReferral = this.state.scheduleReferral;
                                        scheduleReferral.endTime = timeString


                                        let startTimeSplit = scheduleReferral.startTime.split(":");
                                        let endTimeSplit = scheduleReferral.endTime.split(":");

                                        let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                        let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                        if (startTimeHourMinute < endTimeHourMinute) {
                                            this.setState({ scheduleReferral })
                                        }
                                    }}
                                    allowClear={false}
                                /> */}
                            </FormGroup>
                            {
                                this.state.referralId && isDurationHideCheckboxAvailable(this.state.referralId, null, this.state.referrals) /* && enterprise */ ?
                                    <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                                        <Checkbox
                                            onChange={(e) => {
                                                let scheduleReferral = this.state.scheduleReferral;
                                                scheduleReferral.hideDurationForPatient = e.target.checked;
                                                this.setState({
                                                    scheduleReferral
                                                })
                                            }}
                                            checked={this.state.scheduleReferral.hideDurationForPatient}
                                            label={'Hide duration for patient'.translate(this.props.lang)}
                                        />
                                        <div className='button-elements-tooltip' style={{ marginLeft: 8 }}>
                                            <Isvg src={infoIcon} style={{ width: 25 }} />
                                            <div className='tooltip-text' style={{ minWidth: 180, bottom: 29 }}>{'Duration is not displayed to the patient.'.translate(this.props.lang)}</div>
                                        </div>
                                    </FormGroup>
                                    :
                                    null
                            }
                            {
                                this.state.referralId ?
                                    <FormGroup>
                                        <Label className='note-label-wrap'>{'Note'.translate(this.props.lang)}
                                            <div className={this.state.patientNotes?.length ? 'notes-icon-wrap notes-icon-active' : 'notes-icon-wrap'} onClick={() => { this.setState({ showPatientNotes: true }) }}>
                                                <Isvg src={notesIcon} />
                                                <div className='tooltip-text'>{'Notes available'.translate(this.props.lang)}</div>
                                            </div>
                                        </Label>
                                        <Input type='textarea'
                                            name="note"
                                            style={{ height: '150px' }}
                                            onChange={(e) => {
                                                let scheduleReferral = this.state.scheduleReferral;
                                                scheduleReferral.patientNote = striptags(e.target.value);
                                                this.setState({
                                                    scheduleReferral
                                                })
                                            }}
                                            value={this.state.scheduleReferral.patientNote}
                                        />
                                    </FormGroup>
                                    :
                                    null
                            }
                            {
                                this.state.scheduleReferral?.rescheduledMessage ?
                                    <div className='rescheduled-message-schedule-modal'>
                                        *{this.state.scheduleReferral?.rescheduledMessage}
                                    </div>
                                    :
                                    null
                            }
                            <div className='calendar-modal-buttons-wrap'>
                                {
                                    this.state.referralId ?
                                        <FormGroup>
                                            <Button onClick={() => this.setState({
                                                doctorsModal: 2
                                            })} color="primary">
                                                {'Add caregiver'.translate(this.props.lang)}
                                            </Button>
                                        </FormGroup>

                                        :

                                        null
                                }
                                {
                                    this.state.referralId && eventMeetings ?
                                        <FormGroup>
                                            <Button
                                                onClick={() => {
                                                    let guests = [];
                                                    if (this.state.scheduleReferral?.guests) {
                                                        guests = [...this.state.scheduleReferral.guests];
                                                    }
                                                    this.setState({
                                                        eventMeetingsModal: { ...this.state.scheduleReferral, guests, modal: 'scheduleReferral' }
                                                    })
                                                }}
                                                color="primary"
                                            >
                                                {'Add guest'.translate(this.props.lang)}
                                            </Button>
                                        </FormGroup>

                                        :

                                        null
                                }
                            </div>


                            <Button color='primary' disabled={this.state.referralId && !this.state.creatingEvent ? false : true} onClick={() => {
                                this.setState({
                                    creatingEvent: true
                                }, () => {
                                    if (this.state.referrals) {
                                        let index = this.state.referrals.findIndex(ref => ref._id.toString() == this.state.referralId.toString())
                                        if (this.state.referrals[index] && /*this.state.referrals[index].status == 'canceled-by-clinic'*/ this.state.referrals[index].remissType === 'Revisit') {
                                            this.scheduleControl({ ...this.state.scheduleReferral, rescheduleRevisit: true })
                                        } else {
                                            if (this.state.referrals[index] && this.state.referrals[index].status === 'requested-new-appointment') {
                                                this.scheduleReferral({ ...this.state.scheduleReferral, rescheduleReferral: true })
                                            } else {
                                                this.scheduleReferral({ ...this.state.scheduleReferral, rescheduleReferral: false })
                                            }

                                        }
                                    }
                                })


                            }}>{'Schedule referral'.translate(this.props.lang)}</Button>

                        </ModalBody>
                    </Modal>
                    : null}
                {
                    this.state.eventMeetingsModal ?
                        <EventMeetingsModal
                            {...this.props}
                            data={this.state.eventMeetingsModal}
                            onClose={() => this.setState({ eventMeetingsModal: null, meetingParticipants: null, })}
                            closeButtonText={'Close without saving'.translate(this.props.lang)}
                            saveData={(data) => {
                                let setObj = { eventMeetingsModal: null, meetingParticipants: null, };
                                let modal = this.state.eventMeetingsModal?.modal;
                                if (data && modal) {
                                    if (modal === 'scheduleReferral') {
                                        setObj.scheduleReferral = { ...this.state.scheduleReferral, guests: data };
                                    } else if (modal === 'updateEvent') {
                                        setObj.updateEvent = { ...this.state.updateEvent, guests: data };
                                        if (this.state.updateEvent?.type === 'event') {
                                            setObj.updateEvent = { ...this.state.updateEvent, colleagues: data };
                                        } else {
                                            setObj.updateEvent = { ...this.state.updateEvent, guests: data };
                                        }
                                    } else if (modal === 'scheduleControl') {
                                        setObj.scheduleControl = { ...this.state.scheduleControl, guests: data };
                                    } else if (modal === 'schedulePatientTime') {
                                        setObj.schedulePatientTime = { ...this.state.schedulePatientTime, colleagues: data };
                                    }
                                }
                                this.setState(setObj)
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.schedulePatientTimeOneDay ?
                        <Modal isOpen={this.state.schedulePatientTimeOneDay} centered>
                            <ModalHeader toggle={() => this.setState({ schedulePatientTimeOneDay: !this.state.schedulePatientTimeOneDay })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ schedulePatientTimeOneDay: !this.state.schedulePatientTimeOneDay })}>&times;</button>}>{'Set available terms'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody>

                                {/* <FormGroup>
                                    <Label>{'Date'.translate(this.props.lang)}</Label>
                                    <Input type='date' onChange={(e) => {
                                        let schedulePatientTimeOneDay = this.state.schedulePatientTimeOneDay;
                                        schedulePatientTimeOneDay.date = e.target.value;
                                        this.setState({
                                            schedulePatientTimeOneDay
                                        })
                                    }}
                                        value={this.state.schedulePatientTimeOneDay.date} />
                                </FormGroup> */}
                                <DatePicker
                                    label={'Date'.translate(this.props.lang)}
                                    value={this.state.schedulePatientTimeOneDay.date}
                                    holidayEvents={this.state.holidayEvents}
                                    lang={this.props.lang}
                                    onChange={(e) => {
                                        let schedulePatientTimeOneDay = this.state.schedulePatientTimeOneDay;
                                        schedulePatientTimeOneDay.date = e;
                                        this.setState({
                                            schedulePatientTimeOneDay
                                        })
                                        if (Math.floor(new Date(this.state.schedulePatientTimeOneDay.date + ' ' + this.state.schedulePatientTimeOneDay.startTime) / 1000) > Math.floor(new Date(this.state.schedulePatientTimeOneDay.endDate + ' ' + this.state.schedulePatientTimeOneDay.endTime) / 1000)) {
                                            schedulePatientTimeOneDay.endDate = this.state.schedulePatientTimeOneDay.date
                                            this.setState({
                                                schedulePatientTimeOneDay
                                            })
                                        }
                                    }}
                                />

                                <FormGroup className="timepicker-container timepicker-wide">
                                    <Label>{'Start time'.translate(this.props.lang)}</Label>
                                    &nbsp;
                                    <TimePickerV2
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={this.state.schedulePatientTimeOneDay.startTime}
                                        minValue={this.props.getStringDateTs(Math.floor(this.state.min.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.min.getTime() / 1000).format("HH:mm")
                                        maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000 - 300), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                        flag={0}
                                        onChange={(time1, timeString) => {

                                            let schedulePatientTimeOneDay = this.state.schedulePatientTimeOneDay;
                                            schedulePatientTimeOneDay.startTime = timeString

                                            let startTimeSplit = schedulePatientTimeOneDay.startTime.split(":");
                                            let endTimeSplit = schedulePatientTimeOneDay.endTime.split(":");

                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                            // this.setState({ schedulePatientTimeOneDay })
                                            if (startTimeHourMinute < endTimeHourMinute) {
                                                this.setState({ schedulePatientTimeOneDay })
                                            } else {
                                                schedulePatientTimeOneDay.endTime = Math.trunc((Number(this.state.schedulePatientTimeOneDay.startTime.split(':')[0]) * 60 + Number(this.state.schedulePatientTimeOneDay.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.schedulePatientTimeOneDay.startTime.split(':')[0]) * 60 + Number(this.state.schedulePatientTimeOneDay.startTime.split(':')[1]) + 5) % 60
                                                const padded = schedulePatientTimeOneDay?.endTime?.split?.(':');
                                                if (padded && Array.isArray(padded) && padded.length && isStringAValidNumber(padded[0]) && isStringAValidNumber(padded[1])) {
                                                    const h = padded[0]?.padStart?.(2, '0');
                                                    const m = padded[1]?.padStart?.(2, '0');
                                                    if (h && m) schedulePatientTimeOneDay.endTime = `${h}:${m}`;
                                                }
                                                this.setState({
                                                    schedulePatientTimeOneDay
                                                })
                                            }
                                        }}
                                    />
                                    {/* <TimePicker
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={moment(new Date(this.state.schedulePatientTimeOneDay.date.replace(/-/g, "/") + " " + this.state.schedulePatientTimeOneDay.startTime))}
                                        // maxValue={this.state.scheduleReferral.endTime}
                                        minValue={this.props.getStringDateTs(Math.floor(this.state.min.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.min.getTime() / 1000).format("HH:mm")
                                        maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                        flag={0}
                                        onChange={(time1, timeString) => {

                                            let schedulePatientTimeOneDay = this.state.schedulePatientTimeOneDay;
                                            schedulePatientTimeOneDay.startTime = timeString

                                            let startTimeSplit = schedulePatientTimeOneDay.startTime.split(":");
                                            let endTimeSplit = schedulePatientTimeOneDay.endTime.split(":");

                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                            // if (startTimeHourMinute < endTimeHourMinute) {
                                            //     this.setState({ scheduleReferral })
                                            // } else {
                                            // this.setState({ wrongInput: true })
                                            // }

                                            this.setState({ schedulePatientTimeOneDay })
                                        }}
                                        allowClear={false}
                                    /> */}
                                </FormGroup>
                                <FormGroup className="timepicker-container timepicker-wide">
                                    <Label>{'End time'.translate(this.props.lang)}</Label>
                                    &nbsp;
                                    <TimePickerV2
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={this.state.schedulePatientTimeOneDay.endTime}
                                        minValue={Math.trunc((Number(this.state.schedulePatientTimeOneDay.startTime.split(':')[0]) * 60 + Number(this.state.schedulePatientTimeOneDay.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.schedulePatientTimeOneDay.startTime.split(':')[0]) * 60 + Number(this.state.schedulePatientTimeOneDay.startTime.split(':')[1]) + 5) % 60}
                                        maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                        flag={0}
                                        onChange={(time1, timeString) => {

                                            let schedulePatientTimeOneDay = this.state.schedulePatientTimeOneDay;
                                            schedulePatientTimeOneDay.endTime = timeString


                                            let startTimeSplit = schedulePatientTimeOneDay.startTime.split(":");
                                            let endTimeSplit = schedulePatientTimeOneDay.endTime.split(":");

                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                            if (startTimeHourMinute < endTimeHourMinute) {
                                                this.setState({ schedulePatientTimeOneDay })
                                            } else {
                                                // this.setState({ wrongInput: true })
                                            }
                                        }}
                                    />
                                    {/* <TimePicker
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={moment(new Date(this.state.schedulePatientTimeOneDay.date.replace(/-/g, "/") + " " + this.state.schedulePatientTimeOneDay.endTime))}
                                        minValue={Math.trunc((Number(this.state.schedulePatientTimeOneDay.startTime.split(':')[0]) * 60 + Number(this.state.schedulePatientTimeOneDay.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.schedulePatientTimeOneDay.startTime.split(':')[0]) * 60 + Number(this.state.schedulePatientTimeOneDay.startTime.split(':')[1]) + 5) % 60}
                                        maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                        flag={0}
                                        // maxValue={this.state.scheduleReferral.startTime}
                                        // flag={1}
                                        onChange={(time1, timeString) => {

                                            let schedulePatientTimeOneDay = this.state.schedulePatientTimeOneDay;
                                            schedulePatientTimeOneDay.endTime = timeString


                                            let startTimeSplit = schedulePatientTimeOneDay.startTime.split(":");
                                            let endTimeSplit = schedulePatientTimeOneDay.endTime.split(":");

                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                            if (startTimeHourMinute < endTimeHourMinute) {
                                                this.setState({ schedulePatientTimeOneDay })
                                            } else {
                                                // this.setState({ wrongInput: true })
                                            }
                                        }}
                                        allowClear={false}
                                    /> */}
                                </FormGroup>


                                <Button color='primary' onClick={() => this.schedulePatientTimeOneDay(this.state.schedulePatientTimeOneDay)}>{'Set'.translate(this.props.lang)}</Button>





                            </ModalBody>
                        </Modal>
                        : null
                }
                {
                    this.state.updateEventTemplate ?
                        <Modal isOpen={this.state.updateEventTemplate} centered>
                            <ModalHeader
                                toggle={() => this.setState({ updateEventTemplate: !this.state.updateEventTemplate, doctorsList: [] })}
                                close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ updateEventTemplate: !this.state.updateEventTemplate, doctorsList: [] })}>&times;</button>}
                            >
                                <div className='modal-header-title-wrap'>
                                    {'Edit event'.translate(this.props.lang)}
                                    <div className='button-elements-tooltip' style={{ marginLeft: 8 }}>
                                        <Isvg src={infoIcon} style={{ width: 25 }} />
                                        <div className='tooltip-text' style={{ minWidth: 180, bottom: 29 }}>{'You can only edit...'.translate(this.props.lang)}</div>
                                    </div>
                                </div>
                            </ModalHeader>
                            <ModalBody>
                                <FormGroup>
                                    <Label>{'Type'.translate(this.props.lang) + '*'}</Label>
                                    <Input
                                        type='select'
                                        value={this.state.updateEventTemplate.type}
                                        disabled={true}
                                        onChange={(e) => {
                                            return;
                                            let val = false
                                            if (e.target.value != -1) {
                                                val = e.target.value
                                            }
                                            let updateEventTemplate = this.state.updateEventTemplate
                                            updateEventTemplate.type = val
                                            this.setState({
                                                updateEventTemplate
                                            })
                                        }}>
                                        <option value={-1}>{'Select event type'.translate(this.props.lang)}</option>
                                        <option value={'event'}>{'Schedule event'.translate(this.props.lang)}</option>
                                        <option value={'free'}>{'Mark as available'.translate(this.props.lang)}</option>
                                        <option value={'template'}>{'Add availability template'.translate(this.props.lang)}</option>
                                    </Input>
                                </FormGroup>
                                <FormGroup>
                                    <Label>{'Title'.translate(this.props.lang)}</Label>
                                    <Input
                                        type='text'
                                        value={this.state.updateEventTemplate.title}
                                        onChange={(e) => {
                                            let updateEventTemplate = this.state.updateEventTemplate
                                            updateEventTemplate.title = e.target.value
                                            this.setState({
                                                updateEventTemplate
                                            })
                                        }}
                                    />
                                </FormGroup>
                                <FormGroup style={{ position: 'relative' }}>
                                    <Label>{'Chosen availability template'.translate(this.props.lang)}</Label>
                                    <div
                                        className={this.state.chooseAvailabilityTemplateOpenMenu ? 'custom-select-with-search-open' : 'custom-select-with-search-closed'}
                                        // className='custom-select-with-search-disabled'
                                        onClick={() => {
                                            // return;
                                            this.setState({
                                                chooseAvailabilityTemplateOpenMenu: !this.state.chooseAvailabilityTemplateOpenMenu
                                            })
                                        }}
                                    >
                                        {this.state.availabilityTemplates.map(item => {
                                            let selectedAvailabilityTemplate = this.state.updateEventTemplate?.selectedAvailabilityTemplate?.id;
                                            if (selectedAvailabilityTemplate && selectedAvailabilityTemplate === item._id) {
                                                return (
                                                    <div className='calendar-select-template-item-wrap'>
                                                        <div className='calendar-select-template-item-color' style={{ backgroundColor: item.calendarColor }}></div> {item.name} <span>({item.duration} {"min".translate(this.props.lang)})</span>
                                                    </div>
                                                )
                                            }
                                        })}

                                    </div>

                                    {
                                        this.state.chooseAvailabilityTemplateOpenMenu ?
                                            <div className='custom-select-with-search-items custom-select-with-search-items-availability-template'>
                                                <CustomSelectWithSearch
                                                    // disabled={true}
                                                    lang={this.props.lang}
                                                    items={this.state.availabilityTemplates.map((item, idx) => {
                                                        return {
                                                            name: item.name,
                                                            nameComponent: <div className='calendar-select-template-item-wrap'>
                                                                <div className='calendar-select-template-item-color' style={{ backgroundColor: item.calendarColor }}></div> {item.name} <span>({item.duration} {"min".translate(this.props.lang)})</span>
                                                            </div>,
                                                            value: item._id
                                                        }
                                                    })}
                                                    value={this.state.updateEventTemplate?.selectedAvailabilityTemplate?.id}
                                                    maxHeight={'250px'}
                                                    onChange={(val) => {
                                                        let value = val.value != -1 ? val.value : null;
                                                        let updateEventTemplate = this.state.updateEventTemplate;

                                                        let currentTemplate = updateEventTemplate?.selectedAvailabilityTemplate?.id ? this.state.availabilityTemplates.find(item => item._id === updateEventTemplate.selectedAvailabilityTemplate.id) : null;
                                                        let selectedTemplate = this.state.availabilityTemplates.find(item => item._id === value);
                                                        updateEventTemplate.selectedAvailabilityTemplate = {
                                                            ...updateEventTemplate.selectedAvailabilityTemplate,
                                                            id: value
                                                        };

                                                        if (currentTemplate && selectedTemplate && updateEventTemplate.title === currentTemplate?.name) {
                                                            updateEventTemplate.title = selectedTemplate?.name;
                                                        }


                                                        this.setState({ updateEventTemplate }, () => {
                                                            this.setState({
                                                                chooseAvailabilityTemplateOpenMenu: false
                                                            })
                                                        })
                                                    }
                                                    }
                                                />
                                            </div>
                                            :
                                            null
                                    }

                                </FormGroup>




                                <div className='time-wrap' style={{ alignItems: this.state.updateEventTemplate.type === 'template' && this.state.updateEventTemplate.selectedAvailabilityTemplate?.id ? 'center' : 'flex-start' }}>
                                    <div className='update-event-template-time-component-wrap'>
                                        <DatePicker
                                            label={'Date'.translate(this.props.lang)}
                                            value={this.state.updateEventTemplate.date}
                                            holidayEvents={this.state.holidayEvents}
                                            lang={this.props.lang}
                                            onChange={(e) => {
                                                let updateEventTemplate = this.state.updateEventTemplate;
                                                updateEventTemplate.date = e;
                                                this.setState({
                                                    updateEventTemplate
                                                })
                                                if (Math.floor(new Date(this.state.updateEventTemplate.date + ' ' + this.state.updateEventTemplate.startTime) / 1000) > Math.floor(new Date(this.state.updateEventTemplate.endDate + ' ' + this.state.updateEventTemplate.endTime) / 1000)) {
                                                    updateEventTemplate.endDate = this.state.updateEventTemplate.date
                                                    this.setState({
                                                        updateEventTemplate
                                                    })
                                                }
                                            }}
                                        />
                                        <FormGroup className="timepicker-container timepicker-wide">
                                            <Label>{'Start time'.translate(this.props.lang)}</Label>
                                            &nbsp;
                                            <TimePickerV2
                                                getStringDateTs={this.props.getStringDateTs}
                                                format={'HH:mm'}
                                                value={this.state.updateEventTemplate.startTime}
                                                minValue={this.props.getStringDateTs(Math.floor(this.state.min.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.min.getTime() / 1000).format("HH:mm")
                                                maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000 - 300), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                                flag={0}
                                                onChange={(time1, timeString) => {

                                                    let updateEventTemplate = this.state.updateEventTemplate;
                                                    updateEventTemplate.startTime = timeString

                                                    let startTimeSplit = updateEventTemplate.startTime.split(":");
                                                    let endTimeSplit = updateEventTemplate.endTime.split(":");


                                                    let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                                    let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                                    // this.setState({ updateEventTemplate })
                                                    if (startTimeHourMinute < endTimeHourMinute) {
                                                        this.setState({ updateEventTemplate })
                                                    } else {
                                                        updateEventTemplate.endTime = Math.trunc((Number(this.state.updateEventTemplate.startTime.split(':')[0]) * 60 + Number(this.state.updateEventTemplate.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.updateEventTemplate.startTime.split(':')[0]) * 60 + Number(this.state.updateEventTemplate.startTime.split(':')[1]) + 5) % 60
                                                        // updateEventTemplate.endTime = validateTime(updateEventTemplate.endTime);
                                                        const padded = updateEventTemplate?.endTime?.split?.(':');
                                                        if (padded && Array.isArray(padded) && padded.length && isStringAValidNumber(padded[0]) && isStringAValidNumber(padded[1])) {
                                                            const h = padded[0]?.padStart?.(2, '0');
                                                            const m = padded[1]?.padStart?.(2, '0');
                                                            if (h && m) updateEventTemplate.endTime = `${h}:${m}`;
                                                        }
                                                        this.setState({
                                                            updateEventTemplate
                                                        })
                                                    }


                                                }}
                                            />

                                        </FormGroup>
                                    </div>

                                    {
                                        updateEventTemplateWithReccuring && this.state.updateEventTemplate.type === 'template' && this.state.updateEventTemplate.selectedAvailabilityTemplate?.id ?
                                            <div className='availability-template-instances-gap-wrap'>
                                                <FormGroup>
                                                    <Label>{'Instances'.translate(this.props.lang)}</Label>
                                                    <Input type='select'
                                                        value={this.state.updateEventTemplate.selectedAvailabilityTemplate?.instances}
                                                        onChange={(e) => {
                                                            let value = e.target.value;
                                                            let updateEventTemplate = this.state.updateEventTemplate;
                                                            if (updateEventTemplate.selectedAvailabilityTemplate) {
                                                                updateEventTemplate.selectedAvailabilityTemplate.instances = value;
                                                                if (value?.toString() === '1') {
                                                                    updateEventTemplate.selectedAvailabilityTemplate.gap = 0;
                                                                }
                                                                this.setState({ updateEventTemplate })
                                                            }
                                                        }}>
                                                        {
                                                            this.state.selectOptions?.instances?.map((item, idx) => {
                                                                return (
                                                                    <option value={item} key={idx}>{item}</option>
                                                                )
                                                            })
                                                        }
                                                    </Input>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Label>{'Gap'.translate(this.props.lang)}</Label>
                                                    <Input type='select'
                                                        disabled={this.state.updateEventTemplate?.selectedAvailabilityTemplate?.instances == 1}
                                                        value={this.state.updateEventTemplate.selectedAvailabilityTemplate?.gap}
                                                        onChange={(e) => {
                                                            if (this.state.updateEventTemplate?.selectedAvailabilityTemplate?.instances == 1) return;
                                                            let value = e.target.value;
                                                            let updateEventTemplate = this.state.updateEventTemplate;
                                                            if (updateEventTemplate.selectedAvailabilityTemplate) {
                                                                updateEventTemplate.selectedAvailabilityTemplate.gap = value;
                                                                this.setState({ updateEventTemplate })
                                                            }
                                                        }}>
                                                        {
                                                            this.state.selectOptions?.gap?.map((item, idx) => {
                                                                return (
                                                                    <option value={item} key={idx}>{item}</option>
                                                                )
                                                            })
                                                        }
                                                    </Input>
                                                </FormGroup>
                                            </div>
                                            :
                                            null
                                    }
                                </div>


                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}

                                {
                                    updateEventTemplateWithReccuring ?
                                        <>
                                            <FormGroup>
                                                <Label >{'Frequency'.translate(this.props.lang)}</Label>
                                                <Input type='select'
                                                    value={this.state.updateEventTemplate.frequencyType}

                                                    onChange={(e) => {
                                                        let val = null;
                                                        if (e.target.value != -1) {
                                                            val = e.target.value;
                                                        }
                                                        if (!showRecurringOptions && ['week', 'month'].includes(val)) return;
                                                        let updateEventTemplate = this.state.updateEventTemplate;
                                                        updateEventTemplate.frequencyType = val;
                                                        let date = moment(new Date()).format(this.props.dateFormat);
                                                        if (updateEventTemplate.date) {
                                                            date = moment(new Date(updateEventTemplate.date)).format(this.props.dateFormat);
                                                        }
                                                        if (val == 'day') {
                                                            updateEventTemplate.frequencyDayScheduledDateFrom = date;
                                                            updateEventTemplate.frequencyDayScheduledDateTo = date
                                                            updateEventTemplate.recurring = true
                                                        } else if (val == 'week') {
                                                            updateEventTemplate.frequencyWeekScheduledDateFrom = date;
                                                            updateEventTemplate.frequencyWeekScheduledDateTo = moment.unix(Math.floor(new Date(date).getTime() / 1000) + 7 * 24 * 60 * 60).format(this.props.dateFormat);
                                                            updateEventTemplate.recurring = true

                                                        } else if (val == 'month') {
                                                            updateEventTemplate.frequencyMonthScheduledDateFrom = date;
                                                            updateEventTemplate.frequencyMonthScheduledDateTo = moment.unix(Math.floor(new Date(date).getTime() / 1000) + 30 * 24 * 60 * 60).format(this.props.dateFormat);
                                                            updateEventTemplate.recurring = true

                                                        } else {
                                                            updateEventTemplate.recurring = false

                                                        }
                                                        this.setState({
                                                            updateEventTemplate,
                                                            errorEvent: null
                                                        })
                                                    }}>
                                                    <option value={-1}>
                                                        {'Choose frequency'.translate(this.props.lang)}
                                                    </option>
                                                    <option value={'day'}>
                                                        {'Day'.translate(this.props.lang)}
                                                    </option>
                                                    {showRecurringOptions ? <>
                                                        <option value={'week'}>
                                                            {'Week'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'month'}>
                                                            {'Month'.translate(this.props.lang)}
                                                        </option>
                                                    </> : null}
                                                </Input>

                                            </FormGroup>

                                            {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                            {
                                                this.state.updateEventTemplate.frequencyType == 'day' ?
                                                    <div>
                                                        <Row>
                                                            <Col lg="12">
                                                                <div style={{ display: 'flex', textAlign: 'center', alignItems: 'center', marginBottom: 5, marginTop: 10 }}>
                                                                    <Label style={{ marginRight: 5 }}>{'Every'.translate(this.props.lang)}</Label>
                                                                    <Input style={{ width: '25%' }} type='text' value={this.state.updateEventTemplate.frequencyDayText} onChange={(e) => {
                                                                        let value = e.target.value
                                                                        value = value.replace(/[^0-9]/g, '')

                                                                        let updateEventTemplate = this.state.updateEventTemplate;
                                                                        updateEventTemplate.frequencyDayText = value;
                                                                        this.setState({
                                                                            updateEventTemplate
                                                                        })
                                                                    }} />
                                                                    <Label style={{ marginLeft: 5 }}>{'day(s)'.translate(this.props.lang) + '*'}</Label>
                                                                </div>
                                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                                                <DatePicker
                                                                    label={'Start date'.translate(this.props.lang) + '*'}
                                                                    minDate={new Date()}
                                                                    dateFormat={this.props.dateFormat}
                                                                    lang={this.props.lang}
                                                                    holidayEvents={this.state.holidayEvents}
                                                                    value={this.state.updateEventTemplate.frequencyDayScheduledDateFrom ? this.state.updateEventTemplate.frequencyDayScheduledDateFrom : moment(new Date()).format(this.props.dateFormat)}
                                                                    onChange={(e) => {
                                                                        let updateEventTemplate = this.state.updateEventTemplate;
                                                                        updateEventTemplate.frequencyDayScheduledDateFrom = e;
                                                                        this.setState({
                                                                            updateEventTemplate
                                                                        })

                                                                        if (this.state.updateEventTemplate.frequencyDayScheduledDateTo && this.state.updateEventTemplate.frequencyDayScheduledDateFrom) {
                                                                            let dateTo = new Date(this.state.updateEventTemplate.frequencyDayScheduledDateTo)
                                                                            let dateFrom = new Date(this.state.updateEventTemplate.frequencyDayScheduledDateFrom)
                                                                            if (dateFrom.getTime() > dateTo.getTime() || this.calculateMaxDateHotfix(this.state.updateEventTemplate.frequencyDayScheduledDateFrom)) {
                                                                                let updateEventTemplate = this.state.updateEventTemplate;
                                                                                updateEventTemplate.frequencyDayScheduledDateTo = this.state.updateEventTemplate.frequencyDayScheduledDateFrom;
                                                                                this.setState({
                                                                                    updateEventTemplate
                                                                                })
                                                                            }
                                                                        } else if (!this.state.updateEventTemplate.frequencyDayScheduledDateTo && this.state.updateEventTemplate.frequencyDayScheduledDateFrom) {
                                                                            let updateEventTemplate = this.state.updateEventTemplate;
                                                                            updateEventTemplate.frequencyDayScheduledDateTo = this.state.updateEventTemplate.frequencyDayScheduledDateFrom;
                                                                            this.setState({
                                                                                updateEventTemplate
                                                                            })
                                                                        }

                                                                    }}
                                                                />
                                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                                            </Col>
                                                            <Col lg="12">
                                                                <div style={{ marginTop: 5 }}>
                                                                    <DatePicker
                                                                        label={'End date'.translate(this.props.lang) + '*'}
                                                                        dateFormat={this.props.dateFormat}
                                                                        holidayEvents={this.state.holidayEvents}
                                                                        lang={this.props.lang}
                                                                        minDate={new Date(this.state.updateEventTemplate.frequencyDayScheduledDateFrom) != 'Invalid Date' ? new Date(this.state.updateEventTemplate.frequencyDayScheduledDateFrom) : new Date()}
                                                                        maxDate={this.calculateMaxDateHotfix(this.state.updateEventTemplate.frequencyDayScheduledDateFrom)}
                                                                        value={this.state.updateEventTemplate.frequencyDayScheduledDateTo ? this.state.updateEventTemplate.frequencyDayScheduledDateTo : moment(new Date()).format(this.props.dateFormat)}
                                                                        onChange={(e) => {
                                                                            let updateEventTemplate = this.state.updateEventTemplate;
                                                                            updateEventTemplate.frequencyDayScheduledDateTo = e;
                                                                            this.setState({
                                                                                updateEventTemplate
                                                                            })

                                                                        }}
                                                                    />
                                                                </div>
                                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                                            </Col>
                                                        </Row>

                                                    </div>
                                                    : null
                                            }


                                            {
                                                this.state.updateEventTemplate.frequencyType == 'week' ?
                                                    <div style={{ marginTop: 10, marginBottom: 15 }}>
                                                        <Row>
                                                            <Col lg="12">
                                                                <Checkbox
                                                                    onChange={(e) => {
                                                                        let updateEventTemplate = this.state.updateEventTemplate;
                                                                        updateEventTemplate.checkedMonday = e.target.checked
                                                                        this.setState({
                                                                            updateEventTemplate
                                                                        })
                                                                    }}
                                                                    checked={this.state.updateEventTemplate.checkedMonday}
                                                                    label={'Monday'.translate(this.props.lang)}
                                                                />
                                                                <Checkbox
                                                                    onChange={(e) => {
                                                                        let updateEventTemplate = this.state.updateEventTemplate;
                                                                        updateEventTemplate.checkedTuesday = e.target.checked
                                                                        this.setState({
                                                                            updateEventTemplate
                                                                        })
                                                                    }}
                                                                    checked={this.state.updateEventTemplate.checkedTuesday}
                                                                    label={'Tuesday'.translate(this.props.lang)}
                                                                />
                                                                <Checkbox
                                                                    onChange={(e) => {
                                                                        let updateEventTemplate = this.state.updateEventTemplate;
                                                                        updateEventTemplate.checkedWednesday = e.target.checked
                                                                        this.setState({
                                                                            updateEventTemplate
                                                                        })
                                                                    }}
                                                                    checked={this.state.updateEventTemplate.checkedWednesday}
                                                                    label={'Wednesday'.translate(this.props.lang)}
                                                                />
                                                                <Checkbox
                                                                    onChange={(e) => {
                                                                        let updateEventTemplate = this.state.updateEventTemplate;
                                                                        updateEventTemplate.checkedThursday = e.target.checked
                                                                        this.setState({
                                                                            updateEventTemplate
                                                                        })
                                                                    }}
                                                                    checked={this.state.updateEventTemplate.checkedThursday}
                                                                    label={'Thursday'.translate(this.props.lang)}
                                                                />
                                                                <Checkbox
                                                                    onChange={(e) => {
                                                                        let updateEventTemplate = this.state.updateEventTemplate;
                                                                        updateEventTemplate.checkedFriday = e.target.checked
                                                                        this.setState({
                                                                            updateEventTemplate
                                                                        })
                                                                    }}
                                                                    checked={this.state.updateEventTemplate.checkedFriday}
                                                                    label={'Friday'.translate(this.props.lang)}
                                                                />
                                                                <Checkbox
                                                                    onChange={(e) => {
                                                                        let updateEventTemplate = this.state.updateEventTemplate;
                                                                        updateEventTemplate.checkedSaturday = e.target.checked
                                                                        this.setState({
                                                                            updateEventTemplate
                                                                        })
                                                                    }}
                                                                    checked={this.state.updateEventTemplate.checkedSaturday}
                                                                    label={'Saturday'.translate(this.props.lang)}
                                                                />
                                                                <Checkbox
                                                                    onChange={(e) => {
                                                                        let updateEventTemplate = this.state.updateEventTemplate;
                                                                        updateEventTemplate.checkedSunday = e.target.checked
                                                                        this.setState({
                                                                            updateEventTemplate
                                                                        })
                                                                    }}
                                                                    checked={this.state.updateEventTemplate.checkedSunday}
                                                                    label={'Sunday'.translate(this.props.lang)}
                                                                />
                                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                                                <DatePicker
                                                                    label={'Start date'.translate(this.props.lang) + '*'}
                                                                    minDate={new Date()}
                                                                    dateFormat={this.props.dateFormat}
                                                                    holidayEvents={this.state.holidayEvents}
                                                                    lang={this.props.lang}
                                                                    value={this.state.updateEventTemplate.frequencyWeekScheduledDateFrom ? this.state.updateEventTemplate.frequencyWeekScheduledDateFrom : moment(new Date()).format(this.props.dateFormat)}
                                                                    onChange={(e) => {
                                                                        let updateEventTemplate = this.state.updateEventTemplate;
                                                                        updateEventTemplate.frequencyWeekScheduledDateFrom = e;
                                                                        this.setState({
                                                                            updateEventTemplate
                                                                        })

                                                                        if (this.state.updateEventTemplate.frequencyWeekScheduledDateTo && this.state.updateEventTemplate.frequencyWeekScheduledDateFrom) {
                                                                            let dateTo = new Date(this.state.updateEventTemplate.frequencyWeekScheduledDateTo)
                                                                            let dateFrom = new Date(this.state.updateEventTemplate.frequencyWeekScheduledDateFrom)
                                                                            if (dateFrom.getTime() + 1000 * 60 * 60 * 24 * 7 > dateTo.getTime()) {
                                                                                let updateEventTemplate = this.state.updateEventTemplate;
                                                                                let date = new Date(this.state.updateEventTemplate.frequencyWeekScheduledDateFrom)
                                                                                date.setDate(date.getDate() + 7)
                                                                                updateEventTemplate.frequencyWeekScheduledDateTo = moment(new Date(date)).format(this.props.dateFormat ? this.props.dateFormat : 'YYYY-MM-DD');
                                                                                this.setState({
                                                                                    updateEventTemplate
                                                                                })

                                                                            }
                                                                        } else if (!this.state.updateEventTemplate.frequencyWeekScheduledDateTo && this.state.updateEventTemplate.frequencyWeekScheduledDateFrom) {
                                                                            let updateEventTemplate = this.state.updateEventTemplate;
                                                                            let date = new Date(this.state.updateEventTemplate.frequencyWeekScheduledDateFrom)
                                                                            date.setDate(date.getDate() + 7)
                                                                            updateEventTemplate.frequencyWeekScheduledDateTo = moment(new Date(date)).format(this.props.dateFormat ? this.props.dateFormat : 'YYYY-MM-DD');
                                                                            this.setState({
                                                                                updateEventTemplate
                                                                            })
                                                                        }

                                                                    }}
                                                                />
                                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                                            </Col>
                                                            <Col lg="12">
                                                                <DatePicker
                                                                    label={'End date'.translate(this.props.lang) + '*'}
                                                                    dateFormat={this.props.dateFormat}
                                                                    holidayEvents={this.state.holidayEvents}
                                                                    lang={this.props.lang}
                                                                    minDate={new Date(this.state.updateEventTemplate.frequencyWeekScheduledDateFrom) != 'Invalid Date' ? new Date(this.state.updateEventTemplate.frequencyWeekScheduledDateFrom) : new Date(this.state.weekDate)}
                                                                    value={this.state.updateEventTemplate.frequencyWeekScheduledDateTo ? this.state.updateEventTemplate.frequencyWeekScheduledDateTo : moment(this.state.weekDate).format(this.props.dateFormat)}
                                                                    onChange={(e) => {
                                                                        let updateEventTemplate = this.state.updateEventTemplate;
                                                                        updateEventTemplate.frequencyWeekScheduledDateTo = e;
                                                                        this.setState({
                                                                            updateEventTemplate
                                                                        })

                                                                    }}
                                                                />
                                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    : null
                                            }
                                            {
                                                this.state.updateEventTemplate.frequencyType == 'month' ?
                                                    <div style={{ marginBottom: 5 }}>
                                                        <Row>
                                                            <Col lg="12">
                                                                <div style={{ display: 'flex', textAlign: 'center', alignItems: 'center', marginBottom: 5, marginTop: 10 }}>
                                                                    <Label style={{ marginRight: 5 }}>{'Every'.translate(this.props.lang)}</Label>
                                                                    <Input style={{ width: '30%' }} type='select' onChange={(e) => {
                                                                        let val = null;
                                                                        if (e.target.value != '-1') {
                                                                            val = e.target.value;
                                                                        }
                                                                        let updateEventTemplate = this.state.updateEventTemplate;
                                                                        updateEventTemplate.frequencyMonthScheduled = val;
                                                                        this.setState({
                                                                            updateEventTemplate
                                                                        })
                                                                    }}>
                                                                        <option value={'-1'}>

                                                                        </option>
                                                                        <option value={'1'}>
                                                                            {'1st'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'2'}>
                                                                            {'2nd'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'3'}>
                                                                            {'3rd'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'4'}>
                                                                            {'4th'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'5'}>
                                                                            {'5th'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'6'}>
                                                                            {'6th'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'7'}>
                                                                            {'7th'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'8'}>
                                                                            {'8th'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'9'}>
                                                                            {'9th'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'10'}>
                                                                            {'10th'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'11'}>
                                                                            {'11th'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'12'}>
                                                                            {'12th'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'13'}>
                                                                            {'13th'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'14'}>
                                                                            {'14th'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'15'}>
                                                                            {'15th'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'16'}>
                                                                            {'16th'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'17'}>
                                                                            {'17th'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'18'}>
                                                                            {'18th'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'19'}>
                                                                            {'19th'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'20'}>
                                                                            {'20th'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'21'}>
                                                                            {'21st'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'22'}>
                                                                            {'22nd'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'23'}>
                                                                            {'23rd'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'24'}>
                                                                            {'24th'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'25'}>
                                                                            {'25th'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'26'}>
                                                                            {'26th'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'27'}>
                                                                            {'27th'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'28'}>
                                                                            {'28th'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'29'}>
                                                                            {'29th'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'30'}>
                                                                            {'30th'.translate(this.props.lang)}
                                                                        </option>
                                                                        <option value={'31'}>
                                                                            {'31st'.translate(this.props.lang)}
                                                                        </option>

                                                                    </Input>
                                                                    <Label style={{ marginLeft: 5 }}>{'day of the month'.translate(this.props.lang) + '*'}</Label>
                                                                </div>
                                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                                                <DatePicker
                                                                    label={'Start date'.translate(this.props.lang) + '*'}
                                                                    minDate={new Date()}
                                                                    dateFormat={this.props.dateFormat}
                                                                    holidayEvents={this.state.holidayEvents}
                                                                    lang={this.props.lang}
                                                                    value={this.state.updateEventTemplate.frequencyMonthScheduledDateFrom ? this.state.updateEventTemplate.frequencyMonthScheduledDateFrom : moment(new Date()).format(this.props.dateFormat)}
                                                                    onChange={(e) => {
                                                                        let updateEventTemplate = this.state.updateEventTemplate;
                                                                        updateEventTemplate.frequencyMonthScheduledDateFrom = e;
                                                                        this.setState({
                                                                            updateEventTemplate
                                                                        })

                                                                        if (this.state.updateEventTemplate.frequencyMonthScheduledDateTo && this.state.updateEventTemplate.frequencyMonthScheduledDateFrom) {
                                                                            let dateTo = new Date(this.state.updateEventTemplate.frequencyMonthScheduledDateTo)
                                                                            let dateFrom = new Date(this.state.updateEventTemplate.frequencyMonthScheduledDateFrom)
                                                                            if (dateFrom.getTime() + 1000 * 60 * 60 * 24 * 31 > dateTo.getTime()) {
                                                                                let updateEventTemplate = this.state.updateEventTemplate;
                                                                                let date = new Date(this.state.updateEventTemplate.frequencyMonthScheduledDateFrom)
                                                                                date.setDate(date.getDate() + 31)
                                                                                updateEventTemplate.frequencyMonthScheduledDateTo = moment(new Date(date)).format(this.props.dateFormat ? this.props.dateFormat : 'YYYY-MM-DD');
                                                                                this.setState({
                                                                                    updateEventTemplate
                                                                                })

                                                                            }
                                                                        } else if (!this.state.updateEventTemplate.frequencyMonthScheduledDateTo && this.state.updateEventTemplate.frequencyMonthScheduledDateFrom) {
                                                                            let updateEventTemplate = this.state.updateEventTemplate;
                                                                            let date = new Date(this.state.updateEventTemplate.frequencyMonthScheduledDateFrom)
                                                                            date.setDate(date.getDate() + 31)
                                                                            updateEventTemplate.frequencyMonthScheduledDateTo = moment(new Date(date)).format(this.props.dateFormat ? this.props.dateFormat : 'YYYY-MM-DD');
                                                                            this.setState({
                                                                                updateEventTemplate
                                                                            })
                                                                        }
                                                                    }}
                                                                />
                                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                                            </Col>
                                                            <Col lg="12">
                                                                <DatePicker
                                                                    label={'End date'.translate(this.props.lang) + '*'}
                                                                    dateFormat={this.props.dateFormat}
                                                                    holidayEvents={this.state.holidayEvents}
                                                                    lang={this.props.lang}
                                                                    minDate={new Date(this.state.updateEventTemplate.frequencyMonthScheduledDateFrom) != 'Invalid Date' ? new Date(this.state.updateEventTemplate.frequencyMonthScheduledDateFrom) : new Date(this.state.monthDate)}
                                                                    value={this.state.updateEventTemplate.frequencyMonthScheduledDateTo ? this.state.updateEventTemplate.frequencyMonthScheduledDateTo : moment(this.state.monthDate).format(this.props.dateFormat)}
                                                                    onChange={(e) => {
                                                                        let updateEventTemplate = this.state.updateEventTemplate;
                                                                        updateEventTemplate.frequencyMonthScheduledDateTo = e;
                                                                        this.setState({
                                                                            updateEventTemplate
                                                                        })

                                                                    }}
                                                                />
                                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    : null
                                            }
                                        </>
                                        :
                                        null
                                }




                            </ModalBody>
                            <ModalFooter className='modal-footer-buttons-wrap'>

                                <Button
                                    className="apply-button"
                                    color='primary'
                                    onClick={() => {
                                        let date = moment.unix(Math.floor(new Date(this.state.updateEventTemplate.date).getTime() / 1000)).format('MM/DD/YYYY');
                                        let startTime = this.state.updateEventTemplate.startTime;
                                        let _date = moment.unix(Math.floor(new Date(this.state.updateEventTemplate._date).getTime() / 1000)).format('MM/DD/YYYY');
                                        let _startTime = this.state.updateEventTemplate._startTime;
                                        let disabledFutureUpdate = false;
                                        if (_startTime !== startTime || _date !== date) {
                                            disabledFutureUpdate = true;
                                        }
                                        if (this.state.updateEventTemplate)
                                            this.setState({ updateEventTemplateModal: { ...this.state.updateEventTemplate, disabledFutureUpdate } })
                                    }}>
                                    {this.state.loading ?

                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Player
                                                onEvent={() => {
                                                    if (!this.state.loading) this.stopAnimation();
                                                }}
                                                onStateChange={this.toggleVisibility}
                                                ref={this.player} // set the ref to your class instance
                                                autoplay={true}
                                                loop={true}
                                                controls={true}
                                                src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                                style={{ height: "20px", width: "30px" }}
                                            ></Player>
                                            {'Processing...'.translate(this.props.lang)}
                                        </div>

                                        : 'Set'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    className="cancel-time-button"
                                    color='primary'
                                    onClick={() => {
                                        // this.deletePatientTime(this.state.updateEventTemplate)
                                        this.setState({ deleteEventTemplateModal: { ...this.state.updateEventTemplate } })
                                    }}>
                                    {this.state.loadingDelete ?

                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Player
                                                onEvent={() => {
                                                    if (!this.state.loadingDelete) this.stopAnimation();
                                                }}
                                                onStateChange={this.toggleVisibility}
                                                ref={this.player} // set the ref to your class instance
                                                autoplay={true}
                                                loop={true}
                                                controls={true}
                                                src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                                style={{ height: "20px", width: "30px" }}
                                            ></Player>
                                            {'Processing...'.translate(this.props.lang)}
                                        </div>

                                        : 'Cancel time'.translate(this.props.lang)}
                                </Button>

                                <Button
                                    className="book-vitit-from-template-button"
                                    color='primary'
                                    onClick={() => {
                                        let data = { ...this.state.updateEventTemplate };
                                        let scheduleControl = {
                                            date: data.date,
                                            endTime: data.date,
                                            startTime: data.startTime,
                                            endTime: data.endTime,
                                            templateData: { ...data }
                                        }

                                        this.setState({
                                            patientModal: scheduleControl
                                        }, () => {
                                            // this.setVisitReasonFromTemplate();
                                            this.getLastOpenedChats()

                                        })
                                    }}
                                >{'Book visit from template'.translate(this.props.lang)}</Button>
                                {
                                    this.state.updateEventTemplate.id ?
                                        <Button
                                            className="cancel-modal-button"
                                            color='primary'
                                            onClick={() => this.setState({
                                                updateEventTemplate: null
                                            })}
                                        >{'Cancel'.translate(this.props.lang)}</Button>
                                        :
                                        null
                                }

                            </ModalFooter>
                            <div style={{ margin: '5px 15px' }}>
                                {
                                    this.state.updateEventTemplate?.tsCreated && this.state.updateEventTemplate?.tsModified && this.state.updateEventTemplate?.tsCreated !== this.state.updateEventTemplate?.tsModified ?
                                        <div className='info-message-update-wrap'>
                                            {`${'Created on:'.translate(this.props.lang)} ${this.props.getStringDateTs(this.state.updateEventTemplate?.tsCreated, `${this.props.dateFormat} HH:mm`)}. ${'Last update:'.translate(this.props.lang)} ${this.props.getStringDateTs(this.state.updateEventTemplate?.tsModified, `${this.props.dateFormat} HH:mm`)}`}
                                        </div>
                                        :
                                        this.state.updateEventTemplate?.tsCreated ?
                                            <div className='info-message-update-wrap'>
                                                {`${'Created on:'.translate(this.props.lang)} ${this.props.getStringDateTs(this.state.updateEventTemplate?.tsCreated, `${this.props.dateFormat} HH:mm`)}`}
                                            </div>
                                            :
                                            null

                                }
                            </div>

                        </Modal >

                        : null
                }
                {
                    this.state.updateAdministrativeBookingModal ?
                        <UpdateAdministrativeBooking
                            {...this.props}
                            eventId={this.state.updateAdministrativeBookingModal}
                            toggle={(callback) => {
                                this.setState({ updateAdministrativeBookingModal: false }, () => {
                                    if (callback) callback();
                                });
                                this.get();
                            }}
                        />
                        :
                        null
                }
                {

                    this.state.updateEventModal ?
                        <Modal isOpen={this.state.updateEventModal} centered >
                            <ModalBody className="delete-modal">
                                <div className='message' style={{ padding: 20 }}>
                                    {'Do you want to update this event, or this and all future events?'.translate(this.props.lang)}
                                </div>
                            </ModalBody>
                            <ModalFooter
                                className='modal-footer-buttons-wrap'
                                style={{ justifyContent: 'center' }}
                            >
                                <Button
                                    disabled={this.state.loading}
                                    color='primary'
                                    onClick={() => {
                                        const data = { ...this.state.updateEventModal };
                                        this.updateEventTypeEvent(data, false)
                                    }}
                                >
                                    {'This event only'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    disabled={this.state.loading}
                                    color='primary'
                                    onClick={() => {
                                        const data = { ...this.state.updateEventModal };
                                        this.updateEventTypeEvent(data, true)
                                    }}
                                >
                                    {'This event and future events'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    color='primary'
                                    onClick={() => this.setState({ updateEventModal: !this.state.updateEventModal })}>
                                    {'Cancel'.translate(this.props.lang)}
                                </Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {

                    this.state.deleteEventModal?.recurringKey ?
                        <Modal isOpen={this.state.deleteEventModal} centered >
                            <ModalBody className="delete-modal">
                                <div className='message' style={{ padding: 20 }}>
                                    {'Do you want to delete this event, or this and all future events?'.translate(this.props.lang)}
                                </div>
                            </ModalBody>
                            <ModalFooter
                                className='modal-footer-buttons-wrap'
                                style={{ justifyContent: 'center' }}
                            >
                                <Button
                                    disabled={this.state.loadingDelete || this.state.loadingScheduleEvent || this.state.loadingLeaveMeeting}
                                    color='primary'
                                    onClick={() => {
                                        const eventId = this.state.deleteEventModal?.id;
                                        this.deleteEventTypeEvent(eventId, false)
                                    }}
                                >
                                    {'This event only'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    disabled={this.state.loadingDelete || this.state.loadingScheduleEvent || this.state.loadingLeaveMeeting}
                                    color='primary'
                                    onClick={() => {
                                        const eventId = this.state.deleteEventModal?.id;
                                        this.deleteEventTypeEvent(eventId, true)
                                    }}
                                >
                                    {'This event and future events'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    color='primary'
                                    onClick={() => this.setState({ deleteEventModal: !this.state.deleteEventModal })}>
                                    {'Cancel'.translate(this.props.lang)}
                                </Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {

                    this.state.deleteEventModal && !this.state.deleteEventModal.recurringKey ?
                        <Modal isOpen={this.state.deleteEventModal} centered >
                            <ModalBody className="delete-modal">
                                <div className='message' style={{ padding: 20 }}>
                                    {'Do you want to delete this event?'.translate(this.props.lang)}
                                    {/* {'Do you really want to delete the booked time? In that case, do not forget to book a new one!'.translate(this.props.lang)} */}
                                </div>
                            </ModalBody>
                            <ModalFooter
                                className='modal-footer-buttons-wrap'
                                style={{ justifyContent: 'center' }}
                            >
                                <Button
                                    disabled={this.state.loadingDelete || this.state.loadingScheduleEvent || this.state.loadingLeaveMeeting}
                                    color='primary'
                                    onClick={() => {
                                        const eventId = this.state.deleteEventModal?.id;
                                        this.deleteEventTypeEvent(eventId, false)
                                    }}
                                >
                                    {'Continue'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    color='primary'
                                    onClick={() => this.setState({ deleteEventModal: !this.state.deleteEventModal })}>
                                    {'Go back'.translate(this.props.lang)}
                                </Button>

                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {

                    this.state.deleteColleagueEventModal?.recurringKey ?
                        <Modal isOpen={this.state.deleteColleagueEventModal} centered >
                            <ModalBody className="delete-modal">
                                <div className='message' style={{ padding: 20 }}>
                                    {'Do you want to leave this event meeting, or this and all future events?'.translate(this.props.lang)}
                                </div>
                            </ModalBody>
                            <ModalFooter
                                className='modal-footer-buttons-wrap'
                                style={{ justifyContent: 'center' }}
                            >
                                <Button
                                    disabled={this.state.loadingDelete || this.state.loadingScheduleEvent || this.state.loadingLeaveMeeting}
                                    color='primary'
                                    onClick={() => {
                                        const eventId = this.state.deleteColleagueEventModal?.id;
                                        const colleagueId = this.state.doctor ? this.state.doctor : this.props.uData?._id;
                                        if (eventId && colleagueId) {
                                            this.leaveMeeting(eventId, colleagueId, false)
                                        }
                                    }}
                                >
                                    {'This event only'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    disabled={this.state.loadingDelete || this.state.loadingScheduleEvent || this.state.loadingLeaveMeeting}
                                    color='primary'
                                    onClick={() => {
                                        const eventId = this.state.deleteColleagueEventModal?.id;
                                        const colleagueId = this.state.doctor ? this.state.doctor : this.props.uData?._id;
                                        if (eventId && colleagueId) {
                                            this.leaveMeeting(eventId, colleagueId, true)
                                        }

                                    }}
                                >
                                    {'This event and future events'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    color='primary'
                                    onClick={() => this.setState({ deleteColleagueEventModal: !this.state.deleteColleagueEventModal })}>
                                    {'Cancel'.translate(this.props.lang)}
                                </Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {

                    this.state.deleteColleagueEventModal && !this.state.deleteColleagueEventModal.recurringKey ?
                        <Modal isOpen={this.state.deleteColleagueEventModal} centered >
                            <ModalBody className="delete-modal">
                                <div className='message' style={{ padding: 20 }}>
                                    {'Do you want to leave this event meeting?'.translate(this.props.lang)}
                                </div>
                            </ModalBody>
                            <ModalFooter
                                className='modal-footer-buttons-wrap'
                                style={{ justifyContent: 'center' }}
                            >
                                <Button
                                    disabled={this.state.loadingDelete || this.state.loadingScheduleEvent || this.state.loadingLeaveMeeting}
                                    color='primary'
                                    onClick={() => {
                                        const eventId = this.state.deleteColleagueEventModal?.id;
                                        const colleagueId = this.state.doctor ? this.state.doctor : this.props.uData?._id;
                                        if (eventId && colleagueId) {
                                            this.leaveMeeting(eventId, colleagueId, false)
                                        }
                                    }}
                                >
                                    {'Yes'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    color='primary'
                                    onClick={() => this.setState({ deleteColleagueEventModal: !this.state.deleteColleagueEventModal })}>
                                    {'No'.translate(this.props.lang)}
                                </Button>

                            </ModalFooter>
                        </Modal>
                        :
                        null
                }

                {
                    this.state.updateEventTemplateModal ?
                        <Modal isOpen={this.state.updateEventTemplateModal} centered >
                            {/* <ModalHeader style={{ margin: 'auto' }}>{'Warning'.translate(this.props.lang)}</ModalHeader> */}
                            <ModalBody className="delete-modal">
                                {/* <img src={warrning} /> */}
                                <div className='message' style={{ padding: 20 }}>
                                    {'Do you want to apply this changes to this event only, or this and all future events?'.translate(this.props.lang)}
                                </div>
                            </ModalBody>
                            <ModalFooter
                                className='modal-footer-buttons-wrap'
                                style={{ justifyContent: 'center' }}
                            >
                                <Button
                                    disabled={this.state.loadingDelete || this.state.loadingScheduleEvent}
                                    color='primary'
                                    onClick={() => {
                                        this.updateEventTemplate(this.state.updateEventTemplateModal, false)
                                    }}
                                >
                                    {'This event only'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    disabled={this.state.loadingDelete || this.state.loadingScheduleEvent || this.state.updateEventTemplateModal?.disabledFutureUpdate}
                                    color='primary'
                                    onClick={() => {
                                        if (updateEventTemplateWithReccuring) {
                                            const data = JSON.parse(JSON.stringify(this.state.updateEventTemplateModal));
                                            this.deleteEventTemplate(this.state.updateEventTemplateModal, true, () => {
                                                this.scheduleTemplate(data)
                                            })
                                        } else {
                                            this.updateEventTemplate(this.state.updateEventTemplateModal, true)
                                        }

                                    }}
                                >
                                    {'This event and future events'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    color='primary'
                                    onClick={() => this.setState({ updateEventTemplateModal: !this.state.updateEventTemplateModal })}>
                                    {'Cancel'.translate(this.props.lang)}
                                </Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.deleteEventTemplateModal ?
                        <Modal isOpen={this.state.deleteEventTemplateModal} centered >
                            {/* <ModalHeader style={{ margin: 'auto' }}>{'Warning'.translate(this.props.lang)}</ModalHeader> */}
                            <ModalBody className="delete-modal">
                                {/* <img src={warrning} /> */}
                                <div className='message' style={{ padding: 20 }}>
                                    {'Do you want to cancel this event only, or this and all future events?'.translate(this.props.lang)}
                                </div>
                            </ModalBody>
                            <ModalFooter
                                className='modal-footer-buttons-wrap'
                                style={{ justifyContent: 'center' }}
                            >
                                <Button
                                    disabled={this.state.loadingDelete}
                                    color='primary'
                                    onClick={() => {
                                        this.deleteEventTemplate(this.state.deleteEventTemplateModal, false)
                                    }}
                                >
                                    {'This event only'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    disabled={this.state.loadingDelete}
                                    color='primary'
                                    onClick={() => {
                                        this.deleteEventTemplate(this.state.deleteEventTemplateModal, true)
                                    }}
                                >
                                    {'This event and future events'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    color='primary'
                                    onClick={() => this.setState({ deleteEventTemplateModal: !this.state.deleteEventTemplateModal })}>
                                    {'Cancel'.translate(this.props.lang)}
                                </Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.schedulePatientTime ?
                        <Modal isOpen={this.state.schedulePatientTime} centered>
                            <ModalHeader toggle={() => this.setState({ schedulePatientTime: !this.state.schedulePatientTime, doctorsList: [] })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ schedulePatientTime: !this.state.schedulePatientTime, doctorsList: [] })}>&times;</button>}>
                                {'Enter availability'.translate(this.props.lang)}
                            </ModalHeader>
                            <ModalBody>
                                <FormGroup>
                                    <Label>{'Type'.translate(this.props.lang) + '*'}</Label>
                                    <Input type='select' value={this.state.schedulePatientTime.type} onChange={(e) => {
                                        let val = false
                                        if (e.target.value != -1) {
                                            val = e.target.value
                                        }
                                        let schedulePatientTime = this.state.schedulePatientTime
                                        schedulePatientTime.type = val
                                        // if (val === 'event') {
                                        //     schedulePatientTime.title = 'Event'
                                        // } else if (val === 'free') {
                                        //     schedulePatientTime.title = 'Available for booking'
                                        // } else {
                                        //     schedulePatientTime.title = ''
                                        // }
                                        this.setState({
                                            schedulePatientTime
                                        })
                                    }}>
                                        <option value={-1}>{'Select event type'.translate(this.props.lang)}</option>
                                        <option value={'event'}>{'Schedule event'.translate(this.props.lang)}</option>
                                        <option value={'free'}>{'Mark as available'.translate(this.props.lang)}</option>
                                        {
                                            availabilityTemplatesEnabled || this.state.schedulePatientTime?.type === 'template' ?
                                                <option value={'template'}>{'Add availability template'.translate(this.props.lang)}</option>
                                                :
                                                null
                                        }
                                    </Input>
                                </FormGroup>
                                <FormGroup>
                                    <Label>{'Title'.translate(this.props.lang)}</Label>
                                    <Input type='text' value={this.state.schedulePatientTime.title} onChange={(e) => {
                                        let schedulePatientTime = this.state.schedulePatientTime
                                        schedulePatientTime.title = e.target.value
                                        this.setState({
                                            schedulePatientTime
                                        })
                                    }} />
                                </FormGroup>
                                {
                                    this.state.schedulePatientTime.type === 'template' ?
                                        <FormGroup style={{ position: 'relative' }}>
                                            <Label>{'Choose availability template'.translate(this.props.lang)}</Label>
                                            <div className={this.state.chooseAvailabilityTemplateOpenMenu ? 'custom-select-with-search-open' : 'custom-select-with-search-closed'}
                                                onClick={() => {
                                                    this.setState({
                                                        chooseAvailabilityTemplateOpenMenu: !this.state.chooseAvailabilityTemplateOpenMenu
                                                    })
                                                }}
                                            >
                                                {this.state.availabilityTemplates.map(item => {
                                                    let selectedAvailabilityTemplate = this.state.schedulePatientTime?.selectedAvailabilityTemplate?.id;
                                                    if (selectedAvailabilityTemplate && selectedAvailabilityTemplate === item._id) {
                                                        return (
                                                            <div className='calendar-select-template-item-wrap'>
                                                                <div className='calendar-select-template-item-color' style={{ backgroundColor: item.calendarColor }}></div> {item.name} <span>({item.duration} {"min".translate(this.props.lang)})</span>
                                                            </div>
                                                        )
                                                    }
                                                })}

                                            </div>

                                            {
                                                this.state.chooseAvailabilityTemplateOpenMenu ?
                                                    <div className='custom-select-with-search-items custom-select-with-search-items-availability-template'>
                                                        <CustomSelectWithSearch
                                                            lang={this.props.lang}
                                                            items={this.state.availabilityTemplates.map((item, idx) => {
                                                                return {
                                                                    name: item.name,
                                                                    nameComponent: <div className='calendar-select-template-item-wrap'>
                                                                        <div className='calendar-select-template-item-color' style={{ backgroundColor: item.calendarColor }}></div> {item.name} <span>({item.duration} {"min".translate(this.props.lang)})</span>
                                                                    </div>,
                                                                    value: item._id
                                                                }
                                                            })}
                                                            value={this.state.schedulePatientTime?.selectedAvailabilityTemplate?.id}
                                                            maxHeight={'250px'}
                                                            onChange={(val) => {
                                                                let value = val.value != -1 ? val.value : null;
                                                                let schedulePatientTime = this.state.schedulePatientTime;

                                                                schedulePatientTime.selectedAvailabilityTemplate = {
                                                                    id: value,
                                                                    instances: schedulePatientTime?.selectedAvailabilityTemplate?.instances ?? 1,
                                                                    gap: schedulePatientTime?.selectedAvailabilityTemplate?.gap ?? 0
                                                                };

                                                                this.setState({ schedulePatientTime }, () => {
                                                                    this.setState({
                                                                        chooseAvailabilityTemplateOpenMenu: false
                                                                    })
                                                                })
                                                            }}
                                                        />
                                                    </div>
                                                    :
                                                    null
                                            }

                                        </FormGroup>
                                        :
                                        null
                                }
                                {
                                    this.state.schedulePatientTime.type === 'free' ?
                                        <FormGroup>
                                            <Label>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <div>
                                                        {'Enable booking by patient'.translate(this.props.lang)}
                                                    </div>
                                                    <div className="modal-header-tooltip"> <Isvg src={infoIcon} className="info-text" /> <div className="chat-icons-tooltip">{'Leave empty if time-slot should not be made available for patients to book'.translate(this.props.lang)}</div> </div>

                                                </div>

                                            </Label>
                                            <SelectWithCheckbox border={true} size='unset' label={'Select deparments'.translate(this.props.lang)} placeHolder={'Departments'.translate(this.props.lang)} values={this.getClinicDepartments()?.map(item => { return { name: item.name, value: item._id, workingHours: item?.workingHours } })} value={this.state.schedulePatientTime?.selectedEventDepartments}
                                                onChange={(value) => {

                                                    let schedulePatientTime = this.state.schedulePatientTime
                                                    schedulePatientTime.selectedEventDepartments = value

                                                    this.setState({
                                                        schedulePatientTime
                                                    }, () => {
                                                        this.getWebBookingForms()
                                                    })

                                                }} />
                                            <Checkbox label={'All active forms'.translate(this.props.lang)} checked={this.state.schedulePatientTime.allActiveForms} onChange={(e) => {
                                                let schedulePatientTime = this.state.schedulePatientTime
                                                schedulePatientTime.allActiveForms = e.target.checked
                                                this.setState({
                                                    schedulePatientTime
                                                })
                                            }} />
                                            {
                                                this.state.showWebBookingForms ?
                                                    <SelectWithCheckbox border={true} search={true} lang={this.props.lang} disabled={this.state.schedulePatientTime.allActiveForms} checkAll={this.state.schedulePatientTime.allActiveForms} placeHolder={'Search reason'.translate(this.props.lang)} values={this.state.webBookingForms.map(item => { return { name: item.name, value: item._id, additionalInfo: item?.duration ? `${item.duration} ${'min'.translate(this.props.lang)}` : null } })} value={this.state.schedulePatientTime.eventForms}
                                                        onChange={(value) => {
                                                            if (!this.state.schedulePatientTime.allActiveForms) {
                                                                let schedulePatientTime = this.state.schedulePatientTime
                                                                schedulePatientTime.eventForms = value

                                                                this.setState({
                                                                    schedulePatientTime
                                                                })
                                                            }

                                                        }} />
                                                    :
                                                    null
                                            }

                                        </FormGroup>
                                        :
                                        null
                                }
                                {
                                    !this.state.schedulePatientTime.frequencyType ?
                                        <DatePicker
                                            label={'Date'.translate(this.props.lang)}
                                            value={this.state.schedulePatientTime.date}
                                            holidayEvents={this.state.holidayEvents}
                                            lang={this.props.lang}
                                            onChange={(e) => {
                                                let schedulePatientTime = this.state.schedulePatientTime;
                                                schedulePatientTime.date = e;
                                                this.setState({
                                                    schedulePatientTime
                                                })
                                                if (Math.floor(new Date(this.state.schedulePatientTime.date + ' ' + this.state.schedulePatientTime.startTime) / 1000) > Math.floor(new Date(this.state.schedulePatientTime.endDate + ' ' + this.state.schedulePatientTime.endTime) / 1000)) {
                                                    schedulePatientTime.endDate = this.state.schedulePatientTime.date
                                                    this.setState({
                                                        schedulePatientTime
                                                    })
                                                }
                                            }}
                                        />
                                        :
                                        null
                                }



                                <div className='time-wrap' style={{ alignItems: this.state.schedulePatientTime.type === 'template' && this.state.schedulePatientTime.selectedAvailabilityTemplate?.id ? 'center' : 'flex-start' }}>
                                    <div className='time-component-wrap'>
                                        <FormGroup className="timepicker-container timepicker-wide">
                                            <Label>{'Start time'.translate(this.props.lang)}</Label>
                                            &nbsp;
                                            {/* TODO MAYBE */}
                                            <TimePickerV2
                                                getStringDateTs={this.props.getStringDateTs}
                                                format={'HH:mm'}
                                                value={this.state.schedulePatientTime.startTime}
                                                minValue={this.props.getStringDateTs(Math.floor(this.state.min.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.min.getTime() / 1000).format("HH:mm")
                                                maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000 - 300), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                                flag={0}
                                                onChange={(time1, timeString) => {

                                                    let schedulePatientTime = this.state.schedulePatientTime;
                                                    schedulePatientTime.startTime = timeString

                                                    let startTimeSplit = schedulePatientTime.startTime.split(":");
                                                    let endTimeSplit = schedulePatientTime.endTime.split(":");


                                                    let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                                    let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                                    // this.setState({ schedulePatientTime })
                                                    if (startTimeHourMinute < endTimeHourMinute) {
                                                        this.setState({ schedulePatientTime })
                                                    } else {
                                                        schedulePatientTime.endTime = Math.trunc((Number(this.state.schedulePatientTime.startTime.split(':')[0]) * 60 + Number(this.state.schedulePatientTime.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.schedulePatientTime.startTime.split(':')[0]) * 60 + Number(this.state.schedulePatientTime.startTime.split(':')[1]) + 5) % 60
                                                        // schedulePatientTime.endTime = validateTime(schedulePatientTime.endTime);
                                                        const padded = schedulePatientTime?.endTime?.split?.(':');
                                                        if (padded && Array.isArray(padded) && padded.length && isStringAValidNumber(padded[0]) && isStringAValidNumber(padded[1])) {
                                                            const h = padded[0]?.padStart?.(2, '0');
                                                            const m = padded[1]?.padStart?.(2, '0');
                                                            if (h && m) schedulePatientTime.endTime = `${h}:${m}`;
                                                        }
                                                        this.setState({
                                                            schedulePatientTime
                                                        })
                                                    }


                                                }}
                                            />
                                            {/* <TimePicker
                                            getStringDateTs={this.props.getStringDateTs}
                                            format={'HH:mm'}
                                            value={moment(new Date(this.state.schedulePatientTime.date.replace(/-/g, "/") + " " + this.state.schedulePatientTime.startTime))}
                                            // maxValue={this.state.schedulePatientTime.endTime}
                                            minValue={this.props.getStringDateTs(Math.floor(this.state.min.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.min.getTime() / 1000).format("HH:mm")
                                            maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                            flag={0}
                                            onChange={(time1, timeString) => {

                                                let schedulePatientTime = this.state.schedulePatientTime;
                                                schedulePatientTime.startTime = timeString

                                                let startTimeSplit = schedulePatientTime.startTime.split(":");
                                                let endTimeSplit = schedulePatientTime.endTime.split(":");


                                                let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                                let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                                this.setState({ schedulePatientTime })


                                            }}
                                            allowClear={false}
                                        /> */}
                                        </FormGroup>
                                        {
                                            this.state.schedulePatientTime?.type !== 'template' ?
                                                <FormGroup className="timepicker-container timepicker-wide">
                                                    <Label>{'End time'.translate(this.props.lang)}</Label>
                                                    &nbsp;
                                                    <TimePickerV2
                                                        getStringDateTs={this.props.getStringDateTs}
                                                        format={'HH:mm'}
                                                        value={this.state.schedulePatientTime.endTime}
                                                        minValue={Math.trunc((Number(this.state.schedulePatientTime.startTime.split(':')[0]) * 60 + Number(this.state.schedulePatientTime.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.schedulePatientTime.startTime.split(':')[0]) * 60 + Number(this.state.schedulePatientTime.startTime.split(':')[1]) + 5) % 60}
                                                        maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                                        flag={0}
                                                        onChange={(time1, timeString) => {

                                                            let schedulePatientTime = this.state.schedulePatientTime;
                                                            schedulePatientTime.endTime = timeString

                                                            let startTimeSplit = schedulePatientTime.startTime.split(":");
                                                            let endTimeSplit = schedulePatientTime.endTime.split(":");

                                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                                            if (startTimeHourMinute < endTimeHourMinute) {
                                                                this.setState({ schedulePatientTime })

                                                            } else {
                                                            }

                                                        }}
                                                    />
                                                    {/* <TimePicker
                                                        getStringDateTs={this.props.getStringDateTs}
                                                        format={'HH:mm'}
                                                        value={moment(new Date(this.state.schedulePatientTime.date.replace(/-/g, "/") + " " + this.state.schedulePatientTime.endTime))}
                                                        minValue={Math.trunc((Number(this.state.schedulePatientTime.startTime.split(':')[0]) * 60 + Number(this.state.schedulePatientTime.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.schedulePatientTime.startTime.split(':')[0]) * 60 + Number(this.state.schedulePatientTime.startTime.split(':')[1]) + 5) % 60}
                                                        maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                                        flag={0}
                                                        // maxValue={this.state.schedulePatientTime.startTime}
                                                        // flag={1}
                                                        onChange={(time1, timeString) => {

                                                            let schedulePatientTime = this.state.schedulePatientTime;
                                                            schedulePatientTime.endTime = timeString

                                                            let startTimeSplit = schedulePatientTime.startTime.split(":");
                                                            let endTimeSplit = schedulePatientTime.endTime.split(":");

                                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                                            if (startTimeHourMinute < endTimeHourMinute) {
                                                                this.setState({ schedulePatientTime })

                                                            } else {
                                                            }

                                                        }}
                                                        allowClear={false}
                                                    /> */}
                                                </FormGroup>
                                                :
                                                null
                                        }


                                    </div>
                                    {
                                        this.state.schedulePatientTime?.type === 'free' && availabilityInformationToClinicians ?
                                            <div className='availability-information-to-clinicians-component-wrap'>
                                                <h6>{'Information'.translate(this.props.lang)}</h6>
                                                <div className='availability-information-to-clinicians-component'>
                                                    <p>{truncateString(availabilityInformationToClinicians)}</p>
                                                </div>
                                            </div>
                                            :
                                            null
                                    }
                                    {
                                        this.state.schedulePatientTime.type === 'template' && this.state.schedulePatientTime.selectedAvailabilityTemplate?.id ?
                                            <div className='availability-template-instances-gap-wrap'>
                                                <FormGroup>
                                                    <Label>{'Instances'.translate(this.props.lang)}</Label>
                                                    <Input type='select'
                                                        value={this.state.schedulePatientTime.selectedAvailabilityTemplate?.instances}
                                                        onChange={(e) => {
                                                            let value = e.target.value;
                                                            let schedulePatientTime = this.state.schedulePatientTime;
                                                            if (schedulePatientTime.selectedAvailabilityTemplate) {
                                                                schedulePatientTime.selectedAvailabilityTemplate.instances = value;
                                                                if (value?.toString() === '1') {
                                                                    schedulePatientTime.selectedAvailabilityTemplate.gap = 0;
                                                                }
                                                                this.setState({ schedulePatientTime })
                                                            }
                                                        }}>
                                                        {
                                                            this.state.selectOptions?.instances?.map((item, idx) => {
                                                                return (
                                                                    <option value={item} key={idx}>{item}</option>
                                                                )
                                                            })
                                                        }
                                                    </Input>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Label>{'Gap'.translate(this.props.lang)}</Label>
                                                    <Input type='select'
                                                        disabled={this.state.schedulePatientTime?.selectedAvailabilityTemplate?.instances == 1}
                                                        value={this.state.schedulePatientTime.selectedAvailabilityTemplate?.gap}
                                                        onChange={(e) => {
                                                            if (this.state.schedulePatientTime?.selectedAvailabilityTemplate?.instances == 1) return;
                                                            let value = e.target.value;
                                                            let schedulePatientTime = this.state.schedulePatientTime;
                                                            if (schedulePatientTime.selectedAvailabilityTemplate) {
                                                                schedulePatientTime.selectedAvailabilityTemplate.gap = value;
                                                                this.setState({ schedulePatientTime })
                                                            }
                                                        }}>
                                                        {
                                                            this.state.selectOptions?.gap?.map((item, idx) => {
                                                                return (
                                                                    <option value={item} key={idx}>{item}</option>
                                                                )
                                                            })
                                                        }
                                                    </Input>
                                                </FormGroup>
                                            </div>
                                            :
                                            null
                                    }
                                </div>


                                {
                                    !this.state.schedulePatientTime.id ?
                                        <FormGroup>
                                            <Label >{'Frequency'.translate(this.props.lang)}</Label>
                                            <Input type='select'
                                                value={this.state.schedulePatientTime.frequencyType}

                                                onChange={(e) => {
                                                    let val = null;
                                                    if (e.target.value != -1) {
                                                        val = e.target.value;
                                                    }
                                                    if (!showRecurringOptions && ['week', 'month'].includes(val)) return;
                                                    let schedulePatientTime = this.state.schedulePatientTime;
                                                    schedulePatientTime.frequencyType = val;
                                                    let date = moment(new Date()).format(this.props.dateFormat);
                                                    if (schedulePatientTime.date) {
                                                        date = moment(new Date(schedulePatientTime.date)).format(this.props.dateFormat);
                                                    }
                                                    if (val == 'day') {
                                                        schedulePatientTime.frequencyDayScheduledDateFrom = date;
                                                        schedulePatientTime.frequencyDayScheduledDateTo = date
                                                        schedulePatientTime.recurring = true
                                                    } else if (val == 'week') {
                                                        schedulePatientTime.frequencyWeekScheduledDateFrom = date;
                                                        schedulePatientTime.frequencyWeekScheduledDateTo = moment.unix(Math.floor(new Date(date).getTime() / 1000) + 7 * 24 * 60 * 60).format(this.props.dateFormat);
                                                        schedulePatientTime.recurring = true

                                                    } else if (val == 'month') {
                                                        schedulePatientTime.frequencyMonthScheduledDateFrom = date;
                                                        schedulePatientTime.frequencyMonthScheduledDateTo = moment.unix(Math.floor(new Date(date).getTime() / 1000) + 30 * 24 * 60 * 60).format(this.props.dateFormat);
                                                        schedulePatientTime.recurring = true

                                                    } else {
                                                        schedulePatientTime.recurring = false

                                                    }
                                                    this.setState({
                                                        schedulePatientTime,
                                                        errorEvent: null
                                                    })
                                                }}>
                                                <option value={-1}>
                                                    {'Choose frequency'.translate(this.props.lang)}
                                                </option>
                                                <option value={'day'}>
                                                    {'Day'.translate(this.props.lang)}
                                                </option>
                                                {showRecurringOptions ? <>
                                                    <option value={'week'}>
                                                        {'Week'.translate(this.props.lang)}
                                                    </option>
                                                    <option value={'month'}>
                                                        {'Month'.translate(this.props.lang)}
                                                    </option>
                                                </> : null}
                                            </Input>

                                        </FormGroup>
                                        :
                                        null
                                }

                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                {this.state.schedulePatientTime.frequencyType == 'day' ?
                                    <div>
                                        <Row>
                                            <Col lg="12">
                                                <div style={{ display: 'flex', textAlign: 'center', alignItems: 'center', marginBottom: 5, marginTop: 10 }}>
                                                    <Label style={{ marginRight: 5 }}>{'Every'.translate(this.props.lang)}</Label>
                                                    <Input style={{ width: '25%' }} type='text' value={this.state.schedulePatientTime.frequencyDayText} onChange={(e) => {
                                                        let value = e.target.value
                                                        value = value.replace(/[^0-9]/g, '')

                                                        let schedulePatientTime = this.state.schedulePatientTime;
                                                        schedulePatientTime.frequencyDayText = value;
                                                        this.setState({
                                                            schedulePatientTime
                                                        })
                                                    }} />
                                                    <Label style={{ marginLeft: 5 }}>{'day(s)'.translate(this.props.lang) + '*'}</Label>
                                                </div>
                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                                <DatePicker
                                                    label={'Start date'.translate(this.props.lang) + '*'}
                                                    minDate={new Date()}
                                                    dateFormat={this.props.dateFormat}
                                                    holidayEvents={this.state.holidayEvents}
                                                    lang={this.props.lang}
                                                    value={this.state.schedulePatientTime.frequencyDayScheduledDateFrom ? this.state.schedulePatientTime.frequencyDayScheduledDateFrom : moment(new Date()).format(this.props.dateFormat)}
                                                    onChange={(e) => {
                                                        let schedulePatientTime = this.state.schedulePatientTime;
                                                        schedulePatientTime.frequencyDayScheduledDateFrom = e;
                                                        this.setState({
                                                            schedulePatientTime
                                                        })

                                                        if (this.state.schedulePatientTime.frequencyDayScheduledDateTo && this.state.schedulePatientTime.frequencyDayScheduledDateFrom) {
                                                            let dateTo = new Date(this.state.schedulePatientTime.frequencyDayScheduledDateTo)
                                                            let dateFrom = new Date(this.state.schedulePatientTime.frequencyDayScheduledDateFrom)
                                                            if (dateFrom.getTime() > dateTo.getTime() || this.calculateMaxDateHotfix(this.state.schedulePatientTime.frequencyDayScheduledDateFrom)) {
                                                                let schedulePatientTime = this.state.schedulePatientTime;
                                                                schedulePatientTime.frequencyDayScheduledDateTo = this.state.schedulePatientTime.frequencyDayScheduledDateFrom;
                                                                this.setState({
                                                                    schedulePatientTime
                                                                })
                                                            }
                                                        } else if (!this.state.schedulePatientTime.frequencyDayScheduledDateTo && this.state.schedulePatientTime.frequencyDayScheduledDateFrom) {
                                                            let schedulePatientTime = this.state.schedulePatientTime;
                                                            schedulePatientTime.frequencyDayScheduledDateTo = this.state.schedulePatientTime.frequencyDayScheduledDateFrom;
                                                            this.setState({
                                                                schedulePatientTime
                                                            })
                                                        }

                                                    }}
                                                />
                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                            </Col>
                                            <Col lg="12">
                                                <div style={{ marginTop: 5 }}>
                                                    <DatePicker
                                                        label={'End date'.translate(this.props.lang) + '*'}
                                                        dateFormat={this.props.dateFormat}
                                                        holidayEvents={this.state.holidayEvents}
                                                        lang={this.props.lang}
                                                        minDate={new Date(this.state.schedulePatientTime.frequencyDayScheduledDateFrom) != 'Invalid Date' ? new Date(this.state.schedulePatientTime.frequencyDayScheduledDateFrom) : new Date()}
                                                        maxDate={this.calculateMaxDateHotfix(this.state.schedulePatientTime.frequencyDayScheduledDateFrom)}
                                                        value={this.state.schedulePatientTime.frequencyDayScheduledDateTo ? this.state.schedulePatientTime.frequencyDayScheduledDateTo : moment(new Date()).format(this.props.dateFormat)}
                                                        onChange={(e) => {
                                                            let schedulePatientTime = this.state.schedulePatientTime;
                                                            schedulePatientTime.frequencyDayScheduledDateTo = e;
                                                            this.setState({
                                                                schedulePatientTime
                                                            })

                                                        }}
                                                    />
                                                </div>
                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                            </Col>
                                        </Row>

                                    </div>
                                    : null}


                                {this.state.schedulePatientTime.frequencyType == 'week' ?
                                    <div style={{ marginTop: 10, marginBottom: 15 }}>
                                        <Row>
                                            <Col lg="12">
                                                <Checkbox
                                                    onChange={(e) => {
                                                        let schedulePatientTime = this.state.schedulePatientTime;
                                                        schedulePatientTime.checkedMonday = e.target.checked
                                                        this.setState({
                                                            schedulePatientTime
                                                        })
                                                    }}
                                                    checked={this.state.schedulePatientTime.checkedMonday}
                                                    label={'Monday'.translate(this.props.lang)}
                                                />
                                                <Checkbox
                                                    onChange={(e) => {
                                                        let schedulePatientTime = this.state.schedulePatientTime;
                                                        schedulePatientTime.checkedTuesday = e.target.checked
                                                        this.setState({
                                                            schedulePatientTime
                                                        })
                                                    }}
                                                    checked={this.state.schedulePatientTime.checkedTuesday}
                                                    label={'Tuesday'.translate(this.props.lang)}
                                                />
                                                <Checkbox
                                                    onChange={(e) => {
                                                        let schedulePatientTime = this.state.schedulePatientTime;
                                                        schedulePatientTime.checkedWednesday = e.target.checked
                                                        this.setState({
                                                            schedulePatientTime
                                                        })
                                                    }}
                                                    checked={this.state.schedulePatientTime.checkedWednesday}
                                                    label={'Wednesday'.translate(this.props.lang)}
                                                />
                                                <Checkbox
                                                    onChange={(e) => {
                                                        let schedulePatientTime = this.state.schedulePatientTime;
                                                        schedulePatientTime.checkedThursday = e.target.checked
                                                        this.setState({
                                                            schedulePatientTime
                                                        })
                                                    }}
                                                    checked={this.state.schedulePatientTime.checkedThursday}
                                                    label={'Thursday'.translate(this.props.lang)}
                                                />
                                                <Checkbox
                                                    onChange={(e) => {
                                                        let schedulePatientTime = this.state.schedulePatientTime;
                                                        schedulePatientTime.checkedFriday = e.target.checked
                                                        this.setState({
                                                            schedulePatientTime
                                                        })
                                                    }}
                                                    checked={this.state.schedulePatientTime.checkedFriday}
                                                    label={'Friday'.translate(this.props.lang)}
                                                />
                                                <Checkbox
                                                    onChange={(e) => {
                                                        let schedulePatientTime = this.state.schedulePatientTime;
                                                        schedulePatientTime.checkedSaturday = e.target.checked
                                                        this.setState({
                                                            schedulePatientTime
                                                        })
                                                    }}
                                                    checked={this.state.schedulePatientTime.checkedSaturday}
                                                    label={'Saturday'.translate(this.props.lang)}
                                                />
                                                <Checkbox
                                                    onChange={(e) => {
                                                        let schedulePatientTime = this.state.schedulePatientTime;
                                                        schedulePatientTime.checkedSunday = e.target.checked
                                                        this.setState({
                                                            schedulePatientTime
                                                        })
                                                    }}
                                                    checked={this.state.schedulePatientTime.checkedSunday}
                                                    label={'Sunday'.translate(this.props.lang)}
                                                />
                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                                <DatePicker
                                                    label={'Start date'.translate(this.props.lang) + '*'}
                                                    minDate={new Date()}
                                                    dateFormat={this.props.dateFormat}
                                                    holidayEvents={this.state.holidayEvents}
                                                    lang={this.props.lang}
                                                    // completeStaeInput={this.state.schedulePatientTime}
                                                    value={this.state.schedulePatientTime.frequencyWeekScheduledDateFrom ? this.state.schedulePatientTime.frequencyWeekScheduledDateFrom : moment(new Date()).format(this.props.dateFormat)}
                                                    onChange={(e) => {
                                                        let schedulePatientTime = this.state.schedulePatientTime;
                                                        schedulePatientTime.frequencyWeekScheduledDateFrom = e;
                                                        this.setState({
                                                            schedulePatientTime
                                                        })

                                                        if (this.state.schedulePatientTime.frequencyWeekScheduledDateTo && this.state.schedulePatientTime.frequencyWeekScheduledDateFrom) {
                                                            let dateTo = new Date(this.state.schedulePatientTime.frequencyWeekScheduledDateTo)
                                                            let dateFrom = new Date(this.state.schedulePatientTime.frequencyWeekScheduledDateFrom)
                                                            if (dateFrom.getTime() + 1000 * 60 * 60 * 24 * 7 > dateTo.getTime()) {
                                                                let schedulePatientTime = this.state.schedulePatientTime;
                                                                let date = new Date(this.state.schedulePatientTime.frequencyWeekScheduledDateFrom)
                                                                date.setDate(date.getDate() + 7)
                                                                schedulePatientTime.frequencyWeekScheduledDateTo = moment(new Date(date)).format(this.props.dateFormat ? this.props.dateFormat : 'YYYY-MM-DD');
                                                                this.setState({
                                                                    schedulePatientTime
                                                                })

                                                            }
                                                        } else if (!this.state.schedulePatientTime.frequencyWeekScheduledDateTo && this.state.schedulePatientTime.frequencyWeekScheduledDateFrom) {
                                                            let schedulePatientTime = this.state.schedulePatientTime;
                                                            let date = new Date(this.state.schedulePatientTime.frequencyWeekScheduledDateFrom)
                                                            date.setDate(date.getDate() + 7)
                                                            schedulePatientTime.frequencyWeekScheduledDateTo = moment(new Date(date)).format(this.props.dateFormat ? this.props.dateFormat : 'YYYY-MM-DD');
                                                            this.setState({
                                                                schedulePatientTime
                                                            })
                                                        }

                                                    }}
                                                />
                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                            </Col>
                                            <Col lg="12">
                                                <DatePicker
                                                    label={'End date'.translate(this.props.lang) + '*'}
                                                    dateFormat={this.props.dateFormat}
                                                    holidayEvents={this.state.holidayEvents}
                                                    lang={this.props.lang}
                                                    minDate={new Date(this.state.schedulePatientTime.frequencyWeekScheduledDateFrom) != 'Invalid Date' ? new Date(this.state.schedulePatientTime.frequencyWeekScheduledDateFrom) : new Date(this.state.weekDate)}
                                                    // completeStaeInput={this.state.schedulePatientTime}
                                                    value={this.state.schedulePatientTime.frequencyWeekScheduledDateTo ? this.state.schedulePatientTime.frequencyWeekScheduledDateTo : moment(this.state.weekDate).format(this.props.dateFormat)}
                                                    onChange={(e) => {
                                                        let schedulePatientTime = this.state.schedulePatientTime;
                                                        schedulePatientTime.frequencyWeekScheduledDateTo = e;
                                                        this.setState({
                                                            schedulePatientTime
                                                        })

                                                    }}
                                                />
                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                            </Col>
                                        </Row>
                                    </div>
                                    : null}
                                {this.state.schedulePatientTime.frequencyType == 'month' ?
                                    <div style={{ marginBottom: 5 }}>
                                        <Row>
                                            <Col lg="12">
                                                <div style={{ display: 'flex', textAlign: 'center', alignItems: 'center', marginBottom: 5, marginTop: 10 }}>
                                                    <Label style={{ marginRight: 5 }}>{'Every'.translate(this.props.lang)}</Label>
                                                    <Input style={{ width: '30%' }} type='select' onChange={(e) => {
                                                        let val = null;
                                                        if (e.target.value != '-1') {
                                                            val = e.target.value;
                                                        }
                                                        let schedulePatientTime = this.state.schedulePatientTime;
                                                        schedulePatientTime.frequencyMonthScheduled = val;
                                                        this.setState({
                                                            schedulePatientTime
                                                        })
                                                    }}>
                                                        <option value={'-1'}>

                                                        </option>
                                                        <option value={'1'}>
                                                            {'1st'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'2'}>
                                                            {'2nd'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'3'}>
                                                            {'3rd'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'4'}>
                                                            {'4th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'5'}>
                                                            {'5th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'6'}>
                                                            {'6th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'7'}>
                                                            {'7th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'8'}>
                                                            {'8th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'9'}>
                                                            {'9th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'10'}>
                                                            {'10th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'11'}>
                                                            {'11th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'12'}>
                                                            {'12th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'13'}>
                                                            {'13th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'14'}>
                                                            {'14th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'15'}>
                                                            {'15th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'16'}>
                                                            {'16th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'17'}>
                                                            {'17th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'18'}>
                                                            {'18th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'19'}>
                                                            {'19th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'20'}>
                                                            {'20th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'21'}>
                                                            {'21st'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'22'}>
                                                            {'22nd'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'23'}>
                                                            {'23rd'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'24'}>
                                                            {'24th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'25'}>
                                                            {'25th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'26'}>
                                                            {'26th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'27'}>
                                                            {'27th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'28'}>
                                                            {'28th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'29'}>
                                                            {'29th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'30'}>
                                                            {'30th'.translate(this.props.lang)}
                                                        </option>
                                                        <option value={'31'}>
                                                            {'31st'.translate(this.props.lang)}
                                                        </option>

                                                    </Input>
                                                    <Label style={{ marginLeft: 5 }}>{'day of the month'.translate(this.props.lang) + '*'}</Label>
                                                </div>
                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                                <DatePicker
                                                    label={'Start date'.translate(this.props.lang) + '*'}
                                                    minDate={new Date()}
                                                    dateFormat={this.props.dateFormat}
                                                    holidayEvents={this.state.holidayEvents}
                                                    lang={this.props.lang}
                                                    value={this.state.schedulePatientTime.frequencyMonthScheduledDateFrom ? this.state.schedulePatientTime.frequencyMonthScheduledDateFrom : moment(new Date()).format(this.props.dateFormat)}
                                                    onChange={(e) => {
                                                        let schedulePatientTime = this.state.schedulePatientTime;
                                                        schedulePatientTime.frequencyMonthScheduledDateFrom = e;
                                                        this.setState({
                                                            schedulePatientTime
                                                        })

                                                        if (this.state.schedulePatientTime.frequencyMonthScheduledDateTo && this.state.schedulePatientTime.frequencyMonthScheduledDateFrom) {
                                                            let dateTo = new Date(this.state.schedulePatientTime.frequencyMonthScheduledDateTo)
                                                            let dateFrom = new Date(this.state.schedulePatientTime.frequencyMonthScheduledDateFrom)
                                                            if (dateFrom.getTime() + 1000 * 60 * 60 * 24 * 31 > dateTo.getTime()) {
                                                                let schedulePatientTime = this.state.schedulePatientTime;
                                                                let date = new Date(this.state.schedulePatientTime.frequencyMonthScheduledDateFrom)
                                                                date.setDate(date.getDate() + 31)
                                                                schedulePatientTime.frequencyMonthScheduledDateTo = moment(new Date(date)).format(this.props.dateFormat ? this.props.dateFormat : 'YYYY-MM-DD');
                                                                this.setState({
                                                                    schedulePatientTime
                                                                })

                                                            }
                                                        } else if (!this.state.schedulePatientTime.frequencyMonthScheduledDateTo && this.state.schedulePatientTime.frequencyMonthScheduledDateFrom) {
                                                            let schedulePatientTime = this.state.schedulePatientTime;
                                                            let date = new Date(this.state.schedulePatientTime.frequencyMonthScheduledDateFrom)
                                                            date.setDate(date.getDate() + 31)
                                                            schedulePatientTime.frequencyMonthScheduledDateTo = moment(new Date(date)).format(this.props.dateFormat ? this.props.dateFormat : 'YYYY-MM-DD');
                                                            this.setState({
                                                                schedulePatientTime
                                                            })
                                                        }
                                                    }}
                                                />
                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                            </Col>
                                            <Col lg="12">
                                                <DatePicker
                                                    label={'End date'.translate(this.props.lang) + '*'}
                                                    dateFormat={this.props.dateFormat}
                                                    holidayEvents={this.state.holidayEvents}
                                                    lang={this.props.lang}
                                                    minDate={new Date(this.state.schedulePatientTime.frequencyMonthScheduledDateFrom) != 'Invalid Date' ? new Date(this.state.schedulePatientTime.frequencyMonthScheduledDateFrom) : new Date(this.state.monthDate)}
                                                    value={this.state.schedulePatientTime.frequencyMonthScheduledDateTo ? this.state.schedulePatientTime.frequencyMonthScheduledDateTo : moment(this.state.monthDate).format(this.props.dateFormat)}
                                                    onChange={(e) => {
                                                        let schedulePatientTime = this.state.schedulePatientTime;
                                                        schedulePatientTime.frequencyMonthScheduledDateTo = e;
                                                        this.setState({
                                                            schedulePatientTime
                                                        })

                                                    }}
                                                />
                                                {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}
                                            </Col>
                                        </Row>
                                    </div>
                                    : null}

                                {
                                    this.state.schedulePatientTime.type === 'event' && eventMeetings ?
                                        <div style={{ marginTop: 10 }}>
                                            <FormGroup style={{ marginBottom: 0 }}>
                                                <Button
                                                    onClick={() => {
                                                        // let guests = [];
                                                        // if (this.state.updateEvent?.guests) {
                                                        //     guests = [...this.state.updateEvent.guests];
                                                        // }
                                                        this.setState({
                                                            eventMeetingsModal: { ...this.state.schedulePatientTime, modal: 'schedulePatientTime' },
                                                            meetingParticipants: null,
                                                        })
                                                    }}
                                                    color="primary"
                                                >
                                                    {'Add colleague'.translate(this.props.lang)}
                                                </Button>
                                            </FormGroup>
                                        </div>
                                        :
                                        null
                                }

                                <div style={{ display: 'flex', marginTop: 15 }}>
                                    <Button style={{ margin: 10, marginLeft: 0, marginTop: 0, height: 35 }}
                                        disabled={this.state.schedulePatientTime && this.state.schedulePatientTime.type &&
                                            (this.state.schedulePatientTime?.type !== 'template' || (this.state.schedulePatientTime?.type === 'template' && this.state.schedulePatientTime?.selectedAvailabilityTemplate?.id))
                                            && (!this.state.schedulePatientTime.frequencyType || (this.state.schedulePatientTime.frequencyType &&
                                                (this.state.schedulePatientTime.frequencyType == 'day' && this.state.schedulePatientTime.frequencyDayText && this.state.schedulePatientTime.frequencyDayScheduledDateFrom && this.state.schedulePatientTime.frequencyDayScheduledDateTo)
                                                || (this.state.schedulePatientTime.frequencyType == 'month' && this.state.schedulePatientTime.frequencyMonthScheduled && this.state.schedulePatientTime.frequencyMonthScheduledDateFrom && this.state.schedulePatientTime.frequencyMonthScheduledDateTo)
                                                || (this.state.schedulePatientTime.frequencyType == 'week' && (this.state.schedulePatientTime.checkedMonday || this.state.schedulePatientTime.checkedTuesday || this.state.schedulePatientTime.checkedThursday || this.state.schedulePatientTime.checkedWednesday || this.state.schedulePatientTime.checkedFriday || this.state.schedulePatientTime.checkedSaturday || this.state.schedulePatientTime.checkedSunday) && this.state.schedulePatientTime.frequencyWeekScheduledDateFrom && this.state.schedulePatientTime.frequencyWeekScheduledDateTo)
                                            )) && !this.state.creatingEvent
                                            ? false : true}
                                        color='primary' onClick={() => {
                                            this.setState({
                                                creatingEvent: true
                                            }, () => {
                                                if (this.state.schedulePatientTime.id) {
                                                    this.updateEvent(this.state.schedulePatientTime)
                                                } else {
                                                    if (this.state.schedulePatientTime.type === 'event') {
                                                        this.scheduleEvent(this.state.schedulePatientTime)
                                                    } else if (this.state.schedulePatientTime.type === 'template') {
                                                        this.scheduleTemplate(this.state.schedulePatientTime)
                                                    } else {
                                                        this.markAsAvailable(this.state.schedulePatientTime)
                                                    }
                                                }
                                            })


                                        }}>
                                        {this.state.loading ?

                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Player
                                                    onEvent={() => {
                                                        if (!this.state.loading) this.stopAnimation();
                                                    }}
                                                    onStateChange={this.toggleVisibility}
                                                    ref={this.player} // set the ref to your class instance
                                                    autoplay={true}
                                                    loop={true}
                                                    controls={true}
                                                    src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                                    style={{ height: "20px", width: "30px" }}
                                                ></Player>
                                                {'Processing...'.translate(this.props.lang)}
                                            </div>

                                            : 'Set'.translate(this.props.lang)}
                                    </Button>
                                    {
                                        this.state.schedulePatientTime?.type === 'free' ?
                                            <Button style={{ margin: 10, marginTop: 0, height: 35 }}
                                                disabled={this.state.schedulePatientTime && this.state.schedulePatientTime.type && (!this.state.schedulePatientTime.frequencyType || (this.state.schedulePatientTime.frequencyType &&
                                                    (this.state.schedulePatientTime.frequencyType == 'day' && this.state.schedulePatientTime.frequencyDayText && this.state.schedulePatientTime.frequencyDayScheduledDateFrom && this.state.schedulePatientTime.frequencyDayScheduledDateTo)
                                                    || (this.state.schedulePatientTime.frequencyType == 'month' && this.state.schedulePatientTime.frequencyMonthScheduled && this.state.schedulePatientTime.frequencyMonthScheduledDateFrom && this.state.schedulePatientTime.frequencyMonthScheduledDateTo)
                                                    || (this.state.schedulePatientTime.frequencyType == 'week' && (this.state.schedulePatientTime.checkedMonday || this.state.schedulePatientTime.checkedTuesday || this.state.schedulePatientTime.checkedThursday || this.state.schedulePatientTime.checkedWednesday || this.state.schedulePatientTime.checkedFriday || this.state.schedulePatientTime.checkedSaturday || this.state.schedulePatientTime.checkedSunday) && this.state.schedulePatientTime.frequencyWeekScheduledDateFrom && this.state.schedulePatientTime.frequencyWeekScheduledDateTo)
                                                ))
                                                    ? false : true}
                                                color='primary' onClick={() => this.deletePatientTime(this.state.schedulePatientTime)}>
                                                {this.state.loadingDelete ?

                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <Player
                                                            onEvent={() => {
                                                                if (!this.state.loadingDelete) this.stopAnimation();
                                                            }}
                                                            onStateChange={this.toggleVisibility}
                                                            ref={this.player} // set the ref to your class instance
                                                            autoplay={true}
                                                            loop={true}
                                                            controls={true}
                                                            src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                                            style={{ height: "20px", width: "30px" }}
                                                        ></Player>
                                                        {'Processing...'.translate(this.props.lang)}
                                                    </div>

                                                    : 'Cancel time'.translate(this.props.lang)}
                                            </Button>
                                            :
                                            null
                                    }
                                    {
                                        this.state.schedulePatientTime.id ?
                                            <Button style={{ margin: 10, marginTop: 0 }} color='primary' onClick={() => this.setState({
                                                schedulePatientTime: null
                                            })}>{'Cancel'.translate(this.props.lang)}</Button>
                                            :
                                            null
                                    }

                                </div>

                                <div style={{ marginTop: 10 }}>
                                    {
                                        this.state.schedulePatientTime?.tsCreated && this.state.schedulePatientTime?.tsModified && this.state.schedulePatientTime?.tsCreated !== this.state.schedulePatientTime?.tsModified ?
                                            <div className='info-message-update-wrap'>
                                                {`${'Created on:'.translate(this.props.lang)} ${this.props.getStringDateTs(this.state.schedulePatientTime?.tsCreated, `${this.props.dateFormat} HH:mm`)}. ${'Last update:'.translate(this.props.lang)} ${this.props.getStringDateTs(this.state.schedulePatientTime?.tsModified, `${this.props.dateFormat} HH:mm`)}`}
                                            </div>
                                            :
                                            this.state.schedulePatientTime?.tsCreated ?
                                                <div className='info-message-update-wrap'>
                                                    {`${'Created on:'.translate(this.props.lang)} ${this.props.getStringDateTs(this.state.schedulePatientTime?.tsCreated, `${this.props.dateFormat} HH:mm`)}`}
                                                </div>
                                                :
                                                null

                                    }
                                </div>

                            </ModalBody >
                        </Modal >
                        // <Modal isOpen={this.state.schedulePatientTime} centered size="lg">
                        //     <ModalHeader toggle={() => this.setState({ schedulePatientTime: !this.state.schedulePatientTime })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ schedulePatientTime: !this.state.schedulePatientTime })}>&times;</button>}>{'Set available terms'.translate(this.props.lang)}</ModalHeader>

                        //     <ModalBody>
                        //         <Row>
                        //             <Col lg='8'>
                        //                 <DatePicker
                        //                     label={'Start date'.translate(this.props.lang)}
                        //                     value={this.state.schedulePatientTime.date}
                        //                     onChange={(e) => {
                        //                         let schedulePatientTime = this.state.schedulePatientTime;

                        //                         schedulePatientTime.date = e;
                        //                         this.setState({
                        //                             schedulePatientTime
                        //                         })
                        //                         if (Math.floor(new Date(this.state.schedulePatientTime.date + ' ' + this.state.schedulePatientTime.startTime) / 1000) > Math.floor(new Date(this.state.schedulePatientTime.endDate + ' ' + this.state.schedulePatientTime.endTime) / 1000)) {
                        //                             schedulePatientTime.endDate = this.state.schedulePatientTime.date
                        //                             this.setState({
                        //                                 schedulePatientTime
                        //                             })
                        //                         }
                        //                     }}
                        //                 />
                        //                 <DatePicker
                        //                     label={'End date'.translate(this.props.lang)}
                        //                     value={this.state.schedulePatientTime.endDate}
                        //                     onChange={(e) => {
                        //                         let schedulePatientTime = this.state.schedulePatientTime;
                        //                         schedulePatientTime.endDate = e;
                        //                         this.setState({
                        //                             schedulePatientTime
                        //                         })
                        //                         if (Math.floor(new Date(this.state.schedulePatientTime.date + ' ' + this.state.schedulePatientTime.startTime) / 1000) > Math.floor(new Date(this.state.schedulePatientTime.endDate + ' ' + this.state.schedulePatientTime.endTime) / 1000)) {
                        //                             schedulePatientTime.endDate = this.state.schedulePatientTime.date
                        //                             this.setState({
                        //                                 schedulePatientTime
                        //                             })
                        //                         }
                        //                     }}
                        //                 />
                        //                 <div className="flex mob-flex-col" >
                        //                     <FormGroup className="timepicker-container timepicker-wide fullwidth-mobile" style={{ marginRight: '20px' }}>
                        //                         <Label>{'Start time'.translate(this.props.lang)}</Label>
                        //                         &nbsp;
                        //                         <TimePicker
                        //                             getStringDateTs={this.props.getStringDateTs}
                        //                             format={'HH:mm'}
                        //                             value={moment(new Date(this.state.schedulePatientTime.date.replace(/-/g, "/") + " " + this.state.schedulePatientTime.startTime))}
                        //                             // maxValue={this.state.scheduleReferral.endTime}
                        //                              minValue={this.props.getStringDateTs(Math.floor(this.state.min.getTime() / 1000), 'HH:mm')/*moment.unix(this.state.min.getTime() / 1000).format("HH:mm")*/}
                        //                             maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')/*moment.unix(this.state.max.getTime() / 1000).format("HH:mm")*/}
                        //                             flag={0}
                        //                             onChange={(time1, timeString) => {

                        //                                 let schedulePatientTime = this.state.schedulePatientTime;
                        //                                 schedulePatientTime.startTime = timeString

                        //                                 let startTimeSplit = schedulePatientTime.startTime.split(":");
                        //                                 let endTimeSplit = schedulePatientTime.endTime.split(":");

                        //                                 let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                        //                                 let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                        //                                 // if (startTimeHourMinute < endTimeHourMinute) {
                        //                                 //     this.setState({ scheduleReferral })
                        //                                 // } else {
                        //                                 // this.setState({ wrongInput: true })
                        //                                 // }

                        //                                 this.setState({ schedulePatientTime })
                        //                             }}
                        //                             allowClear={false}
                        //                         />
                        //                     </FormGroup>
                        //                     <FormGroup className="timepicker-container timepicker-wide fullwidth-mobile">
                        //                         <Label>{'End time'.translate(this.props.lang)}</Label>
                        //                         &nbsp;
                        //                         <TimePicker
                        //                              getStringDateTs={this.props.getStringDateTs}
                        //                             format={'HH:mm'}
                        //                             value={moment(new Date(this.state.schedulePatientTime.date.replace(/-/g, "/") + " " + this.state.schedulePatientTime.endTime))}
                        //                             minValue={Math.trunc((Number(this.state.schedulePatientTime.startTime.split(':')[0]) * 60 + Number(this.state.schedulePatientTime.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.schedulePatientTime.startTime.split(':')[0]) * 60 + Number(this.state.schedulePatientTime.startTime.split(':')[1]) + 5) % 60}
                        //                             maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')/*moment.unix(this.state.max.getTime() / 1000).format("HH:mm")*/}
                        //                             flag={0}
                        //                             // maxValue={this.state.scheduleReferral.startTime}
                        //                             // flag={1}
                        //                             onChange={(time1, timeString) => {

                        //                                 let schedulePatientTime = this.state.schedulePatientTime;
                        //                                 schedulePatientTime.endTime = timeString


                        //                                 let startTimeSplit = schedulePatientTime.startTime.split(":");
                        //                                 let endTimeSplit = schedulePatientTime.endTime.split(":");

                        //                                 let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                        //                                 let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                        //                                 if (startTimeHourMinute < endTimeHourMinute) {
                        //                                     this.setState({ schedulePatientTime })
                        //                                 } else {
                        //                                     // this.setState({ wrongInput: true })
                        //                                 }
                        //                             }}
                        //                             allowClear={false}
                        //                         />
                        //                     </FormGroup>
                        //                 </div>
                        //             </Col>
                        //             <Col lg='4'>
                        //                 <FormGroup>
                        //                     <Checkbox
                        //                         onChange={(e) => {
                        //                             let schedulePatientTime = this.state.schedulePatientTime;
                        //                             schedulePatientTime.monday = e.target.checked;
                        //                             this.setState({
                        //                                 schedulePatientTime
                        //                             })
                        //                         }}
                        //                         checked={this.state.schedulePatientTime.monday}
                        //                         label={'Monday'.translate(this.props.lang)}
                        //                     />
                        //                 </FormGroup>
                        //                 <FormGroup>
                        //                     <Checkbox
                        //                         onChange={(e) => {
                        //                             let schedulePatientTime = this.state.schedulePatientTime;
                        //                             schedulePatientTime.tuesday = e.target.checked;
                        //                             this.setState({
                        //                                 schedulePatientTime
                        //                             })
                        //                         }}
                        //                         checked={this.state.schedulePatientTime.tuesday}
                        //                         label={'Tuesday'.translate(this.props.lang)}
                        //                     />
                        //                 </FormGroup>
                        //                 <FormGroup>
                        //                     <Checkbox
                        //                         onChange={(e) => {
                        //                             let schedulePatientTime = this.state.schedulePatientTime;
                        //                             schedulePatientTime.wednesday = e.target.checked;
                        //                             this.setState({
                        //                                 schedulePatientTime
                        //                             })
                        //                         }}
                        //                         checked={this.state.schedulePatientTime.wednesday}
                        //                         label={'Wednesday'.translate(this.props.lang)}
                        //                     />
                        //                 </FormGroup>
                        //                 <FormGroup>
                        //                     <Checkbox
                        //                         onChange={(e) => {
                        //                             let schedulePatientTime = this.state.schedulePatientTime;
                        //                             schedulePatientTime.thursday = e.target.checked;
                        //                             this.setState({
                        //                                 schedulePatientTime
                        //                             })
                        //                         }}
                        //                         checked={this.state.schedulePatientTime.thursday}
                        //                         label={'Thursday'.translate(this.props.lang)}
                        //                     />
                        //                 </FormGroup>
                        //                 <FormGroup>
                        //                     <Checkbox
                        //                         onChange={(e) => {
                        //                             let schedulePatientTime = this.state.schedulePatientTime;
                        //                             schedulePatientTime.friday = e.target.checked;
                        //                             this.setState({
                        //                                 schedulePatientTime
                        //                             })
                        //                         }}
                        //                         checked={this.state.schedulePatientTime.friday}
                        //                         label={'Friday'.translate(this.props.lang)}
                        //                     />
                        //                 </FormGroup>
                        //                 <FormGroup>
                        //                     <Checkbox
                        //                         onChange={(e) => {
                        //                             let schedulePatientTime = this.state.schedulePatientTime;
                        //                             schedulePatientTime.saturday = e.target.checked;
                        //                             this.setState({
                        //                                 schedulePatientTime
                        //                             })
                        //                         }}
                        //                         checked={this.state.schedulePatientTime.saturday}
                        //                         label={'Saturday'.translate(this.props.lang)}
                        //                     />
                        //                 </FormGroup>
                        //                 <FormGroup>
                        //                     <Checkbox
                        //                         onChange={(e) => {
                        //                             let schedulePatientTime = this.state.schedulePatientTime;
                        //                             schedulePatientTime.sunday = e.target.checked;
                        //                             this.setState({
                        //                                 schedulePatientTime
                        //                             })
                        //                         }}
                        //                         checked={this.state.schedulePatientTime.sunday}
                        //                         label={'Sunday'.translate(this.props.lang)}
                        //                     />
                        //                 </FormGroup>
                        //             </Col>
                        //             <Col lg="12">
                        //                 <Button style={{ margin: 10 }} color='primary' onClick={() => this.schedulePatientTime(this.state.schedulePatientTime)}>
                        //                     {/* {'Set'.translate(this.props.lang)} */}
                        //                     {this.state.loading ? /*'Processing...'.translate(this.props.lang)*/

                        //                         <div style={{ display: 'flex', alignItems: 'center' }}>
                        //                             <Player
                        //                                 onEvent={() => {
                        //                                     if (!this.state.loading) this.stopAnimation();
                        //                                 }}
                        //                                 onStateChange={this.toggleVisibility}
                        //                                 ref={this.player} // set the ref to your class instance
                        //                                 autoplay={true}
                        //                                 loop={true}
                        //                                 controls={true}
                        //                                 src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                        //                                 style={{ height: "20px", width: "30px" }}
                        //                             ></Player>
                        //                             {'Processing...'.translate(this.props.lang)}
                        //                         </div>

                        //                         : 'Set'.translate(this.props.lang)}
                        //                 </Button>
                        //                 <Button style={{ margin: 10 }} color='primary' onClick={() => this.deletePatientTime(this.state.schedulePatientTime)}>
                        //                     {/* {'Delete'.translate(this.props.lang)} */}
                        //                     {this.state.loadingDelete ? /*'Processing...'.translate(this.props.lang)*/

                        //                         <div style={{ display: 'flex', alignItems: 'center' }}>
                        //                             <Player
                        //                                 onEvent={() => {
                        //                                     if (!this.state.loadingDelete) this.stopAnimation();
                        //                                 }}
                        //                                 onStateChange={this.toggleVisibility}
                        //                                 ref={this.player} // set the ref to your class instance
                        //                                 autoplay={true}
                        //                                 loop={true}
                        //                                 controls={true}
                        //                                 src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                        //                                 style={{ height: "20px", width: "30px" }}
                        //                             ></Player>
                        //                             {'Processing...'.translate(this.props.lang)}
                        //                         </div>

                        //                         : 'Delete'.translate(this.props.lang)}
                        //                 </Button>

                        //             </Col>
                        //         </Row>






                        //     </ModalBody>
                        // </Modal>
                        : null
                }
                {
                    this.state.addSecondGuardian ?
                        <AddSecondParentModal
                            {...this.props}
                            languages={this.state.languages}
                            data={this.state.addSecondGuardian}
                            close={(getPatientData, childSSN) => this.setState({ addSecondGuardian: null }, () => {
                                if (getPatientData) {
                                    if (childSSN) {
                                        this.setState({ patientSocialSecurityNumber: childSSN }, () => {
                                            this.findPatient();
                                        });
                                    } else {
                                        this.findPatient()
                                    }

                                }
                            })}
                        />
                        :
                        null
                }
                {
                    this.state.showPatientNotes ?
                        <PatientNotesPreview
                            {...this.props}
                            isOpen={this.state.showPatientNotes}
                            items={this.state.patientNotes}
                            toggle={() => this.setState({ showPatientNotes: !this.state.showPatientNotes })}
                            showInModal={true}
                        />
                        :
                        null
                }

                {
                    this.state.scheduleControl ?
                        <Modal isOpen={this.state.scheduleControl} centered >
                            <ModalHeader toggle={() => this.setState({ scheduleControl: !this.state.scheduleControl, age: null, patient: null, doctorsList: [], revisitFormsSelected: [], revisitFormsSelect: [], journalNoteFormSelected: null })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ scheduleControl: !this.state.scheduleControl, age: null, patient: null, doctorsList: [], revisitFormsSelected: [], revisitFormsSelect: [], journalNoteFormSelected: null })}>&times;</button>}>{'Schedule control'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody>
                                <div className='schedule-control-find-patient-wrap'>
                                    {
                                        this.props.preselectPatient && this.props.preselectPatient != '' ?
                                            null :
                                            <FormGroup>
                                                <Button color='primary' onClick={() => this.setState({ patientModal: this.state.scheduleControl, scheduleControl: !this.state.scheduleControl, doctorsList: [], patient: null, patientSocialSecurityNumber: '', age: null }, () => {
                                                    this.getLastOpenedChats()

                                                })}>{'Find patient'.translate(this.props.lang)}</Button>
                                            </FormGroup>
                                    }
                                    {
                                        this.state.scheduleControl?.templateData?.selectedAvailabilityTemplate?._id && this.state.scheduleControl?.patient && this.state.scheduleControl?.patient === this.state.patient?._id ?
                                            <div className='schedule-control-patient-info-wrap'>
                                                <div className='schedule-control-patient-info-item-wrap'>
                                                    {
                                                        this.state.patient?.userData?.name || this.state.patient?.name ?
                                                            <>
                                                                <h6>{'Name'.translate(this.props.lang)}</h6>
                                                                <h5>{this.state.patient?.userData?.name ?? this.state.patient?.name}</h5>
                                                            </>
                                                            :
                                                            null
                                                    }
                                                </div>
                                                <div className='schedule-control-patient-info-item-wrap'>
                                                    {
                                                        this.state.patient?.socialSecurityNumber ?
                                                            <>
                                                                <h6>{'Social security number'.translate(this.props.lang)}</h6>
                                                                <h5>{this.state.patient?.socialSecurityNumber}</h5>
                                                            </>
                                                            :
                                                            null
                                                    }
                                                </div>
                                            </div>
                                            :
                                            null
                                    }
                                </div>
                                {
                                    this.state.scheduleControl?.templateData?.selectedAvailabilityTemplate?._id ?
                                        <div className='schedule-control-booking-information-wrap'>
                                            <div className='schedule-control-booking-information-item-wrap'>
                                                <h5>{'Booking information'.translate(this.props.lang)}</h5>
                                                <h6>{this.state.scheduleControl?.templateData?.selectedAvailabilityTemplate?.visitTypeName} <span className='no-space-wrap-text'>({this.state.scheduleControl?.templateData?.selectedAvailabilityTemplate?.duration} {'min'.translate(this.props.lang)})</span></h6>
                                            </div>
                                            <div className='schedule-control-booking-information-item-wrap'>
                                                <h6>{this.state.scheduleControl?.templateData?.date}</h6>
                                                <h6>{this.state.scheduleControl?.templateData?.startTime !== this.state.scheduleControl?.startTime || this.state.scheduleControl?.templateData?.endTime !== this.state.scheduleControl?.endTime ? <span>{`${this.state.scheduleControl?.templateData?.startTime} - ${this.state.scheduleControl?.templateData?.endTime}`}</span> : null}{isTimeValidString(this.state.scheduleControl?.startTime) && isTimeValidString(this.state.scheduleControl?.endTime) ? `${this.state.scheduleControl?.startTime} - ${this.state.scheduleControl?.endTime}` : 'Wrong time input'.translate(this.props.lang)}</h6>
                                            </div>
                                        </div>
                                        :
                                        null
                                }

                                {
                                    isChild ?
                                        <FormGroup>
                                            <Label style={{ color: 'red' }}>{msg2}</Label>
                                        </FormGroup>
                                        :
                                        null
                                }
                                {
                                    isChild ?
                                        <FormGroup>
                                            <Label style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{"Parent/legal guardian added to appointment".translate(this.props.lang)} <div className="parent-tooltip"> <Isvg src={infoIcon} className="info-text" /> <div className="chat-icons-tooltip">{'Appointment can be managed by one or two parents/legal guardians. Selected persons will receive notification and can participate in chat and videocalls'.translate(this.props.lang)}</div> </div></Label>
                                            {
                                                this.state.patient?.parentObj?.socialSecurityNumber && this.state.patient?.parentObj2?.socialSecurityNumber ?
                                                    <div className='table-parents-wrap'>
                                                        <table className='table-parents'>
                                                            <tr>
                                                                <td>
                                                                    <Checkbox
                                                                        checked={this.state.scheduleControl?.selectedParents?.indexOf(this.state.patient?.parentObj?._id) !== -1 ? true : false} onChange={(e) => {
                                                                            let scheduleControl = this.state.scheduleControl;
                                                                            let selectedParents = scheduleControl.selectedParents ?? [];
                                                                            let parentId;
                                                                            if (this.state.patient?.parentObj?._id) {
                                                                                parentId = this.state.patient.parentObj._id;
                                                                            }
                                                                            if (e.target.checked) {
                                                                                if (parentId && selectedParents.indexOf(parentId) === -1) {
                                                                                    selectedParents.push(parentId)
                                                                                }
                                                                            } else {
                                                                                if (parentId && selectedParents.indexOf(parentId) !== -1 && selectedParents.length > 1) {
                                                                                    let index = selectedParents.indexOf(parentId);
                                                                                    selectedParents.splice(index, 1)
                                                                                }
                                                                            }
                                                                            scheduleControl.selectedParents = selectedParents;
                                                                            let parents = [];

                                                                            for (let i = 0; i < selectedParents.length; i++) {
                                                                                if (this.state.patient?.parentObj?._id === selectedParents[i] && this.state.patient?.parentObj?.name) {
                                                                                    parents.push(this.state.patient.parentObj.name.trim())
                                                                                }
                                                                                if (this.state.patient?.parentObj2?._id === selectedParents[i] && this.state.patient?.parentObj2?.name) {
                                                                                    parents.push(this.state.patient.parentObj2.name.trim())
                                                                                }
                                                                            }

                                                                            // scheduleControl.title = this.state.patient.userData.name.trim() + ' ' + 'Parent/legal guardian:'.translate(this.props.lang) + ` ${parents.join(', ')}`;
                                                                            scheduleControl.title = this.state.patient.userData.name.trim()

                                                                            this.setState({ scheduleControl })

                                                                        }} />
                                                                </td>
                                                                <td>{this.state.patient && this.state.patient.parentObj && this.state.patient.parentObj.name}</td>
                                                                <td>{this.state.patient && this.state.patient.parentObj && this.state.patient.parentObj.socialSecurityNumber}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <Checkbox
                                                                        checked={this.state.scheduleControl?.selectedParents?.indexOf(this.state.patient?.parentObj2?._id) !== -1 ? true : false} onChange={(e) => {
                                                                            let scheduleControl = this.state.scheduleControl;
                                                                            let selectedParents = scheduleControl.selectedParents ?? [];
                                                                            let parentId;
                                                                            if (this.state.patient?.parentObj2?._id) {
                                                                                parentId = this.state.patient.parentObj2._id;
                                                                            }
                                                                            if (e.target.checked) {
                                                                                if (parentId && selectedParents.indexOf(parentId) === -1) {
                                                                                    selectedParents.push(parentId)
                                                                                }
                                                                            } else {
                                                                                if (parentId && selectedParents.indexOf(parentId) !== -1 && selectedParents.length > 1) {
                                                                                    let index = selectedParents.indexOf(parentId);
                                                                                    selectedParents.splice(index, 1)
                                                                                }
                                                                            }
                                                                            scheduleControl.selectedParents = selectedParents;
                                                                            let parents = [];

                                                                            for (let i = 0; i < selectedParents.length; i++) {
                                                                                if (this.state.patient?.parentObj?._id === selectedParents[i] && this.state.patient?.parentObj?.name) {
                                                                                    parents.push(this.state.patient.parentObj.name.trim())
                                                                                }
                                                                                if (this.state.patient?.parentObj2?._id === selectedParents[i] && this.state.patient?.parentObj2?.name) {
                                                                                    parents.push(this.state.patient.parentObj2.name.trim())
                                                                                }
                                                                            }

                                                                            // scheduleControl.title = this.state.patient.userData.name.trim() + ' ' + 'Parent/legal guardian:'.translate(this.props.lang) + ` ${parents.join(', ')}`;
                                                                            scheduleControl.title = this.state.patient.userData.name.trim()

                                                                            this.setState({ scheduleControl })
                                                                        }} />
                                                                </td>
                                                                <td>{this.state.patient && this.state.patient.parentObj2 && this.state.patient.parentObj2.name}</td>
                                                                <td>{this.state.patient && this.state.patient.parentObj2 && this.state.patient.parentObj2.socialSecurityNumber}</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                    :
                                                    <div>
                                                        <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}>
                                                            <p>{this.state.patient && this.state.patient.parentObj && this.state.patient.parentObj.name}</p>
                                                            <p>{this.state.patient && this.state.patient.parentObj && this.state.patient.parentObj.socialSecurityNumber}</p>
                                                        </div>
                                                        <div className='add-second-guardian-btn'>
                                                            <Button color='primary' onClick={() => {
                                                                let patientObj = JSON.parse(JSON.stringify(this.state.patient))
                                                                this.setState({ addSecondGuardian: patientObj })
                                                            }}>{'Add second parent/legal guardian'.translate(this.props.lang)}</Button>
                                                        </div>
                                                    </div>
                                            }


                                        </FormGroup>
                                        :
                                        null
                                }

                                {
                                    isChild && this.state.scheduleControl && this.state.scheduleControl.title ?
                                        <FormGroup>
                                            <div className='patient-no-notif-modal'>
                                                <Label>{'Title'.translate(this.props.lang)}</Label>
                                                {
                                                    !this.state.patient?.phone && !this.state.patient?.email ?
                                                        <div className='patient-no-notif'>
                                                            <Isvg src={noNotifications} width={20} height={20} />
                                                            <div>
                                                                {'Phone and email not registered'.translate(this.props.lang)}
                                                            </div>
                                                            <div className='tooltip-text'>{'No contact details registered. Add information in the patient profile to send notifications.'.translate(this.props.lang)}</div>
                                                        </div>
                                                        :
                                                        null
                                                }
                                            </div>

                                            <Input disabled type='textarea'

                                                value={this.state.scheduleControl.titleDoctor && this.state.scheduleControl.titleDoctor != '' ?
                                                    `Patient: ${this.state.scheduleControl.title}, ${this.state.doctor ? this.state.doctors.filter(item => item._id === this.state.doctor)[0]?.userData?.title && this.state.doctors.filter(item => item._id === this.state.doctor)[0]?.userData.name ? `${this.props.formatName(this.state.doctors.filter(item => item._id === this.state.doctor)[0]?.userData.title, this.state.doctors.filter(item => item._id === this.state.doctor)[0]?.userData.name)}` : this.state.doctors.filter(item => item._id === this.state.doctor)[0]?.name : this.props.uData.name}, ${this.state.scheduleControl.visitReasonName && this.state.scheduleControl.visitReasonName != '' ? ', (' + this.state.scheduleControl.visitReasonName + ')' : ''}` + ', ' + this.state.scheduleControl.titleDoctor :
                                                    `Patient: ${this.state.scheduleControl.title}, ${this.state.doctor ? this.state.doctors.filter(item => item._id === this.state.doctor)[0]?.userData?.title && this.state.doctors.filter(item => item._id === this.state.doctor)[0]?.userData.name ? `${this.props.formatName(this.state.doctors.filter(item => item._id === this.state.doctor)[0]?.userData.title, this.state.doctors.filter(item => item._id === this.state.doctor)[0]?.userData.name)}` : this.state.doctors.filter(item => item._id === this.state.doctor)[0]?.name : this.props.uData.name}, ${this.state.scheduleControl.visitReasonName && this.state.scheduleControl.visitReasonName != '' ? ', (' + this.state.scheduleControl.visitReasonName + ')' : ''}`} />
                                            <Input type='text' style={{ marginTop: 5 }} onChange={(e) => {
                                                let scheduleControl = this.state.scheduleControl;
                                                scheduleControl.titleDoctor = striptags(e.target.value);

                                                this.setState({
                                                    scheduleControl
                                                })
                                            }}
                                                value={this.state.scheduleControl.titleDoctor} />

                                        </FormGroup>

                                        :

                                        this.state.scheduleControl && this.state.scheduleControl.title ?
                                            <FormGroup>
                                                <div className='patient-no-notif-modal'>
                                                    <Label>{'Title'.translate(this.props.lang)}</Label>
                                                    {
                                                        !this.state.patient?.phone && !this.state.patient?.email ?
                                                            <div className='patient-no-notif'>
                                                                <Isvg src={noNotifications} width={20} height={20} />
                                                                <div>
                                                                    {'Phone and email not registered'.translate(this.props.lang)}
                                                                </div>
                                                                <div className='tooltip-text'>{'No contact details registered. Add information in the patient profile to send notifications.'.translate(this.props.lang)}</div>
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                </div>

                                                <Input disabled type='textarea'

                                                    value={this.state.scheduleControl.titleDoctor && this.state.scheduleControl.titleDoctor != '' ? `Patient: ${this.state.scheduleControl.title}, ${this.state.doctor ? this.state.doctors.filter(item => item._id === this.state.doctor)[0]?.userData?.title && this.state.doctors.filter(item => item._id === this.state.doctor)[0]?.userData.name ? `${this.props.formatName(this.state.doctors.filter(item => item._id === this.state.doctor)[0]?.userData.title, this.state.doctors.filter(item => item._id === this.state.doctor)[0]?.userData.name)}` : this.state.doctors.filter(item => item._id === this.state.doctor)[0]?.name : this.props.uData.name}${this.state.scheduleControl.visitReasonName && this.state.scheduleControl.visitReasonName != '' ? ', (' + this.state.scheduleControl.visitReasonName + ')' : ''}` + ', ' + this.state.scheduleControl.titleDoctor : `Patient: ${this.state.scheduleControl.title}, ${this.state.doctor ? this.state.doctors.filter(item => item._id === this.state.doctor)[0]?.userData?.title && this.state.doctors.filter(item => item._id === this.state.doctor)[0]?.userData.name ? `${this.props.formatName(this.state.doctors.filter(item => item._id === this.state.doctor)[0]?.userData.title, this.state.doctors.filter(item => item._id === this.state.doctor)[0]?.userData.name)}` : this.state.doctors.filter(item => item._id === this.state.doctor)[0]?.name : this.props.uData.name}${this.state.scheduleControl.visitReasonName && this.state.scheduleControl.visitReasonName != '' ? ', (' + this.state.scheduleControl.visitReasonName + ')' : ''}`} />
                                                <Input type='text' style={{ marginTop: 5 }} onChange={(e) => {
                                                    let scheduleControl = this.state.scheduleControl;
                                                    scheduleControl.titleDoctor = striptags(e.target.value);

                                                    this.setState({
                                                        scheduleControl
                                                    })
                                                }}
                                                    value={this.state.scheduleControl.titleDoctor} />

                                            </FormGroup>
                                            :
                                            null

                                }
                                {/* {
                                    this.state.scheduleControl && this.state.scheduleControl.title ?
                                        <FormGroup>
                                            <Label>{'Title'.translate(this.props.lang)}</Label>

                                            <Input disabled type='textarea'

                                                value={this.state.scheduleControl.titleDoctor && this.state.scheduleControl.titleDoctor != '' ? `Patient: ${this.state.scheduleControl.title}, ${this.props.uData.name}${this.state.scheduleControl.visitReasonName && this.state.scheduleControl.visitReasonName != '' ? ', (' + this.state.scheduleControl.visitReasonName + ')' : ''}` + ', ' + this.state.scheduleControl.titleDoctor : `Patient: ${this.state.scheduleControl.title}, ${this.props.uData.name}${this.state.scheduleControl.visitReasonName && this.state.scheduleControl.visitReasonName != '' ? ', (' + this.state.scheduleControl.visitReasonName + ')' : ''}`} />
                                            <Input type='text' style={{ marginTop: 5 }} onChange={(e) => {
                                                let scheduleControl = this.state.scheduleControl;
                                                scheduleControl.titleDoctor = striptags(e.target.value);

                                                this.setState({
                                                    scheduleControl
                                                })
                                            }}
                                                value={this.state.scheduleControl.titleDoctor} />

                                        </FormGroup>
                                        :
                                        null
                                } */}
                                {
                                    !this.state.scheduleControl?.templateData?.selectedAvailabilityTemplate?._id ?
                                        <DatePicker
                                            label={'Date'.translate(this.props.lang)}
                                            value={this.state.scheduleControl.date}
                                            holidayEvents={this.state.holidayEvents}
                                            lang={this.props.lang}
                                            onChange={(e) => {
                                                let scheduleControl = this.state.scheduleControl;
                                                scheduleControl.date = e;
                                                this.setState({
                                                    scheduleControl
                                                })
                                                if (Math.floor(new Date(this.state.scheduleControl.date + ' ' + this.state.scheduleControl.startTime) / 1000) > Math.floor(new Date(this.state.scheduleControl.endDate + ' ' + this.state.scheduleControl.endTime) / 1000)) {
                                                    scheduleControl.endDate = this.state.scheduleControl.date
                                                    this.setState({
                                                        scheduleControl
                                                    })
                                                }
                                            }}
                                        />
                                        :
                                        null
                                }

                                <div className={this.state.scheduleControl?.templateData?.selectedAvailabilityTemplate?._id ? 'schedule-control-time-wrap-template' : ''}>
                                    <FormGroup className="timepicker-container timepicker-wide">
                                        <Label>{'Start time'.translate(this.props.lang)}</Label>
                                        &nbsp;
                                        <TimePickerV2
                                            getStringDateTs={this.props.getStringDateTs}
                                            format={'HH:mm'}
                                            value={this.state.scheduleControl.startTime}
                                            minValue={this.props.getStringDateTs(Math.floor(this.state.min.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.min.getTime() / 1000).format("HH:mm")
                                            maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000 - 300), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                            flag={0}
                                            onChange={(time1, timeString) => {

                                                let scheduleControl = this.state.scheduleControl;
                                                scheduleControl.startTime = timeString


                                                let startTimeSplit = scheduleControl.startTime.split(":");
                                                let endTimeSplit = scheduleControl.endTime.split(":");

                                                let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                                let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);
                                                // this.setState({ scheduleControl })

                                                if (startTimeHourMinute < endTimeHourMinute) {
                                                    this.setState({ scheduleControl })
                                                } else {
                                                    scheduleControl.endTime = Math.trunc((Number(this.state.scheduleControl.startTime.split(':')[0]) * 60 + Number(this.state.scheduleControl.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.scheduleControl.startTime.split(':')[0]) * 60 + Number(this.state.scheduleControl.startTime.split(':')[1]) + 5) % 60
                                                    // scheduleControl.endTime = validateTime(scheduleControl.endTime);
                                                    const padded = scheduleControl?.endTime?.split?.(':');
                                                    if (padded && Array.isArray(padded) && padded.length && isStringAValidNumber(padded[0]) && isStringAValidNumber(padded[1])) {
                                                        const h = padded[0]?.padStart?.(2, '0');
                                                        const m = padded[1]?.padStart?.(2, '0');
                                                        if (h && m) scheduleControl.endTime = `${h}:${m}`;
                                                    }
                                                    this.setState({
                                                        scheduleControl
                                                    })
                                                }
                                                // if (startTimeHourMinute < endTimeHourMinute) {
                                                //     this.setState({ scheduleControl })
                                                // } else {
                                                // this.setState({ wrongInput: true })
                                                // }
                                            }}
                                        />
                                        {/* <TimePicker
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={moment(new Date(this.state.scheduleControl.date.replace(/-/g, "/") + " " + this.state.scheduleControl.startTime))}
                                        // maxValue={this.state.scheduleControl.endTime}
                                        minValue={this.props.getStringDateTs(Math.floor(this.state.min.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.min.getTime() / 1000).format("HH:mm")
                                        maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                        flag={0}
                                        onChange={(time1, timeString) => {

                                            let scheduleControl = this.state.scheduleControl;
                                            scheduleControl.startTime = timeString


                                            let startTimeSplit = scheduleControl.startTime.split(":");
                                            let endTimeSplit = scheduleControl.endTime.split(":");

                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);
                                            this.setState({ scheduleControl })
                                            // if (startTimeHourMinute < endTimeHourMinute) {
                                            //     this.setState({ scheduleControl })
                                            // } else {
                                            // this.setState({ wrongInput: true })
                                            // }
                                        }}
                                        allowClear={false}
                                    /> */}
                                    </FormGroup>
                                    <FormGroup className="timepicker-container timepicker-wide">
                                        <Label>{'End time'.translate(this.props.lang)}</Label>
                                        &nbsp;
                                        <TimePickerV2
                                            getStringDateTs={this.props.getStringDateTs}
                                            format={'HH:mm'}
                                            value={this.state.scheduleControl.endTime}
                                            minValue={Math.trunc((Number(this.state.scheduleControl.startTime.split(':')[0]) * 60 + Number(this.state.scheduleControl.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.scheduleControl.startTime.split(':')[0]) * 60 + Number(this.state.scheduleControl.startTime.split(':')[1]) + 5) % 60}
                                            maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                            flag={0}
                                            onChange={(time1, timeString) => {

                                                let scheduleControl = this.state.scheduleControl;
                                                scheduleControl.endTime = timeString

                                                let startTimeSplit = scheduleControl.startTime.split(":");
                                                let endTimeSplit = scheduleControl.endTime.split(":");

                                                let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                                let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                                if (startTimeHourMinute < endTimeHourMinute) {
                                                    this.setState({ scheduleControl })
                                                } else {
                                                    // this.setState({ wrongInput: true })
                                                }
                                            }}
                                        />
                                        {/* <TimePicker
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={moment(new Date(this.state.scheduleControl.date.replace(/-/g, "/") + " " + this.state.scheduleControl.endTime))}
                                        minValue={Math.trunc((Number(this.state.scheduleControl.startTime.split(':')[0]) * 60 + Number(this.state.scheduleControl.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.scheduleControl.startTime.split(':')[0]) * 60 + Number(this.state.scheduleControl.startTime.split(':')[1]) + 5) % 60}
                                        maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                        flag={0}
                                        // maxValue={this.state.scheduleControl.startTime}
                                        // flag={1}
                                        onChange={(time1, timeString) => {

                                            let scheduleControl = this.state.scheduleControl;
                                            scheduleControl.endTime = timeString

                                            let startTimeSplit = scheduleControl.startTime.split(":");
                                            let endTimeSplit = scheduleControl.endTime.split(":");

                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                            if (startTimeHourMinute < endTimeHourMinute) {
                                                this.setState({ scheduleControl })
                                            } else {
                                                // this.setState({ wrongInput: true })
                                            }
                                        }}
                                        allowClear={false}
                                    /> */}
                                    </FormGroup>
                                </div>
                                {
                                    this.state.scheduleControl.title ?
                                        <FormGroup>
                                            <Label className='note-label-wrap'>{this.state.scheduleControl?.templateData?.selectedAvailabilityTemplate?._id ? 'Internal note'.translate(this.props.lang) : 'Note'.translate(this.props.lang)}
                                                {/* <div className={this.state.patientNotes?.length ? 'notes-icon-wrap notes-icon-active' : 'notes-icon-wrap'} onClick={() => { this.setState({ showPatientNotes: true }) }}>
                                                    <Isvg src={notesIcon} />
                                                    <div className='tooltip-text'>{'Notes available'.translate(this.props.lang)}</div>
                                                </div> */}
                                            </Label>
                                            <Input type='textarea'
                                                name="note"
                                                style={{ height: '150px' }}
                                                onChange={(e) => {
                                                    let scheduleControl = this.state.scheduleControl;
                                                    scheduleControl.patientControlNote = striptags(e.target.value);
                                                    this.setState({
                                                        scheduleControl
                                                    })
                                                }}
                                                value={this.state.scheduleControl.patientControlNote}
                                            />
                                        </FormGroup>
                                        :
                                        null
                                }
                                {
                                    this.state.scheduleControl.title && this.state.scheduleControl?.templateData?.selectedAvailabilityTemplate?._id ?
                                        <FormGroup>
                                            <Label style={{ display: 'flex', alignItems: 'center' }}>
                                                {'Note to patient'.translate(this.props.lang)}
                                                <div className='button-elements-tooltip' style={{ marginLeft: 8 }}>
                                                    <Isvg src={infoIcon} style={{ width: 25 }} />
                                                    <div className='tooltip-text' style={{ minWidth: 180, bottom: 29 }}>{'This information wiil be shown to patient in ther booking information in "My cases"'.translate(this.props.lang)}</div>
                                                </div>
                                            </Label>
                                            <Input type='textarea'
                                                name="noteToPatient"
                                                style={{ height: '110px' }}
                                                onChange={(e) => {
                                                    let value = striptags(e.target.value);
                                                    if (value?.length <= 160) {
                                                        let scheduleControl = this.state.scheduleControl;
                                                        scheduleControl.noteToPatient = value;
                                                        if (value?.trim() === '') {
                                                            scheduleControl.sendNoteAsPatientNotification = false;
                                                        }
                                                        this.setState({
                                                            scheduleControl
                                                        })
                                                    }

                                                }}
                                                value={this.state.scheduleControl.noteToPatient}
                                            />
                                        </FormGroup>
                                        :
                                        null
                                }
                                {
                                    this.state.scheduleControl.title && this.state.scheduleControl?.templateData?.selectedAvailabilityTemplate?._id ?
                                        <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                                            <Checkbox
                                                onChange={(e) => {
                                                    if (!this.state.scheduleControl?.noteToPatient || this.state.scheduleControl?.noteToPatient?.trim() === '') return;
                                                    let scheduleControl = this.state.scheduleControl;
                                                    scheduleControl.sendNoteAsPatientNotification = e.target.checked;
                                                    this.setState({
                                                        scheduleControl
                                                    })
                                                }}
                                                disabled={!this.state.scheduleControl?.noteToPatient || this.state.scheduleControl?.noteToPatient?.trim() === '' ? true : false}
                                                checked={this.state.scheduleControl?.noteToPatient?.trim() === '' ? false : this.state.scheduleControl.sendNoteAsPatientNotification}
                                                label={'Send note as patient notification'.translate(this.props.lang)}
                                            />
                                            <div className='button-elements-tooltip' style={{ marginLeft: 8 }}>
                                                <Isvg src={infoIcon} style={{ width: 25 }} />
                                                <div className='tooltip-text' style={{ minWidth: 180, bottom: 29 }}>{'By checking box the note to patient will also be sent as a separate notification to the patient'.translate(this.props.lang)}</div>
                                            </div>
                                        </FormGroup>
                                        :
                                        null
                                }
                                {
                                    this.state.scheduleControl.title && enterprise ?
                                        <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                                            <Checkbox
                                                onChange={(e) => {
                                                    let scheduleControl = this.state.scheduleControl;
                                                    scheduleControl.hideTimeFromThePatient = e.target.checked;
                                                    if (scheduleControl.hideTimeFromThePatient) {
                                                        scheduleControl.hideDurationForPatient = true;
                                                    }
                                                    this.setState({
                                                        scheduleControl
                                                    })
                                                }}
                                                checked={this.state.scheduleControl.hideTimeFromThePatient}
                                                label={'Hide time from the patient'.translate(this.props.lang)}
                                            />
                                            <div className='button-elements-tooltip' style={{ marginLeft: 8 }}>
                                                <Isvg src={infoIcon} style={{ width: 25 }} />
                                                <div className='tooltip-text' style={{ minWidth: 180, bottom: 29 }}>{'Time is not displayed to the patient.'.translate(this.props.lang)}</div>
                                            </div>
                                        </FormGroup>
                                        :
                                        null
                                }
                                {
                                    this.state.scheduleControl.title /* && enterprise */ ?
                                        <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                                            <Checkbox
                                                onChange={(e) => {
                                                    if (this.state.scheduleControl.hideTimeFromThePatient) return;
                                                    let scheduleControl = this.state.scheduleControl;
                                                    scheduleControl.hideDurationForPatient = e.target.checked;
                                                    this.setState({
                                                        scheduleControl
                                                    })
                                                }}
                                                disabled={this.state.scheduleControl.hideTimeFromThePatient ? true : false}
                                                checked={this.state.scheduleControl.hideDurationForPatient}
                                                label={'Hide duration for patient'.translate(this.props.lang)}
                                            />
                                            <div className='button-elements-tooltip' style={{ marginLeft: 8 }}>
                                                <Isvg src={infoIcon} style={{ width: 25 }} />
                                                <div className='tooltip-text' style={{ minWidth: 180, bottom: 29 }}>{'Duration is not displayed to the patient.'.translate(this.props.lang)}</div>
                                            </div>
                                        </FormGroup>
                                        :
                                        null
                                }
                                {
                                    this.state.scheduleControl.title && enterprise ?
                                        <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                                            <Checkbox
                                                onChange={(e) => {
                                                    let scheduleControl = this.state.scheduleControl;
                                                    scheduleControl.closeCaseManually = e.target.checked;
                                                    this.setState({
                                                        scheduleControl
                                                    })
                                                }}
                                                checked={this.state.scheduleControl.closeCaseManually}
                                                label={'Close case manually'.translate(this.props.lang)}
                                            />

                                        </FormGroup>
                                        :
                                        null
                                }

                                {/* <FormGroup>
                                <div >
                                    <Checkbox checked={this.state.scheduleControl.onlineVisit} onChange={(e) => {
                                        let scheduleControl = this.state.scheduleControl;
                                        scheduleControl.onlineVisit = e.target.checked;
                                        this.setState({
                                            scheduleControl
                                        })
                                    }} label={'Online visit'.translate(this.props.lang)} />
                                </div>
                            </FormGroup> */}
                                {
                                    this.state.scheduleControl.title ?
                                        <FormGroup>
                                            {
                                                !this.state.scheduleControl?.templateData?.selectedAvailabilityTemplate?._id ?
                                                    <Button onClick={() => this.setState({
                                                        selectVisitReason: true
                                                    })} color="primary">
                                                        {'Select a visit reason'.translate(this.props.lang)}
                                                    </Button>
                                                    :
                                                    null
                                            }
                                            {
                                                enterprise ?
                                                    <Button disabled={!this.state.scheduleControl?.visiReason} style={{ marginLeft: this.state.scheduleControl?.templateData?.selectedAvailabilityTemplate?._id ? 0 : 10 }}
                                                        onClick={() => {

                                                            this.setState({
                                                                selectRevisitForm: true,
                                                                revisitFormsSelect: this.state.revisitFormsSelected ? [...this.state.revisitFormsSelected] : [],
                                                                journalNoteForm: this.state.journalNoteFormSelected ? this.state.journalNoteFormSelected : null
                                                            })
                                                        }}
                                                        color="primary"
                                                    >
                                                        {'Insert form'.translate(this.props.lang)}
                                                    </Button>
                                                    :
                                                    null
                                            }

                                        </FormGroup>
                                        :
                                        null
                                }
                                {
                                    this.state.scheduleControl.title && enterprise && this.state.revisitFormsSelected?.length ?
                                        <FormGroup className='attached-forms-wrap'>
                                            <Label>{'Attached forms'.translate(this.props.lang)}</Label>
                                            <ul>
                                                {
                                                    this.state.revisitFormsSelected.map((item, idx) => {
                                                        let revisitForms = this.state.revisitForms?.items ? this.state.revisitForms.items : [];
                                                        let formName = revisitForms.filter(el => el && el._id === item).length ? revisitForms.filter(el => el._id === item)[0].name : null;
                                                        if (formName)
                                                            return (
                                                                <li className="attached-forms-item">
                                                                    {formName}
                                                                </li>
                                                            )
                                                    })
                                                }
                                            </ul>

                                        </FormGroup>
                                        :
                                        null
                                }


                                {
                                    this.state.scheduleControl.title && !this.state.scheduleControl?.templateData?.selectedAvailabilityTemplate?._id ?
                                        <FormGroup>
                                            <Label>{'Visit reason'.translate(this.props.lang)}</Label>
                                            <Input disabled type='text' value={this.state.scheduleControl.visitReasonName ? this.state.scheduleControl.visitReasonName : ''} />
                                        </FormGroup>
                                        :
                                        null
                                }
                                {
                                    this.state.scheduleControl.title /*&& !this.state.scheduleControl?.templateData?.selectedAvailabilityTemplate?._id*/ ?
                                        <FormGroup>
                                            <Label>{'Price'.translate(this.props.lang)} {this.props.currency}</Label>
                                            <Input
                                                disabled={this.state.scheduleControl.visitReasonName && EXTENDED_PAYMENT_MANAGEMENT ? false : true}
                                                type='text'
                                                value={this.state.scheduleControl.visitReasonPrice}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/\D/g, "");
                                                    let scheduleControl = this.state.scheduleControl;
                                                    scheduleControl.visitReasonPrice = Number(value);
                                                    this.setState({ isPaymentMethodErrorShow: false, showPaymentMethodError: false }, () => {
                                                        this.setState({ scheduleControl });
                                                    })
                                                }}
                                            />
                                        </FormGroup>
                                        :
                                        null
                                }
                                {
                                    Number(this.state.scheduleControl.visitReasonPrice) > 0 && Number(this.state.scheduleControl._visitReasonPrice) === 0 ?
                                        <PaymentMethodsField
                                            {...this.props}
                                            onChange={(data) => {
                                                let scheduleControl = this.state.scheduleControl;
                                                scheduleControl.paymentMethods = data.paymentMethods ?? [];
                                                scheduleControl.attachedInvoice = data?.attachedInvoice ?? null;
                                                let setObj = { scheduleControl, showPaymentMethodError: false };
                                                setObj.isPaymentMethodErrorShow = data?.errors ? true : false;
                                                this.setState(setObj);
                                            }}
                                            showError={this.state.showPaymentMethodError}
                                            price={this.state.scheduleControl.visitReasonPrice}
                                        />
                                        :
                                        null
                                }


                                <div className='calendar-modal-buttons-wrap'>
                                    {
                                        this.state.scheduleControl.title ?
                                            <FormGroup>
                                                <Button onClick={() => this.setState({
                                                    doctorsModal: 3
                                                })} color="primary">
                                                    {'Add caregiver'.translate(this.props.lang)}
                                                </Button>
                                            </FormGroup>
                                            :
                                            null
                                    }
                                    {
                                        this.state.scheduleControl.title && eventMeetings ?
                                            <FormGroup>
                                                <Button
                                                    onClick={() => {
                                                        let guests = [];
                                                        if (this.state.scheduleControl?.guests) {
                                                            guests = [...this.state.scheduleControl.guests];
                                                        }
                                                        this.setState({
                                                            eventMeetingsModal: { ...this.state.scheduleControl, guests, modal: 'scheduleControl' },
                                                            meetingParticipants: null,
                                                        })
                                                    }}
                                                    color="primary"
                                                >
                                                    {'Add guest'.translate(this.props.lang)}
                                                </Button>
                                            </FormGroup>

                                            :

                                            null
                                    }
                                </div>


                                <Button color='primary' disabled={this.state.scheduleControl.title && this.state.scheduleControl.visitReasonName && !this.state.creatingEvent ? false : true} onClick={() => this.setState({
                                    creatingEvent: true
                                }, () => this.scheduleControl(this.state.scheduleControl))}>{'Schedule control'.translate(this.props.lang)}</Button>

                            </ModalBody>
                        </Modal>
                        : null
                }

                {
                    this.state.patientModal ?
                        <Modal isOpen={this.state.patientModal} size={!enterprise && !canSearchPatients ? 'lg' : ''} centered>
                            <ModalHeader toggle={() => this.setState({ patientModal: !this.state.patientModal, patientSocialSecurityNumber: '', patient: null, age: null })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ patientModal: !this.state.patientModal, patientSocialSecurityNumber: '', patient: null, age: null })}>&times;</button>}>{'Find patient'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody>
                                {
                                    !enterprise && !canSearchPatients ?
                                        <PatientFilter
                                            {...this.props}
                                            hideUserLevel={true}
                                            hideForUser={this.state.doctor ? this.state.doctor : this.props.uData._id}
                                            value={this.state.patientModal.title}
                                            onChange={(val) => {
                                                let patientModal = this.state.patientModal;
                                                patientModal.title = val.userData.name.trim();
                                                patientModal.socialSecurityNumber = val.socialSecurityNumber;
                                                patientModal.patient = val._id;

                                                this.setState({ scheduleControl: this.state.patientModal, patientModal: !this.state.patientModal, patientSocialSecurityNumber: '' }, () => {
                                                    this.patientAge(val._id, () => this.setVisitReasonFromTemplate())
                                                })
                                            }}>
                                        </PatientFilter>
                                        :
                                        <div>
                                            <div style={this.state.searchByNameAndEmail ? { marginBottom: 90 } : this.props.country === 'uk' ? { alignItems: 'flex-end' } : {}} className='patient-search-modal-calendar'>
                                                <SocialSecurityNumber
                                                    filterFields={['email']}
                                                    includeChildren={true}
                                                    hideFindChildren={true}
                                                    // hideDateOfBirth={true}
                                                    // inThisGroup={true}
                                                    patientInfoSettings={patientInfoSettings}
                                                    disableNewPatientBtn={true}
                                                    selectedGroup={this.props.selectedGroup}
                                                    selectedClinic={this.props.selectedClinic}
                                                    lang={this.props.lang}
                                                    searchByNameAndEmail={this.state.searchByNameAndEmail || true}
                                                    searchByNameAndEmailShow={(show) => {
                                                        this.setState({
                                                            searchByNameAndEmail: show
                                                        })
                                                    }}
                                                    // label={this.props.country === 'uk' ? "Date of birth".translate(this.props.lang) : "Social security number".translate(this.props.lang)}
                                                    // label={this.props.country === 'uk' ? "Search patient by email".translate(this.props.lang) : ''}
                                                    error={isSocialSecurityNumberValid(this.state.patientSocialSecurityNumber, this.state.countryStateDict?.['search-ssn'] ?? this.props.country) ? null : 'Social security number is incorrect'.translate(this.props.lang)}
                                                    type={'text'}
                                                    // labelInfo={'Searches are logged'.translate(this.props.lang)}
                                                    country={this.props.country}
                                                    placeholder={this.props.country === 'denmark' ? 'DDMMYYNNNNN' : this.props.lang === 'en' ? 'YYYYMMDDNNNN' : 'ÅÅÅÅMMDDNNNN'}
                                                    value={this.state.patientSocialSecurityNumber}
                                                    onKeyUp={(e) => {
                                                        if (e.keyCode == 13) {
                                                            if (!(!this.state.patientSocialSecurityNumber || (!patientInfoSettings?.isCustomIdEnabled && !isSocialSecurityNumberValid(this.state.patientSocialSecurityNumber, this.state.countryStateDict?.['search-ssn'] ?? this.props.country)))) {
                                                                this.findPatient()
                                                            }
                                                        }
                                                    }}
                                                    onChange={(value, callback) => {
                                                        let country = this.state.countryStateDict?.['search-ssn'] ?? this.props.country;
                                                        if (country === 'denmark' && value?.length > 10) {
                                                            value = value.substr(0, 10);
                                                        }
                                                        this.setState({
                                                            patientSocialSecurityNumber: value
                                                        }, () => {
                                                            if (callback) {
                                                                callback()
                                                            }

                                                            // if (this.state.patientSocialSecurityNumber && isSocialSecurityNumberValid(this.state.patientSocialSecurityNumber, this.state.countryStateDict?.['search-ssn'] ?? this.props.country)) {
                                                            //     this.findPatient()
                                                            // }

                                                        })
                                                    }}
                                                    newUserCallback={() => {
                                                        if (!(!this.state.patientSocialSecurityNumber || (!patientInfoSettings?.isCustomIdEnabled && !isSocialSecurityNumberValid(this.state.patientSocialSecurityNumber, this.state.countryStateDict?.['search-ssn'] ?? this.props.country)))) {
                                                            this.findPatient()
                                                        }
                                                    }}
                                                    selectUserCallback={() => {
                                                        if (!(!this.state.patientSocialSecurityNumber || (!patientInfoSettings?.isCustomIdEnabled && !isSocialSecurityNumberValid(this.state.patientSocialSecurityNumber, this.state.countryStateDict?.['search-ssn'] ?? this.props.country)))) {
                                                            this.findPatient()
                                                        }
                                                    }}
                                                    getCountryState={(countryState) => {
                                                        let countryStateDict = this.state.countryStateDict ?? {};
                                                        countryStateDict['search-ssn'] = countryState;
                                                        this.setState({ countryStateDict })
                                                    }}

                                                ></SocialSecurityNumber>
                                                {/* {
                                                    this.props.country === 'uk' ?
                                                        <div className={this.state.searchByNameAndEmail ? 'little-dropdown-icon-down little-dropdown-icon-down-hide' : 'little-dropdown-icon-down arrow-icon-info'} onClick={() => {
                                                            this.setState({
                                                                searchByNameAndEmail: !this.state.searchByNameAndEmail
                                                            })
                                                        }}>
                                                            <div>{'Show additional search options'.translate(this.props.lang)}</div>
                                                        </div>
                                                        :
                                                        null
                                                } */}
                                                <Button
                                                    style={this.props.country === 'uk' ? { marginBottom: 8 } : {}}
                                                    disabled={!this.state.patientSocialSecurityNumber || (!patientInfoSettings?.isCustomIdEnabled && !isSocialSecurityNumberValid(this.state.patientSocialSecurityNumber, this.state.countryStateDict?.['search-ssn'] ?? this.props.country))}
                                                    className='patient-search-modal-calendar-button'
                                                    color='primary'
                                                    onClick={() => {
                                                        this.findPatient()
                                                    }}>
                                                    {'Search'.translate(this.props.lang)}
                                                </Button>
                                            </div>
                                            {
                                                this.state.patient ?
                                                    <FormGroup className='search-history-calendar'>
                                                        <Label>{'Search results'.translate(this.props.lang)}</Label>
                                                        <div className='patient-search-modal-result' onClick={() => {
                                                            if (this.state.patient?.twoFactorAuthentication?.[this.props.selectedGroup]?.createAccount && !this.state.patient?.twoFactorAuthentication?.[this.props.selectedGroup]?.infoIsVerified) return;

                                                            let patientModal = this.state.patientModal;
                                                            if (isChild) {
                                                                // patientModal.title = this.state.patient.userData.name.trim() + ' ' + 'Parent/legal guardian:'.translate(this.props.lang) + ` ${this.state.patient && this.state.patient.parentObj && this.state.patient.parentObj.name}`;
                                                                patientModal.title = this.state.patient.userData.name.trim()
                                                            } else {
                                                                patientModal.title = this.state.patient.userData.name.trim();

                                                            }
                                                            patientModal.socialSecurityNumber = this.state.patient.socialSecurityNumber;
                                                            patientModal.patient = this.state.patient._id;

                                                            let selectedParents = null;
                                                            if (this.state.patient?.parentObj?._id) {
                                                                selectedParents = [this.state.patient.parentObj._id]
                                                            }

                                                            this.setState({ scheduleControl: { ...this.state.patientModal, selectedParents }, patientModal: !this.state.patientModal, patientSocialSecurityNumber: '', updateEventTemplate: null }, () => {
                                                                if (this.state.scheduleControl?.patient) {
                                                                    this.patientAge(this.state.scheduleControl?.patient, () => this.setVisitReasonFromTemplate())
                                                                } else {
                                                                    this.setVisitReasonFromTemplate();
                                                                }
                                                                // this.patientAge(this.state.patient._id)
                                                            })
                                                        }}>
                                                            <div>
                                                                <p>{'Name'.translate(this.props.lang)}</p>
                                                                <p className='patient-search-modal-result-text'>{this.state.patient.name}</p>
                                                            </div>
                                                            <div>
                                                                <p>{'Social security number'.translate(this.props.lang)}</p>
                                                                <p className='patient-search-modal-result-text'>{this.state.patient.socialSecurityNumber}</p>
                                                            </div>
                                                            {this.state.patient?.twoFactorAuthentication?.[this.props.selectedGroup]?.createAccount && !this.state.patient?.twoFactorAuthentication?.[this.props.selectedGroup]?.infoIsVerified ? <div>
                                                                <p>{'Info'.translate(this.props.lang)}</p>
                                                                <p className='patient-search-modal-result-text' style={{ textAlign: 'center' }}>
                                                                    <UserIsNotVerifiedTooltip lang={this.props.lang} />
                                                                </p>
                                                            </div> : (this.state.patient?.twoFactorAuthentication && Object.keys(this.state.patient?.twoFactorAuthentication)?.find(key => this.state.patient?.twoFactorAuthentication?.[key]?.createAccount)) ? <div>
                                                                <p>{'Info'.translate(this.props.lang)}</p>
                                                                <p className='patient-search-modal-result-text' style={{ textAlign: 'center' }}>
                                                                    <UserIsNotVerifiedTooltip lang={this.props.lang} warning />
                                                                </p>
                                                            </div> : null}
                                                        </div>
                                                        {
                                                            isChild ?
                                                                <p style={{ color: 'red' }}>{msg2}</p>
                                                                :
                                                                null
                                                        }

                                                    </FormGroup>
                                                    :
                                                    null
                                            }
                                            {
                                                this.state.lastSerach?.length ?
                                                    <FormGroup className='search-history-calendar'>
                                                        <Label>{'Last opened patient profiles / Search history'.translate(this.props.lang)}</Label>
                                                        <div>
                                                            <div className="table-h-scroll">
                                                                <table>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>{'Name'.translate(this.props.lang)}</th>
                                                                            <th>{'Social security number'.translate(this.props.lang)}</th>
                                                                            {/* {
                                                                                patientInfoSettings?.isCustomIdEnabled ?
                                                                                    <th>{patientInfoSettings?.customIdLabel ? patientInfoSettings?.customIdLabel : 'Custom id'.translate(this.props.lang)}</th>
                                                                                    :
                                                                                    null
                                                                            } */}

                                                                            <th>{'Last opened'.translate(this.props.lang)}</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            this.state.lastSerach && this.state.lastSerach.map((item, idx) => {
                                                                                if (idx < 7)
                                                                                    return (
                                                                                        <tr className='calendar-patient-search-history' key={item._id} onClick={() => {
                                                                                            this.setState({
                                                                                                patientSocialSecurityNumber: item.socialSecurityNumber
                                                                                            }, () => {
                                                                                                if (!(!this.state.patientSocialSecurityNumber || (!patientInfoSettings?.isCustomIdEnabled && !isSocialSecurityNumberValid(this.state.patientSocialSecurityNumber, this.state.countryStateDict?.['search-ssn'] ?? this.props.country)))) {
                                                                                                    this.findPatient(() => {
                                                                                                        if (!this.state.patientModal) return;

                                                                                                        if (this.state.patient?.twoFactorAuthentication?.[this.props.selectedGroup]?.createAccount && !this.state.patient?.twoFactorAuthentication?.[this.props.selectedGroup]?.infoIsVerified) return;

                                                                                                        let patientModal = this.state.patientModal;
                                                                                                        if (isChild) {
                                                                                                            patientModal.title = this.state.patient.userData.name.trim()
                                                                                                        } else {
                                                                                                            patientModal.title = this.state.patient.userData.name.trim();

                                                                                                        }
                                                                                                        patientModal.socialSecurityNumber = this.state.patient.socialSecurityNumber;
                                                                                                        patientModal.patient = this.state.patient._id;

                                                                                                        let selectedParents = null;
                                                                                                        if (this.state.patient?.parentObj?._id) {
                                                                                                            selectedParents = [this.state.patient.parentObj._id]
                                                                                                        }
                                                                                                        this.setState({ scheduleControl: { ...this.state.patientModal, selectedParents }, patientModal: !this.state.patientModal, patientSocialSecurityNumber: '', updateEventTemplate: null }, () => {
                                                                                                            if (this.state.scheduleControl?.patient) {
                                                                                                                this.patientAge(this.state.scheduleControl?.patient, () => this.setVisitReasonFromTemplate())
                                                                                                            } else {
                                                                                                                this.setVisitReasonFromTemplate();
                                                                                                            }
                                                                                                        })
                                                                                                    })
                                                                                                }
                                                                                            })
                                                                                        }}>
                                                                                            <td>{item.name}</td>
                                                                                            <td>{item.socialSecurityNumber}</td>
                                                                                            {/* {
                                                                                                patientInfoSettings?.isCustomIdEnabled ?
                                                                                                    <td>{item?.customId?.[this.props.selectedGroup]}</td>
                                                                                                    :
                                                                                                    null
                                                                                            } */}
                                                                                            <td>{this.props.getStringDateTs(item.timestamp, this.props.dateFormat)}</td>

                                                                                        </tr>
                                                                                    )
                                                                            })
                                                                        }


                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </FormGroup>
                                                    :
                                                    null
                                            }
                                        </div>
                                }





                            </ModalBody>
                        </Modal>
                        : null
                }

                {
                    this.state.takeCareEvent
                        ? <Modal isOpen={this.state.takeCareEvent} size='lg' centered toggle={() => this.setState({ takeCareEvent: null, doctorsList: [] })} backdrop={true}>
                            <ModalHeader close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ takeCareEvent: null, doctorsList: [] })}>&times;</button>}>
                                {'Take Care Event'.translate?.(this.props?.lang)}
                            </ModalHeader>
                            <ModalBody>
                                {this.state.takeCareEvent.takeCareData
                                    ? <>
                                        <h6 style={{ marginTop: 20, fontWeight: '600', fontSize: 20 }}>{'Appointment information'.translate?.(this.props?.lang)}</h6>
                                        <Row>
                                            <Col lg={8}>
                                                <FormGroup>
                                                    <Label>
                                                        {'Event Name'.translate?.(this.props?.lang)}
                                                    </Label>
                                                    <Input type='text' value={this.state.takeCareEvent.takeCareData._title || this.state.takeCareEvent.takeCareData.title || ''} disabled={true} />
                                                </FormGroup>
                                            </Col>
                                            <Col lg={4}>
                                                <FormGroup>
                                                    <Label>
                                                        {'Status'.translate?.(this.props?.lang)}
                                                    </Label>
                                                    <Input type='text' value={this.state.takeCareEvent.takeCareData.status || ''} disabled={true} />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={6}>
                                                <FormGroup>
                                                    <Label>
                                                        {'Description'.translate?.(this.props?.lang)}
                                                    </Label>
                                                    <Input type='textarea' value={this.state.takeCareEvent.takeCareData.description || ''} disabled={true} />
                                                </FormGroup>
                                            </Col>
                                            <Col lg={6}>
                                                <FormGroup>
                                                    <Label>
                                                        {'Comment'.translate?.(this.props?.lang)}
                                                    </Label>
                                                    <Input type='textarea' value={this.state.takeCareEvent.takeCareData.comment || ''} disabled={true} />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <h6 style={{ marginTop: 20, fontWeight: '600', fontSize: 20 }}>{'Patient information'.translate?.(this.props?.lang)}</h6>
                                        {this.state.takeCareEvent.takeCareData?.participants?.map((obj, i) => {
                                            if (!obj || tcDoctorTitles.includes(obj?.role)) return null;
                                            return <Row key={obj?.emr_id ? `${obj.emr_id}-${i}` : i} style={{ marginBottom: (i === this.state?.takeCareEvent?.takeCareData?.participants?.length - 1) ? 10 : null, alignItems: 'center' }}>
                                                <Col lg={canOpenProfile && (obj?.emr_id || obj?.id) ? 5 : 6}>
                                                    <FormGroup>
                                                        <Label>
                                                            {'Name'.translate?.(this.props?.lang)}
                                                        </Label>
                                                        <Input type='text' value={obj?.name || ''} disabled={true} />
                                                    </FormGroup>
                                                </Col>
                                                <Col lg={canOpenProfile && (obj?.emr_id || obj?.id) ? 5 : 6}>
                                                    <FormGroup>
                                                        <Label>
                                                            {'Social security number'.translate?.(this.props?.lang)}
                                                        </Label>
                                                        <Input type='text' value={obj?.emr_id || obj?.id || ''} disabled={true} />
                                                    </FormGroup>
                                                </Col>
                                                {canOpenProfile && (obj?.emr_id || obj?.id) ? <Col lg={2} style={{ position: 'relative', top: 6 }}>
                                                    <Button color='primary' size='lg' onClick={() => this.searchPatientWithRedirect(obj?.emr_id ? obj?.emr_id : obj?.id)}>{'Open'.translate(this.props.lang)}</Button>
                                                </Col> : null}
                                            </Row>
                                        })}
                                    </>
                                    : <Row>
                                        <Col>
                                            {'No Details'.translate?.(this.props?.lang)}
                                        </Col>
                                    </Row>
                                }
                                <h6 style={{ marginTop: 20, fontWeight: '600', fontSize: 20 }}>{'Schedule information'.translate?.(this.props?.lang)}</h6>
                                <Row className='take-care-modal-date-container'>
                                    <Col sm={12} lg={6}>
                                        {this.state.takeCareEvent.date ? <DatePicker
                                            label={'Start date'.translate(this.props.lang)}
                                            value={this.state.takeCareEvent.date}
                                            holidayEvents={this.state.holidayEvents}
                                            lang={this.props.lang}
                                            onChange={e => { return; }}
                                            disabled={true}
                                        /> : null}
                                    </Col>
                                    {this.state.takeCareEvent.date && this.state.takeCareEvent.startTime ? <Col sm={6} lg={3}><FormGroup className="timepicker-container timepicker-wide">
                                        <Label>{'Start time'.translate(this.props.lang)}</Label>
                                        &nbsp;
                                        <TimePicker
                                            format={'HH:mm'}
                                            value={moment(new Date(this.state.takeCareEvent.date.replace(/-/g, "/") + " " + this.state.takeCareEvent.startTime))}
                                            // minValue={moment.unix(this.state.min.getTime() / 1000).format("HH:mm")}
                                            // maxValue={moment.unix(this.state.max.getTime() / 1000).format("HH:mm")}
                                            // maxValue={this.state.updateEvent.endTime}
                                            flag={0}
                                            onChange={() => { return; }}
                                            allowClear={false}
                                            disabled={true}
                                        />
                                    </FormGroup></Col>
                                        : null}
                                    {this.state.takeCareEvent.date && this.state.takeCareEvent.endTime ? <Col sm={6} lg={3}>
                                        <FormGroup className="timepicker-container timepicker-wide">
                                            <Label>{'End time'.translate(this.props.lang)}</Label>
                                            &nbsp;
                                            <TimePicker
                                                format={'HH:mm'}
                                                value={moment(new Date(this.state.takeCareEvent.date.replace(/-/g, "/") + " " + this.state.takeCareEvent.endTime))}
                                                // minValue={Math.trunc((Number(this.state.updateEvent.startTime.split(':')[0]) * 60 + Number(this.state.updateEvent.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.updateEvent.startTime.split(':')[0]) * 60 + Number(this.state.updateEvent.startTime.split(':')[1]) + 5) % 60}
                                                // maxValue={moment.unix(this.state.max.getTime() / 1000).format("HH:mm")}
                                                flag={0}
                                                // maxValue={this.state.updateEvent.startTime}
                                                // flag={1}
                                                onChange={() => { return; }}
                                                allowClear={false}
                                                disabled={true}
                                            />
                                        </FormGroup>
                                    </Col> : null}
                                </Row>
                                {this.state.takeCareEvent?.takeCareData?.arbitraryTime
                                    ? <Row>
                                        <Col>
                                            <p style={{ fontWeight: 400, fontSize: 14, color: '#E30B5C' }}>* {'End time for this event was not provided by TakeCare, so we added an arbitrary duration of 30 minutes, which might not be accurate! Please check the real duration and end time in TakeCare Calendar!'.translate?.(this.props?.lang)}</p>
                                        </Col>
                                    </Row>
                                    : null}
                            </ModalBody>
                            <ModalFooter style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button color='primary' onClick={() => this.setState({ takeCareEvent: null, doctorsList: [] })} style={{ minWidth: 100 }}>
                                    {'Close'.translate?.(this.props?.lang)}
                                </Button>
                            </ModalFooter>
                        </Modal>
                        : null
                }

                {
                    _sembleEvent ? <Modal
                        isOpen={_sembleEvent}
                        size='lg'
                        centered
                        toggle={() => this.setState({ sembleEvent: null, doctorsList: [] })}
                        backdrop={true}
                    >
                        <ModalHeader close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ sembleEvent: null, doctorsList: [] })}>&times;</button>}>
                            {'Semble Event'.translate?.(this.props?.lang)}
                        </ModalHeader>
                        <ModalBody>
                            {/* Appointment info */}
                            <h6 key='appo' style={{ marginTop: 20, fontWeight: '600', fontSize: 20 }}>{'Appointment information'.translate?.(this.props?.lang)}</h6>
                            <Row key='appo1'>
                                <Col lg={7}>
                                    <FormGroup>
                                        <Label>
                                            {'Event Name'.translate?.(this.props?.lang)}
                                        </Label>
                                        <Input type='text' value={_sembleEvent.sembleData?.appointment?.title || ''} disabled={true} />
                                    </FormGroup>
                                </Col>
                                <Col lg={3}>
                                    <FormGroup>
                                        <Label>
                                            {'Status'.translate?.(this.props?.lang)}
                                        </Label>
                                        <Input type='text' value={_sembleEvent.sembleData?.deleted ? 'deleted' : 'booked'} disabled={true} />
                                    </FormGroup>
                                </Col>
                                <Col lg={2}>
                                    <FormGroup>
                                        <Label>
                                            {'Price'.translate?.(this.props?.lang)} {this.props.currency}
                                        </Label>
                                        <Input type='text' value={_sembleEvent.sembleData?.appointment?.price} disabled={true} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row key='appo2'>
                                <Col>
                                    <FormGroup>
                                        <Label>{'Comment'.translate?.(this.props?.lang)}</Label>
                                        <Input type='textarea' value={_sembleEvent.sembleData?.comments || ''} disabled={true} />
                                    </FormGroup>
                                </Col>
                            </Row>

                            {/* Patient info */}
                            <div style={{
                                display: 'flex',
                                alignItems: 'flex-end',
                                justifyContent: 'space-between',
                                gap: 10,
                                marginBottom: 15
                            }}>
                                <h6 key='pati' style={{ marginTop: 20, fontWeight: '600', fontSize: 20 }}>{'Patient information'.translate?.(this.props?.lang)}</h6>
                                {canOpenProfile && _semblePatient?.ssn ? <Button color='primary' onClick={() => this.searchPatientWithRedirect(_semblePatient?.ssn)}>{'Open Patient Profile'.translate(this.props.lang)}</Button> : null}
                            </div>

                            {_semblePatient ? <Fragment key='pati_f_1'>
                                <Row key='pati1'>
                                    <Col lg={6}>
                                        <FormGroup>
                                            <Label>{'Name'.translate?.(this.props.lang)}</Label>
                                            <Input type='text' value={_semblePatient.name || ''} disabled={true} />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={3}>
                                        <FormGroup>
                                            <Label>{'Date of birth'.translate(this.props.lang)}</Label>
                                            <Input type='text' value={this.getGBDate(_semblePatient.dob)} disabled={true} />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={3}>
                                        <FormGroup>
                                            <Label>{'Sex'.translate(this.props.lang)}</Label>
                                            <Input type='text' value={_semblePatient.gender} disabled={true} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row key='pati2'>
                                    <Col lg={6}>
                                        <FormGroup>
                                            <Label>{'Email'.translate?.(this.props.lang)}</Label>
                                            <Input type='text' value={_semblePatient.email || ''} disabled={true} />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={6}>
                                        <FormGroup>
                                            <Label>{'Phone'.translate(this.props.lang)}</Label>
                                            <PhoneField
                                                countryTwoLetter={this.props.countryTwoLetter}
                                                country={this.props.country}
                                                value={_semblePatient.phone || ''}
                                                disabled={true}
                                                onChange={() => { return; }}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                {_semblePatient.address?.city || _semblePatient.address?.street || _semblePatient.address?.zip ? <Row key='pati3'>
                                    <Col lg={4}>
                                        <FormGroup>
                                            <Label>{'City'.translate?.(this.props.lang)}</Label>
                                            <Input type='text' value={_semblePatient.address.city || ''} disabled={true} />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={4}>
                                        <FormGroup>
                                            <Label>{'Postal code'.translate(this.props.lang)}</Label>
                                            <Input type='text' value={_semblePatient.address.zip || ''} disabled={true} />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={4}>
                                        <FormGroup>
                                            <Label>{'Street'.translate(this.props.lang)}</Label>
                                            <Input type='text' value={_semblePatient.address.street || ''} disabled={true} />
                                        </FormGroup>
                                    </Col>
                                </Row> : null}
                            </Fragment> : <Fragment key='pati_f_2'>
                                <Row>
                                    <Col>
                                        {'No Details'.translate?.(this.props?.lang)}
                                    </Col>
                                </Row>
                            </Fragment>}

                            {/* Schedule info */}
                            <h6 style={{ marginTop: 20, fontWeight: '600', fontSize: 20 }}>{'Schedule information'.translate?.(this.props?.lang)}</h6>
                            <Row className='take-care-modal-date-container' key='sche'>
                                <Col sm={12} lg={6}>
                                    {_sembleEvent.date ? <DatePicker
                                        label={'Start date'.translate(this.props.lang)}
                                        value={_sembleEvent.date}
                                        holidayEvents={this.state.holidayEvents}
                                        lang={this.props.lang}
                                        onChange={e => { return; }}
                                        disabled={true}
                                    /> : null}
                                </Col>
                                {_sembleEvent.date && _sembleEvent.startTime ? <Col sm={6} lg={3}><FormGroup className="timepicker-container timepicker-wide">
                                    <Label>{'Start time'.translate(this.props.lang)}</Label>
                                    &nbsp;
                                    <TimePicker
                                        format={'HH:mm'}
                                        value={moment(new Date(_sembleEvent.date.replace(/-/g, "/") + " " + _sembleEvent.startTime))}
                                        flag={0}
                                        onChange={() => { return; }}
                                        allowClear={false}
                                        disabled={true}
                                    />
                                </FormGroup></Col>
                                    : null}
                                {_sembleEvent.date && _sembleEvent.endTime ? <Col sm={6} lg={3}>
                                    <FormGroup className="timepicker-container timepicker-wide">
                                        <Label>{'End time'.translate(this.props.lang)}</Label>
                                        &nbsp;
                                        <TimePicker
                                            format={'HH:mm'}
                                            value={moment(new Date(_sembleEvent.date.replace(/-/g, "/") + " " + _sembleEvent.endTime))}
                                            flag={0}
                                            onChange={() => { return; }}
                                            allowClear={false}
                                            disabled={true}
                                        />
                                    </FormGroup>
                                </Col> : null}
                            </Row>
                        </ModalBody>
                        <ModalFooter style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <button style={{ display: 'none', visibility: 'none' }} hidden aria-hidden='true' />
                            {_semblePatient?.ssn && _sembleEvent?.referral ? <>
                                <Button
                                    color='primary'
                                    onClick={() => {
                                        this.openConveration(this.state.sembleEvent)
                                    }}
                                >
                                    {'Open conversation'.translate?.(this.props?.lang)}
                                </Button>
                                <Button
                                    color='primary'
                                    onClick={() => {
                                        this.startVideoCall(this.state.sembleEvent)
                                    }}
                                    className='calendar-video-start-tooltip'
                                >
                                    <div className="quick-phrase-tooltip-on">
                                        {'Start video call'.translate(this.props.lang)}
                                        <div className="chat-icons-tooltip">{'Please note that by starting a video call, you will also open a chat with the participant(s). You can see and close this chat after the video call on the "Chat"-page.'.translate(this.props.lang)}</div>
                                    </div>
                                </Button>
                            </> : null}
                            <Button color='primary' disabled={!_sembleEvent?.canEdit || _sembleEvent.sembleData?.deleted} onClick={() => {
                                if (!_sembleEvent?.canEdit || _sembleEvent.sembleData?.deleted) return;
                                this.prepareSembleUpdate();
                            }} style={{ minWidth: 100 }}>
                                {'Update Event'.translate?.(this.props?.lang)}
                            </Button>
                            <Button color='danger' disabled={!_sembleEvent?.canEdit || _sembleEvent.sembleData?.deleted} onClick={() => {
                                if (!_sembleEvent?.canEdit || _sembleEvent.sembleData?.deleted) return;
                                this.setState({ sembleEventCancel: _sembleEvent })
                            }} style={{ minWidth: 100 }}>
                                {'Cancel Event'.translate?.(this.props?.lang)}
                            </Button>
                            <Button color='primary' onClick={() => this.setState({ sembleEvent: null, doctorsList: [] })} style={{ minWidth: 100 }}>
                                {'Close'.translate?.(this.props?.lang)}
                            </Button>
                            <button style={{ display: 'none', visibility: 'none' }} hidden aria-hidden='true' />
                        </ModalFooter>
                    </Modal> : null
                }

                {
                    this.state.sembleEventCancel ? <Modal
                        isOpen={this.state.sembleEventCancel}
                        size='md'
                        centered
                        toggle={() => this.setState({ sembleEventCancel: null })}
                        backdrop={true}
                    >
                        <ModalHeader close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ sembleEventCancel: null, doctorsList: [] })}>&times;</button>}>
                            {'Cancel Event'.translate?.(this.props?.lang)}
                        </ModalHeader>
                        <ModalBody>
                            <p style={{ width: '75%', margin: 'auto', textAlign: 'center' }}>{"Are you sure you want to cancel this event? This action cannot be reversed!".translate?.(this.props.lang)}</p>
                        </ModalBody>
                        <ModalFooter style={{ display: 'flex', justifyContent: 'center' }}>
                            <button style={{ display: 'none', visibility: 'none' }} hidden aria-hidden='true' />
                            <Button
                                color='danger'
                                onClick={this.cancelSembleEvent}
                                style={{ minWidth: 100 }}
                            >
                                {'Cancel Event'.translate?.(this.props?.lang)}
                            </Button>
                            <Button
                                color='primary'
                                onClick={() => this.setState({ sembleEventCancel: null })}
                                style={{ minWidth: 100 }}
                            >
                                {'Abort'.translate?.(this.props?.lang)}
                            </Button>
                            <button style={{ display: 'none', visibility: 'none' }} hidden aria-hidden='true' />
                        </ModalFooter>
                    </Modal> : null
                }

                {
                    this.state.sembleEventUpdate ? <Modal
                        isOpen={this.state.sembleEventUpdate}
                        size='md'
                        centered
                        toggle={() => this.setState({ sembleEventUpdate: null })}
                        backdrop={true}
                        key='pioasuhfbpoiuagdbso08iyu'
                    >
                        <ModalHeader key='pioasuhbpiuaosdfbpiuasdf' close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ sembleEventUpdate: null, doctorsList: [] })}>&times;</button>}>
                            {'Update Event'.translate?.(this.props?.lang)}
                        </ModalHeader>
                        <ModalBody key='poasuidfpo9iuadfpiuhasdpfiugh'>
                            {this.state.sembleEventUpdate?.fullEdit ? <Fragment key='poasinfpoaishdfpoiuasf'>
                                <FormGroup key='doc'>
                                    <Label>{'Doctor'.translate(this.props.lang)}</Label>
                                    <Input
                                        type='select'
                                        value={this.state.sembleEventUpdate?.values?.doctor || ''}
                                        onChange={e => {
                                            const value = e.target.value;

                                            this.setState(prev => ({
                                                ...prev,
                                                sembleEventUpdate: {
                                                    ...prev.sembleEventUpdate,
                                                    values: {
                                                        ...prev.sembleEventUpdate.values,
                                                        doctor: value
                                                    },
                                                }
                                            }))
                                        }}
                                    >
                                        {this.state.sembleEventUpdate?.availableDoctors?.map(doc => <option
                                            key={doc._id}
                                            value={doc._id}
                                        >
                                            {doc.name}
                                        </option>)}
                                    </Input>
                                </FormGroup>

                                <FormGroup key='loc'>
                                    <Label>{'Location'.translate(this.props.lang)}</Label>
                                    <Input
                                        type='select'
                                        value={this.state.sembleEventUpdate?.values?.location || ''}
                                        onChange={e => {
                                            const value = e.target.value;

                                            this.setState(prev => ({
                                                ...prev,
                                                sembleEventUpdate: {
                                                    ...prev.sembleEventUpdate,
                                                    values: {
                                                        ...prev.sembleEventUpdate.values,
                                                        location: value
                                                    },
                                                }
                                            }))
                                        }}
                                    >
                                        {this.state.sembleEventUpdate?.availableLocations?.map(loc => <option
                                            key={loc._id}
                                            value={loc._id}
                                        >
                                            {loc.name}
                                        </option>)}
                                    </Input>
                                </FormGroup>
                            </Fragment> : null}


                            <Row key='dte1'>
                                <Col key='dte-dte'>
                                    <DatePicker
                                        label={'Date'.translate(this.props.lang)}
                                        value={this.state.sembleEventUpdate?.values?.date || ''}
                                        holidayEvents={this.state.holidayEvents}
                                        lang={this.props.lang}
                                        onChange={date => {
                                            this.setState(prev => ({
                                                ...prev,
                                                sembleEventUpdate: {
                                                    ...prev.sembleEventUpdate,
                                                    values: {
                                                        ...prev.sembleEventUpdate.values,
                                                        date
                                                    },
                                                }
                                            }))
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row key='dte2'>
                                <Col md={6} key='dte-st'>
                                    <FormGroup className="timepicker-container timepicker-wide">
                                        <Label>{'Start time'.translate(this.props.lang)}</Label>
                                        &nbsp;
                                        <TimePickerV2
                                            getStringDateTs={this.props.getStringDateTs}
                                            format={'HH:mm'}
                                            value={this.state.sembleEventUpdate?.values?.startTime || ''}
                                            flag={0}
                                            minValue='00:00'
                                            maxValue='23:59'
                                            onChange={(_, startTime) => {
                                                const newStartTime = new Date(`${this.state.sembleEventUpdate?.values?.date} ${startTime}`);
                                                const oldEndTime = new Date(`${this.state.sembleEventUpdate?.values?.date} ${this.state.sembleEventUpdate?.values?.endTime}`);
                                                const fiveMinutesAfterNewStartTime = new Date(newStartTime.getTime() + 5 * 60000);
                                                const _fiveMinutesAfter = `${String(fiveMinutesAfterNewStartTime.getHours()).padStart(2, '0')}:${String(fiveMinutesAfterNewStartTime.getMinutes()).padStart(2, '0')}`;
                                                this.setState(prev => ({
                                                    ...prev,
                                                    sembleEventUpdate: {
                                                        ...prev.sembleEventUpdate,
                                                        values: {
                                                            ...prev.sembleEventUpdate.values,
                                                            startTime,
                                                            endTime: (newStartTime > oldEndTime) ? _fiveMinutesAfter : prev.sembleEventUpdate?.values?.endTime
                                                        },
                                                    }
                                                }));
                                            }}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={6} key='dte-et'>
                                    <FormGroup className="timepicker-container timepicker-wide">
                                        <Label>{'End time'.translate(this.props.lang)}</Label>
                                        &nbsp;
                                        <TimePickerV2
                                            getStringDateTs={this.props.getStringDateTs}
                                            format={'HH:mm'}
                                            value={this.state.sembleEventUpdate?.values?.endTime || ''}
                                            flag={0}
                                            minValue={this.state.sembleEventUpdate?.values?.startTime || '00:00'}
                                            maxValue='23:59'
                                            onChange={(_, endTime) => {
                                                this.setState(prev => ({
                                                    ...prev,
                                                    sembleEventUpdate: {
                                                        ...prev.sembleEventUpdate,
                                                        values: {
                                                            ...prev.sembleEventUpdate.values,
                                                            endTime
                                                        },
                                                    }
                                                }));
                                            }}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </ModalBody>
                        <ModalFooter style={{ display: 'flex', justifyContent: 'flex-end' }} key='oeidh0jpedifro0sifhgoihsih'>
                            <button style={{ display: 'none', visibility: 'none' }} hidden aria-hidden='true' />
                            <Button
                                color='primary'
                                onClick={() => {
                                    if (!hasSembleUpdate) return;
                                    this.updateSembleEvent();
                                }}
                                style={{ minWidth: 100 }}
                                disabled={!this.state.sembleEventUpdate?.values?.doctor || !this.state.sembleEventUpdate?.values?.location || !this.state.sembleEventUpdate?.values?.date || !this.state.sembleEventUpdate?.values?.startTime || !this.state.sembleEventUpdate?.values?.endTime || !hasSembleUpdate}
                            >
                                {'Update Event'.translate?.(this.props?.lang)}
                            </Button>
                            <Button
                                color='primary'
                                onClick={() => this.setState({ sembleEventUpdate: null })}
                                style={{ minWidth: 100 }}
                            >
                                {'Abort'.translate?.(this.props?.lang)}
                            </Button>
                            <button style={{ display: 'none', visibility: 'none' }} hidden aria-hidden='true' />
                        </ModalFooter>
                    </Modal> : null
                }

                {
                    this.state.updateEvent ?

                        <Modal isOpen={this.state.updateEvent} size={this.state.updateEvent.patientProfile ? 'lg' : ''} centered>
                            <ModalHeader className='modal-header-flex' toggle={() => /*this.setState({ updateEvent: !this.state.updateEvent, doctorsList: [] }, () => */this.checkForChanges()/*)*/} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => /*this.setState({ updateEvent: !this.state.updateEvent, doctorsList: [] }, () => */this.checkForChanges()/*)*/}>&times;</button>}>
                                <Label style={{ display: 'flex', gap: 10 }}>
                                    <div>{'Update event'.translate(this.props.lang)}</div>
                                    {
                                        journalCuroflowEnable && this.state.updateEvent?.isMarkedForCheckIn ?
                                            <div className='check-in-event'>
                                                <Isvg src={handled} width={20} height={20} />
                                                <div>{'Checked in'.translate(this.props.lang)}</div>
                                            </div>
                                            :
                                            null
                                    }
                                </Label>
                                <div className='tooltip-title'>
                                    {
                                        this.state.updateEvent?.createOnWebDoc ?
                                            <Col lg='12'>
                                                <div className='flex-end mb-5'>
                                                    <WebDocInfo lang={this.props.lang} bottomTooltip={true} />
                                                </div>
                                            </Col>
                                            :
                                            null
                                    }
                                    {
                                        this.state.updateEvent.patientProfile && !this.state.updateEvent.patientProfile?.phone && !this.state.updateEvent.patientProfile?.email ?
                                            <div className='patient-no-notif'>
                                                <Isvg src={noNotifications} width={20} height={20} />
                                                <div>
                                                    {'Phone and email not registered'.translate(this.props.lang)}
                                                </div>
                                                <div className='tooltip-text'>{'No contact details registered. Add information in the patient profile to send notifications.'.translate(this.props.lang)}</div>
                                            </div>
                                            :
                                            null
                                    }
                                </div>

                            </ModalHeader>

                            <ModalBody>
                                <Row>

                                    <Col lg={this.state.updateEvent.patientProfile ? '6' : '12'}>
                                        {this.state.updateEvent.type == 'referral' || this.state.updateEvent.type == 'revisit' ?
                                            <FormGroup>
                                                <Label>{'Title'.translate(this.props.lang)}</Label>

                                                <Input disabled type='textarea'
                                                    // onChange={(e) => {
                                                    //     let updateEvent = this.state.updateEvent;
                                                    //     updateEvent.title = striptags(e.target.value);
                                                    //     this.setState({
                                                    //         updateEvent
                                                    //     })
                                                    // }}
                                                    value={this.state.updateEvent.titleDoctor && this.state.updateEvent.titleDoctor != '' ? this.state.updateEvent.baseTitle + ', ' + this.state.updateEvent.titleDoctor : this.state.updateEvent.title} />
                                                <Input type='text' style={{ marginTop: 5 }} onChange={(e) => {
                                                    let updateEvent = this.state.updateEvent;
                                                    updateEvent.titleDoctor = striptags(e.target.value);

                                                    this.setState({
                                                        updateEvent
                                                    })
                                                }}
                                                    value={this.state.updateEvent.titleDoctor} />

                                            </FormGroup>
                                            :
                                            <FormGroup>
                                                <Label>{'Title'.translate(this.props.lang)}</Label>

                                                <Input type='text'
                                                    disabled={this.state.updateEvent?.isColleagueEvent}
                                                    onChange={(e) => {
                                                        let updateEvent = this.state.updateEvent;
                                                        updateEvent.title = striptags(e.target.value);
                                                        this.setState({
                                                            updateEvent
                                                        })
                                                    }}
                                                    value={this.state.updateEvent.title} />


                                            </FormGroup>
                                        }
                                        <DatePicker
                                            label={'Start date'.translate(this.props.lang)}
                                            value={this.state.updateEvent.date}
                                            disabled={this.state.updateEvent?.isColleagueEvent}
                                            holidayEvents={this.state.holidayEvents}
                                            lang={this.props.lang}
                                            onChange={(e) => {
                                                let updateEvent = this.state.updateEvent;
                                                updateEvent.date = e;
                                                this.setState({
                                                    updateEvent
                                                })
                                                if (Math.floor(new Date(this.state.updateEvent.date + ' ' + this.state.updateEvent.startTime) / 1000) > Math.floor(new Date(this.state.updateEvent.endDate + ' ' + this.state.updateEvent.endTime) / 1000)) {
                                                    updateEvent.endDate = this.state.updateEvent.date
                                                    this.setState({
                                                        updateEvent
                                                    })
                                                }
                                            }}
                                        />
                                        <Row>
                                            <Col xs={12} sm={eventMeetings && this.state.updateEvent?.type === 'event' && this.state.updateEvent?.meeting?._id && this.state.updateEvent?.meeting?.meetingHost?.length > 1 ? 4 : 12}>
                                                <FormGroup className="timepicker-container timepicker-wide">
                                                    <Label>{'Start time'.translate(this.props.lang)}</Label>
                                                    &nbsp;
                                                    <TimePickerV2
                                                        getStringDateTs={this.props.getStringDateTs}
                                                        format={'HH:mm'}
                                                        disabled={this.state.updateEvent?.isColleagueEvent}
                                                        value={this.state.updateEvent.startTime}
                                                        minValue={this.props.getStringDateTs(Math.floor(this.state.min.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.min.getTime() / 1000).format("HH:mm")
                                                        maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000 - 300), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                                        flag={0}
                                                        onChange={(time1, timeString) => {

                                                            let updateEvent = this.state.updateEvent;
                                                            updateEvent.startTime = timeString

                                                            let startTimeSplit = updateEvent.startTime.split(":");
                                                            let endTimeSplit = updateEvent.endTime.split(":");

                                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                                            if (startTimeHourMinute < endTimeHourMinute) {
                                                                this.setState({ updateEvent })
                                                            } else {
                                                                updateEvent.endTime = Math.trunc((Number(this.state.updateEvent.startTime.split(':')[0]) * 60 + Number(this.state.updateEvent.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.updateEvent.startTime.split(':')[0]) * 60 + Number(this.state.updateEvent.startTime.split(':')[1]) + 5) % 60
                                                                // updateEvent.endTime = validateTime(updateEvent.endTime);
                                                                const padded = updateEvent?.endTime?.split?.(':');
                                                                if (padded && Array.isArray(padded) && padded.length && isStringAValidNumber(padded[0]) && isStringAValidNumber(padded[1])) {
                                                                    const h = padded[0]?.padStart?.(2, '0');
                                                                    const m = padded[1]?.padStart?.(2, '0');
                                                                    if (h && m) updateEvent.endTime = `${h}:${m}`;
                                                                }
                                                                this.setState({
                                                                    updateEvent
                                                                })
                                                            }

                                                            // if (startTimeHourMinute < endTimeHourMinute) {
                                                            //     this.setState({ updateEvent })
                                                            // } else {
                                                            // this.setState({ wrongInput: true })
                                                            // }
                                                        }}
                                                    />
                                                </FormGroup>
                                                <FormGroup className="timepicker-container timepicker-wide">
                                                    <Label>{'End time'.translate(this.props.lang)}</Label>
                                                    &nbsp;
                                                    <TimePickerV2
                                                        getStringDateTs={this.props.getStringDateTs}
                                                        format={'HH:mm'}
                                                        disabled={this.state.updateEvent?.isColleagueEvent}
                                                        value={this.state.updateEvent.endTime}
                                                        minValue={Math.trunc((Number(this.state.updateEvent.startTime.split(':')[0]) * 60 + Number(this.state.updateEvent.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.updateEvent.startTime.split(':')[0]) * 60 + Number(this.state.updateEvent.startTime.split(':')[1]) + 5) % 60}
                                                        maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                                        flag={0}
                                                        onChange={(time1, timeString) => {

                                                            let updateEvent = this.state.updateEvent;
                                                            updateEvent.endTime = timeString

                                                            let startTimeSplit = updateEvent.startTime.split(":");
                                                            let endTimeSplit = updateEvent.endTime.split(":");

                                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                                            if (startTimeHourMinute < endTimeHourMinute) {
                                                                this.setState({ updateEvent })
                                                            } else {
                                                                // this.setState({ wrongInput: true })
                                                            }
                                                        }}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            {eventMeetings && this.state.updateEvent?.type === 'event' && this.state.updateEvent?.meeting?._id && this.state.updateEvent?.meeting?.meetingHost?.length > 1 ? <Col
                                                xs={12}
                                                sm={8}
                                                className='event-meeting-participants-wrapper'
                                            >
                                                <button
                                                    type='button'
                                                    className={`event-meeting-participants-button ${this.state.meetingParticipants?.meetingId === this.state.updateEvent?.meeting?._id ? 'event-meeting-participants-button-expanded' : ''}`}
                                                    onClick={() => {
                                                        // console.log('this.state.updateEvent?.meeting: ', this.state.updateEvent?.meeting);

                                                        if (this.state.meetingParticipants) return this.setState({
                                                            meetingParticipants: null
                                                        });

                                                        if (this.state.updateEvent?.meeting) {
                                                            const meeting = this.state.updateEvent?.meeting;

                                                            let hostId;
                                                            let participantIds = [];

                                                            if (meeting?.meetingHost && Array.isArray(meeting?.meetingHost) && meeting?.meetingHost.length) {
                                                                const newArr = [...new Set(meeting?.meetingHost)];
                                                                hostId = newArr[0];
                                                                if (newArr.length > 1) {
                                                                    participantIds = newArr.slice(1);
                                                                }
                                                            }

                                                            let meetingParticipants = [];

                                                            if (hostId) {
                                                                const user = this.state.meetingParticipantsList.find(item => item._id === hostId);
                                                                if (!user) return;

                                                                meetingParticipants.push(`<span>${this.props.formatName?.(user.userData?.title, user.userData?.name)} <strong>(${'Organizer'.translate(this.props.lang)})</strong></span>`);
                                                            } else {
                                                                return;
                                                            }

                                                            if (participantIds?.length) {
                                                                for (const userId of participantIds) {
                                                                    const user = this.state.meetingParticipantsList.find(item => item._id === userId);
                                                                    if (!user) continue;

                                                                    meetingParticipants.push(`<span>${this.props.formatName?.(user.userData?.title, user.userData?.name)}</span>`);
                                                                }
                                                            }

                                                            if (meetingParticipants?.length) {
                                                                this.setState({
                                                                    meetingParticipants: {
                                                                        meetingId: meeting._id,
                                                                        list: meetingParticipants,
                                                                    },
                                                                })
                                                            }
                                                        }
                                                    }}
                                                >
                                                    <p>{'Meeting participants'.translate(this.props.lang)}</p>
                                                    <span>&gt;</span>
                                                </button>
                                                {this.state.meetingParticipants?.meetingId === this.state.updateEvent?.meeting?._id ? <ul className='event-meeting-participants-list'>
                                                    {this.state.meetingParticipants.list.map((item, index) => {
                                                        return <li
                                                            key={index}
                                                        >
                                                            <div dangerouslySetInnerHTML={{ __html: item }} />
                                                        </li>
                                                    })}
                                                </ul> : null}
                                            </Col> : null}
                                        </Row>
                                        {this.state.updateEvent?._doctorName ? <FormGroup>
                                            <Label>{'Clinician'.translate(this.props.lang)}</Label>
                                            <Input
                                                type='text'
                                                value={this.state.updateEvent?._doctorName}
                                                disabled={true}
                                            />
                                        </FormGroup> : null}
                                        {_additionalDoctors?.length ? <FormGroup>
                                            <Label>{'Additional doctors'.translate(this.props.lang)}</Label>
                                            <Input
                                                type='text'
                                                value={_additionalDoctors.join(', ')}
                                                disabled={true}
                                            />
                                        </FormGroup> : null}
                                        {
                                            this.state.updateEvent.type == "referral" ?
                                                <FormGroup>
                                                    <Label className='note-label-wrap'>{'Note'.translate(this.props.lang)}
                                                        <div className={this.state.patientNotes?.length ? 'notes-icon-wrap notes-icon-active' : 'notes-icon-wrap'} onClick={() => { this.setState({ showPatientNotes: true }) }}>
                                                            <Isvg src={notesIcon} />
                                                            <div className='tooltip-text'>{'Notes available'.translate(this.props.lang)}</div>
                                                        </div>
                                                    </Label>
                                                    <Input type='textarea'
                                                        name="note"
                                                        style={{ height: '150px' }}
                                                        onChange={(e) => {
                                                            let updateEvent = this.state.updateEvent;
                                                            updateEvent.patientNote = striptags(e.target.value);
                                                            this.setState({
                                                                updateEvent
                                                            })
                                                        }}
                                                        value={this.state.updateEvent.patientNote}
                                                    />
                                                </FormGroup>
                                                :
                                                null
                                        }
                                        {
                                            this.state.updateEvent.type == 'revisit' ?
                                                <FormGroup>
                                                    <Label className='note-label-wrap'>{this.state.updateEvent?.noteToPatient?.note ? 'Internal note'.translate(this.props.lang) : 'Note'.translate(this.props.lang)}
                                                        <div className={this.state.patientNotes?.length ? 'notes-icon-wrap notes-icon-active' : 'notes-icon-wrap'} onClick={() => { this.setState({ showPatientNotes: true }) }}>
                                                            <Isvg src={notesIcon} />
                                                            <div className='tooltip-text'>{'Notes available'.translate(this.props.lang)}</div>
                                                        </div>
                                                    </Label>
                                                    <Input type='textarea'
                                                        name="note"
                                                        style={{ height: '150px' }}
                                                        onChange={(e) => {
                                                            let updateEvent = this.state.updateEvent;
                                                            updateEvent.patientControlNote = striptags(e.target.value);
                                                            this.setState({
                                                                updateEvent
                                                            })
                                                        }}
                                                        value={this.state.updateEvent.patientControlNote}
                                                    />
                                                </FormGroup>
                                                :
                                                null
                                        }
                                        {
                                            this.state.updateEvent?.noteToPatient?.note ?
                                                <>
                                                    <FormGroup>
                                                        <Label style={{ display: 'flex', alignItems: 'center' }}>
                                                            {'Note to patient'.translate(this.props.lang)}
                                                            {/* <div className='button-elements-tooltip' style={{ marginLeft: 8 }}>
                                                            <Isvg src={infoIcon} style={{ width: 25 }} />
                                                            <div className='tooltip-text' style={{ minWidth: 180, bottom: 29 }}>{'This information wiil be shown to patient in ther booking information in "My cases"'.translate(this.props.lang)}</div>
                                                        </div> */}
                                                        </Label>
                                                        <Input
                                                            type='textarea'
                                                            name="noteToPatient"
                                                            style={{ height: '110px' }}
                                                            disabled={true}
                                                            onChange={(e) => {


                                                            }}
                                                            value={this.state.updateEvent.noteToPatient.note}
                                                        />
                                                    </FormGroup>
                                                    <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                                                        <Checkbox
                                                            disabled={true}
                                                            checked={this.state.updateEvent?.noteToPatient?.sendNoteAsPatientNotification}
                                                            label={'Sent note as patient notification'.translate(this.props.lang)}
                                                        />
                                                        {/* <div className='button-elements-tooltip' style={{ marginLeft: 8 }}>
                                                            <Isvg src={infoIcon} style={{ width: 25 }} />
                                                            <div className='tooltip-text' style={{ minWidth: 180, bottom: 29 }}>{'By checking box the note to patient will also be sent as a separate notification to the patient'.translate(this.props.lang)}</div>
                                                        </div> */}
                                                    </FormGroup>
                                                </>
                                                :
                                                null
                                        }
                                        {
                                            this.state.updateEvent.type == 'revisit' && enterprise ?
                                                <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                                                    <Checkbox
                                                        disabled
                                                        checked={this.state.updateEvent.hideTimeFromThePatient}
                                                        label={'Hide time from the patient'.translate(this.props.lang)}
                                                    />
                                                    <div className='button-elements-tooltip' style={{ marginLeft: 8 }}>
                                                        <Isvg src={infoIcon} style={{ width: 25 }} />
                                                        <div className='tooltip-text' style={{ minWidth: 180, bottom: 29 }}>{'Time is not displayed to the patient.'.translate(this.props.lang)}</div>
                                                    </div>
                                                </FormGroup>
                                                :
                                                null
                                        }
                                        {
                                            this.state.updateEvent.type == 'revisit' || this.state.updateEvent.type == 'referral' /* && enterprise */ ?
                                                <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                                                    <Checkbox
                                                        disabled
                                                        checked={this.state.updateEvent.hideDurationForPatient}
                                                        label={'Hide duration for patient'.translate(this.props.lang)}
                                                    />
                                                    <div className='button-elements-tooltip' style={{ marginLeft: 8 }}>
                                                        <Isvg src={infoIcon} style={{ width: 25 }} />
                                                        <div className='tooltip-text' style={{ minWidth: 180, bottom: 29 }}>{'Duration is not displayed to the patient.'.translate(this.props.lang)}</div>
                                                    </div>
                                                </FormGroup>
                                                :
                                                null
                                        }
                                        {
                                            this.state.updateEvent.type == 'revisit' && enterprise ?
                                                <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                                                    <Checkbox
                                                        onChange={(e) => {
                                                            let updateEvent = this.state.updateEvent;
                                                            updateEvent.closeCaseManually = e.target.checked;
                                                            this.setState({
                                                                updateEvent
                                                            })
                                                        }}
                                                        checked={this.state.updateEvent.closeCaseManually}
                                                        label={'Close case manually'.translate(this.props.lang)}
                                                    />

                                                </FormGroup>
                                                :
                                                null
                                        }

                                    </Col>

                                    {
                                        this.state.updateEvent.patientProfile ?
                                            <>
                                                <Col lg="6">

                                                    <FormGroup>
                                                        <Label>{'Case ID'.translate(this.props.lang)}</Label>
                                                        <Input type='text' disabled
                                                            value={this.state.updateEvent.patientProfile.referralNumber} />
                                                    </FormGroup>
                                                    <FormGroup className='form-with-search-patient'>
                                                        <Label>{'Social security number'.translate(this.props.lang)} {this.state.updateEvent?._2fa ? <UserIsNotVerifiedTooltip warning lang={this.props.lang} /> : null}</Label>
                                                        <Input type='text' disabled
                                                            value={this.state.updateEvent.patientProfile.socialSecurityNumber} />
                                                        {canOpenProfile ? <button
                                                            className='form-with-search-patient-button'
                                                            type='button'
                                                            onClick={() => {
                                                                this.checkForChanges(this.state.updateEvent.patientProfile.socialSecurityNumber);
                                                                // this.searchPatientWithRedirect(this.state.updateEvent.patientProfile.socialSecurityNumber)
                                                            }}
                                                        >
                                                            <svg enableBackground="new 0 0 24 24;" version="1.1" viewBox="0 0 24 24" xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"><g id="info" /><g id="icons"><g id="user"><ellipse cx="12" cy="8" rx="5" ry="6" /><path d="M21.8,19.1c-0.9-1.8-2.6-3.3-4.8-4.2c-0.6-0.2-1.3-0.2-1.8,0.1c-1,0.6-2,0.9-3.2,0.9s-2.2-0.3-3.2-0.9    C8.3,14.8,7.6,14.7,7,15c-2.2,0.9-3.9,2.4-4.8,4.2C1.5,20.5,2.6,22,4.1,22h15.8C21.4,22,22.5,20.5,21.8,19.1z" /></g></g></svg>
                                                            <span>{'Go to patient profile'.translate(this.props.lang)}</span>
                                                            {
                                                                !this.state.updateEvent.patientProfile?.phone && !this.state.updateEvent.patientProfile?.email ?
                                                                    <div className='orange-curcle'></div>
                                                                    :
                                                                    null
                                                            }
                                                        </button> : null}
                                                    </FormGroup>
                                                    {
                                                        patientInfoSettings?.isCustomIdEnabled ?
                                                            <FormGroup>
                                                                <Label>{patientInfoSettings?.customIdLabel ? patientInfoSettings?.customIdLabel : 'Custom id'.translate(this.props.lang)}</Label>
                                                                <Input type='text' disabled value={this.state.updateEvent.patientProfile?.customId ?? 'N/A'} />
                                                            </FormGroup>
                                                            :
                                                            null
                                                    }
                                                    <FormGroup>
                                                        <Label>{'Name'.translate(this.props.lang)}</Label>
                                                        <Input type='text' disabled
                                                            value={this.state.updateEvent.patientProfile.name} />
                                                    </FormGroup>
                                                    {
                                                        (this.state.updateEvent.type == 'referral' || this.state.updateEvent.type == 'revisit') && this.state.updateEvent?.patientProfile?.parentUser ?
                                                            <FormGroup>
                                                                <Label>{'Legal guardian/parent'.translate(this.props.lang)}</Label>
                                                                <Input type='text' style={{ marginTop: 5 }} disabled
                                                                    value={`${this.state.updateEvent?.patientProfile?.parentUser}${this.state.updateEvent?.patientProfile?.parentUser2 ? ', ' + this.state.updateEvent?.patientProfile?.parentUser2 : ''}`} />
                                                            </FormGroup>
                                                            :
                                                            null
                                                    }
                                                    <FormGroup>
                                                        <Label>{'Email'.translate(this.props.lang)}</Label>
                                                        <Input type='text' disabled
                                                            value={this.state.updateEvent.patientProfile.email} />
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Label>{'Phone'.translate(this.props.lang)}</Label>
                                                        <Input type='text' disabled
                                                            value={this.state.updateEvent.patientProfile.phone} />
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Label>{'Address'.translate(this.props.lang)}</Label>
                                                        <Input type='text' disabled
                                                            value={this.state.updateEvent.patientProfile.address} />
                                                    </FormGroup>

                                                    {
                                                        this.state.previewReferral?._id ?
                                                            <EventPreviewPaymentField
                                                                {...this.props}
                                                                caseId={this.state.previewReferral._id}
                                                            />
                                                            :
                                                            null
                                                    }
                                                </Col>
                                            </>
                                            :
                                            null
                                    }
                                    <Col lg="12">

                                        {
                                            this.state.updateEvent?.isColleagueEvent ?
                                                <div className='info-message-wrap'>
                                                    *{'You have been added as a colleague for this event. Only limited options are available for your access.'.translate(this.props.lang)}
                                                </div>
                                                :
                                                null
                                        }

                                        {
                                            this.state.updateEvent?.type === 'event' && this.state.updateEvent?.recurringObj?.frequencyType ?
                                                <RecurringDescription {...this.props} data={this.state.updateEvent} />
                                                :
                                                null
                                        }

                                        <div className='calendar-modal-buttons-wrap'>
                                            {
                                                this.state.updateEvent.patientProfile && !this.state.updateEvent.additionalDoctor ?
                                                    <Button onClick={() => this.setState({
                                                        doctorsModal: 1
                                                    })} color="primary">
                                                        {'Add caregiver'.translate(this.props.lang)}
                                                    </Button>
                                                    :
                                                    null
                                            }

                                            {

                                                this.state.updateEvent?.type !== 'free' && this.state.updateEvent?.type !== 'event' && eventMeetings ?
                                                    <>
                                                        {
                                                            !this.state.updateEvent?.isColleagueEvent ?

                                                                <FormGroup style={{ marginBottom: 0 }}>
                                                                    <Button
                                                                        onClick={() => {
                                                                            let guests = [];
                                                                            if (this.state.updateEvent?.guests) {
                                                                                guests = [...this.state.updateEvent.guests];
                                                                            }
                                                                            this.setState({
                                                                                eventMeetingsModal: { ...this.state.updateEvent, guests, modal: 'updateEvent' },
                                                                                meetingParticipants: null,
                                                                            })
                                                                        }}
                                                                        color="primary"
                                                                    >
                                                                        {this.state.updateEvent?.type === 'event' ? 'Add colleague'.translate(this.props.lang) : 'Add guest'.translate(this.props.lang)}
                                                                    </Button>
                                                                </FormGroup>
                                                                :
                                                                null
                                                        }
                                                        {
                                                            this.state.updateEvent?.meeting?._id ?
                                                                <FormGroup style={{ marginBottom: this.state.updateEvent?.isColleagueEvent ? 10 : 0 }} className='start-video-call-meeting-btn-wrap calendar-video-start-tooltip'>
                                                                    <Button
                                                                        disabled={!this.state.updateEvent?.meeting?.active}
                                                                        onClick={() => {
                                                                            if (this.state.updateEvent?.meeting?.active) {
                                                                                const conversationId = this.state.updateEvent?.meeting?._id;
                                                                                this.props.startVideoCall(conversationId)
                                                                            }
                                                                        }}
                                                                        color="primary"
                                                                    >
                                                                        <div className="quick-phrase-tooltip-on">
                                                                            {'Start video'.translate(this.props.lang)}
                                                                            <div className="chat-icons-tooltip">{'Please note that by starting a video call, you will also open a chat with the participant(s). You can see and close this chat after the video call on the "Chat"-page.'.translate(this.props.lang)}</div>
                                                                        </div>
                                                                    </Button>
                                                                    {
                                                                        !this.state.updateEvent?.meeting?.active && this.state.updateEvent?.meeting?.message ?
                                                                            <div className='button-tooltip-wrap'>
                                                                                {this.state.updateEvent.meeting.message?.translate(this.props.lang)}
                                                                            </div>
                                                                            :
                                                                            null
                                                                    }
                                                                </FormGroup>
                                                                :
                                                                null
                                                        }
                                                        {
                                                            this.state.updateEvent?.meeting?._id && this.state.updateEvent?.type === 'event' ?
                                                                <FormGroup style={{ marginBottom: this.state.updateEvent?.isColleagueEvent ? 10 : 0 }} className='start-video-call-meeting-btn-wrap calendar-video-start-tooltip'>
                                                                    <Button
                                                                        disabled={!this.state.updateEvent?.meeting?.active}
                                                                        onClick={() => {
                                                                            const conversationId = this.state.updateEvent?.meeting?._id;
                                                                            this.props[0].history.push(`/chat?conversation=${conversationId}`);
                                                                        }}
                                                                        color="primary"
                                                                    >
                                                                        <div className="quick-phrase-tooltip-on">
                                                                            {'Chat'.translate(this.props.lang)}
                                                                            {/* <div className="chat-icons-tooltip">{'Please note that by starting a video call, you will also open a chat with the participant(s). You can see and close this chat after the video call on the "Chat"-page.'.translate(this.props.lang)}</div> */}
                                                                        </div>
                                                                    </Button>
                                                                    {/* {
                                                                        !this.state.updateEvent?.meeting?.active && this.state.updateEvent?.meeting?.message ?
                                                                            <div className='button-tooltip-wrap'>
                                                                                {this.state.updateEvent.meeting.message?.translate(this.props.lang)}
                                                                            </div>
                                                                            :
                                                                            null
                                                                    } */}
                                                                </FormGroup>
                                                                :
                                                                null
                                                        }
                                                    </>

                                                    :

                                                    null
                                            }

                                        </div></Col>
                                    <Col lg="12" className='align-buttons-footer'>


                                        {
                                            this.state.updateEvent.type === 'event' ?
                                                <>
                                                    {
                                                        eventMeetings ?
                                                            <div className='update-event-btns-wrap' style={{ marginBottom: 0 }}>
                                                                {
                                                                    this.state.updateEvent?.meeting?._id && this.state.updateEvent?.type === 'event' ?
                                                                        <FormGroup style={{
                                                                            marginBottom: 0,
                                                                        }} className='start-video-call-meeting-btn-wrap calendar-video-start-tooltip'>
                                                                            <Button
                                                                                disabled={!this.state.updateEvent?.meeting?.active}
                                                                                onClick={() => {
                                                                                    const conversationId = this.state.updateEvent?.meeting?._id;
                                                                                    this.props[0].history.push(`/chat?conversation=${conversationId}`);
                                                                                }}
                                                                                color="primary"
                                                                            >
                                                                                <div className="quick-phrase-tooltip-on">
                                                                                    {'Chat'.translate(this.props.lang)}
                                                                                </div>
                                                                            </Button>

                                                                        </FormGroup>
                                                                        :
                                                                        null
                                                                }
                                                                {
                                                                    this.state.updateEvent?.meeting?._id ?
                                                                        <FormGroup style={{
                                                                            marginBottom: 0,
                                                                            // marginBottom: this.state.updateEvent?.isColleagueEvent ? 10 : 0, marginLeft: 10
                                                                        }} className='start-video-call-meeting-btn-wrap calendar-video-start-tooltip'>
                                                                            <Button
                                                                                disabled={!this.state.updateEvent?.meeting?.active}
                                                                                onClick={() => {
                                                                                    if (this.state.updateEvent?.meeting?.active) {
                                                                                        const conversationId = this.state.updateEvent?.meeting?._id;
                                                                                        this.props.startVideoCall(conversationId)
                                                                                    }
                                                                                }}
                                                                                color="primary"
                                                                            >
                                                                                <div className="quick-phrase-tooltip-on">
                                                                                    {'Start video'.translate(this.props.lang)}
                                                                                    <div className="chat-icons-tooltip">{'Please note that by starting a video call, you will also open a chat with the participant(s). You can see and close this chat after the video call on the "Chat"-page.'.translate(this.props.lang)}</div>
                                                                                </div>
                                                                            </Button>
                                                                            {
                                                                                !this.state.updateEvent?.meeting?.active && this.state.updateEvent?.meeting?.message ?
                                                                                    <div className='button-tooltip-wrap'>
                                                                                        {this.state.updateEvent.meeting.message?.translate(this.props.lang)}
                                                                                    </div>
                                                                                    :
                                                                                    null
                                                                            }
                                                                        </FormGroup>
                                                                        :
                                                                        null
                                                                }

                                                            </div>

                                                            :

                                                            null
                                                    }
                                                    <div className='update-event-btns-wrap'>

                                                        {
                                                            eventMeetings ?
                                                                <>
                                                                    {
                                                                        !this.state.updateEvent?.isColleagueEvent ?

                                                                            <FormGroup style={{ marginBottom: 0 }}>
                                                                                <Button
                                                                                    onClick={() => {
                                                                                        let guests = [];
                                                                                        if (this.state.updateEvent?.guests) {
                                                                                            guests = [...this.state.updateEvent.guests];
                                                                                        }
                                                                                        this.setState({
                                                                                            eventMeetingsModal: { ...this.state.updateEvent, guests, modal: 'updateEvent' },
                                                                                            meetingParticipants: null,
                                                                                        })
                                                                                    }}
                                                                                    color="primary"
                                                                                >
                                                                                    {this.state.updateEvent?.type === 'event' ? 'Add colleague'.translate(this.props.lang) : 'Add guest'.translate(this.props.lang)}
                                                                                </Button>
                                                                            </FormGroup>
                                                                            :
                                                                            null
                                                                    }
                                                                </>

                                                                :

                                                                null
                                                        }
                                                        {
                                                            !this.state.updateEvent?.isColleagueEvent && !this.state.updateEvent.additionalDoctor ?
                                                                <Button
                                                                    color='danger'
                                                                    style={{
                                                                    }}
                                                                    onClick={() => {
                                                                        let setObj = { warningModal: this.state.updateEvent, updateEvent: !this.state.updateEvent, meetingParticipants: null, prevUpdateEvent: !this.state.prevUpdateEvent, doctorsList: [] };
                                                                        if (this.state.updateEvent?.type === 'event') {
                                                                            let deleteEventModal = { ...this.state.updateEvent };
                                                                            setObj.deleteEventModal = deleteEventModal;
                                                                            delete setObj.warningModal;
                                                                            this.setState(setObj)
                                                                        } else {
                                                                            this.setState(setObj)
                                                                        }


                                                                    }}
                                                                >
                                                                    {'Cancel time'.translate(this.props.lang)}
                                                                </Button>

                                                                :
                                                                null
                                                        }
                                                        {
                                                            this.state.updateEvent?.isColleagueEvent && this.state.updateEvent.type === 'event' && ((this.state.doctor && this.state.updateEvent?.doctor !== this.state.doctor) || (!this.state.doctor && this.state.updateEvent?.doctor !== this.props.uData?._id)) ?
                                                                <Button
                                                                    color='danger'
                                                                    style={{
                                                                    }}
                                                                    onClick={() => {

                                                                        let setObj = { updateEvent: !this.state.updateEvent, meetingParticipants: null, prevUpdateEvent: !this.state.prevUpdateEvent, doctorsList: [] };
                                                                        let deleteColleagueEventModal = { ...this.state.updateEvent };
                                                                        setObj.deleteColleagueEventModal = deleteColleagueEventModal;
                                                                        this.setState(setObj)
                                                                    }}
                                                                >
                                                                    {'Cancel time'.translate(this.props.lang)}
                                                                </Button>

                                                                :
                                                                null
                                                        }



                                                    </div>
                                                    <div>

                                                        <Button color='primary' style={{ marginRight: 10 }} onClick={() => this.checkForChanges()}>{'Close'.translate(this.props.lang)}</Button>

                                                        {
                                                            !this.state.updateEvent?.isColleagueEvent && !this.state.updateEvent.additionalDoctor ?
                                                                <Button color='success' style={{ marginRight: 10 }} onClick={() => this.updateEvent(this.state.updateEvent)}>
                                                                    {/* {'Update'.translate(this.props.lang)} */}
                                                                    {this.state.loading ? /*'Processing...'.translate(this.props.lang)*/

                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                            <Player
                                                                                onEvent={() => {
                                                                                    if (!this.state.loading) this.stopAnimation();
                                                                                }}
                                                                                onStateChange={this.toggleVisibility}
                                                                                ref={this.player} // set the ref to your class instance
                                                                                autoplay={true}
                                                                                loop={true}
                                                                                controls={true}
                                                                                src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                                                                style={{ height: "20px", width: "30px" }}
                                                                            ></Player>
                                                                            {'Processing...'.translate(this.props.lang)}
                                                                        </div>

                                                                        : 'Save changes'.translate(this.props.lang)}
                                                                </Button>
                                                                :
                                                                null
                                                        }
                                                        {
                                                            this.state.updateEvent?.isMarkedAsDone ?
                                                                <Button onClick={() => {
                                                                    let updateEvent = this.state.updateEvent;
                                                                    updateEvent.isMarkedAsDone = false
                                                                    this.setState({
                                                                        updateEvent
                                                                    }, () => {
                                                                        this.updateEventIsDone(false, this.state.updateEvent?.id, this.state.doctor ? this.state.doctor : this.props.uData?._id)
                                                                    })
                                                                }} color='primary'>{'Mark as undone'.translate(this.props.lang)}</Button>
                                                                :
                                                                <Button onClick={() => {
                                                                    let updateEvent = this.state.updateEvent;
                                                                    updateEvent.isMarkedAsDone = true
                                                                    this.setState({
                                                                        updateEvent
                                                                    }, () => {
                                                                        this.updateEventIsDone(true, this.state.updateEvent?.id, this.state.doctor ? this.state.doctor : this.props.uData?._id)
                                                                    })
                                                                }} color='primary'>{'Mark as done'.translate(this.props.lang)}</Button>
                                                        }
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    <div className='update-event-btns-wrap'>
                                                        {
                                                            !this.state.updateEvent?.isColleagueEvent && this.state.updateEvent.patientProfile && (!this.state.updateEvent.additionalDoctors || (this.state.updateEvent.additionalDoctors && !this.state.updateEvent.additionalDoctors.filter(item => item == (this.state.doctor ? this.state.doctor : this.props.uData._id)).length)) ?
                                                                <Button color='primary'
                                                                    style={{
                                                                        // marginRight: !this.state.updateEvent?.meeting?._id ? 10 : 0
                                                                    }}
                                                                    onClick={() => {
                                                                        this.openConveration(this.state.updateEvent)

                                                                    }}>{'Open conversation'.translate(this.props.lang)}</Button>
                                                                :
                                                                null
                                                        }
                                                        {
                                                            this.state.updateEvent.patientProfile && this.state.updateEvent.additionalDoctors && this.state.updateEvent.additionalDoctors.filter(item => item == (this.state.doctor ? this.state.doctor : this.props.uData._id)).length ?
                                                                <Button color='primary'
                                                                    style={{
                                                                        //  marginRight: !this.state.updateEvent?.meeting?._id ? 10 : 0 
                                                                    }}
                                                                    onClick={() => {
                                                                        this.openConveration(this.state.updateEvent)

                                                                    }}>{'Open conversation'.translate(this.props.lang)}</Button>
                                                                :
                                                                null
                                                        }
                                                        {
                                                            this.state.updateEvent.patientProfile && this.state.offerData && this.state.startedVideoCallConversation && this.state.updateEvent.additionalDoctors && this.state.updateEvent.additionalDoctors.filter(item => item == (this.state.doctor ? this.state.doctor : this.props.uData._id)).length ?
                                                                <Button
                                                                    color='primary'
                                                                    style={{
                                                                        //  marginRight: !this.state.updateEvent?.meeting?._id ? 10 : 0
                                                                    }}
                                                                    onClick={() => {
                                                                        this.answerCall(this.state.offerData[this.state.startedVideoCallConversation])

                                                                    }}>{'Join video call'.translate(this.props.lang)}</Button>
                                                                :
                                                                null
                                                        }
                                                        {
                                                            !this.state.updateEvent?.meeting?._id && !this.state.updateEvent?.isColleagueEvent && this.state.updateEvent.patientProfile && (!this.state.updateEvent.additionalDoctors || (this.state.updateEvent.additionalDoctors && !this.state.updateEvent.additionalDoctors.filter(item => item == (this.state.doctor ? this.state.doctor : this.props.uData._id)).length)) ?
                                                                <div className='start-video-call-btn-wrap calendar-video-start-tooltip'>
                                                                    <button className={this.state.waitingRoom?.patientId === this.state.updateEvent?.patientId && this.state.waitingRoom?.showInfoWaitingRoom ? 'start-video-btn patient-waiting-room' : 'start-video-btn'} style={{ padding: 6, paddingLeft: 12, paddingRight: 12, height: 'auto' }} onClick={() => {
                                                                        this.startVideoCall(this.state.updateEvent)

                                                                    }}>

                                                                        <div className="quick-phrase-tooltip-on">
                                                                            {'Start video chat'.translate(this.props.lang)}
                                                                            <div className="chat-icons-tooltip">{'Please note that by starting a video call, you will also open a chat with the participant(s). You can see and close this chat after the video call on the "Chat"-page.'.translate(this.props.lang)}</div>
                                                                        </div>
                                                                    </button>

                                                                </div>
                                                                :
                                                                null
                                                        }
                                                        {
                                                            !this.state.updateEvent?.isColleagueEvent && this.state.updateEvent.additionalDoctors && this.state.updateEvent.additionalDoctors.filter(item => item == (this.state.doctor ? this.state.doctor : this.props.uData._id)).length ?
                                                                <Button color='primary'
                                                                    style={{
                                                                        // marginRight: 10
                                                                    }}
                                                                    onClick={() => {
                                                                        this.setState({ leaveCaseModal: this.state.updateEvent })

                                                                    }}>{'Leave case'.translate(this.props.lang)}</Button>
                                                                :
                                                                null
                                                        }
                                                        {
                                                            !this.state.updateEvent?.isColleagueEvent && !this.state.updateEvent.additionalDoctor && (this.props.uData?.groupPermissionsUser?.[this.props.selectedGroup]?.[this.props.selectedClinic]?.includes(this.props.uData?.permissions?.admin) || this.props.uData?.groupPermissionsUser?.[this.props.selectedGroup]?.[this.props.selectedClinic]?.includes(this.props.uData?.permissions?.scheduler)) ?
                                                                <Button color='primary' style={{
                                                                    // margin: 10,
                                                                    // marginLeft: this.state.updateEvent.type === 'event' ? 0 : 10
                                                                }} onClick={() => this.setState({ transferModal: this.state.updateEvent, updateEvent: !this.state.updateEvent, meetingParticipants: null, prevUpdateEvent: !this.state.prevUpdateEvent, doctorsList: [] })}>{'Transfer'.translate(this.props.lang)}</Button>
                                                                :
                                                                null
                                                        }
                                                        {
                                                            !this.state.updateEvent?.isColleagueEvent && !this.state.updateEvent.additionalDoctor ?
                                                                <Button
                                                                    color='primary'
                                                                    style={{
                                                                        //  marginRight: 10, marginLeft: this.state.updateEvent.type === 'event' ? 0 : 10 
                                                                    }}
                                                                    onClick={() => {
                                                                        const caseId = this.state.previewReferral?._id;
                                                                        if (caseId) {
                                                                            this.setState({ cancelVisitModal: caseId })
                                                                            return;
                                                                        }
                                                                        let setObj = { warningModal: this.state.updateEvent, updateEvent: !this.state.updateEvent, meetingParticipants: null, prevUpdateEvent: !this.state.prevUpdateEvent, doctorsList: [] };
                                                                        if (this.state.updateEvent?.type === 'event') {
                                                                            let deleteEventModal = { ...this.state.updateEvent };
                                                                            setObj.deleteEventModal = deleteEventModal;
                                                                            delete setObj.warningModal;
                                                                            this.setState(setObj)
                                                                        } else {
                                                                            this.setState(setObj)
                                                                        }


                                                                    }}
                                                                >
                                                                    {'Cancel time'.translate(this.props.lang)}
                                                                </Button>

                                                                :
                                                                null
                                                        }
                                                        {
                                                            this.state.updateEvent?.isColleagueEvent && this.state.updateEvent.type === 'event' && ((this.state.doctor && this.state.updateEvent?.doctor !== this.state.doctor) || (!this.state.doctor && this.state.updateEvent?.doctor !== this.props.uData?._id)) ?
                                                                <Button
                                                                    color='primary'
                                                                    style={{
                                                                        //  marginBottom: 10
                                                                    }}
                                                                    onClick={() => {

                                                                        let setObj = { updateEvent: !this.state.updateEvent, meetingParticipants: null, prevUpdateEvent: !this.state.prevUpdateEvent, doctorsList: [] };
                                                                        let deleteColleagueEventModal = { ...this.state.updateEvent };
                                                                        setObj.deleteColleagueEventModal = deleteColleagueEventModal;
                                                                        this.setState(setObj)
                                                                    }}
                                                                >
                                                                    {'Cancel time'.translate(this.props.lang)}
                                                                </Button>

                                                                :
                                                                null
                                                        }
                                                        {
                                                            this.state.updateEvent?.type !== 'free' && this.state.updateEvent?.type === 'event' && eventMeetings ?
                                                                <>
                                                                    {
                                                                        !this.state.updateEvent?.isColleagueEvent ?

                                                                            <FormGroup style={{ marginBottom: 0 }}>
                                                                                <Button
                                                                                    onClick={() => {
                                                                                        let guests = [];
                                                                                        if (this.state.updateEvent?.guests) {
                                                                                            guests = [...this.state.updateEvent.guests];
                                                                                        }
                                                                                        this.setState({
                                                                                            eventMeetingsModal: { ...this.state.updateEvent, guests, modal: 'updateEvent' },
                                                                                            meetingParticipants: null,
                                                                                        })
                                                                                    }}
                                                                                    color="primary"
                                                                                >
                                                                                    {this.state.updateEvent?.type === 'event' ? 'Add colleague'.translate(this.props.lang) : 'Add guest'.translate(this.props.lang)}
                                                                                </Button>
                                                                            </FormGroup>
                                                                            :
                                                                            null
                                                                    }
                                                                    {
                                                                        this.state.updateEvent?.meeting?._id ?
                                                                            <FormGroup style={{
                                                                                marginBottom: 0,
                                                                                // marginBottom: this.state.updateEvent?.isColleagueEvent ? 10 : 0, marginLeft: 10
                                                                            }} className='start-video-call-meeting-btn-wrap calendar-video-start-tooltip'>
                                                                                <Button
                                                                                    disabled={!this.state.updateEvent?.meeting?.active}
                                                                                    onClick={() => {
                                                                                        if (this.state.updateEvent?.meeting?.active) {
                                                                                            const conversationId = this.state.updateEvent?.meeting?._id;
                                                                                            this.props.startVideoCall(conversationId)
                                                                                        }
                                                                                    }}
                                                                                    color="primary"
                                                                                >
                                                                                    <div className="quick-phrase-tooltip-on">
                                                                                        {'Start video'.translate(this.props.lang)}
                                                                                        <div className="chat-icons-tooltip">{'Please note that by starting a video call, you will also open a chat with the participant(s). You can see and close this chat after the video call on the "Chat"-page.'.translate(this.props.lang)}</div>
                                                                                    </div>
                                                                                </Button>
                                                                                {
                                                                                    !this.state.updateEvent?.meeting?.active && this.state.updateEvent?.meeting?.message ?
                                                                                        <div className='button-tooltip-wrap'>
                                                                                            {this.state.updateEvent.meeting.message?.translate(this.props.lang)}
                                                                                        </div>
                                                                                        :
                                                                                        null
                                                                                }
                                                                            </FormGroup>
                                                                            :
                                                                            null
                                                                    }
                                                                    {
                                                                        this.state.updateEvent?.meeting?._id && this.state.updateEvent?.type === 'event' ?
                                                                            <FormGroup style={{
                                                                                marginBottom: 0,
                                                                                // marginBottom: this.state.updateEvent?.isColleagueEvent ? 10 : 0, marginLeft: 10
                                                                            }} className='start-video-call-meeting-btn-wrap calendar-video-start-tooltip'>
                                                                                <Button
                                                                                    disabled={!this.state.updateEvent?.meeting?.active}
                                                                                    onClick={() => {
                                                                                        const conversationId = this.state.updateEvent?.meeting?._id;
                                                                                        this.props[0].history.push(`/chat?conversation=${conversationId}`);
                                                                                    }}
                                                                                    color="primary"
                                                                                >
                                                                                    <div className="quick-phrase-tooltip-on">
                                                                                        {'Chat'.translate(this.props.lang)}
                                                                                        {/* <div className="chat-icons-tooltip">{'Please note that by starting a video call, you will also open a chat with the participant(s). You can see and close this chat after the video call on the "Chat"-page.'.translate(this.props.lang)}</div> */}
                                                                                    </div>
                                                                                </Button>
                                                                                {/* {
                                                                        !this.state.updateEvent?.meeting?.active && this.state.updateEvent?.meeting?.message ?
                                                                            <div className='button-tooltip-wrap'>
                                                                                {this.state.updateEvent.meeting.message?.translate(this.props.lang)}
                                                                            </div>
                                                                            :
                                                                            null
                                                                    } */}
                                                                            </FormGroup>
                                                                            :
                                                                            null
                                                                    }
                                                                </>

                                                                :

                                                                null
                                                        }

                                                        {
                                                            !this.state.updateEvent?.isColleagueEvent && this.state.previewReferral ?
                                                                <Button color='primary'
                                                                    style={{
                                                                        // marginRight: 10, marginLeft: 0

                                                                    }}
                                                                    onClick={() => this.setState({ openPreviewReferral: true })}>{'Case preview'.translate(this.props.lang)}</Button>

                                                                :
                                                                null
                                                        }
                                                        {
                                                            _showStatusHistoryButton ? <Button
                                                                color='primary'
                                                                style={{ padding: 6, paddingLeft: 12, paddingRight: 12 }}
                                                                onClick={() => {
                                                                    this.setState({ statusHistoryModal: _showStatusHistoryButton })
                                                                }}
                                                            >
                                                                {'View history'.translate(this.props.lang)}
                                                            </Button> : null
                                                        }
                                                        {
                                                            this.state.previewReferral?.journalNote ?
                                                                <Button
                                                                    color='primary'
                                                                    // style={{ marginTop: 10, marginBottom: 10 }}
                                                                    onClick={() => this.setState({ previewJournalNote: this.state.previewReferral?.journalNote })}
                                                                >
                                                                    {'Journal note'.translate(this.props.lang)}
                                                                </Button>
                                                                :
                                                                null
                                                        }
                                                    </div>
                                                    <div>
                                                        {/* {
                                                !this.state.updateEvent.additionalDoctor ? */}
                                                        <Button color='danger' style={{ marginRight: 10 }} onClick={() => /*this.setState({ updateEvent: !this.state.updateEvent, doctorsList: [] }, () => */this.checkForChanges()/*)*/}>{'Cancel'.translate(this.props.lang)}</Button>
                                                        {/* 
                                                    :
                                                    null
                                            } */}
                                                        {
                                                            !this.state.updateEvent?.isColleagueEvent && !this.state.updateEvent.additionalDoctor ?
                                                                <Button color='success' style={{ marginRight: 10 }} onClick={() => this.updateEvent(this.state.updateEvent)}>
                                                                    {/* {'Update'.translate(this.props.lang)} */}
                                                                    {this.state.loading ? /*'Processing...'.translate(this.props.lang)*/

                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                            <Player
                                                                                onEvent={() => {
                                                                                    if (!this.state.loading) this.stopAnimation();
                                                                                }}
                                                                                onStateChange={this.toggleVisibility}
                                                                                ref={this.player} // set the ref to your class instance
                                                                                autoplay={true}
                                                                                loop={true}
                                                                                controls={true}
                                                                                src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                                                                style={{ height: "20px", width: "30px" }}
                                                                            ></Player>
                                                                            {'Processing...'.translate(this.props.lang)}
                                                                        </div>

                                                                        : 'Save changes'.translate(this.props.lang)}
                                                                </Button>
                                                                :
                                                                null
                                                        }
                                                        {
                                                            this.state.updateEvent?.isMarkedAsDone ?
                                                                <Button style={{ marginRight: 10 }} onClick={() => {
                                                                    let updateEvent = this.state.updateEvent;
                                                                    updateEvent.isMarkedAsDone = false
                                                                    this.setState({
                                                                        updateEvent
                                                                    }, () => {
                                                                        this.updateEventIsDone(false, this.state.updateEvent?.id, this.state.doctor ? this.state.doctor : this.props.uData?._id)
                                                                    })
                                                                }} color='primary'>{'Mark as undone'.translate(this.props.lang)}</Button>
                                                                :
                                                                <Button style={{ marginRight: 10 }} onClick={() => {
                                                                    let updateEvent = this.state.updateEvent;
                                                                    updateEvent.isMarkedAsDone = true
                                                                    this.setState({
                                                                        updateEvent
                                                                    }, () => {
                                                                        this.updateEventIsDone(true, this.state.updateEvent?.id, this.state.doctor ? this.state.doctor : this.props.uData?._id)
                                                                    })
                                                                }} color='primary'>{'Mark as done'.translate(this.props.lang)}</Button>
                                                        }
                                                        {journalCuroflowEnable ?
                                                            this.state.updateEvent?.isMarkedForCheckIn ?
                                                                <Button color='primary' style={{ marginRight: 10 }} onClick={() => this.doctorCheckedEventFroPatient(false)}>{"Cancel check in".translate(this.props.lang)}</Button>
                                                                :
                                                                <Button color='primary' style={{ marginRight: 10 }} onClick={() => this.doctorCheckedEventFroPatient(true)}>{"Check in".translate(this.props.lang)}</Button>
                                                            :
                                                            null
                                                        }
                                                    </div>
                                                </>

                                        }




                                    </Col>
                                    <Col lg='12' style={{ marginTop: 15 }}>
                                        {
                                            this.state.updateEvent?.type === 'event' || true ?
                                                this.state.updateEvent?.tsCreated && this.state.updateEvent?.tsModified && this.state.updateEvent?.tsCreated !== this.state.updateEvent?.tsModified ?
                                                    <div className='info-message-update-wrap'>
                                                        {`${'Created on:'.translate(this.props.lang)} ${this.props.getStringDateTs(this.state.updateEvent?.tsCreated, `${this.props.dateFormat} HH:mm`)}. ${'Last update:'.translate(this.props.lang)} ${this.props.getStringDateTs(this.state.updateEvent?.tsModified, `${this.props.dateFormat} HH:mm`)}`}
                                                    </div>
                                                    :
                                                    this.state.updateEvent?.tsCreated ?
                                                        <div className='info-message-update-wrap'>
                                                            {`${'Created on:'.translate(this.props.lang)} ${this.props.getStringDateTs(this.state.updateEvent?.tsCreated, `${this.props.dateFormat} HH:mm`)}`}
                                                        </div>
                                                        :
                                                        null
                                                :
                                                null

                                        }
                                    </Col>

                                </Row>
                            </ModalBody>
                        </Modal>
                        : null
                }
                {
                    this.state.cancelVisitModal ?
                        <VisitCancellation
                            {...this.props}
                            isOpen={this.state.cancelVisitModal}
                            onClose={(refetchData = false, closeUpdateEvent = false) => {
                                let setObj = { cancelVisitModal: null };
                                if (closeUpdateEvent) {
                                    setObj.updateEvent = null;
                                    setObj.meetingParticipants = null;
                                    setObj.prevUpdateEvent = null;
                                    setObj.doctorsList = [];
                                    setObj.offerData = null;
                                }
                                this.setState(setObj, () => {
                                    if (refetchData) {
                                        this.get();
                                    }
                                })
                            }}
                            caseId={this.state.cancelVisitModal}
                        />
                        :
                        null
                }
                {
                    this.state.previewJournalNote ?
                        <Modal isOpen={this.state.previewJournalNote} centered>
                            <ModalHeader toggle={() => this.setState({ previewJournalNote: null })}>{'Journal note'.translate(this.props.lang)}</ModalHeader>
                            <ModalBody>
                                <div className="journal-note-preview-calendar-wrap">
                                    {
                                        this.state.previewJournalNote.map((note, i) => {
                                            return (
                                                <div className='journal-note-preview-item-wrap'>
                                                    <h6>{note?.title?.translate(this.props.lang)}</h6>
                                                    <p>{note?.content}</p>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </ModalBody>
                            <ModalFooter style={{ display: 'flex', justifyContent: 'flex-end' }} className='buttons-right-blue'>
                                <Button color='primary'
                                    onClick={() => {
                                        let text = '';
                                        for (let i = 0; i < this.state.previewJournalNote?.length; i++) {
                                            text += `${this.state.previewJournalNote[i]?.title?.translate(this.props.lang)}\n${this.state.previewJournalNote[i]?.content}`;
                                            if (i !== this.state.previewJournalNote.length - 1) {
                                                text += '\n\n';
                                            }

                                        }
                                        this.setState({ textCopied: true }, () => {
                                            if (this.copyTimeout) {
                                                clearTimeout(this.copyTimeout)
                                            }
                                            this.copyTimeout = setTimeout(() => {
                                                this.setState({ textCopied: false })
                                            }, 1200)
                                        })

                                        navigator.clipboard.writeText(text)

                                    }}
                                >
                                    {this.state.textCopied ? 'Text copied'.translate(this.props.lang) : 'Copy text'.translate(this.props.lang)}
                                </Button>
                                <Button color="primary" onClick={() => this.setState({ previewJournalNote: null })}> {'Close'.translate(this.props.lang)} </Button>

                            </ModalFooter>
                        </Modal>
                        : null
                }

                {
                    this.state.statusHistoryModal ? <ReferralStatusHistoryModal
                        isOpen={this.state.statusHistoryModal}
                        currency={this.props.currency}
                        onClose={() => this.setState({ statusHistoryModal: null })}
                        history={this.state.statusHistoryModal._id}
                        lang={this.props.lang}
                        country={this.props.country}
                        getStringDateTs={this.props.getStringDateTs}
                    /> : null
                }

                {
                    this.state.selectRevisitForm ?
                        <Modal isOpen={this.state.selectRevisitForm} size="lg" centered >
                            <ModalHeader toggle={() => this.setState({ selectRevisitForm: !this.state.selectRevisitForm })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ selectRevisitForm: !this.state.selectRevisitForm })}>&times;</button>}>{'Revisit forms'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody>
                                <div className="search-box-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <FormGroup>
                                        <Label>{'Search'.translate(this.props.lang)}</Label>
                                        <Input value={this.state.searchRevisitForm}
                                            onChange={(e) => {
                                                this.setState({ searchRevisitForm: striptags(e.target.value) }, () => this.getRevisitQuestionary())
                                            }}
                                        />
                                    </FormGroup>
                                    <Button color="primary" onClick={() => {
                                        if (this.state.revisitForms && this.state.revisitForms.items && this.state.revisitForms.items.length) {
                                            let revisitFormsSelect = [];
                                            let journalNoteForm = this.state.journalNoteForm ? this.state.journalNoteForm : null;
                                            for (let i = 0; i < this.state.revisitForms.items.length; i++) {
                                                revisitFormsSelect.push(this.state.revisitForms.items[i]._id)
                                                if (!journalNoteForm) {
                                                    journalNoteForm = this.state.revisitForms.items[i]._id;
                                                }
                                            }
                                            this.setState({ revisitFormsSelect, journalNoteForm })
                                        }
                                    }}>{'Mark all'.translate(this.props.lang)}</Button>
                                </div>
                                <div className="general-health-care-wrap">
                                    {
                                        this.state.revisitForms && this.state.revisitForms.items && this.state.revisitForms.items.map((item, idx) => {
                                            return (
                                                <div className="health-care-wrap">
                                                    <div className="content">
                                                        <div className="title">
                                                            {item.name}
                                                            <span>
                                                                &nbsp;&nbsp;/&nbsp;&nbsp;
                                                                {item.description}</span>
                                                        </div>

                                                    </div>
                                                    <div className='checkbox-wrap'>
                                                        <Checkbox
                                                            onChange={(e) => {
                                                                let val = e.target.checked;
                                                                let revisitFormsSelect = this.state.revisitFormsSelect;
                                                                let journalNoteForm = this.state.journalNoteForm ? this.state.journalNoteForm : null;
                                                                if (val && revisitFormsSelect.filter(el => el == item._id).length == 0) {
                                                                    revisitFormsSelect.push(item._id)
                                                                    if (!journalNoteForm) {
                                                                        journalNoteForm = item._id;
                                                                    }
                                                                } else if (!val && revisitFormsSelect.filter(el => el == item._id).length) {
                                                                    let index = revisitFormsSelect.findIndex(el => el == item._id)
                                                                    if (index > -1) {
                                                                        revisitFormsSelect.splice(index, 1)
                                                                    }
                                                                    if (journalNoteForm && journalNoteForm == item._id) {
                                                                        let check = null;
                                                                        if (revisitFormsSelect && revisitFormsSelect.filter(el => el != item._id).length) {
                                                                            check = revisitFormsSelect.filter(el => el != item._id)[0];
                                                                        }
                                                                        journalNoteForm = check;
                                                                    }
                                                                }
                                                                this.setState({
                                                                    revisitFormsSelect,
                                                                    journalNoteForm
                                                                })
                                                            }}
                                                            checked={this.state.revisitFormsSelect.filter(el => el == item._id).length ? true : false}
                                                        />
                                                        <div className='use-in-journal-notes-checkbox'>
                                                            {
                                                                this.state.revisitFormsSelect.filter(el => el == item._id).length ?
                                                                    <Checkbox
                                                                        label={'Use in Journal notes'.translate(this.props.lang)}
                                                                        onChange={(e) => {
                                                                            let val = e.target.checked;
                                                                            let journalNoteForm = this.state.journalNoteForm;
                                                                            if (val) {
                                                                                journalNoteForm = item._id;
                                                                            }
                                                                            this.setState({
                                                                                journalNoteForm
                                                                            })
                                                                        }}
                                                                        checked={this.state.journalNoteForm == item._id ? true : false}
                                                                    />
                                                                    :
                                                                    null
                                                            }
                                                        </div>


                                                    </div>


                                                </div>
                                            )
                                        })
                                    }
                                </div>


                            </ModalBody>

                            <ModalFooter style={{ display: 'flex', justifyContent: 'flex-end' }} className='buttons-right-blue'>
                                <Button color="primary" onClick={() => {
                                    let revisitFormsSelect = this.state.revisitFormsSelect;
                                    let journalNoteForm = this.state.journalNoteForm;
                                    this.setState({ selectRevisitForm: null, revisitFormsSelected: revisitFormsSelect, revisitFormsSelect: [], journalNoteFormSelected: journalNoteForm, journalNoteForm: null })
                                }}> {'Insert'.translate(this.props.lang)} </Button>
                                <Button color="primary" onClick={() => this.setState({ selectRevisitForm: null, revisitFormsSelect: [] })}> {'Cancel'.translate(this.props.lang)} </Button>

                            </ModalFooter>



                        </Modal>
                        :
                        null
                }
                {
                    this.state.selectVisitReason ?
                        <Modal isOpen={this.state.selectVisitReason} size="lg" centered >
                            <ModalHeader toggle={() => this.setState({ selectVisitReason: !this.state.selectVisitReason })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ selectVisitReason: !this.state.selectVisitReason })}>&times;</button>}>{'Visit reasons'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody>
                                <div className="search-box-wrap">
                                    <FormGroup>
                                        <Label>{'Search'.translate(this.props.lang)}</Label>
                                        <Input value={this.state.searchVisitReason}
                                            onChange={(e) => {
                                                this.setState({ searchVisitReason: striptags(e.target.value) }, () => this.getPriceList())
                                            }}
                                        />
                                    </FormGroup>
                                </div>
                                <div className="general-health-care-wrap">
                                    {
                                        this.state.visitReasons && this.state.visitReasons.items && this.state.visitReasons.items.sort((a, b) => {
                                            const nameA = a.name;
                                            const nameB = b.name;
                                            if (nameA < nameB) {
                                                return -1
                                            }
                                            if (nameA > nameB) {
                                                return 1
                                            }
                                        }).map((item, idx) => {
                                            return (
                                                <div className="health-care-wrap">
                                                    <div className="content">
                                                        <div className="title">
                                                            {item.name}
                                                            <span>
                                                                &nbsp;&nbsp;/&nbsp;&nbsp;
                                                                {item.description}</span>
                                                        </div>

                                                    </div>
                                                    <Button color='primary' onClick={() => {
                                                        let scheduleControl = this.state.scheduleControl;
                                                        scheduleControl.visitReasonName = item.name;
                                                        if (this.state.age && item.under18 && this.state.age < 18) {
                                                            scheduleControl.visitReasonPrice = 0;
                                                            scheduleControl.freePayment = 4
                                                        } else if (this.state.age && item.under20 && this.state.age < 20) {
                                                            scheduleControl.visitReasonPrice = 0;
                                                            scheduleControl.freePayment = 3
                                                        } else if (this.state.age && item.under23 && this.state.age < 23) {
                                                            scheduleControl.visitReasonPrice = 0;
                                                            scheduleControl.freePayment = 2
                                                        } else if (this.state.age && item.under18child && this.state.age < 18) {
                                                            scheduleControl.visitReasonPrice = 0;
                                                            scheduleControl.freePayment = 6
                                                        } else if (this.state.age && item.older85 && this.state.age > 85) {
                                                            scheduleControl.visitReasonPrice = 0;
                                                            scheduleControl.freePayment = 5
                                                        } else {
                                                            scheduleControl.visitReasonPrice = item.price;
                                                            // scheduleControl.paymentMethod = item.onlinePayment ? 3 : item.invoice ? 2 : item.paymentOnSite ? 1 : 0
                                                        }
                                                        scheduleControl._visitReasonPrice = Number(scheduleControl.visitReasonPrice);

                                                        scheduleControl.visiReason = item._id;
                                                        scheduleControl.visitReasonOnline = item.onlineVisit;
                                                        scheduleControl.videoCall = item.videoCall;
                                                        let setObj = { selectVisitReason: false, scheduleControl }
                                                        let revisitFormsSelected = [];
                                                        let journalNoteFormSelected = null;

                                                        if (enterprise && item && item.defaultForm && this.state.revisitForms && this.state.revisitForms.items?.filter(el => el._id === item.defaultForm).length) {
                                                            revisitFormsSelected.push(item.defaultForm);
                                                            journalNoteFormSelected = item.defaultForm;

                                                        }
                                                        setObj.journalNoteFormSelected = journalNoteFormSelected;
                                                        setObj.revisitFormsSelected = revisitFormsSelected;
                                                        this.setState(setObj)
                                                    }}>{'Select'.translate(this.props.lang)}</Button>

                                                </div>
                                            )
                                        })
                                    }
                                </div>


                            </ModalBody>

                            <ModalFooter style={{ display: 'flex', justifyContent: 'flex-end' }}>

                                <Button color="primary" onClick={() => this.setState({ selectVisitReason: null })}> {'Close'.translate(this.props.lang)} </Button>

                            </ModalFooter>



                        </Modal>
                        :
                        null
                }
                {
                    this.state.doctorsModal ?
                        <Modal isOpen={this.state.doctorsModal} centered toggle={() => this.setState({ doctorsModal: !this.state.doctorsModal })} >
                            <ModalHeader toggle={() => this.setState({ doctorsModal: !this.state.doctorsModal })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ doctorsModal: !this.state.doctorsModal })}><Isvg src={xIcon} /></button>}>{'Choose doctors'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody className="run-modal">

                                {
                                    this.state.doctors && this.state.doctors.length && this.state.doctors.filter((item) => {
                                        if (this.props.uData._id && item._id != (this.state.doctor ? this.state.doctor : this.props.uData._id)) {
                                            return true;
                                        } else {
                                            return false;
                                        }
                                    }).length ?
                                        <FormGroup >
                                            <Label>{'Search'.translate(this.props.lang)}</Label>
                                            <Input type='text' value={this.state.filterDoctors ? this.state.filterDoctors : ''} onChange={(e) => {
                                                this.setState({
                                                    filterDoctors: e.target.value
                                                })
                                            }} />

                                        </FormGroup>
                                        :
                                        null
                                }

                                <FormGroup /*className="form-group-checkbox"*/>
                                    {
                                        this.state.doctors && this.state.doctors.length && this.state.doctors.filter((item) => {
                                            if (this.props.uData._id && item._id != (this.state.doctor ? this.state.doctor : this.props.uData._id)) {
                                                return true;
                                            } else {
                                                return false;
                                            }
                                        }).length ?
                                            <DoctorListComponent

                                                value={this.state.doctorsList ? this.state.doctorsList : []}
                                                values={this.state.doctors.filter(el =>
                                                    (!this.state.updateEvent || (this.state.updateEvent && this.state.updateEvent.patientId != el._id))
                                                    && (!this.state.scheduleReferral || (this.state.scheduleReferral && this.state.referralId && this.state.referrals.filter(ref => ref._id == this.state.referralId) && this.state.referrals.filter(ref => ref._id == this.state.referralId)[0] && this.state.referrals.filter(ref => ref._id == this.state.referralId)[0].patientId != el._id))
                                                    && (!this.state.scheduleControl || (this.state.scheduleControl && this.state.scheduleControl.patient != el._id))
                                                ).sort((a, b) => {
                                                    const nameA = a.name;
                                                    const nameB = b.name;
                                                    if (nameA < nameB) {
                                                        return -1
                                                    }
                                                    if (nameA > nameB) {
                                                        return 1
                                                    }
                                                }).filter(doc => doc._id !== (this.state.doctor ? this.state.doctor : this.props.uData._id) && doc.name.toLowerCase().indexOf(this.state.filterDoctors ? this.state.filterDoctors.toLowerCase() : ' ') != -1).map(item => {
                                                    return ({
                                                        name: item?.userData?.title && item?.userData.name ? `${this.props.formatName(item?.userData?.title, item?.userData?.name)}` : item.name,
                                                        value: item._id,
                                                        profilePicture: item.profilePicture,
                                                        username: item.username
                                                    })
                                                })}
                                                onChange={(item) => {
                                                    let doctorsList = this.state.doctorsList;
                                                    doctorsList = [...item]
                                                    this.setState({ doctorsList })
                                                }}
                                            />

                                            :
                                            "The doctor's list is empty".translate(this.props.lang)
                                    }
                                </FormGroup>


                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                {
                                    this.state.doctors && this.state.doctors.length && this.state.doctors.filter((item) => {
                                        if (this.props.uData._id && item._id != (this.state.doctor ? this.state.doctor : this.props.uData._id)) {
                                            return true;
                                        } else {
                                            return false;
                                        }
                                    }).length ?
                                        <Button color='primary'
                                            // disabled={this.state.doctorsList && this.state.doctorsList.length > 0 ? false : true}
                                            onClick={() =>
                                                this.checkDoctorsAvailable(this.state.doctorsList, this.state.doctorsModal)
                                            }>{'Add'.translate(this.props.lang)}</Button>
                                        :
                                        null
                                }
                                <Button color='primary' onClick={() => {
                                    // console.log(this.state.doctorsList)
                                    // console.log(this.state.updateEvent.additionalDoctors)
                                    this.setState({ doctorsModal: false })
                                }
                                }>{"Close".translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.successfullyAdditionalDoctors ?
                        <InfoModal
                            isOpen={this.state.successfullyAdditionalDoctors}
                            toggle={() => this.setState({ successfullyAdditionalDoctors: !this.state.successfullyAdditionalDoctors })}
                            header={'Info'.translate(this.props.lang)}
                            info={`All doctors were successfully added`.translate(this.props.lang)}
                            buttons={[
                                <Button color="primary" style={{ margin: 10 }} onClick={() => this.setState({ successfullyAdditionalDoctors: false })}>{'Ok'.translate(this.props.lang)}</Button>,
                                // <Button color="primary" style={{ margin: 10 }} onClick={() => this.setState({ cancelCostModal: false })}>{'Cancel'.translate(this.props.lang)}</Button>

                            ]}

                        />
                        :
                        null
                }
                {
                    this.state.noSearchResults ?
                        <InfoModal
                            isOpen={this.state.noSearchResults}
                            toggle={() => this.setState({ noSearchResults: !this.state.noSearchResults })}
                            header={'Info'.translate(this.props.lang)}
                            info={<>{this.state.noSearchResults} <br /> {this.state.searchText}</>}
                            buttons={[
                                <Button color="primary" style={{ margin: 10 }} onClick={() => this.setState({ noSearchResults: false })}>{'Ok'.translate(this.props.lang)}</Button>,
                                // <Button color="primary" style={{ margin: 10 }} onClick={() => this.setState({ cancelCostModal: false })}>{'Cancel'.translate(this.props.lang)}</Button>

                            ]}

                        />
                        :
                        null
                }
                {
                    this.state.closeCaseActionModal ?
                        <ErrorModalV2
                            isOpen={this.state.closeCaseActionModal}
                            modalFooterClassName={'modal-footer-buttons-wrap'}
                            buttons={[
                                {
                                    text: 'Close case and keep calendar post'.translate(this.props.lang),
                                    onClick: () => {
                                        const data = this.state.closeCaseActionModal?.data;
                                        const func = this.state.closeCaseActionModal?.function;
                                        this.setState({ closeCaseActionModal: false }, () => {
                                            if (func === 'closeReferral') {
                                                this.closeReferral(data, 'keepCalendarPost');
                                            }
                                        })
                                    }
                                },
                                {
                                    text: 'Close case and delete calendar post'.translate(this.props.lang),
                                    onClick: () => {
                                        const data = this.state.closeCaseActionModal?.data;
                                        const func = this.state.closeCaseActionModal?.function;
                                        this.setState({ closeCaseActionModal: false }, () => {
                                            if (func === 'closeReferral') {
                                                this.closeReferral(data, 'deleteCalendarPost');
                                            }
                                        })
                                    }
                                },
                                {
                                    text: 'Cancel'.translate(this.props.lang),
                                    onClick: () => {
                                        this.setState({ closeCaseActionModal: false })
                                    }
                                }
                            ]}
                        >
                            {'Do you also want to delete the calendar post?'.translate(this.props.lang)}
                        </ErrorModalV2>
                        :
                        null
                }
                {
                    this.state.errorAdditionalDoctors ?

                        <ErrorModal lang={this.props.lang}
                            isOpen={this.state.errorAdditionalDoctors}
                            toggle={() => {
                                // let newDoctorList = this.state.doctorsList;
                                // if (newDoctorList && newDoctorList.length) {
                                //     for (let i = 0; i < newDoctorList.length; i++) {
                                //         if (this.state.errorAdditionalDoctors && this.state.errorAdditionalDoctors.length && this.state.errorAdditionalDoctors.filter(item => item.doctorId == newDoctorList[i] && !item.available).length) {
                                //             let index = newDoctorList.indexOf(newDoctorList[i]);
                                //             if (index > -1) {
                                //                 newDoctorList.splice(index, 1);
                                //             }
                                //         }
                                //     }
                                // }

                                // this.setState({ doctorsList: newDoctorList }, () => this.setState({ errorAdditionalDoctors: null }))

                                this.setState({ errorAdditionalDoctors: null })
                            }}

                        >
                            {
                                this.state.errorAdditionalDoctors && this.state.errorAdditionalDoctors.map((item, idx) => {
                                    return (
                                        <div>
                                            <span style={{ fontWeight: 600 }}>
                                                {item.doctorName}  {' - '}
                                            </span>

                                            {
                                                item.available ?
                                                    <span style={{ color: 'green' }}>{'Available'.translate(this.props.lang)}</span>
                                                    :
                                                    <span style={{ color: 'red' }}>{'Unavailable'.translate(this.props.lang)}</span>
                                            }

                                        </div>
                                    )
                                })

                            }
                        </ErrorModal>
                        :
                        null
                }
                {
                    this.state.conversationModal ?
                        <Modal isOpen={this.state.conversationModal} centered toggle={() => this.setState({ conversationModal: !this.state.conversationModal })} >
                            <ModalHeader>
                                <h4>{'Start conversation or enter existing conversation'.translate(this.props.lang)}</h4>
                            </ModalHeader>
                            <ModalBody>
                                {this.state.conversationModal.conversations.length ?
                                    <>
                                        <h6>{'Existing conversations'.translate(this.props.lang)}</h6>
                                        <Table responsive>
                                            <thead>
                                                <tr>
                                                    <th>{'Conversation name'.translate(this.props.lang)}</th>
                                                    <th>{'Clinic doctor'.translate(this.props.lang)}</th>
                                                    <th>{'Patient'.translate(this.props.lang)}</th>
                                                    <th>{'Action'.translate(this.props.lang)}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.conversationModal.conversations.map((item, idx) => {
                                                        return (
                                                            <tr>
                                                                <td>{item.name}</td>

                                                                <td><Checkbox checked={item._doctorIncludedInConversation} /></td>
                                                                <td><Checkbox checked={item._patientIncludedInConversation} /></td>
                                                                <td>
                                                                    <Link to={`/chat?conversation=${item._id}`}>< Isvg src={openChat} style={{ width: 21 }} /></Link>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }

                                            </tbody>
                                        </Table>
                                    </>
                                    :
                                    null
                                }

                                <h6>{'New conversation:'.translate(this.props.lang)}</h6>

                                <FormGroup>
                                    <Button size="sm" color="primary" onClick={() => {
                                        this.conversation(this.state.conversationModal._id, { ...this.state.conversationForm, patient: true });
                                    }}>{'Start new conversation'.translate(this.props.lang)}</Button>
                                </FormGroup>

                            </ModalBody>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.conversationControlModal ?
                        <Modal isOpen={this.state.conversationControlModal} centered toggle={() => this.setState({ conversationControlModal: !this.state.conversationControlModal })} >
                            <ModalHeader>
                                <h4>{'Start conversation'.translate(this.props.lang)}</h4>
                            </ModalHeader>
                            <ModalBody>


                                <h6>{'New conversation:'.translate(this.props.lang)}</h6>

                                <FormGroup>
                                    <Button size="sm" color="primary" onClick={() => {
                                        this.controlConversation(this.state.conversationControlModal.id, { ...this.state.conversationForm, patient: true });
                                    }}>{'Start new conversation'.translate(this.props.lang)}</Button>
                                </FormGroup>

                            </ModalBody>
                        </Modal>
                        :
                        null
                }

                {
                    this.state.leaveCaseModal ?
                        <Modal isOpen={this.state.leaveCaseModal} centered >
                            {/* <ModalHeader style={{ margin: 'auto' }}>{'Warning'.translate(this.props.lang)}</ModalHeader> */}
                            <ModalBody className="delete-modal">
                                {/* <img src={warrning} /> */}
                                <div className='message'>
                                    {'Do you want to leave the case'.translate(this.props.lang)}
                                </div>



                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button color='primary' style={{ margin: 10, minWidth: 100 }} onClick={() => this.leaveCase(this.state.updateEvent)}>
                                    {'Yes'.translate(this.props.lang)}
                                </Button>
                                <Button color='primary' style={{ margin: 10, minWidth: 100 }} onClick={() => this.setState({ leaveCaseModal: !this.state.leaveCaseModal })}>{'No'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>

                        : null
                }
                {
                    this.state.noteToPatientPreScheduleInfo ?
                        <Modal isOpen={this.state.noteToPatientPreScheduleInfo} centered >
                            <ModalBody className="delete-modal">
                                <div className='message'>{'Are you sure you also want to send the note as a notification? Depending on the content of your note and your settings, sensitive information might be shared via SMS/email/push.'.translate(this.props.lang)}</div>
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button color='primary' style={{ margin: 10, minWidth: 100 }}
                                    disabled={this.state.loading}
                                    onClick={() => {
                                        const data = this.state.noteToPatientPreScheduleInfo?.data;
                                        if (data) {
                                            this.setState({ noteToPatientPreScheduleInfo: null }, () => {
                                                this.scheduleControl(data, true)
                                            });
                                        }
                                    }}>
                                    {this.state.loading ? /*'Processing...'.translate(this.props.lang)*/

                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Player
                                                onEvent={() => {
                                                    if (!this.state.loading) this.stopAnimation();
                                                }}
                                                onStateChange={this.toggleVisibility}
                                                ref={this.player} // set the ref to your class instance
                                                autoplay={true}
                                                loop={true}
                                                controls={true}
                                                src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                                style={{ height: "20px", width: "30px" }}
                                            ></Player>
                                            {'Processing...'.translate(this.props.lang)}
                                        </div>

                                        : 'Continue'.translate(this.props.lang)}
                                </Button>
                                <Button color='primary' style={{ margin: 10, minWidth: 100 }} onClick={() => {
                                    this.setState({
                                        noteToPatientPreScheduleInfo: !this.state.noteToPatientPreScheduleInfo,
                                        creatingEvent: false
                                    })
                                }}>{'Go back'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>

                        : null
                }
                {
                    this.state.errorOverlap ?
                        <Modal isOpen={this.state.errorOverlap} centered >
                            <ModalBody className="delete-modal">
                                <div className='message'>{'Bookings in your calendar already exist for the selected period'.translate(this.props.lang)}</div>
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button color='primary' style={{ margin: 10, minWidth: 100 }}
                                    disabled={this.state.loading || this.state.loadingScheduleEvent}
                                    onClick={() => {
                                        const data = this.state.errorOverlap?.data;
                                        const _data = this.state.errorOverlap?._data;
                                        const updateAllRecurringEvents = this.state.errorOverlap?.updateAllRecurringEvents;
                                        if (data) {
                                            this.updateEventTypeEvent(data, updateAllRecurringEvents, true)
                                        } else if (_data) {
                                            this.scheduleEvent(_data, true)
                                        }
                                    }}>
                                    {this.state.loading ? /*'Processing...'.translate(this.props.lang)*/

                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Player
                                                onEvent={() => {
                                                    if (!this.state.loading) this.stopAnimation();
                                                }}
                                                onStateChange={this.toggleVisibility}
                                                ref={this.player} // set the ref to your class instance
                                                autoplay={true}
                                                loop={true}
                                                controls={true}
                                                src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                                style={{ height: "20px", width: "30px" }}
                                            ></Player>
                                            {'Processing...'.translate(this.props.lang)}
                                        </div>

                                        : 'Continue anyways'.translate(this.props.lang)}
                                </Button>
                                <Button color='primary' style={{ margin: 10, minWidth: 100 }} onClick={() => {
                                    this.setState({
                                        errorOverlap: !this.state.errorOverlap,
                                        updateEventModal: null,
                                        updateEvent: null,
                                        meetingParticipants: null,
                                        offerData: null,
                                        prevUpdateEvent: null,
                                        schedulePatientTime: null,
                                        loading: false,
                                        doctorsList: []

                                    })
                                }}>{'Go back'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>

                        : null
                }
                {
                    this.state.warningModal ?
                        <Modal isOpen={this.state.warningModal} centered >
                            {/* <ModalHeader style={{ margin: 'auto' }}>{'Warning'.translate(this.props.lang)}</ModalHeader> */}
                            <ModalBody className="delete-modal">
                                {/* <img src={warrning} /> */}
                                {this.state.warningModal.title == 'Free time'.translate(this.props.lang) ?
                                    <div className='message'>{'Do you really want to delete the scheduled time? In that case, do not forget to book a new one!'.translate(this.props.lang)}</div>
                                    :
                                    <div className='message'>{'Do you really want to delete the booked time? In that case, do not forget to book a new one!'.translate(this.props.lang)}</div>
                                }



                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button color='primary' style={{ margin: 10, minWidth: 100 }} onClick={() => this.deleteEvent(this.state.warningModal)}>
                                    {this.state.loading ? /*'Processing...'.translate(this.props.lang)*/

                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Player
                                                onEvent={() => {
                                                    if (!this.state.loading) this.stopAnimation();
                                                }}
                                                onStateChange={this.toggleVisibility}
                                                ref={this.player} // set the ref to your class instance
                                                autoplay={true}
                                                loop={true}
                                                controls={true}
                                                src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                                style={{ height: "20px", width: "30px" }}
                                            ></Player>
                                            {'Processing...'.translate(this.props.lang)}
                                        </div>

                                        : 'Cancel time'.translate(this.props.lang)}
                                </Button>
                                <Button color='primary' style={{ margin: 10, minWidth: 100 }} onClick={() => this.setState({ warningModal: !this.state.warningModal })}>{'Cancel'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>

                        : null
                }

                {
                    this.state.wrongDate ?
                        <Modal isOpen={this.state.wrongDate} centered>
                            {/* <ModalHeader style={{ margin: 'auto' }}>
                                {'Warning'.translate(this.props.lang)}
                            </ModalHeader> */}
                            <ModalBody className="delete-modal">
                                {/* <img src={warrning} /> */}
                                <p className='message'>{'You can not pick date form the past'.translate(this.props.lang)}</p>
                            </ModalBody>
                            <ModalFooter className="buttons-right-blue">
                                <Button style={{ minWidth: 100 }} color='primary' onClick={() => this.setState({ wrongDate: !this.state.wrongDate })}>{'Pick again'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        : null
                }

                {
                    this.state.wrongInput ?
                        <Modal isOpen={this.state.wrongInput} toggle={() => this.setState({ wrongInput: !this.state.wrongInput })} centered>
                            {/* <ModalHeader>
                                <h4></h4>
                            </ModalHeader> */}
                            <ModalBody className='delete-modal'>
                                <p>{'Wrong input'.translate(this.props.lang)}</p>
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button style={{ minWidth: 100 }} onClick={() => this.setState({ wrongInput: !this.state.wrongInput, scheduleModal: !this.state.scheduleModal })}>{'Pick again'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>

                        : null
                }
                {
                    this.state.errorPatientNotFound ?
                        <Modal isOpen={this.state.errorPatientNotFound} toggle={() => this.setState({ errorPatientNotFound: !this.state.errorPatientNotFound })} centered>
                            <ModalHeader style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                {'Patient not found'.translate(this.props.lang)}
                            </ModalHeader>
                            <ModalBody className='delete-modal'>
                                <p>{this.state.errorPatientNotFound}</p>
                            </ModalBody>
                            <ModalFooter style={{ justifyContent: 'center' }}>
                                <Button style={{ minWidth: 100 }} className={'danger-button'} onClick={() => this.setState({ errorPatientNotFound: !this.state.errorPatientNotFound })}>{'Cancel'.translate(this.props.lang)}</Button>
                                <Button style={{ minWidth: 100 }} color='primary' onClick={() => {
                                    let setObj = { errorPatientNotFound: !this.state.errorPatientNotFound, registerNewPatientModal: { language: this.state.languages && this.state.languages[0] && this.state.languages[0]._id, socialSecurityNumber: this.state.patientSocialSecurityNumber, twoFactorAuthenticationEnabled: this.props.country === 'uk' ? true : false } }
                                    let countryStateDict = this.state.countryStateDict ?? {};
                                    if (countryStateDict['search-ssn']) {
                                        countryStateDict['socialSecurityNumber'] = countryStateDict['search-ssn']
                                        setObj.countryStateDict = countryStateDict
                                    }

                                    this.setState(setObj, () => {
                                        this.checkSSN(this.state.patientSocialSecurityNumber)
                                    })
                                }}>{'Register a new patient'.translate(this.props.lang)}</Button>

                            </ModalFooter>
                        </Modal>

                        : null
                }

                {
                    this.state.registerNewPatientModal ?
                        <FormBuilder
                            selectedGroup={this.props.selectedGroup}
                            selectedClinic={this.props.selectedClinic}
                            countryTwoLetter={this.props.countryTwoLetter}
                            country={this.props.country} dateFormat={this.props.dateFormat}
                            getStringDateTs={this.props.getStringDateTs}
                            onSubmit={(data) => {
                                if (!this.state.ssnExistInThisGroup) {
                                    this.checkPatientValidations(data)
                                } else {
                                    this.setState({ registerNewPatientModal: null, ssnExistInThisGroup: null, socialSecurityNumberExist: null, needsParent: null, hasParent: null })
                                }

                            }}
                            initialValues={this.state.registerNewPatientModal}
                            size="lg"
                            isOpen={this.state.registerNewPatientModal}
                            toggle={() => this.setState({ registerNewPatientModal: null, age: null, ssnExistInThisGroup: null, socialSecurityNumberExist: null, needsParent: null, hasParent: null })}
                            title={this.state.registerNewPatientModal._id ? 'Edit patient'.translate(this.props.lang) : 'Register a new patient'.translate(this.props.lang)}
                            _saving={this.state._saving}
                            buttonConfirmText={'Saved'.translate(this.props.lang)}
                            buttonText={!this.state.ssnExistInThisGroup ? 'Save and send confirmation'.translate(this.props.lang) : 'Close'.translate(this.props.lang)}

                            lang={this.props.lang}
                            fields={[
                                {
                                    type: 'row',
                                    children: [
                                        {
                                            type: 'col',
                                            width: {
                                                lg: 6,
                                                sm: 12,
                                                xs: 12
                                            },
                                            children: [
                                                {
                                                    type: 'socialSecurityNumber',
                                                    name: 'socialSecurityNumber',
                                                    label: this.props.country === 'uk' ? "Date of birth".translate(this.props.lang) : 'Social security number'.translate(this.props.lang),
                                                    disableNewPatientBtn: true,
                                                    hideFindChildren: true,
                                                    // searchByNameAndEmailFormBuilder: this.props.country === 'uk' ? true : false,
                                                    disabled: patientInfoSettings?.isCustomIdEnabled ? false : true,
                                                    defaultCountry: this.state.countryStateDict?.['socialSecurityNumber'] ?? this.props.country,
                                                    getCountryState: (countryState) => {
                                                        let countryStateDict = this.state.countryStateDict ?? {};
                                                        countryStateDict['socialSecurityNumber'] = countryState;
                                                        this.setState({ countryStateDict })
                                                    },
                                                    validate: [required('Social security number is required!'.translate(this.props.lang)), checkSocialSecurityNumber('Social security number is not valid!'.translate(this.props.lang), this.state.countryStateDict?.['socialSecurityNumber'] ?? this.props.country)]

                                                },
                                            ]
                                        },
                                        patientInfoSettings?.isCustomIdEnabled ?
                                            {
                                                type: "col",
                                                width: {
                                                    lg: 6,
                                                    sm: 12,
                                                    xs: 12,
                                                },
                                                children: [
                                                    {
                                                        type: 'customId',
                                                        name: `customId.${this.props.selectedGroup}`,
                                                        label: patientInfoSettings?.customIdLabel ? patientInfoSettings?.customIdLabel : 'Custom id'.translate(this.props.lang),
                                                        labelInfo: patientInfoSettings?.customIdInfoText ?? null,
                                                        // validate: patientInfoSettings?.isCustomIdRequired ? [required((patientInfoSettings?.customIdLabel + ' ' + 'is required!'.translate(this.props.lang)) ?? 'Custom id is required!'.translate(this.props.lang))] : [],
                                                    },
                                                ],
                                            }
                                            :
                                            null,
                                        this.props.showDateOfBirth ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 4,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'date-of-birth',
                                                        dateFormat: this.props.dateFormat,
                                                        name: 'dateOfBirth.date',
                                                        disabled: this.state.disabledDateOfBirth,
                                                        label: 'Date of birth'.translate(this.props.lang),
                                                        validate: [required('Date of birth is required!'.translate(this.props.lang)), dateValidate('Invalid date!'.translate(this.props.lang))]

                                                    },
                                                ]
                                            } : null,
                                        this.state.socialSecurityNumberExist && !this.state.ssnExistInThisGroup ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 12,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'h6',
                                                        text: 'The user already exists in the system'.translate(this.props.lang),
                                                        style: { marginBottom: 20 }
                                                    },
                                                ]
                                            } : { type: 'empty' },
                                        this.state.socialSecurityNumberExist && this.state.ssnExistInThisGroup ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 12,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'h6',
                                                        text: "The user is already registered within your clinic group".translate(this.props.lang),
                                                        style: { marginBottom: 20 }
                                                    },
                                                ]
                                            } : { type: 'empty' },

                                        !this.state.socialSecurityNumberExist /*|| (isChild && this.state.socialSecurityNumberExist)*/ ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 6,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'gender',
                                                        name: 'userData.sex',
                                                        labelInfo: "The patient's biological sex is needed for proper treatment".translate(this.props.lang),
                                                        // label: 'Sex'.translate(this.props.lang),
                                                        disabled: this.state.socialSecurityNumberExist && !this.state.ssnExistInThisGroup ? true : false,
                                                        // values: [{ value: 0, name: 'Select'.translate(this.props.lang) }, { value: 'male', name: 'Male'.translate(this.props.lang) }, { value: 'female', name: 'Female'.translate(this.props.lang) }],
                                                        groupData: this.state.clinicGroupSettings,
                                                        validate: [validateGender(this.state.clinicGroupSettings?.patientInfoSettings?.canHaveOtherGender === true, this.props.lang)]
                                                    },
                                                ]
                                            } : { type: 'empty' },
                                        !this.state.socialSecurityNumberExist /*|| (isChild && this.state.socialSecurityNumberExist)*/ ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: this.props.showDateOfBirth ? this.props.secondaryLanguageDisabled ? 6 : 4 : this.props.secondaryLanguageDisabled ? 12 : 8,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'text',
                                                        name: 'userData.name',
                                                        label: 'First and last name'.translate(this.props.lang),
                                                        disabled: this.state.socialSecurityNumberExist && !this.state.ssnExistInThisGroup ? true : false,
                                                        validate: [required('Name is required!'.translate(this.props.lang))]
                                                    },
                                                ]
                                            } : { type: 'empty' },
                                        isChild ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 12,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'h6',
                                                        style: { color: 'red', marginBottom: 20 },
                                                        text: msg,
                                                    },
                                                ]
                                            } : { type: 'empty' },
                                        (!this.state.socialSecurityNumberExist || (this.state.socialSecurityNumberExist && this.state.needsParent && !this.state.hasParent)) && isChild /*|| (isChild && this.state.socialSecurityNumberExist)*/ ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 12,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'h6',
                                                        style: { marginBottom: 20 },
                                                        text: 'Register parent or legal guardian'.translate(this.props.lang),
                                                    },
                                                ]
                                            } : { type: 'empty' },
                                        (!this.state.socialSecurityNumberExist || (this.state.socialSecurityNumberExist && this.state.needsParent && !this.state.hasParent)) && isChild /*|| (isChild && this.state.socialSecurityNumberExist)*/ ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 8,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'socialSecurityNumber',
                                                        name: 'socialSecurityNumberParent',
                                                        hideFindChildren: true,
                                                        disableNewPatientBtn: true,
                                                        searchByNameAndEmailFormBuilder: this.state.socialSecurityNumberExist && !this.state.ssnExistInThisGroup ? false : true,
                                                        label: this.props.country === 'uk' ? "Date of birth".translate(this.props.lang) : 'Social security number'.translate(this.props.lang),
                                                        disabled: this.state.socialSecurityNumberExist && !this.state.ssnExistInThisGroup && (!this.state.needsParent || (this.state.needsParent && this.state.hasParent)) ? true : false,
                                                        getCountryState: (countryState) => {
                                                            let countryStateDict = this.state.countryStateDict ?? {};
                                                            countryStateDict['socialSecurityNumberParent'] = countryState;
                                                            this.setState({ countryStateDict })
                                                        },
                                                        validate: [required('Social security number is required!'.translate(this.props.lang)), checkSocialSecurityNumber('Social security number is not valid!'.translate(this.props.lang), this.state.countryStateDict?.['socialSecurityNumberParent'] ?? this.props.country)]
                                                    },
                                                ]
                                            } : { type: 'empty' },
                                        (!this.state.socialSecurityNumberExist || (this.state.socialSecurityNumberExist && this.state.needsParent && !this.state.hasParent)) && isChild && patientInfoSettings?.isCustomIdEnabled ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 8,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'customId',
                                                        name: `customIdParent.${this.props.selectedGroup}`,
                                                        label: patientInfoSettings?.customIdLabel ? patientInfoSettings?.customIdLabel : 'Custom id'.translate(this.props.lang),
                                                        labelInfo: patientInfoSettings?.customIdInfoText ?? null,
                                                        // validate: patientInfoSettings?.isCustomIdRequired ? [required((patientInfoSettings?.customIdLabel + ' ' + 'is required!'.translate(this.props.lang)) ?? 'Custom id is required!'.translate(this.props.lang))] : [],
                                                    },
                                                ],
                                            } : { type: 'empty' },
                                        isChild && this.props.showDateOfBirth ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 4,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'date-of-birth',
                                                        name: 'dateOfBirthParent.date',
                                                        disabled: this.state.disabledDateOfBirthParent,
                                                        label: 'Date of birth'.translate(this.props.lang),
                                                        validate: [required('Date of birth is required!'.translate(this.props.lang)), dateValidate('Invalid date!'.translate(this.props.lang))]

                                                    },
                                                ]
                                            } : { type: 'empty' },
                                        (!this.state.socialSecurityNumberExist || (this.state.socialSecurityNumberExist && this.state.needsParent && !this.state.hasParent)) && isChild /*|| (isChild && this.state.socialSecurityNumberExist)*/ ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 4,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'select',
                                                        name: 'sexParent',
                                                        label: 'Sex'.translate(this.props.lang),
                                                        disabled: this.state.socialSecurityNumberExist && !this.state.ssnExistInThisGroup && (!this.state.needsParent || (this.state.needsParent && this.state.hasParent)) ? true : false,
                                                        values: [{ value: 0, name: 'Select'.translate(this.props.lang) }, { value: 'male', name: 'Male'.translate(this.props.lang) }, { value: 'female', name: 'Female'.translate(this.props.lang) }],
                                                    },
                                                ]
                                            } : { type: 'empty' },
                                        (!this.state.socialSecurityNumberExist || (this.state.socialSecurityNumberExist && this.state.needsParent && !this.state.hasParent)) && isChild /*|| (isChild && this.state.socialSecurityNumberExist)*/ ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: this.props.showDateOfBirth ? this.props.secondaryLanguageDisabled ? 6 : 4 : this.props.secondaryLanguageDisabled ? 12 : 8,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'text',
                                                        name: 'nameParent',
                                                        label: 'First and last name'.translate(this.props.lang),
                                                        disabled: this.state.socialSecurityNumberExist && !this.state.ssnExistInThisGroup && (!this.state.needsParent || (this.state.needsParent && this.state.hasParent)) ? true : false,
                                                        validate: [required('Name is required!'.translate(this.props.lang))]


                                                    },
                                                ]
                                            } : { type: 'empty' },
                                        ((!this.state.socialSecurityNumberExist || (this.state.socialSecurityNumberExist && this.state.needsParent && !this.state.hasParent)) /*|| (isChild && this.state.socialSecurityNumberExist)*/) && !this.props.secondaryLanguageDisabled ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 4,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'select',
                                                        name: 'language',
                                                        label: 'Language'.translate(this.props.lang),
                                                        disabled: this.state.socialSecurityNumberExist && !this.state.ssnExistInThisGroup && (!this.state.needsParent || (this.state.needsParent && this.state.hasParent)) ? true : false,
                                                        values: this.state.languages.map(item => { return { name: item.name?.translate(this.props.lang), value: item._id } })
                                                    },
                                                ]
                                            } : { type: 'empty' },

                                        (!this.state.socialSecurityNumberExist || (this.state.socialSecurityNumberExist && this.state.needsParent && !this.state.hasParent)) /*|| (isChild && this.state.socialSecurityNumberExist)*/ ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 6,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'text',
                                                        name: 'email',
                                                        label: 'Email address'.translate(this.props.lang),
                                                        disabled: this.state.socialSecurityNumberExist && !this.state.ssnExistInThisGroup && (!this.state.needsParent || (this.state.needsParent && this.state.hasParent)) ? true : false,
                                                        validate: this.props.twoFactorAuthenticationEnabled && this.state.clinicGroupSettings?.useOnlyEmailFor2fa ? [required('This field is required!'.translate(this.props.lang))] : []
                                                    },
                                                ]
                                            } : { type: 'empty' },
                                        (!this.state.socialSecurityNumberExist || (this.state.socialSecurityNumberExist && this.state.needsParent && !this.state.hasParent)) /*|| (isChild && this.state.socialSecurityNumberExist)*/ ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 6,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'phone',

                                                        name: 'phone',
                                                        label: 'Phone'.translate(this.props.lang),
                                                        disabled: this.state.socialSecurityNumberExist && !this.state.ssnExistInThisGroup && (!this.state.needsParent || (this.state.needsParent && this.state.hasParent)) ? true : false,
                                                        // validate: this.props.twoFactorAuthenticationEnabled ? [required('When two factor authentication is enabled, both email and phone number are required!'.translate(this.props.lang))] : []
                                                    },
                                                ]
                                            } : { type: 'empty' },
                                        // ---

                                        (!this.state.socialSecurityNumberExist || (this.state.socialSecurityNumberExist && this.state.needsParent && !this.state.hasParent)) && isChild /*|| (isChild && this.state.socialSecurityNumberExist)*/ ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 12,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'h6',
                                                        style: { marginBottom: 20 },
                                                        text: 'Register second parent or legal guardian'.translate(this.props.lang),
                                                    },
                                                ]
                                            } : { type: 'empty' },
                                        (!this.state.socialSecurityNumberExist || (this.state.socialSecurityNumberExist && this.state.needsParent && !this.state.hasParent)) && isChild/*|| (isChild && this.state.socialSecurityNumberExist)*/ ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 8,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'socialSecurityNumber',
                                                        name: 'socialSecurityNumberParent2',
                                                        hideFindChildren: true,
                                                        searchByNameAndEmailFormBuilder: this.state.socialSecurityNumberExist && !this.state.ssnExistInThisGroup ? false : true,
                                                        disableNewPatientBtn: true,
                                                        label: this.props.country === 'uk' ? "Date of birth".translate(this.props.lang) : 'Social security number'.translate(this.props.lang),
                                                        disabled: this.state.socialSecurityNumberExist && !this.state.ssnExistInThisGroup && (!this.state.needsParent || (this.state.needsParent && this.state.hasParent)) ? true : false,
                                                        getCountryState: (countryState) => {
                                                            let countryStateDict = this.state.countryStateDict ?? {};
                                                            countryStateDict['socialSecurityNumberParent2'] = countryState;
                                                            this.setState({ countryStateDict })
                                                        },
                                                        validate: !this.state.parent2Required ? [] : [required('Social security number is required!'.translate(this.props.lang)), checkSocialSecurityNumber('Social security number is not valid!'.translate(this.props.lang), this.state.countryStateDict?.['socialSecurityNumberParent2'] ?? this.props.country)]
                                                    },
                                                ]
                                            } : { type: 'empty' },
                                        (!this.state.socialSecurityNumberExist || (this.state.socialSecurityNumberExist && this.state.needsParent && !this.state.hasParent)) && isChild && patientInfoSettings?.isCustomIdEnabled ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 8,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'customId',
                                                        name: `customIdParent2.${this.props.selectedGroup}`,
                                                        label: patientInfoSettings?.customIdLabel ? patientInfoSettings?.customIdLabel : 'Custom id'.translate(this.props.lang),
                                                        labelInfo: patientInfoSettings?.customIdInfoText ?? null,
                                                        // validate: patientInfoSettings?.isCustomIdRequired ? [required((patientInfoSettings?.customIdLabel + ' ' + 'is required!'.translate(this.props.lang)) ?? 'Custom id is required!'.translate(this.props.lang))] : [],
                                                    },
                                                ],
                                            } : { type: 'empty' },
                                        isChild && this.props.showDateOfBirth ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 4,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'date-of-birth',
                                                        dateFormat: this.props.dateFormat,
                                                        name: 'dateOfBirthParent2.date',
                                                        disabled: this.state.disabledDateOfBirthParent2,
                                                        label: 'Date of birth'.translate(this.props.lang),
                                                        validate: !this.state.parent2Required ? [] : [required('Date of birth is required!'.translate(this.props.lang)), dateValidate('Invalid date!'.translate(this.props.lang))]

                                                    },
                                                ]
                                            } : { type: 'empty' },
                                        (!this.state.socialSecurityNumberExist || (this.state.socialSecurityNumberExist && this.state.needsParent && !this.state.hasParent)) && isChild /*|| (isChild && this.state.socialSecurityNumberExist)*/ ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 4,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'select',
                                                        name: 'sexParent2',
                                                        label: 'Sex'.translate(this.props.lang),
                                                        disabled: this.state.socialSecurityNumberExist && !this.state.ssnExistInThisGroup && (!this.state.needsParent || (this.state.needsParent && this.state.hasParent)) ? true : false,
                                                        values: [{ value: 0, name: 'Select'.translate(this.props.lang) }, { value: 'male', name: 'Male'.translate(this.props.lang) }, { value: 'female', name: 'Female'.translate(this.props.lang) }],
                                                    },
                                                ]
                                            } : { type: 'empty' },
                                        (!this.state.socialSecurityNumberExist || (this.state.socialSecurityNumberExist && this.state.needsParent && !this.state.hasParent)) && isChild /*|| (isChild && this.state.socialSecurityNumberExist)*/ ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: this.props.showDateOfBirth ? this.props.secondaryLanguageDisabled ? 6 : 4 : this.props.secondaryLanguageDisabled ? 12 : 8,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'text',
                                                        name: 'nameParent2',
                                                        label: 'First and last name'.translate(this.props.lang),
                                                        validate: !this.state.parent2Required ? [] : [required('Name is required!'.translate(this.props.lang))],
                                                        disabled: this.state.socialSecurityNumberExist && !this.state.ssnExistInThisGroup && (!this.state.needsParent || (this.state.needsParent && this.state.hasParent)) ? true : false,

                                                    },
                                                ]
                                            } : { type: 'empty' },
                                        (!this.state.socialSecurityNumberExist || (this.state.socialSecurityNumberExist && this.state.needsParent && !this.state.hasParent)) && isChild /*|| (isChild && this.state.socialSecurityNumberExist)*/ && !this.props.secondaryLanguageDisabled ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 4,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'select',
                                                        name: 'language2',
                                                        label: 'Language'.translate(this.props.lang),
                                                        disabled: this.state.socialSecurityNumberExist && !this.state.ssnExistInThisGroup && (!this.state.needsParent || (this.state.needsParent && this.state.hasParent)) ? true : false,
                                                        values: this.state.languages.map(item => { return { name: item.name?.translate(this.props.lang), value: item._id } })
                                                    },
                                                ]
                                            } : { type: 'empty' },

                                        (!this.state.socialSecurityNumberExist || (this.state.socialSecurityNumberExist && this.state.needsParent && !this.state.hasParent)) && isChild /*|| (isChild && this.state.socialSecurityNumberExist)*/ ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 6,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'text',
                                                        name: 'email2',
                                                        label: 'Email address'.translate(this.props.lang),
                                                        disabled: this.state.socialSecurityNumberExist && !this.state.ssnExistInThisGroup && (!this.state.needsParent || (this.state.needsParent && this.state.hasParent)) ? true : false,
                                                        validate: !this.state.parent2Required ? [] : this.props.twoFactorAuthenticationEnabled ? [] : []
                                                    },
                                                ]
                                            } : { type: 'empty' },
                                        (!this.state.socialSecurityNumberExist || (this.state.socialSecurityNumberExist && this.state.needsParent && !this.state.hasParent)) && isChild /*|| (isChild && this.state.socialSecurityNumberExist)*/ ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 6,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'phone',

                                                        name: 'phone2',
                                                        label: 'Phone'.translate(this.props.lang),
                                                        disabled: this.state.socialSecurityNumberExist && !this.state.ssnExistInThisGroup && (!this.state.needsParent || (this.state.needsParent && this.state.hasParent)) ? true : false,
                                                        validate: !this.state.parent2Required ? [] : this.props.twoFactorAuthenticationEnabled ? [] : []
                                                    },
                                                ]
                                            } : { type: 'empty' },
                                        // ---
                                        (!this.state.socialSecurityNumberExist || (this.state.socialSecurityNumberExist && this.state.needsParent && !this.state.hasParent)) && this.state.clinicGroupSettings?.twoFactorAuthentication ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 12,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'checkbox',
                                                        name: 'twoFactorAuthenticationEnabled',
                                                        label: 'Enable login with two factor authentication'.translate(this.props.lang),
                                                        labelInfo: 'Login link is sent to the users phone number and email. The link is valid for 7 days.'.translate(this.props.lang)
                                                    }
                                                ]

                                            }
                                            : { type: 'empty' },
                                        !this.state.ssnExistInThisGroup ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 12,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'checkbox',
                                                        validate: [required('Consent is required!'.translate(this.props.lang))],
                                                        name: 'consentAccepted',
                                                        label: 'Consent has been obtained'.translate(this.props.lang),

                                                    },
                                                ]
                                            } : { type: 'empty' },




                                    ]
                                }
                            ]}
                        ></FormBuilder>
                        :
                        null
                }
                {
                    this.state.previewAnswersModal ?
                        <Modal isOpen={this.state.previewAnswersModal} centered toggle={() => this.setState({ previewAnswersModal: !this.state.previewAnswersModal })} size="lg">
                            <ModalHeader toggle={() => this.setState({ previewAnswersModal: !this.state.previewAnswersModal })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ previewAnswersModal: !this.state.previewAnswersModal })}><Isvg src={xIcon} /></button>}>{'Form preview'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody>

                                <FormPreview {...this.props} referral={{ _id: this.state.previewAnswersModal._id, name: this.state.previewAnswersModal.name, description: this.state.previewAnswersModal.description, intelligentReferral: this.state.previewAnswersModal.intelligentReferral, items: this.state.previewAnswersModal.items, group: this.props.uData?.clinicGroups[selectedGroupIdx]?._id }} sections={this.generateSections(this.state.previewAnswersModal.items)} answers={this.state.previewAnswersModal.answers} disabledForm={true} hidePreview={true}></FormPreview>

                            </ModalBody>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.openPreviewReferral ?
                        <ReferralContent
                            {...this.props}
                            data={this.state.previewReferral}
                            screen={'my-cases'}
                            calendar={true}
                            doctorPage={true}
                            enterprise={enterprise}
                            // adminPermission={this.state.adminPermission}
                            // generateTimeReferral={(referral) => { this.generateTimeReferral(referral) }}
                            // allowReferral={() => { this.allowReferral() }}
                            // disallowReferral={(referral) => { this.setState({ disallowForm: referral }) }}
                            // acceptReferral={() => this.acceptReferral()}
                            // rejectReferral={() => this.rejectReferral()}
                            // acceptRequestedTime={() => this.acceptRequestedTime()}
                            // rejectRequestedTime={(referral) => {
                            //     this.setState({ scheduleForm: referral })
                            // }}
                            // priorityModal={(referral) => {
                            //     this.setState({
                            //         priorityModal: { ...referral }
                            //     })
                            // }}
                            closeCase={() => { this.setState({ closeCase: true }) }}
                            deleteCase={() => { this.setState({ deleteCase: true }) }}

                            previewAnswersRevisit={(form) => {
                                this.setState({ previewAnswersModal: form })
                            }}
                            closeReferralContent={(data) => {
                                if (this.state.openPreviewReferral) {
                                    this.setState({
                                        openPreviewReferral: null
                                    })
                                }
                            }}
                            setData={(data, refresh = false) => {
                                if (data) {
                                    let previewReferral = this.state.previewReferral;
                                    if (data && Object.keys(data)?.length) {
                                        for (var key in data) {
                                            previewReferral[key] = data[key];
                                        }
                                        this.setState({
                                            previewReferral: null,
                                            openPreviewReferral: false,
                                            updateEvent: null,
                                            meetingParticipants: null,
                                            offerData: null,
                                            prevUpdateEvent: null,
                                        }, () => {
                                            if (refresh) {
                                                this.get();
                                            }
                                        })
                                    }
                                }
                            }}
                        />
                        :
                        null
                }

                {
                    this.state.closeCase ?
                        <Modal isOpen={this.state.closeCase} centered>
                            {/* <ModalHeader style={{ margin: 'auto' }}>{'Warning'.translate(this.props.lang)}</ModalHeader> */}
                            <ModalBody className="delete-modal">
                                {/* <img src={warrning} /> */}
                                <p className="message">{`Are you sure you want to close the case?`.translate(this.props.lang)}</p>
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => this.setState({ closeCase: false }, () => this.closeReferral())}>{'Yes'.translate(this.props.lang)}</Button>
                                <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => this.setState({ closeCase: false })}>{'No'.translate(this.props.lang)}</Button>

                            </ModalFooter>
                        </Modal>
                        :
                        null
                }

                {
                    this.state.transferModal ?
                        <Modal isOpen={this.state.transferModal} centered>
                            <ModalHeader toggle={() => this.setState({ transferModal: !this.state.transferModal, timeErrorMessage: null })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ transferModal: !this.state.transferModal, timeErrorMessage: null })}>&times;</button>}>{'Transfer event'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody>
                                <FormGroup>
                                    <Label>{'Doctors'.translate(this.props.lang)}</Label>
                                    <Input type='select'

                                        onChange={e => {
                                            let transferModal = this.state.transferModal;
                                            transferModal.doctor = e.target.value == -1 ? null : e.target.value;
                                            this.setState({
                                                transferModal
                                            },
                                                () => {
                                                    this.get();
                                                    this.getWorkingTime();
                                                }
                                            )

                                        }}>
                                        <option value={-1}>{'None'.translate(this.props.lang)}</option>

                                        {this.state.doctors.filter(el => el._id != this.state.transferModal.patientId).sort((a, b) => {
                                            const nameA = a.name.toLowerCase();
                                            const nameB = b.name.toLowerCase();
                                            if (nameA < nameB) {
                                                return -1
                                            }
                                            if (nameA > nameB) {
                                                return 1
                                            }
                                        }).map(item => {
                                            let obj = {}
                                            obj.min = new Date()
                                            obj.min.setHours(7, 0, 0)
                                            obj.max = new Date()
                                            obj.max.setHours(18, 0, 0)
                                            if (item.workingTimeConfig) {

                                                if (item.workingTimeConfig[this.props.selectedGroup] && item.workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic]) {
                                                    let minTime = item.workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic].min
                                                    let maxTime = item.workingTimeConfig[this.props.selectedGroup][this.props.selectedClinic].max
                                                    obj.min = new Date();
                                                    obj.min.setHours(new Date(minTime).getHours(), new Date(minTime).getMinutes(), 0)
                                                    obj.max = new Date();
                                                    obj.max.setHours(new Date(maxTime).getHours(), new Date(maxTime).getMinutes(), 0)
                                                }
                                            } else if (this.props.uData && this.props.selectedGroup && this.props.selectedClinic) {

                                                if (selectedGroupIdx !== -1) {
                                                    if (this.props.uData.clinicGroups && this.props.uData.clinicGroups[selectedGroupIdx] && this.props.uData.clinicGroups[selectedGroupIdx].bookingSettings) {
                                                        const bookingSettings = this.props.uData.clinicGroups[selectedGroupIdx].bookingSettings;

                                                        if (bookingSettings?.workingHours && bookingSettings?.workingHours.min && bookingSettings?.workingHours.max) {

                                                            obj.min = new Date(this.props.getStringDateTs(Math.floor(new Date(bookingSettings?.workingHours.min).getTime() / 1000), 'MM/DD/YYYY HH:mm'))
                                                            obj.max = new Date(this.props.getStringDateTs(Math.floor(new Date(bookingSettings?.workingHours.max).getTime() / 1000), 'MM/DD/YYYY HH:mm'))

                                                        }

                                                    }
                                                }
                                            }

                                            if (item._id != this.state.doctor)
                                                return <option value={item._id}>
                                                    {item.userData && item.userData.title && item.userData.name ? this.props.formatName(item?.userData?.title, item?.userData?.name) : item.name} - {item.username}    ({this.props.getStringDateTs(Math.floor(obj?.min?.getTime() / 1000), 'HH:mm')} - {this.props.getStringDateTs(Math.floor(obj?.max?.getTime() / 1000), 'HH:mm')})
                                                </option>
                                        })}

                                    </Input>
                                </FormGroup>
                                {this.state.transferModal.type == 'referral' || this.state.transferModal.type == 'revisit' ?
                                    <FormGroup>
                                        <Label>{'Title'.translate(this.props.lang)}</Label>
                                        <Input disabled type='textarea'

                                            value={this.state.transferModal.titleDoctor && this.state.transferModal.titleDoctor != '' ? this.state.transferModal.baseTitle + ', ' + this.state.transferModal.titleDoctor : this.state.transferModal.title} />
                                        <Input type='text' style={{ marginTop: 5 }} onChange={(e) => {
                                            let transferModal = this.state.transferModal;
                                            transferModal.titleDoctor = striptags(e.target.value);

                                            this.setState({
                                                transferModal
                                            })
                                        }}
                                            value={this.state.transferModal.titleDoctor} />

                                    </FormGroup>
                                    :
                                    <FormGroup>
                                        <Label>{'Title'.translate(this.props.lang)}</Label>
                                        <Input type='text'
                                            onChange={(e) => {
                                                let updateEvent = this.state.updateEvent;
                                                updateEvent.title = striptags(e.target.value);
                                                this.setState({
                                                    updateEvent
                                                })
                                            }}
                                            value={this.state.transferModal.title} />


                                    </FormGroup>
                                }
                                <DatePicker
                                    label={'Start date'.translate(this.props.lang)}
                                    value={this.state.transferModal.date}
                                    holidayEvents={this.state.holidayEvents}
                                    lang={this.props.lang}
                                    onChange={(e) => {
                                        let transferModal = this.state.transferModal;
                                        transferModal.date = e;
                                        this.setState({
                                            transferModal
                                        })
                                        if (Math.floor(new Date(this.state.transferModal.date + ' ' + this.state.transferModal.startTime) / 1000) > Math.floor(new Date(this.state.transferModal.endDate + ' ' + this.state.transferModal.endTime) / 1000)) {
                                            transferModal.endDate = this.state.transferModal.date
                                            this.setState({
                                                transferModal
                                            })
                                        }
                                    }}
                                />
                                <FormGroup className="timepicker-container timepicker-wide">
                                    <Label>{'Start time'.translate(this.props.lang)}</Label>
                                    &nbsp;
                                    <TimePickerV2
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={this.state.transferModal.startTime}
                                        minValue={this.props.getStringDateTs(Math.floor(this.state.minTransferDoctor.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.min.getTime() / 1000).format("HH:mm")
                                        maxValue={this.props.getStringDateTs(Math.floor(this.state.maxTransferDoctor.getTime() / 1000 - 300), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                        flag={0}
                                        onChange={(time1, timeString) => {

                                            let transferModal = this.state.transferModal;
                                            transferModal.startTime = timeString

                                            let startTimeSplit = transferModal.startTime.split(":");
                                            let endTimeSplit = transferModal.endTime.split(":");

                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);
                                            this.setState({ transferModal })

                                            if (startTimeHourMinute < endTimeHourMinute) {
                                                this.setState({ transferModal }, () => {
                                                    this.disableTransferIfTimeIsOutOfWorkingHours()
                                                })
                                            } else {
                                                transferModal.endTime = Math.trunc((Number(this.state.transferModal.startTime.split(':')[0]) * 60 + Number(this.state.transferModal.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.transferModal.startTime.split(':')[0]) * 60 + Number(this.state.transferModal.startTime.split(':')[1]) + 5) % 60
                                                const padded = transferModal?.endTime?.split?.(':');
                                                if (padded && Array.isArray(padded) && padded.length && isStringAValidNumber(padded[0]) && isStringAValidNumber(padded[1])) {
                                                    const h = padded[0]?.padStart?.(2, '0');
                                                    const m = padded[1]?.padStart?.(2, '0');
                                                    if (h && m) transferModal.endTime = `${h}:${m}`;
                                                }
                                                this.setState({
                                                    transferModal
                                                }, () => {
                                                    this.disableTransferIfTimeIsOutOfWorkingHours()
                                                })
                                            }
                                        }}
                                    />
                                </FormGroup>
                                <FormGroup className="timepicker-container timepicker-wide">
                                    <Label>{'End time'.translate(this.props.lang)}</Label>
                                    &nbsp;
                                    <TimePickerV2
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={this.state.transferModal.endTime}
                                        minValue={Math.trunc((Number(this.state.transferModal.startTime.split(':')[0]) * 60 + Number(this.state.transferModal.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.transferModal.startTime.split(':')[0]) * 60 + Number(this.state.transferModal.startTime.split(':')[1]) + 5) % 60}
                                        maxValue={this.props.getStringDateTs(Math.floor(this.state.maxTransferDoctor.getTime() / 1000), 'HH:mm')} // moment.unix(this.state.max.getTime() / 1000).format("HH:mm")
                                        flag={0}
                                        onChange={(time1, timeString) => {

                                            let transferModal = this.state.transferModal;
                                            transferModal.endTime = timeString

                                            let startTimeSplit = transferModal.startTime.split(":");
                                            let endTimeSplit = transferModal.endTime.split(":");

                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                            if (startTimeHourMinute < endTimeHourMinute) {
                                                this.setState({ transferModal }, () => {
                                                    this.disableTransferIfTimeIsOutOfWorkingHours()
                                                })
                                            }
                                        }}
                                    />
                                </FormGroup>
                                {
                                    this.state.timeErrorMessage ?
                                        <p style={{ color: 'red' }}>{this.state.timeErrorMessage}</p>
                                        :
                                        null
                                }


                                <Button color='primary' disabled={!this.state.timeErrorMessage && this.state.transferModal.doctor ? false : true} style={{ margin: 10 }} onClick={() => this.transferEvent(this.state.transferModal)}>{'Transfer doctor'.translate(this.props.lang)}</Button>
                                <Button color='primary' style={{ margin: 10 }} onClick={() => this.setState({ transferModal: !this.state.transferModal })}>{'Cancel'.translate(this.props.lang)}</Button>

                            </ModalBody>
                        </Modal>
                        :
                        null
                }

                {
                    this.state.deleteCase ?
                        <Modal isOpen={this.state.deleteCase} centered>
                            <ModalBody className="delete-modal">
                                <p className="message">{`Are you sure you want to delete the case?`.translate(this.props.lang)}</p>
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => this.setState({ deleteCase: false }, () => this.deleteReferral())}>{'Yes'.translate(this.props.lang)}</Button>
                                <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => this.setState({ deleteCase: false })}>{'No'.translate(this.props.lang)}</Button>

                            </ModalFooter>
                        </Modal>
                        : null
                }
                {
                    this.state.succesMessage ?
                        <InfoModal
                            isOpen={this.state.succesMessage}
                            onClose={(item) => {
                                this.setState({
                                    succesMessage: item
                                })
                            }}
                            // toggle={() => this.setState({ succesMessage: false })}
                            header={'Info'.translate(this.props.lang)}
                            info={this.state.succesMessage.translate(this.props.lang)}
                            buttons={[
                                <Button color='primary' style={{ margin: 10 }} onClick={() => this.setState({ succesMessage: null })}>{'Close'.translate(this.props.lang)}</Button>,

                            ]}
                        />
                        :
                        null
                }
                {
                    this.state.saveModal ?
                        <InfoModal
                            isOpen={this.state.saveModal}
                            onClose={(item) => {
                                this.setState({
                                    saveModal: item
                                })
                            }}
                            // toggle={() => this.setState({ saveModal: false })}
                            header={'Warning'.translate(this.props.lang)}
                            info={this.state.saveModal?.twoFactorAuthenticationEnabled
                                ? 'Is the information correct? Incorrect information may lead to the wrong person accessing the account'.translate(this.props.lang)
                                : 'Is it true that consent has been obtained to open the account'.translate(this.props.lang)}
                            buttons={[
                                <button style={{ visibility: 'hidden', display: 'none' }} aria-hidden='true'></button>,
                                <Button
                                    color='success'
                                    style={{ margin: 10 }}
                                    disabled={this.state.addPatientLoader}
                                    onClick={() => this.addPatient(this.state.saveModal)}
                                >
                                    {this.state.saveModal?.twoFactorAuthenticationEnabled
                                        ? 'Confirm'.translate(this.props.lang)
                                        : 'Yes'.translate(this.props.lang)
                                    }
                                </Button>,
                                <Button
                                    color='danger'
                                    style={{ margin: 10 }}
                                    onClick={() => this.setState({
                                        saveModal: null
                                    })}
                                >
                                    {this.state.saveModal?.twoFactorAuthenticationEnabled
                                        ? 'Go back'.translate(this.props.lang)
                                        : 'No'.translate(this.props.lang)
                                    }
                                </Button>,
                                <button style={{ visibility: 'hidden', display: 'none' }} aria-hidden='true'></button>
                            ]}
                        />
                        :
                        null
                }

                {
                    this.state.wrongDateModal ?
                        <InfoModal
                            isOpen={this.state.wrongDateModal}
                            onClose={(item) => {
                                this.setState({
                                    wrongDateModal: null
                                })
                            }}
                            info={"This event has already occurred. When saving changes, no notifications will be sent out.".translate(this.props.lang)}
                            buttons={[
                                <Button
                                    // color='success'
                                    style={{ margin: 10, border: 'none' }}
                                    onClick={() => {

                                        if (this.state.wrongDateModal?.function === 'updateEvent') {
                                            this.updateEvent(this.state.wrongDateModal?.data, this.state.wrongDateModal?.cb)
                                        } else if (this.state.wrongDateModal?.function === 'scheduleControl') {
                                            this.scheduleControl(this.state.wrongDateModal?.data, this.state.wrongDateModal?.checkPreScheduleInfo)
                                        } else if (this.state.wrongDateModal?.function === 'scheduleReferral') {
                                            this.scheduleReferral(this.state.wrongDateModal?.data);
                                        } else if (this.state.wrongDateModal?.function === 'scheduleEvent') {
                                            this.scheduleEvent(this.state.wrongDateModal?.data, this.state.wrongDateModal?.forceInsert)
                                        } else if (this.state.wrongDateModal?.function === 'updateEventTypeEvent') {
                                            this.updateEventTypeEvent(this.state.wrongDateModal?.data, this.state.wrongDateModal?.updateAllRecurringEvents, this.state.wrongDateModal?.forceUpdate)
                                        }
                                    }}
                                >
                                    {"Save".translate(this.props.lang)}
                                </Button>,
                                <Button
                                    // color='danger'
                                    style={{ margin: 10, border: 'none' }}
                                    onClick={() => this.setState({
                                        wrongDateModal: null,
                                        creatingEvent: null,
                                    })}
                                >
                                    {'Go back'.translate(this.props.lang)}
                                </Button>,
                            ]}
                        />
                        :
                        null
                }

                {
                    this.state.wrongDateCheckInModal ?
                        <InfoModal
                            isOpen={this.state.wrongDateCheckInModal}
                            onClose={(item) => {
                                this.setState({
                                    wrongDateCheckInModal: null
                                })
                            }}
                            info={"This event has already occurred.".translate(this.props.lang)}
                            buttons={[
                                <Button
                                    // color='success'
                                    style={{ margin: 10, border: 'none' }}
                                    onClick={() => {

                                        if (this.state.wrongDateCheckInModal === 'yes') {
                                            this.doctorCheckedEventFroPatient(true)
                                        } else if (this.state.wrongDateCheckInModal === 'no') {
                                            this.doctorCheckedEventFroPatient(false)
                                        }
                                    }}
                                >
                                    {"Save".translate(this.props.lang)}
                                </Button>,
                                <Button
                                    style={{ margin: 10, border: 'none' }}
                                    onClick={() => this.setState({
                                        wrongDateCheckInModal: null,
                                    })}
                                >
                                    {'Go back'.translate(this.props.lang)}
                                </Button>,
                            ]}
                        />
                        :
                        null
                }

                {
                    this.state.invoiceMessage ?
                        <InfoModal
                            isOpen={this.state.invoiceMessage}
                            onClose={(item) => {
                                this.setState({
                                    invoiceMessage: item
                                })
                            }}
                            info={this.state.invoiceMessage.translate(this.props.lang)}
                            buttons={[
                                <Button
                                    // color='success'
                                    style={{ margin: 10, border: 'none' }}
                                    onClick={() => this.props[0].history.push('/my-data/clinic/payments')}
                                >
                                    {"Go to payment".translate(this.props.lang)}
                                </Button>,
                                <Button
                                    // color='danger'
                                    style={{ margin: 10, border: 'none' }}
                                    onClick={() => this.setState({
                                        invoiceMessage: null
                                    })}
                                >
                                    {'Close'.translate(this.props.lang)}
                                </Button>,
                            ]}
                        />
                        :
                        null
                }

                {
                    this.state.changesNotSaved ?
                        <Modal isOpen={this.state.changesNotSaved ? true : false} centered>
                            <ModalBody className="delete-modal">
                                <p className="message">{'Some changes are not saved.'.translate(this.props.lang)}</p>
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => {
                                    if (typeof this.state.changesNotSaved === 'string') {
                                        let ssn = this.state.changesNotSaved;

                                        this.setState({
                                            changesNotSaved: false
                                        }, () => {
                                            this.updateEvent(this.state.updateEvent, () => {
                                                this.searchPatientWithRedirect(ssn);
                                            })
                                        })

                                        return;
                                    }
                                    this.setState({
                                        changesNotSaved: false
                                    }, () => {
                                        this.updateEvent(this.state.updateEvent)
                                    })


                                }}>{'Save and exit'.translate(this.props.lang)}</Button>


                                <Button color="primary" style={{ margin: 10, minWidth: 100 }} onClick={() => {
                                    if (typeof this.state.changesNotSaved === 'string') {
                                        this.searchPatientWithRedirect(this.state.changesNotSaved);
                                        return;
                                    }
                                    this.setState({
                                        updateEvent: null,
                                        meetingParticipants: null,
                                        offerData: null,
                                        prevUpdateEvent: null,
                                        changesNotSaved: false,
                                        doctorsList: [],
                                    })
                                }}>{'Exit without saving'.translate(this.props.lang)}</Button>

                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.error ?

                        <ErrorModal lang={this.props.lang}
                            isOpen={this.state.error}
                            toggle={() => this.setState({ error: null })}

                        >
                            {this.state.error.translate(this.props.lang)}
                        </ErrorModal>

                        :
                        null
                }
            </div >
        );
    }
}
const selector = formValueSelector('modalForm');

export default connect(state => {
    return {
        socialSecurityNumber: selector(state, 'socialSecurityNumber'),
        socialSecurityNumberParent: selector(state, 'socialSecurityNumberParent'),
        dateOfBirth: selector(state, 'dateOfBirth.date'),
        dateOfBirthParent: selector(state, 'dateOfBirthParent.date'),
        dateOfBirthParent2: selector(state, 'dateOfBirthParent2.date'),

        socialSecurityNumberParent2: selector(state, 'socialSecurityNumberParent2'),
        email2: selector(state, 'email2'),
        phone2: selector(state, 'phone2'),
        language2: selector(state, 'language2'),
        nameParent2: selector(state, 'nameParent2'),

        twoFactorAuthenticationEnabled: selector(state, 'twoFactorAuthenticationEnabled')

    }

}, {
    changeName: value => change('modalForm', 'userData.name', value),
    changeSex: value => change('modalForm', 'userData.sex', value),
    changeSocialSecurityNumberParent: value => change('modalForm', 'socialSecurityNumberParent', value),

    changeEmail: value => change("modalForm", "email", value),
    changeNameParent: value => change("modalForm", "nameParent", value),
    changeLanguage: value => change("modalForm", "language", value),
    changePhone: value => change("modalForm", "phone", value),
    changeSexParent: value => change("modalForm", "sexParent", value),

    changeEmail2: value => change("modalForm", "email2", value),
    changeNameParent2: value => change("modalForm", "nameParent2", value),
    changeLanguage2: value => change("modalForm", "language2", value),
    changePhone2: value => change("modalForm", "phone2", value),
    changeSexParent2: value => change("modalForm", "sexParent2", value),

    changeDateOfBirth: value => change("modalForm", "dateOfBirth.date", value),
    changeDateOfBirthParent: value => change("modalForm", "dateOfBirthParent.date", value),
    changeDateOfBirthParent2: value => change("modalForm", "dateOfBirthParent2.date", value)


})(DoctorWorkingHoursComponent);
